export const ukCustom = {
    'type': 'FeatureCollection',
    'features': [
        {
            'type': 'Feature',
            'geometry': {
                'type': 'MultiPolygon',
                'coordinates': [
                    [
                        [
                            [-7.1508, 57.6232],
                            [-7.1336, 57.6182],
                            [-7.1375, 57.6132],
                            [-7.1514, 57.6174],
                            [-7.1508, 57.6232]
                        ]
                    ],
                    [
                        [
                            [-7.4019, 57.5518],
                            [-7.4036, 57.5449],
                            [-7.3919, 57.5399],
                            [-7.3825, 57.546],
                            [-7.3658, 57.5487],
                            [-7.3642, 57.5418],
                            [-7.3531, 57.5432],
                            [-7.3492, 57.5362],
                            [-7.3364, 57.5332],
                            [-7.3431, 57.5265],
                            [-7.3581, 57.524],
                            [-7.3486, 57.5174],
                            [-7.3558, 57.5068],
                            [-7.3536, 57.4968],
                            [-7.3692, 57.501],
                            [-7.3742, 57.5171],
                            [-7.4069, 57.5429],
                            [-7.4019, 57.5518]
                        ]
                    ],
                    [
                        [
                            [-6.3508, 57.7082],
                            [-6.3397, 57.7007],
                            [-6.3236, 57.7007],
                            [-6.3136, 57.7068],
                            [-6.3003, 57.7079],
                            [-6.2903, 57.7004],
                            [-6.2964, 57.6935],
                            [-6.2797, 57.6876],
                            [-6.2747, 57.6824],
                            [-6.2603, 57.681],
                            [-6.2497, 57.6732],
                            [-6.2458, 57.6607],
                            [-6.2364, 57.6524],
                            [-6.2342, 57.6374],
                            [-6.2236, 57.6346],
                            [-6.2047, 57.6376],
                            [-6.1908, 57.6332],
                            [-6.1747, 57.6196],
                            [-6.1692, 57.6065],
                            [-6.1558, 57.5974],
                            [-6.1497, 57.5865],
                            [-6.1392, 57.5818],
                            [-6.1453, 57.5749],
                            [-6.1469, 57.5657],
                            [-6.1419, 57.5624],
                            [-6.1425, 57.5518],
                            [-6.1381, 57.5468],
                            [-6.1419, 57.5385],
                            [-6.1392, 57.5279],
                            [-6.1408, 57.5129],
                            [-6.1464, 57.5001],
                            [-6.1408, 57.4932],
                            [-6.1353, 57.4726],
                            [-6.1386, 57.4524],
                            [-6.1447, 57.4371],
                            [-6.1453, 57.4274],
                            [-6.1625, 57.4207],
                            [-6.173, 57.4121],
                            [-6.1886, 57.4143],
                            [-6.2003, 57.409],
                            [-6.1958, 57.4043],
                            [-6.2003, 57.3949],
                            [-6.1658, 57.406],
                            [-6.1419, 57.4062],
                            [-6.1269, 57.3971],
                            [-6.123, 57.3868],
                            [-6.1358, 57.3715],
                            [-6.1364, 57.361],
                            [-6.1236, 57.3532],
                            [-6.1169, 57.3424],
                            [-6.1053, 57.3382],
                            [-6.1075, 57.3287],
                            [-6.0997, 57.3212],
                            [-6.1297, 57.3165],
                            [-6.1581, 57.301],
                            [-6.1486, 57.2996],
                            [-6.1381, 57.3071],
                            [-6.1175, 57.314],
                            [-6.1025, 57.3149],
                            [-6.0847, 57.311],
                            [-6.0697, 57.3146],
                            [-6.047, 57.3101],
                            [-6.0497, 57.2979],
                            [-6.0408, 57.2921],
                            [-6.0547, 57.2849],
                            [-6.0781, 57.2765],
                            [-6.0803, 57.2715],
                            [-6.0697, 57.2674],
                            [-6.0503, 57.2782],
                            [-6.0436, 57.2771],
                            [-6.0242, 57.2882],
                            [-6.0147, 57.2857],
                            [-5.9992, 57.2729],
                            [-5.9703, 57.2693],
                            [-5.9414, 57.261],
                            [-5.9364, 57.2643],
                            [-5.9197, 57.2618],
                            [-5.9042, 57.2535],
                            [-5.9092, 57.2421],
                            [-5.8869, 57.2404],
                            [-5.8536, 57.2551],
                            [-5.8358, 57.2526],
                            [-5.8219, 57.2579],
                            [-5.8064, 57.2585],
                            [-5.7786, 57.271],
                            [-5.7425, 57.2749],
                            [-5.717, 57.2726],
                            [-5.7158, 57.2668],
                            [-5.6931, 57.2643],
                            [-5.6631, 57.2646],
                            [-5.6469, 57.2546],
                            [-5.6664, 57.2363],
                            [-5.6642, 57.2204],
                            [-5.6719, 57.2063],
                            [-5.7081, 57.1893],
                            [-5.7175, 57.1829],
                            [-5.7481, 57.1771],
                            [-5.7636, 57.169],
                            [-5.7869, 57.1674],
                            [-5.8053, 57.1726],
                            [-5.7953, 57.1599],
                            [-5.7969, 57.1521],
                            [-5.7825, 57.1499],
                            [-5.7881, 57.1374],
                            [-5.7975, 57.1321],
                            [-5.8042, 57.1201],
                            [-5.8281, 57.1074],
                            [-5.8553, 57.109],
                            [-5.8631, 57.0935],
                            [-5.8714, 57.0854],
                            [-5.8864, 57.0801],
                            [-5.8875, 57.0743],
                            [-5.8964, 57.0688],
                            [-5.8919, 57.0612],
                            [-5.9153, 57.0526],
                            [-5.9225, 57.0427],
                            [-5.9536, 57.0354],
                            [-5.9597, 57.0271],
                            [-5.9758, 57.0285],
                            [-5.9964, 57.0232],
                            [-6.0136, 57.0215],
                            [-6.0242, 57.0243],
                            [-6.0225, 57.0302],
                            [-6.0375, 57.0524],
                            [-6.0386, 57.0574],
                            [-6.0231, 57.0715],
                            [-6.0081, 57.0726],
                            [-6.0097, 57.0899],
                            [-5.9964, 57.1049],
                            [-5.9869, 57.1087],
                            [-5.9936, 57.1143],
                            [-6.0058, 57.114],
                            [-5.9964, 57.1265],
                            [-5.988, 57.1285],
                            [-5.9692, 57.1412],
                            [-5.9431, 57.1468],
                            [-5.9331, 57.1587],
                            [-5.9208, 57.1604],
                            [-5.9175, 57.1654],
                            [-5.8858, 57.1674],
                            [-5.8564, 57.1765],
                            [-5.8608, 57.1818],
                            [-5.8753, 57.1757],
                            [-5.9025, 57.1704],
                            [-5.9231, 57.171],
                            [-5.9358, 57.1754],
                            [-5.9558, 57.1721],
                            [-5.9719, 57.1671],
                            [-5.9931, 57.1682],
                            [-5.9969, 57.1732],
                            [-5.9936, 57.1851],
                            [-6.0047, 57.196],
                            [-6.0075, 57.2038],
                            [-6.0197, 57.2051],
                            [-6.0281, 57.1829],
                            [-6.0358, 57.1779],
                            [-6.0453, 57.1785],
                            [-6.0475, 57.1679],
                            [-6.0547, 57.1565],
                            [-6.0797, 57.1279],
                            [-6.0869, 57.1262],
                            [-6.1019, 57.1337],
                            [-6.1136, 57.1365],
                            [-6.1081, 57.1465],
                            [-6.1097, 57.1549],
                            [-6.1042, 57.1713],
                            [-6.1125, 57.1782],
                            [-6.1103, 57.1862],
                            [-6.1169, 57.1907],
                            [-6.1292, 57.184],
                            [-6.1497, 57.1951],
                            [-6.1614, 57.1951],
                            [-6.1658, 57.176],
                            [-6.1853, 57.1726],
                            [-6.2103, 57.1771],
                            [-6.2442, 57.1693],
                            [-6.2564, 57.1699],
                            [-6.2836, 57.164],
                            [-6.3053, 57.161],
                            [-6.3153, 57.1646],
                            [-6.3147, 57.1707],
                            [-6.3014, 57.1746],
                            [-6.2842, 57.1896],
                            [-6.2847, 57.2004],
                            [-6.2914, 57.2024],
                            [-6.3303, 57.1857],
                            [-6.3431, 57.1846],
                            [-6.3619, 57.1921],
                            [-6.3853, 57.2124],
                            [-6.3853, 57.2251],
                            [-6.3792, 57.2279],
                            [-6.3547, 57.2276],
                            [-6.3469, 57.2332],
                            [-6.3853, 57.2346],
                            [-6.4042, 57.2315],
                            [-6.4269, 57.2418],
                            [-6.4292, 57.2507],
                            [-6.4514, 57.2626],
                            [-6.4603, 57.2774],
                            [-6.4569, 57.2851],
                            [-6.477, 57.2874],
                            [-6.482, 57.2907],
                            [-6.482, 57.3118],
                            [-6.4475, 57.3204],
                            [-6.4303, 57.3343],
                            [-6.4131, 57.3365],
                            [-6.4036, 57.331],
                            [-6.3892, 57.3282],
                            [-6.3719, 57.3199],
                            [-6.3569, 57.304],
                            [-6.3408, 57.2985],
                            [-6.3186, 57.2971],
                            [-6.3164, 57.301],
                            [-6.3397, 57.3037],
                            [-6.3481, 57.3088],
                            [-6.3647, 57.3243],
                            [-6.3853, 57.3346],
                            [-6.3992, 57.3379],
                            [-6.4142, 57.3488],
                            [-6.4458, 57.3474],
                            [-6.462, 57.3413],
                            [-6.4553, 57.3599],
                            [-6.482, 57.3665],
                            [-6.4703, 57.376],
                            [-6.4864, 57.3815],
                            [-6.4886, 57.3882],
                            [-6.5069, 57.3829],
                            [-6.5192, 57.374],
                            [-6.5258, 57.3849],
                            [-6.5181, 57.3913],
                            [-6.5269, 57.399],
                            [-6.5342, 57.3926],
                            [-6.5425, 57.3962],
                            [-6.5503, 57.3849],
                            [-6.5681, 57.3899],
                            [-6.5619, 57.361],
                            [-6.5675, 57.3588],
                            [-6.5631, 57.3365],
                            [-6.5703, 57.3318],
                            [-6.5942, 57.3368],
                            [-6.6236, 57.3496],
                            [-6.6497, 57.3535],
                            [-6.6531, 57.3574],
                            [-6.6736, 57.3563],
                            [-6.6992, 57.3676],
                            [-6.7219, 57.3732],
                            [-6.7319, 57.381],
                            [-6.7375, 57.3907],
                            [-6.7297, 57.3935],
                            [-6.7447, 57.4171],
                            [-6.7686, 57.4268],
                            [-6.7825, 57.4229],
                            [-6.7881, 57.4313],
                            [-6.7864, 57.4404],
                            [-6.7781, 57.4424],
                            [-6.7847, 57.4518],
                            [-6.7803, 57.4585],
                            [-6.7642, 57.4593],
                            [-6.7342, 57.4524],
                            [-6.7275, 57.4565],
                            [-6.7425, 57.4632],
                            [-6.7503, 57.4824],
                            [-6.7492, 57.4993],
                            [-6.727, 57.5118],
                            [-6.7108, 57.5121],
                            [-6.6858, 57.4835],
                            [-6.6669, 57.4715],
                            [-6.6614, 57.4613],
                            [-6.6525, 57.459],
                            [-6.6481, 57.4493],
                            [-6.6408, 57.4435],
                            [-6.6208, 57.4349],
                            [-6.6114, 57.4463],
                            [-6.5997, 57.4454],
                            [-6.5914, 57.4496],
                            [-6.6003, 57.4557],
                            [-6.6147, 57.4546],
                            [-6.6136, 57.4674],
                            [-6.6242, 57.4735],
                            [-6.6292, 57.4899],
                            [-6.6358, 57.4949],
                            [-6.6364, 57.5043],
                            [-6.6192, 57.5021],
                            [-6.6114, 57.5071],
                            [-6.5981, 57.5099],
                            [-6.5747, 57.4949],
                            [-6.5642, 57.4957],
                            [-6.5669, 57.5029],
                            [-6.5608, 57.5082],
                            [-6.5731, 57.5151],
                            [-6.5819, 57.5157],
                            [-6.5858, 57.5229],
                            [-6.6042, 57.536],
                            [-6.6131, 57.5371],
                            [-6.6419, 57.5521],
                            [-6.6425, 57.5679],
                            [-6.6353, 57.5807],
                            [-6.6331, 57.5946],
                            [-6.6381, 57.6015],
                            [-6.6286, 57.606],
                            [-6.6153, 57.6062],
                            [-6.6003, 57.596],
                            [-6.5892, 57.5943],
                            [-6.5681, 57.5715],
                            [-6.5675, 57.5515],
                            [-6.5536, 57.5437],
                            [-6.5403, 57.5476],
                            [-6.5275, 57.5404],
                            [-6.4997, 57.5321],
                            [-6.4964, 57.5254],
                            [-6.4864, 57.5238],
                            [-6.4681, 57.5082],
                            [-6.4536, 57.506],
                            [-6.4364, 57.5171],
                            [-6.4258, 57.5171],
                            [-6.4358, 57.4974],
                            [-6.4497, 57.4849],
                            [-6.4342, 57.4826],
                            [-6.4369, 57.4904],
                            [-6.4219, 57.4982],
                            [-6.4214, 57.5043],
                            [-6.4003, 57.5088],
                            [-6.4003, 57.516],
                            [-6.4069, 57.5235],
                            [-6.3986, 57.5288],
                            [-6.3831, 57.521],
                            [-6.3742, 57.5035],
                            [-6.3647, 57.5038],
                            [-6.347, 57.4926],
                            [-6.3469, 57.4843],
                            [-6.3331, 57.4801],
                            [-6.3242, 57.4904],
                            [-6.3303, 57.4968],
                            [-6.3636, 57.5135],
                            [-6.3758, 57.5279],
                            [-6.3736, 57.5351],
                            [-6.3825, 57.5407],
                            [-6.3836, 57.5482],
                            [-6.3969, 57.5546],
                            [-6.3992, 57.5643],
                            [-6.3942, 57.5701],
                            [-6.3731, 57.5718],
                            [-6.3603, 57.5887],
                            [-6.3692, 57.5901],
                            [-6.3775, 57.5849],
                            [-6.3958, 57.5846],
                            [-6.3919, 57.5921],
                            [-6.3992, 57.5957],
                            [-6.3947, 57.6135],
                            [-6.4269, 57.6407],
                            [-6.4214, 57.6485],
                            [-6.4047, 57.651],
                            [-6.4108, 57.6588],
                            [-6.3886, 57.6618],
                            [-6.3836, 57.6599],
                            [-6.3542, 57.6713],
                            [-6.3431, 57.6843],
                            [-6.3469, 57.6935],
                            [-6.3547, 57.6971],
                            [-6.3508, 57.7082]
                        ]
                    ],
                    [
                        [
                            [-6.4203, 58.0054],
                            [-6.4119, 57.9971],
                            [-6.4447, 57.9976],
                            [-6.4436, 58.0051],
                            [-6.4203, 58.0054]
                        ]
                    ],
                    [
                        [
                            [-7.4325, 57.5696],
                            [-7.4247, 57.5624],
                            [-7.4031, 57.5621],
                            [-7.4108, 57.5499],
                            [-7.4264, 57.5521],
                            [-7.4353, 57.5587],
                            [-7.4325, 57.5696]
                        ]
                    ],
                    [
                        [
                            [-7.1919, 57.6976],
                            [-7.1931, 57.6893],
                            [-7.1792, 57.6874],
                            [-7.1664, 57.6821],
                            [-7.1581, 57.6746],
                            [-7.1586, 57.6674],
                            [-7.1664, 57.6601],
                            [-7.1525, 57.6529],
                            [-7.1358, 57.6626],
                            [-7.1297, 57.6565],
                            [-7.1386, 57.6482],
                            [-7.1058, 57.6501],
                            [-7.1053, 57.6585],
                            [-7.0975, 57.6676],
                            [-7.0858, 57.6618],
                            [-7.0975, 57.6532],
                            [-7.0631, 57.6424],
                            [-7.0647, 57.6379],
                            [-7.0886, 57.6212],
                            [-7.0964, 57.6093],
                            [-7.1064, 57.6107],
                            [-7.1369, 57.6282],
                            [-7.1731, 57.6193],
                            [-7.1514, 57.6154],
                            [-7.1575, 57.5993],
                            [-7.1536, 57.5935],
                            [-7.1314, 57.5901],
                            [-7.1131, 57.5962],
                            [-7.1003, 57.5938],
                            [-7.1086, 57.5829],
                            [-7.1108, 57.574],
                            [-7.1186, 57.564],
                            [-7.1369, 57.5576],
                            [-7.162, 57.5565],
                            [-7.1725, 57.5635],
                            [-7.1803, 57.5576],
                            [-7.2042, 57.5618],
                            [-7.2292, 57.5537],
                            [-7.2164, 57.5518],
                            [-7.1819, 57.5524],
                            [-7.1753, 57.549],
                            [-7.1653, 57.5554],
                            [-7.1342, 57.554],
                            [-7.138, 57.5399],
                            [-7.1308, 57.5379],
                            [-7.1386, 57.5249],
                            [-7.1486, 57.5185],
                            [-7.1508, 57.5104],
                            [-7.1647, 57.5082],
                            [-7.1964, 57.5115],
                            [-7.2058, 57.5082],
                            [-7.2242, 57.509],
                            [-7.2497, 57.5068],
                            [-7.2608, 57.5088],
                            [-7.2664, 57.5126],
                            [-7.2697, 57.5113],
                            [-7.2969, 57.5129],
                            [-7.3042, 57.5071],
                            [-7.3225, 57.509],
                            [-7.3314, 57.5138],
                            [-7.3331, 57.521],
                            [-7.3253, 57.5296],
                            [-7.3558, 57.5476],
                            [-7.3553, 57.5532],
                            [-7.3847, 57.5632],
                            [-7.3931, 57.5632],
                            [-7.4131, 57.5732],
                            [-7.4214, 57.5812],
                            [-7.4442, 57.5687],
                            [-7.4586, 57.5685],
                            [-7.4631, 57.5635],
                            [-7.4797, 57.5671],
                            [-7.4919, 57.5815],
                            [-7.5058, 57.5865],
                            [-7.5253, 57.5901],
                            [-7.5303, 57.6024],
                            [-7.5203, 57.6024],
                            [-7.5158, 57.6146],
                            [-7.5181, 57.6243],
                            [-7.5119, 57.629],
                            [-7.4986, 57.631],
                            [-7.4914, 57.6546],
                            [-7.4836, 57.6629],
                            [-7.4631, 57.659],
                            [-7.4575, 57.6624],
                            [-7.4369, 57.6538],
                            [-7.4197, 57.6535],
                            [-7.4192, 57.6468],
                            [-7.4064, 57.639],
                            [-7.3753, 57.6396],
                            [-7.3719, 57.6579],
                            [-7.3536, 57.6624],
                            [-7.3381, 57.6693],
                            [-7.3331, 57.6862],
                            [-7.3153, 57.6937],
                            [-7.3086, 57.6904],
                            [-7.3236, 57.6815],
                            [-7.3214, 57.6735],
                            [-7.3364, 57.6643],
                            [-7.3336, 57.6582],
                            [-7.3164, 57.6588],
                            [-7.3103, 57.6546],
                            [-7.2897, 57.6529],
                            [-7.2775, 57.664],
                            [-7.2603, 57.6662],
                            [-7.2431, 57.6718],
                            [-7.2397, 57.6796],
                            [-7.2164, 57.6907],
                            [-7.1919, 57.6976]
                        ]
                    ],
                    [
                        [
                            [-7.1314, 58.0382],
                            [-7.1264, 58.034],
                            [-7.1092, 58.0313],
                            [-7.1014, 58.004],
                            [-7.1147, 58.0018],
                            [-7.1247, 58.0088],
                            [-7.147, 58.0099],
                            [-7.1603, 58.0132],
                            [-7.1714, 58.0257],
                            [-7.1625, 58.0332],
                            [-7.1314, 58.0382]
                        ]
                    ],
                    [
                        [
                            [-6.7003, 57.8796],
                            [-6.6747, 57.874],
                            [-6.6569, 57.8735],
                            [-6.6492, 57.8701],
                            [-6.6397, 57.8562],
                            [-6.6608, 57.8504],
                            [-6.6858, 57.8512],
                            [-6.6981, 57.8562],
                            [-6.6842, 57.8621],
                            [-6.6931, 57.8668],
                            [-6.7036, 57.8668],
                            [-6.7147, 57.8749],
                            [-6.7003, 57.8796]
                        ]
                    ],
                    [
                        [
                            [-7.3942, 57.6701],
                            [-7.3786, 57.6685],
                            [-7.3808, 57.6635],
                            [-7.4131, 57.6551],
                            [-7.4358, 57.656],
                            [-7.4175, 57.6643],
                            [-7.4003, 57.666],
                            [-7.3942, 57.6701]
                        ]
                    ],
                    [
                        [
                            [-6.7231, 58.0076],
                            [-6.7131, 57.9962],
                            [-6.7164, 57.9868],
                            [-6.7247, 57.9851],
                            [-6.7408, 57.9987],
                            [-6.7364, 58.0062],
                            [-6.7231, 58.0076]
                        ]
                    ],
                    [
                        [
                            [-5.9808, 57.5143],
                            [-5.9964, 57.5213],
                            [-6.0008, 57.5457],
                            [-5.9908, 57.5432],
                            [-5.9803, 57.5465],
                            [-5.9875, 57.5562],
                            [-5.9903, 57.5674],
                            [-5.9869, 57.574],
                            [-5.9758, 57.5771],
                            [-5.9731, 57.5838],
                            [-5.9575, 57.5818],
                            [-5.9553, 57.5607],
                            [-5.9664, 57.5474],
                            [-5.9642, 57.5415],
                            [-5.9714, 57.5301],
                            [-5.9758, 57.5143],
                            [-5.9808, 57.5143]
                        ]
                    ],
                    [
                        [
                            [-6.2603, 58.5196],
                            [-6.2575, 58.5157],
                            [-6.2292, 58.5021],
                            [-6.2175, 58.4946],
                            [-6.2153, 58.484],
                            [-6.2042, 58.4829],
                            [-6.1808, 58.469],
                            [-6.1808, 58.4637],
                            [-6.1931, 58.4574],
                            [-6.1925, 58.4474],
                            [-6.1686, 58.4307],
                            [-6.1669, 58.4174],
                            [-6.1875, 58.409],
                            [-6.1914, 58.3985],
                            [-6.1986, 58.3949],
                            [-6.2058, 58.3846],
                            [-6.2086, 58.3726],
                            [-6.2169, 58.3671],
                            [-6.1986, 58.3532],
                            [-6.1631, 58.3415],
                            [-6.1947, 58.3396],
                            [-6.2075, 58.326],
                            [-6.2214, 58.3176],
                            [-6.2319, 58.3168],
                            [-6.2403, 58.3068],
                            [-6.2369, 58.2999],
                            [-6.2425, 58.2946],
                            [-6.2681, 58.2912],
                            [-6.2797, 58.2837],
                            [-6.2803, 58.2687],
                            [-6.2969, 58.266],
                            [-6.3214, 58.2685],
                            [-6.3275, 58.259],
                            [-6.3247, 58.2513],
                            [-6.3158, 58.2443],
                            [-6.3275, 58.2379],
                            [-6.3408, 58.2371],
                            [-6.3469, 58.2279],
                            [-6.3303, 58.2257],
                            [-6.3197, 58.2171],
                            [-6.3108, 58.2179],
                            [-6.3036, 58.2104],
                            [-6.2914, 58.2068],
                            [-6.2758, 58.2146],
                            [-6.2653, 58.2151],
                            [-6.2497, 58.2243],
                            [-6.2369, 58.2235],
                            [-6.2192, 58.2313],
                            [-6.2086, 58.2385],
                            [-6.2047, 58.2468],
                            [-6.1642, 58.2568],
                            [-6.1658, 58.2626],
                            [-6.1408, 58.2626],
                            [-6.1347, 58.2588],
                            [-6.1397, 58.2499],
                            [-6.1531, 58.2438],
                            [-6.1469, 58.2393],
                            [-6.1575, 58.2346],
                            [-6.1642, 58.2265],
                            [-6.1575, 58.2199],
                            [-6.1653, 58.2099],
                            [-6.1747, 58.2046],
                            [-6.2053, 58.1993],
                            [-6.2164, 58.1849],
                            [-6.2286, 58.1813],
                            [-6.2558, 58.1796],
                            [-6.2581, 58.1857],
                            [-6.273, 58.1876],
                            [-6.2847, 58.1982],
                            [-6.2869, 58.2051],
                            [-6.3075, 58.2051],
                            [-6.3253, 58.1971],
                            [-6.3203, 58.1896],
                            [-6.3447, 58.1854],
                            [-6.3558, 58.1888],
                            [-6.3558, 58.1971],
                            [-6.3719, 58.199],
                            [-6.3881, 58.1951],
                            [-6.3708, 58.1863],
                            [-6.3803, 58.1846],
                            [-6.3675, 58.1604],
                            [-6.3669, 58.1526],
                            [-6.3742, 58.1471],
                            [-6.3669, 58.1396],
                            [-6.3708, 58.1304],
                            [-6.3903, 58.129],
                            [-6.4308, 58.1296],
                            [-6.4275, 58.1204],
                            [-6.4386, 58.1193],
                            [-6.4542, 58.111],
                            [-6.4575, 58.1049],
                            [-6.4803, 58.1021],
                            [-6.4919, 58.0985],
                            [-6.5031, 58.0996],
                            [-6.5236, 58.0943],
                            [-6.5408, 58.0921],
                            [-6.5564, 58.0926],
                            [-6.5775, 58.0885],
                            [-6.5192, 58.0882],
                            [-6.5114, 58.0935],
                            [-6.4997, 58.0929],
                            [-6.4719, 58.0963],
                            [-6.4431, 58.0954],
                            [-6.4286, 58.1043],
                            [-6.4108, 58.1093],
                            [-6.3958, 58.1071],
                            [-6.3897, 58.1029],
                            [-6.3858, 58.0915],
                            [-6.3986, 58.0915],
                            [-6.3969, 58.0851],
                            [-6.3803, 58.084],
                            [-6.3692, 58.0749],
                            [-6.3797, 58.0679],
                            [-6.3669, 58.0651],
                            [-6.3664, 58.056],
                            [-6.3769, 58.0468],
                            [-6.403, 58.0426],
                            [-6.3569, 58.0396],
                            [-6.3586, 58.029],
                            [-6.3647, 58.026],
                            [-6.3653, 58.0168],
                            [-6.3792, 58.0146],
                            [-6.3881, 58.0076],
                            [-6.3858, 58.0004],
                            [-6.3997, 58.0004],
                            [-6.4097, 58.0096],
                            [-6.4197, 58.0118],
                            [-6.4431, 58.0107],
                            [-6.4647, 58.0132],
                            [-6.4692, 58.0093],
                            [-6.4886, 58.009],
                            [-6.4981, 58.006],
                            [-6.5147, 58.0079],
                            [-6.5264, 58.0049],
                            [-6.5208, 57.999],
                            [-6.5019, 58.0015],
                            [-6.4725, 58.0012],
                            [-6.4542, 57.9926],
                            [-6.4558, 57.9857],
                            [-6.4475, 57.9785],
                            [-6.4508, 57.9638],
                            [-6.4653, 57.9588],
                            [-6.4664, 57.941],
                            [-6.4703, 57.9374],
                            [-6.4903, 57.9371],
                            [-6.4975, 57.9399],
                            [-6.5081, 57.9307],
                            [-6.5197, 57.9268],
                            [-6.5297, 57.9385],
                            [-6.5492, 57.9396],
                            [-6.5392, 57.9315],
                            [-6.5358, 57.9179],
                            [-6.5653, 57.9143],
                            [-6.5703, 57.9096],
                            [-6.5975, 57.9229],
                            [-6.6036, 57.9346],
                            [-6.6142, 57.9443],
                            [-6.6375, 57.9593],
                            [-6.6419, 57.9554],
                            [-6.6286, 57.9457],
                            [-6.6203, 57.9315],
                            [-6.612, 57.9268],
                            [-6.6103, 57.9149],
                            [-6.6242, 57.9165],
                            [-6.6331, 57.921],
                            [-6.6525, 57.9179],
                            [-6.6753, 57.9354],
                            [-6.6786, 57.9426],
                            [-6.6903, 57.9524],
                            [-6.6931, 57.9593],
                            [-6.7025, 57.9596],
                            [-6.7092, 57.9668],
                            [-6.7125, 57.9865],
                            [-6.7047, 57.9946],
                            [-6.7142, 58.0057],
                            [-6.7242, 58.0126],
                            [-6.7569, 58.0035],
                            [-6.7381, 57.991],
                            [-6.7303, 57.9815],
                            [-6.7208, 57.9638],
                            [-6.7264, 57.9579],
                            [-6.7036, 57.9515],
                            [-6.7025, 57.9463],
                            [-6.6814, 57.9315],
                            [-6.6753, 57.919],
                            [-6.6953, 57.9113],
                            [-6.6703, 57.901],
                            [-6.6697, 57.8904],
                            [-6.6636, 57.8871],
                            [-6.6686, 57.8793],
                            [-6.6981, 57.8804],
                            [-6.7408, 57.8854],
                            [-6.7686, 57.894],
                            [-6.7736, 57.8985],
                            [-6.7925, 57.8962],
                            [-6.7864, 57.8799],
                            [-6.8086, 57.8815],
                            [-6.8042, 57.8676],
                            [-6.7853, 57.8704],
                            [-6.7692, 57.8646],
                            [-6.767, 57.854],
                            [-6.7519, 57.8412],
                            [-6.7403, 57.8418],
                            [-6.7386, 57.8257],
                            [-6.7436, 57.8224],
                            [-6.7647, 57.8218],
                            [-6.7875, 57.8287],
                            [-6.7881, 57.8099],
                            [-6.8042, 57.8118],
                            [-6.8097, 57.8038],
                            [-6.8286, 57.8054],
                            [-6.8336, 57.8149],
                            [-6.8481, 57.8026],
                            [-6.8553, 57.7996],
                            [-6.8581, 57.7913],
                            [-6.8714, 57.7949],
                            [-6.8842, 57.7901],
                            [-6.8714, 57.7763],
                            [-6.8747, 57.7726],
                            [-6.9081, 57.7724],
                            [-6.8986, 57.7635],
                            [-6.9403, 57.7549],
                            [-6.9375, 57.7479],
                            [-6.9436, 57.7388],
                            [-6.9553, 57.7332],
                            [-6.9781, 57.7349],
                            [-6.9992, 57.749],
                            [-7.0192, 57.7549],
                            [-7.0253, 57.7682],
                            [-7.0547, 57.7779],
                            [-7.0764, 57.7943],
                            [-7.0764, 57.8015],
                            [-7.0847, 57.8074],
                            [-7.1153, 57.8132],
                            [-7.1253, 57.8201],
                            [-7.1247, 57.839],
                            [-7.1142, 57.8379],
                            [-7.1025, 57.8412],
                            [-7.0808, 57.8326],
                            [-7.0736, 57.8246],
                            [-7.0619, 57.824],
                            [-7.0458, 57.8282],
                            [-7.0397, 57.8335],
                            [-7.0169, 57.8379],
                            [-7.0147, 57.8437],
                            [-7.0047, 57.8468],
                            [-7.0008, 57.8593],
                            [-6.9825, 57.8657],
                            [-6.9542, 57.8704],
                            [-6.9431, 57.8674],
                            [-6.9164, 57.8668],
                            [-6.912, 57.871],
                            [-6.9392, 57.881],
                            [-6.9608, 57.8871],
                            [-6.9508, 57.8943],
                            [-6.9519, 57.9021],
                            [-6.9397, 57.9026],
                            [-6.9214, 57.9107],
                            [-6.8992, 57.9074],
                            [-6.8842, 57.9074],
                            [-6.8764, 57.9012],
                            [-6.8519, 57.9038],
                            [-6.8436, 57.9096],
                            [-6.8597, 57.9168],
                            [-6.8669, 57.9254],
                            [-6.8881, 57.9335],
                            [-6.9153, 57.9365],
                            [-6.9436, 57.9496],
                            [-6.9858, 57.9557],
                            [-7.0169, 57.9521],
                            [-7.0397, 57.9554],
                            [-7.0631, 57.9657],
                            [-7.0803, 57.9668],
                            [-7.0842, 57.9746],
                            [-7.0803, 57.9801],
                            [-7.0864, 57.9915],
                            [-7.0947, 57.9951],
                            [-7.1025, 57.9857],
                            [-7.1153, 57.9887],
                            [-7.1058, 57.9982],
                            [-7.0958, 57.9987],
                            [-7.0897, 58.0051],
                            [-7.0925, 58.0107],
                            [-7.0858, 58.0193],
                            [-7.0703, 58.0182],
                            [-7.0597, 58.009],
                            [-7.0442, 58.0257],
                            [-7.0264, 58.0318],
                            [-7.0069, 58.0354],
                            [-6.9869, 58.0426],
                            [-6.9686, 58.0415],
                            [-6.9608, 58.0488],
                            [-6.9814, 58.0471],
                            [-7.0392, 58.0329],
                            [-7.0542, 58.0407],
                            [-7.047, 58.0515],
                            [-7.0608, 58.0546],
                            [-7.0547, 58.0629],
                            [-7.0397, 58.0651],
                            [-7.0386, 58.0732],
                            [-7.0614, 58.0676],
                            [-7.0614, 58.0607],
                            [-7.0719, 58.0601],
                            [-7.0919, 58.0682],
                            [-7.1008, 58.069],
                            [-7.1025, 58.0888],
                            [-7.1119, 58.1018],
                            [-7.1108, 58.1099],
                            [-7.1236, 58.1132],
                            [-7.1364, 58.1226],
                            [-7.1314, 58.1387],
                            [-7.1131, 58.1418],
                            [-7.1125, 58.1462],
                            [-7.1008, 58.1532],
                            [-7.0936, 58.1654],
                            [-7.1053, 58.1835],
                            [-7.0964, 58.1882],
                            [-7.0808, 58.1904],
                            [-7.0742, 58.1835],
                            [-7.0369, 58.184],
                            [-7.0392, 58.1899],
                            [-7.0653, 58.1949],
                            [-7.0564, 58.2093],
                            [-7.0492, 58.2265],
                            [-7.0397, 58.2332],
                            [-7.0392, 58.2388],
                            [-7.0231, 58.2429],
                            [-7.0247, 58.2335],
                            [-6.9992, 58.2343],
                            [-6.9908, 58.2271],
                            [-6.9758, 58.2196],
                            [-6.9647, 58.2235],
                            [-6.9692, 58.2296],
                            [-6.9536, 58.2338],
                            [-6.9397, 58.2168],
                            [-6.9169, 58.2149],
                            [-6.9097, 58.2032],
                            [-6.9414, 58.2029],
                            [-6.9447, 58.1943],
                            [-6.9331, 58.1893],
                            [-6.9058, 58.186],
                            [-6.897, 58.1882],
                            [-6.8831, 58.1724],
                            [-6.8697, 58.174],
                            [-6.8797, 58.181],
                            [-6.8708, 58.184],
                            [-6.8681, 58.1907],
                            [-6.8392, 58.1996],
                            [-6.8347, 58.2038],
                            [-6.8119, 58.2012],
                            [-6.7831, 58.1949],
                            [-6.7719, 58.1901],
                            [-6.7503, 58.1924],
                            [-6.7392, 58.1785],
                            [-6.7253, 58.1782],
                            [-6.7214, 58.1865],
                            [-6.7325, 58.1874],
                            [-6.7631, 58.2007],
                            [-6.7503, 58.2163],
                            [-6.7647, 58.221],
                            [-6.7697, 58.2315],
                            [-6.7819, 58.2329],
                            [-6.7942, 58.2401],
                            [-6.8003, 58.2479],
                            [-6.8103, 58.2532],
                            [-6.8192, 58.2701],
                            [-6.8003, 58.2762],
                            [-6.8203, 58.2782],
                            [-6.8297, 58.2832],
                            [-6.8047, 58.2943],
                            [-6.8053, 58.3015],
                            [-6.7736, 58.3099],
                            [-6.7614, 58.3079],
                            [-6.7431, 58.3185],
                            [-6.7314, 58.3207],
                            [-6.7247, 58.3285],
                            [-6.7031, 58.3374],
                            [-6.6786, 58.3396],
                            [-6.6692, 58.3504],
                            [-6.6475, 58.3546],
                            [-6.6364, 58.3482],
                            [-6.6208, 58.3529],
                            [-6.6019, 58.3537],
                            [-6.5986, 58.3582],
                            [-6.5792, 58.3651],
                            [-6.5508, 58.366],
                            [-6.5236, 58.3951],
                            [-6.4986, 58.3996],
                            [-6.4908, 58.4079],
                            [-6.4603, 58.4187],
                            [-6.4436, 58.4312],
                            [-6.3992, 58.4499],
                            [-6.3792, 58.4515],
                            [-6.3708, 58.4576],
                            [-6.3547, 58.4604],
                            [-6.3325, 58.4793],
                            [-6.3136, 58.4787],
                            [-6.2836, 58.491],
                            [-6.2764, 58.4971],
                            [-6.2742, 58.5076],
                            [-6.2603, 58.5196]
                        ]
                    ],
                    [
                        [
                            [-3.1969, 59.1549],
                            [-3.1803, 59.1443],
                            [-3.1631, 59.1418],
                            [-3.1475, 59.1338],
                            [-3.1325, 59.1329],
                            [-3.0947, 59.1182],
                            [-3.0831, 59.1249],
                            [-3.073, 59.1237],
                            [-3.0697, 59.1137],
                            [-3.0525, 59.111],
                            [-3.0447, 59.1046],
                            [-3.0503, 59.096],
                            [-3.0264, 59.0804],
                            [-3.0175, 59.0818],
                            [-3.0075, 59.0762],
                            [-3.0008, 59.0649],
                            [-3.0125, 59.051],
                            [-3.0136, 59.0385],
                            [-3.0208, 59.0371],
                            [-3.0336, 59.0465],
                            [-3.0586, 59.0482],
                            [-3.0603, 59.0435],
                            [-3.0525, 59.0346],
                            [-3.0625, 59.0301],
                            [-3.0608, 59.0232],
                            [-3.0797, 59.0235],
                            [-3.1114, 59.0046],
                            [-3.0714, 58.9965],
                            [-3.0553, 58.9971],
                            [-3.0325, 59.0104],
                            [-3.0092, 59.0104],
                            [-2.9992, 59.0049],
                            [-2.9692, 58.996],
                            [-2.9664, 58.9815],
                            [-2.947, 58.991],
                            [-2.9453, 59.0074],
                            [-2.9314, 59.0157],
                            [-2.9253, 59.006],
                            [-2.9142, 59.0112],
                            [-2.9064, 59.0007],
                            [-2.9147, 58.9918],
                            [-2.8964, 58.9901],
                            [-2.8969, 58.986],
                            [-2.9186, 58.9832],
                            [-2.9131, 58.974],
                            [-2.9186, 58.9685],
                            [-2.9119, 58.9621],
                            [-2.8914, 58.9638],
                            [-2.8831, 58.9693],
                            [-2.8658, 58.974],
                            [-2.8569, 58.9862],
                            [-2.8425, 58.9804],
                            [-2.8103, 58.9849],
                            [-2.7992, 58.9904],
                            [-2.7914, 58.9796],
                            [-2.7908, 58.9699],
                            [-2.8208, 58.9665],
                            [-2.8292, 58.9621],
                            [-2.8469, 58.959],
                            [-2.8464, 58.9504],
                            [-2.8308, 58.949],
                            [-2.8264, 58.9424],
                            [-2.8314, 58.9379],
                            [-2.8192, 58.9293],
                            [-2.8058, 58.929],
                            [-2.8053, 58.9221],
                            [-2.7864, 58.9162],
                            [-2.7786, 58.9276],
                            [-2.7936, 58.9265],
                            [-2.7869, 58.9368],
                            [-2.8053, 58.9451],
                            [-2.7975, 58.951],
                            [-2.7775, 58.9513],
                            [-2.7753, 58.9551],
                            [-2.7519, 58.9615],
                            [-2.7347, 58.9643],
                            [-2.7147, 58.9735],
                            [-2.7064, 58.9732],
                            [-2.703, 58.9624],
                            [-2.7092, 58.954],
                            [-2.7053, 58.9474],
                            [-2.718, 58.9393],
                            [-2.7114, 58.9304],
                            [-2.7125, 58.9196],
                            [-2.7225, 58.919],
                            [-2.7519, 58.9226],
                            [-2.7636, 58.9126],
                            [-2.7786, 58.916],
                            [-2.7997, 58.9038],
                            [-2.8019, 58.8946],
                            [-2.8219, 58.8854],
                            [-2.8164, 58.8821],
                            [-2.8281, 58.8726],
                            [-2.8553, 58.8915],
                            [-2.8814, 58.8988],
                            [-2.8964, 58.8951],
                            [-2.8953, 58.8899],
                            [-2.8814, 58.8893],
                            [-2.8936, 58.8832],
                            [-2.8992, 58.884],
                            [-2.9119, 58.8735],
                            [-2.8997, 58.8718],
                            [-2.8853, 58.874],
                            [-2.8925, 58.8615],
                            [-2.8886, 58.8537],
                            [-2.8569, 58.8537],
                            [-2.877, 58.8443],
                            [-2.8864, 58.8437],
                            [-2.9025, 58.8365],
                            [-2.8875, 58.834],
                            [-2.8864, 58.8262],
                            [-2.8753, 58.8196],
                            [-2.8808, 58.8165],
                            [-2.8975, 58.8182],
                            [-2.9119, 58.809],
                            [-2.9158, 58.7996],
                            [-2.9242, 58.8004],
                            [-2.9297, 58.7918],
                            [-2.9192, 58.7863],
                            [-2.9253, 58.7743],
                            [-2.9397, 58.7671],
                            [-2.9258, 58.7593],
                            [-2.9142, 58.7585],
                            [-2.9136, 58.7496],
                            [-2.9181, 58.7362],
                            [-2.9231, 58.7332],
                            [-2.9475, 58.7329],
                            [-2.9608, 58.7287],
                            [-2.9664, 58.7374],
                            [-2.9864, 58.7474],
                            [-2.9925, 58.7588],
                            [-2.9814, 58.7615],
                            [-2.9792, 58.7699],
                            [-2.9831, 58.7846],
                            [-2.9936, 58.786],
                            [-3.0047, 58.7971],
                            [-3.0153, 58.7971],
                            [-3.0225, 58.8076],
                            [-3.0086, 58.8135],
                            [-2.9942, 58.8038],
                            [-2.9825, 58.806],
                            [-3.0081, 58.8254],
                            [-3.0247, 58.8168],
                            [-3.0347, 58.8232],
                            [-3.0164, 58.8329],
                            [-3.0025, 58.8304],
                            [-2.9625, 58.8368],
                            [-2.9353, 58.8343],
                            [-2.9108, 58.8379],
                            [-2.9186, 58.8435],
                            [-2.932, 58.8415],
                            [-2.963, 58.8479],
                            [-2.9642, 58.8526],
                            [-2.9397, 58.8615],
                            [-2.9142, 58.8532],
                            [-2.9175, 58.8712],
                            [-2.9253, 58.8782],
                            [-2.9064, 58.8804],
                            [-2.8969, 58.889],
                            [-2.8981, 58.8949],
                            [-2.9181, 58.8946],
                            [-2.932, 58.8901],
                            [-2.9336, 58.9026],
                            [-2.9508, 58.9149],
                            [-2.9747, 58.9449],
                            [-2.9708, 58.9613],
                            [-2.9814, 58.9624],
                            [-2.9964, 58.9504],
                            [-3.0081, 58.9446],
                            [-3.0414, 58.9371],
                            [-3.0675, 58.9354],
                            [-3.0858, 58.9276],
                            [-3.0981, 58.9318],
                            [-3.1136, 58.931],
                            [-3.1281, 58.926],
                            [-3.1175, 58.9196],
                            [-3.1414, 58.9162],
                            [-3.1903, 58.9176],
                            [-3.1986, 58.9115],
                            [-3.2225, 58.9246],
                            [-3.2369, 58.9415],
                            [-3.2342, 58.9549],
                            [-3.2386, 58.9696],
                            [-3.2503, 58.9721],
                            [-3.247, 58.9801],
                            [-3.2369, 58.9854],
                            [-3.2075, 58.9893],
                            [-3.2086, 58.9962],
                            [-3.2014, 59.011],
                            [-3.2147, 59.0124],
                            [-3.2203, 59.0174],
                            [-3.217, 59.0235],
                            [-3.2253, 59.0301],
                            [-3.232, 59.0424],
                            [-3.2253, 59.0429],
                            [-3.2308, 59.0551],
                            [-3.2408, 59.0535],
                            [-3.2419, 59.0465],
                            [-3.2653, 59.0496],
                            [-3.2775, 59.0451],
                            [-3.2625, 59.0404],
                            [-3.262, 59.0354],
                            [-3.2369, 59.0318],
                            [-3.2369, 59.0104],
                            [-3.2492, 59.006],
                            [-3.2686, 59.0149],
                            [-3.2953, 59.014],
                            [-3.2836, 59.0071],
                            [-3.2681, 59.0057],
                            [-3.2603, 58.9835],
                            [-3.2514, 58.9793],
                            [-3.2658, 58.9682],
                            [-3.2864, 58.9599],
                            [-3.3003, 58.9585],
                            [-3.2986, 58.9493],
                            [-3.3075, 58.949],
                            [-3.3319, 58.9546],
                            [-3.3353, 58.9599],
                            [-3.3586, 58.9651],
                            [-3.3531, 58.9726],
                            [-3.3597, 58.9762],
                            [-3.3631, 58.9937],
                            [-3.3686, 58.9982],
                            [-3.3603, 59.0093],
                            [-3.3653, 59.0126],
                            [-3.3619, 59.0304],
                            [-3.3508, 59.0379],
                            [-3.3592, 59.0463],
                            [-3.3531, 59.051],
                            [-3.3414, 59.0493],
                            [-3.3347, 59.0535],
                            [-3.3497, 59.0615],
                            [-3.3475, 59.0768],
                            [-3.3514, 59.0951],
                            [-3.358, 59.104],
                            [-3.3436, 59.1154],
                            [-3.3258, 59.1218],
                            [-3.3269, 59.1349],
                            [-3.3136, 59.1382],
                            [-3.2792, 59.1412],
                            [-3.2697, 59.1457],
                            [-3.2453, 59.1499],
                            [-3.2358, 59.1535],
                            [-3.1969, 59.1549]
                        ]
                    ],
                    [
                        [
                            [-0.9579, 60.3789],
                            [-0.9333, 60.3798],
                            [-0.9397, 60.3689],
                            [-0.9739, 60.34],
                            [-0.9842, 60.3397],
                            [-0.9932, 60.3315],
                            [-1.0161, 60.3271],
                            [-1.0397, 60.3331],
                            [-1.0438, 60.3429],
                            [-1.0284, 60.347],
                            [-1.0248, 60.3603],
                            [-1.0113, 60.3654],
                            [-0.9834, 60.369],
                            [-0.9774, 60.3802],
                            [-0.9692, 60.3834],
                            [-0.9579, 60.3789]
                        ]
                    ],
                    [
                        [
                            [-2.4192, 59.3132],
                            [-2.4214, 59.3021],
                            [-2.4164, 59.286],
                            [-2.3908, 59.2793],
                            [-2.4158, 59.2754],
                            [-2.4275, 59.2815],
                            [-2.4486, 59.2837],
                            [-2.4714, 59.2788],
                            [-2.4853, 59.2729],
                            [-2.4858, 59.2665],
                            [-2.5081, 59.2501],
                            [-2.5203, 59.2576],
                            [-2.5314, 59.2557],
                            [-2.5192, 59.2363],
                            [-2.5053, 59.2318],
                            [-2.5114, 59.2232],
                            [-2.5258, 59.234],
                            [-2.5375, 59.2335],
                            [-2.5481, 59.2382],
                            [-2.5675, 59.2374],
                            [-2.5664, 59.2204],
                            [-2.5819, 59.2257],
                            [-2.5819, 59.2354],
                            [-2.5958, 59.2299],
                            [-2.6131, 59.2385],
                            [-2.6364, 59.2349],
                            [-2.6419, 59.2201],
                            [-2.6658, 59.209],
                            [-2.6714, 59.2032],
                            [-2.6875, 59.2032],
                            [-2.6864, 59.1851],
                            [-2.6958, 59.1851],
                            [-2.702, 59.194],
                            [-2.7014, 59.2118],
                            [-2.6958, 59.2218],
                            [-2.6831, 59.2207],
                            [-2.6814, 59.2271],
                            [-2.6642, 59.2299],
                            [-2.662, 59.2399],
                            [-2.6525, 59.2424],
                            [-2.6297, 59.2546],
                            [-2.6008, 59.2607],
                            [-2.5936, 59.2687],
                            [-2.5992, 59.2754],
                            [-2.6153, 59.2821],
                            [-2.6008, 59.2937],
                            [-2.5786, 59.2949],
                            [-2.5653, 59.2987],
                            [-2.5608, 59.3049],
                            [-2.5253, 59.304],
                            [-2.5247, 59.2999],
                            [-2.5542, 59.2904],
                            [-2.5586, 59.2812],
                            [-2.5692, 59.2774],
                            [-2.5753, 59.2615],
                            [-2.5603, 59.2618],
                            [-2.5547, 59.2712],
                            [-2.5425, 59.2665],
                            [-2.5175, 59.2737],
                            [-2.4992, 59.2818],
                            [-2.4858, 59.2907],
                            [-2.4742, 59.2924],
                            [-2.4658, 59.2879],
                            [-2.4486, 59.2915],
                            [-2.448, 59.3046],
                            [-2.4286, 59.3132],
                            [-2.4192, 59.3132]
                        ]
                    ],
                    [
                        [
                            [-2.8764, 59.3874],
                            [-2.8675, 59.3765],
                            [-2.8719, 59.3649],
                            [-2.8808, 59.3657],
                            [-2.8875, 59.3571],
                            [-2.8808, 59.3385],
                            [-2.8819, 59.3254],
                            [-2.8964, 59.3301],
                            [-2.9114, 59.3293],
                            [-2.9092, 59.3407],
                            [-2.9125, 59.351],
                            [-2.8981, 59.3624],
                            [-2.8981, 59.3713],
                            [-2.8903, 59.384],
                            [-2.8764, 59.3874]
                        ]
                    ],
                    [
                        [
                            [-2.8019, 59.0876],
                            [-2.7992, 59.0701],
                            [-2.8164, 59.059],
                            [-2.8219, 59.0463],
                            [-2.8058, 59.036],
                            [-2.8064, 59.0279],
                            [-2.8358, 59.0176],
                            [-2.8353, 59.0246],
                            [-2.8508, 59.0249],
                            [-2.8581, 59.0307],
                            [-2.8814, 59.0329],
                            [-2.8919, 59.0307],
                            [-2.8997, 59.0351],
                            [-2.9108, 59.0288],
                            [-2.9364, 59.0307],
                            [-2.9247, 59.0507],
                            [-2.9147, 59.0537],
                            [-2.917, 59.0629],
                            [-2.9036, 59.0707],
                            [-2.8836, 59.0604],
                            [-2.8553, 59.0565],
                            [-2.8375, 59.0665],
                            [-2.8425, 59.0718],
                            [-2.8408, 59.0799],
                            [-2.8169, 59.0796],
                            [-2.8136, 59.0854],
                            [-2.8019, 59.0876]
                        ]
                    ],
                    [
                        [
                            [-1.0759, 60.7306],
                            [-1.0531, 60.7229],
                            [-1.0318, 60.7266],
                            [-1.0124, 60.7185],
                            [-1.0178, 60.7052],
                            [-1.0087, 60.6984],
                            [-1.004, 60.6815],
                            [-0.999, 60.677],
                            [-1.0051, 60.6676],
                            [-0.9971, 60.651],
                            [-1.0039, 60.648],
                            [-0.9948, 60.6356],
                            [-1.0418, 60.6426],
                            [-1.0487, 60.6546],
                            [-1.0577, 60.6521],
                            [-1.0558, 60.6427],
                            [-1.0397, 60.6284],
                            [-1.0275, 60.6265],
                            [-1.0245, 60.6159],
                            [-1.0365, 60.6016],
                            [-1.054, 60.6011],
                            [-1.0706, 60.6094],
                            [-1.0938, 60.603],
                            [-1.0687, 60.6003],
                            [-1.0556, 60.5963],
                            [-1.0359, 60.5965],
                            [-1.0317, 60.5907],
                            [-1.0207, 60.5892],
                            [-1.0205, 60.581],
                            [-1.0079, 60.5657],
                            [-1.0181, 60.5606],
                            [-1.0186, 60.5493],
                            [-1.0348, 60.5461],
                            [-1.0487, 60.5351],
                            [-1.0341, 60.5222],
                            [-1.0411, 60.4998],
                            [-1.0603, 60.4954],
                            [-1.0711, 60.4877],
                            [-1.1078, 60.5058],
                            [-1.1193, 60.51],
                            [-1.1272, 60.5017],
                            [-1.123, 60.4931],
                            [-1.105, 60.4886],
                            [-1.119, 60.483],
                            [-1.1343, 60.4869],
                            [-1.1602, 60.488],
                            [-1.179, 60.5103],
                            [-1.1852, 60.5328],
                            [-1.1985, 60.544],
                            [-1.1842, 60.5506],
                            [-1.1886, 60.5617],
                            [-1.2049, 60.5617],
                            [-1.2086, 60.568],
                            [-1.2032, 60.5766],
                            [-1.1911, 60.5801],
                            [-1.2083, 60.5943],
                            [-1.2026, 60.5986],
                            [-1.2089, 60.6052],
                            [-1.1935, 60.6207],
                            [-1.193, 60.6342],
                            [-1.1593, 60.6531],
                            [-1.16, 60.6235],
                            [-1.1487, 60.633],
                            [-1.151, 60.6428],
                            [-1.1434, 60.6491],
                            [-1.1449, 60.664],
                            [-1.1295, 60.6921],
                            [-1.1404, 60.6976],
                            [-1.1267, 60.7174],
                            [-1.1314, 60.7248],
                            [-1.1156, 60.7299],
                            [-1.0941, 60.7294],
                            [-1.0829, 60.7173],
                            [-1.0759, 60.7306]
                        ]
                    ],
                    [
                        [
                            [-3.0769, 59.2004],
                            [-3.0675, 59.1957],
                            [-3.048, 59.1949],
                            [-3.0475, 59.1846],
                            [-3.0392, 59.1793],
                            [-3.0136, 59.1776],
                            [-2.9958, 59.1787],
                            [-2.978, 59.1874],
                            [-2.9675, 59.1882],
                            [-2.953, 59.1765],
                            [-2.973, 59.1685],
                            [-2.9764, 59.1596],
                            [-2.9636, 59.141],
                            [-2.9647, 59.1346],
                            [-2.9969, 59.1268],
                            [-3.0408, 59.1262],
                            [-3.0597, 59.1343],
                            [-3.0769, 59.1374],
                            [-3.0931, 59.1457],
                            [-3.1008, 59.1571],
                            [-3.1158, 59.1621],
                            [-3.1192, 59.1746],
                            [-3.1058, 59.179],
                            [-3.1042, 59.1863],
                            [-3.0769, 59.2004]
                        ]
                    ],
                    [
                        [
                            [-2.9592, 59.3607],
                            [-2.9442, 59.3476],
                            [-2.958, 59.3468],
                            [-2.9508, 59.3393],
                            [-2.9586, 59.326],
                            [-2.9847, 59.3232],
                            [-2.9608, 59.3163],
                            [-2.9603, 59.3112],
                            [-2.9381, 59.3104],
                            [-2.9375, 59.3046],
                            [-2.9158, 59.2987],
                            [-2.9003, 59.3032],
                            [-2.8975, 59.2929],
                            [-2.8819, 59.2865],
                            [-2.8831, 59.2757],
                            [-2.8714, 59.271],
                            [-2.8542, 59.2685],
                            [-2.8364, 59.2476],
                            [-2.8592, 59.2513],
                            [-2.877, 59.2307],
                            [-2.8875, 59.2293],
                            [-2.8881, 59.2379],
                            [-2.8758, 59.256],
                            [-2.9058, 59.2682],
                            [-2.9108, 59.2749],
                            [-2.9275, 59.281],
                            [-2.9286, 59.2857],
                            [-2.947, 59.2854],
                            [-2.9642, 59.2893],
                            [-2.958, 59.2788],
                            [-2.9453, 59.2743],
                            [-2.9947, 59.264],
                            [-3.0086, 59.274],
                            [-3.027, 59.2776],
                            [-3.0203, 59.2851],
                            [-3.0253, 59.2935],
                            [-3.0214, 59.2996],
                            [-3.033, 59.311],
                            [-3.0414, 59.3115],
                            [-3.0608, 59.3187],
                            [-3.0725, 59.3329],
                            [-3.0325, 59.3244],
                            [-3.0242, 59.3299],
                            [-3.012, 59.3279],
                            [-2.9942, 59.3343],
                            [-2.9825, 59.3343],
                            [-2.9831, 59.3471],
                            [-2.978, 59.3535],
                            [-2.9592, 59.3607]
                        ]
                    ],
                    [
                        [
                            [-1.0815, 60.1733],
                            [-1.0888, 60.164],
                            [-1.0763, 60.1586],
                            [-1.0627, 60.1613],
                            [-1.0659, 60.1386],
                            [-1.0773, 60.1335],
                            [-1.0816, 60.1254],
                            [-1.0822, 60.1116],
                            [-1.0996, 60.1081],
                            [-1.1255, 60.1156],
                            [-1.1345, 60.1221],
                            [-1.1232, 60.1517],
                            [-1.1327, 60.1641],
                            [-1.1501, 60.1729],
                            [-1.1552, 60.1818],
                            [-1.138, 60.1824],
                            [-1.1288, 60.1787],
                            [-1.0952, 60.1755],
                            [-1.0983, 60.1861],
                            [-1.0923, 60.1899],
                            [-1.0815, 60.1733]
                        ]
                    ],
                    [
                        [
                            [-6.8875, 58.2718],
                            [-6.8703, 58.2662],
                            [-6.8547, 58.2665],
                            [-6.8531, 58.259],
                            [-6.8408, 58.254],
                            [-6.8425, 58.2399],
                            [-6.8219, 58.2393],
                            [-6.7969, 58.2246],
                            [-6.7858, 58.2232],
                            [-6.7814, 58.214],
                            [-6.7831, 58.2004],
                            [-6.8008, 58.2063],
                            [-6.8119, 58.2071],
                            [-6.8347, 58.2043],
                            [-6.8636, 58.206],
                            [-6.8725, 58.2121],
                            [-6.8653, 58.2188],
                            [-6.8664, 58.2268],
                            [-6.8769, 58.2293],
                            [-6.8931, 58.2521],
                            [-6.8925, 58.2612],
                            [-6.8831, 58.2618],
                            [-6.8875, 58.2718]
                        ]
                    ],
                    [
                        [
                            [-1.3333, 60.0592],
                            [-1.346, 60.0666],
                            [-1.3558, 60.0581],
                            [-1.3659, 60.068],
                            [-1.3505, 60.0805],
                            [-1.3528, 60.0848],
                            [-1.3359, 60.0939],
                            [-1.3476, 60.0969],
                            [-1.3458, 60.1065],
                            [-1.3191, 60.1047],
                            [-1.3241, 60.0951],
                            [-1.305, 60.0921],
                            [-1.3233, 60.0669],
                            [-1.3333, 60.0592]
                        ]
                    ],
                    [
                        [
                            [-3.3436, 58.9338],
                            [-3.3258, 58.9288],
                            [-3.3258, 58.919],
                            [-3.3103, 58.9151],
                            [-3.3175, 58.9099],
                            [-3.2853, 58.906],
                            [-3.2436, 58.8907],
                            [-3.2347, 58.8887],
                            [-3.2119, 58.8776],
                            [-3.2153, 58.8624],
                            [-3.2131, 58.8579],
                            [-3.1997, 58.8554],
                            [-3.1947, 58.8393],
                            [-3.1892, 58.8346],
                            [-3.2003, 58.8299],
                            [-3.1708, 58.824],
                            [-3.1836, 58.8138],
                            [-3.1969, 58.8124],
                            [-3.2247, 58.8015],
                            [-3.2458, 58.8007],
                            [-3.2536, 58.7901],
                            [-3.2364, 58.784],
                            [-3.2264, 58.786],
                            [-3.2108, 58.8007],
                            [-3.1953, 58.799],
                            [-3.1808, 58.8032],
                            [-3.1614, 58.8013],
                            [-3.1492, 58.8071],
                            [-3.1375, 58.8024],
                            [-3.147, 58.7899],
                            [-3.1403, 58.7832],
                            [-3.1825, 58.7771],
                            [-3.2197, 58.7768],
                            [-3.2269, 58.7718],
                            [-3.2414, 58.7735],
                            [-3.2564, 58.7807],
                            [-3.2919, 58.7757],
                            [-3.3097, 58.7896],
                            [-3.3231, 58.7974],
                            [-3.3236, 58.804],
                            [-3.3542, 58.8296],
                            [-3.3703, 58.8362],
                            [-3.3764, 58.8437],
                            [-3.3792, 58.8565],
                            [-3.3769, 58.864],
                            [-3.3881, 58.8701],
                            [-3.4058, 58.8688],
                            [-3.4175, 58.8718],
                            [-3.4336, 58.8707],
                            [-3.4364, 58.8793],
                            [-3.4253, 58.8893],
                            [-3.4231, 58.9032],
                            [-3.4175, 58.9107],
                            [-3.3964, 58.924],
                            [-3.3792, 58.9238],
                            [-3.3658, 58.9307],
                            [-3.3436, 58.9338]
                        ]
                    ],
                    [
                        [
                            [-0.8735, 60.5669],
                            [-0.9009, 60.5613],
                            [-0.9064, 60.5693],
                            [-0.9207, 60.5739],
                            [-0.9217, 60.5868],
                            [-0.9316, 60.5921],
                            [-0.9394, 60.6023],
                            [-0.9458, 60.6029],
                            [-0.9518, 60.6198],
                            [-0.9431, 60.6228],
                            [-0.9441, 60.63],
                            [-0.9261, 60.6255],
                            [-0.8878, 60.619],
                            [-0.8826, 60.6304],
                            [-0.8724, 60.6317],
                            [-0.8551, 60.6278],
                            [-0.8413, 60.6288],
                            [-0.8263, 60.6212],
                            [-0.8331, 60.6057],
                            [-0.8172, 60.5999],
                            [-0.8043, 60.6009],
                            [-0.7978, 60.6116],
                            [-0.772, 60.6044],
                            [-0.7725, 60.5934],
                            [-0.7954, 60.5805],
                            [-0.8001, 60.5731],
                            [-0.8218, 60.5745],
                            [-0.8348, 60.5785],
                            [-0.8359, 60.5853],
                            [-0.8632, 60.5868],
                            [-0.8962, 60.5915],
                            [-0.8992, 60.5832],
                            [-0.884, 60.5802],
                            [-0.8727, 60.573],
                            [-0.8735, 60.5669]
                        ]
                    ],
                    [
                        [
                            [-2.6308, 59.1612],
                            [-2.6164, 59.1554],
                            [-2.6269, 59.1518],
                            [-2.6247, 59.1432],
                            [-2.6125, 59.1451],
                            [-2.6036, 59.1412],
                            [-2.5758, 59.1437],
                            [-2.5719, 59.1387],
                            [-2.6019, 59.136],
                            [-2.6086, 59.1282],
                            [-2.5947, 59.1151],
                            [-2.5658, 59.1201],
                            [-2.5419, 59.1215],
                            [-2.5392, 59.1168],
                            [-2.5508, 59.1118],
                            [-2.5419, 59.0963],
                            [-2.5264, 59.0943],
                            [-2.5308, 59.0874],
                            [-2.5408, 59.0824],
                            [-2.5642, 59.0824],
                            [-2.5758, 59.0762],
                            [-2.5969, 59.0818],
                            [-2.5981, 59.071],
                            [-2.6114, 59.076],
                            [-2.6042, 59.0807],
                            [-2.6069, 59.0974],
                            [-2.6186, 59.0993],
                            [-2.6336, 59.1071],
                            [-2.6586, 59.1015],
                            [-2.6425, 59.0901],
                            [-2.6486, 59.0813],
                            [-2.6453, 59.0749],
                            [-2.6886, 59.0762],
                            [-2.6886, 59.0865],
                            [-2.6792, 59.0965],
                            [-2.6714, 59.0988],
                            [-2.672, 59.1079],
                            [-2.6519, 59.1126],
                            [-2.6281, 59.1107],
                            [-2.6219, 59.1246],
                            [-2.6392, 59.131],
                            [-2.6519, 59.1421],
                            [-2.6658, 59.1499],
                            [-2.6531, 59.1518],
                            [-2.6308, 59.1612]
                        ]
                    ],
                    [
                        [
                            [-3.0697, 58.8496],
                            [-3.0647, 58.8437],
                            [-3.0819, 58.8435],
                            [-3.1064, 58.8365],
                            [-3.1086, 58.8304],
                            [-3.0942, 58.8296],
                            [-3.0831, 58.8257],
                            [-3.0775, 58.8149],
                            [-3.1053, 58.8143],
                            [-3.1381, 58.8157],
                            [-3.1481, 58.8276],
                            [-3.1447, 58.8332],
                            [-3.1308, 58.836],
                            [-3.1203, 58.8435],
                            [-3.0914, 58.8457],
                            [-3.0697, 58.8496]
                        ]
                    ],
                    [
                        [
                            [-0.8827, 60.8053],
                            [-0.873, 60.8057],
                            [-0.8607, 60.8149],
                            [-0.8561, 60.8368],
                            [-0.8124, 60.8304],
                            [-0.7974, 60.8265],
                            [-0.7776, 60.8301],
                            [-0.7806, 60.8183],
                            [-0.8063, 60.8081],
                            [-0.7944, 60.8048],
                            [-0.7815, 60.7966],
                            [-0.789, 60.7837],
                            [-0.8012, 60.7823],
                            [-0.8263, 60.7874],
                            [-0.8243, 60.7727],
                            [-0.8085, 60.7629],
                            [-0.8084, 60.7574],
                            [-0.8693, 60.759],
                            [-0.8677, 60.7543],
                            [-0.8437, 60.7524],
                            [-0.8247, 60.7531],
                            [-0.8184, 60.7499],
                            [-0.8203, 60.7387],
                            [-0.842, 60.7294],
                            [-0.8456, 60.7227],
                            [-0.8615, 60.723],
                            [-0.8742, 60.7043],
                            [-0.8717, 60.6994],
                            [-0.8563, 60.6972],
                            [-0.8436, 60.6916],
                            [-0.8602, 60.6744],
                            [-0.9107, 60.6825],
                            [-0.9153, 60.6904],
                            [-0.9304, 60.6867],
                            [-0.9356, 60.6792],
                            [-0.9499, 60.6743],
                            [-0.9707, 60.6776],
                            [-0.971, 60.6855],
                            [-0.9855, 60.684],
                            [-0.9849, 60.6958],
                            [-0.9781, 60.7081],
                            [-0.9825, 60.7204],
                            [-0.9604, 60.7149],
                            [-0.9703, 60.7374],
                            [-0.9671, 60.7428],
                            [-0.9473, 60.7483],
                            [-0.9516, 60.761],
                            [-0.944, 60.7615],
                            [-0.9379, 60.7763],
                            [-0.9468, 60.7861],
                            [-0.9592, 60.7926],
                            [-0.9327, 60.8081],
                            [-0.944, 60.8121],
                            [-0.9019, 60.8273],
                            [-0.8989, 60.841],
                            [-0.8782, 60.8444],
                            [-0.874, 60.8275],
                            [-0.8858, 60.8088],
                            [-0.8827, 60.8053]
                        ]
                    ],
                    [
                        [
                            [-1.3028, 60.1012],
                            [-1.3152, 60.1007],
                            [-1.3049, 60.1138],
                            [-1.3063, 60.1236],
                            [-1.2887, 60.13],
                            [-1.2832, 60.1278],
                            [-1.2936, 60.1168],
                            [-1.2909, 60.107],
                            [-1.3028, 60.1012]
                        ]
                    ],
                    [
                        [
                            [-2.7592, 59.2515],
                            [-2.7542, 59.244],
                            [-2.7625, 59.2376],
                            [-2.733, 59.2238],
                            [-2.7353, 59.2146],
                            [-2.7475, 59.2074],
                            [-2.747, 59.2004],
                            [-2.7592, 59.1879],
                            [-2.7547, 59.1813],
                            [-2.7542, 59.1576],
                            [-2.7458, 59.1579],
                            [-2.7364, 59.1515],
                            [-2.7381, 59.1432],
                            [-2.7719, 59.1443],
                            [-2.7914, 59.1371],
                            [-2.7958, 59.1599],
                            [-2.8119, 59.169],
                            [-2.8286, 59.174],
                            [-2.8286, 59.1921],
                            [-2.8197, 59.1882],
                            [-2.7947, 59.184],
                            [-2.7803, 59.1899],
                            [-2.7775, 59.2068],
                            [-2.7919, 59.2135],
                            [-2.7847, 59.2285],
                            [-2.7925, 59.2324],
                            [-2.7875, 59.2407],
                            [-2.7703, 59.2451],
                            [-2.7592, 59.2515]
                        ]
                    ],
                    [
                        [
                            [-1.39, 60.3969],
                            [-1.3674, 60.3992],
                            [-1.3506, 60.408],
                            [-1.3564, 60.414],
                            [-1.3507, 60.4264],
                            [-1.3397, 60.4356],
                            [-1.3275, 60.4359],
                            [-1.3185, 60.4404],
                            [-1.2843, 60.447],
                            [-1.2809, 60.4593],
                            [-1.2947, 60.4561],
                            [-1.3095, 60.4589],
                            [-1.3108, 60.4691],
                            [-1.2957, 60.4754],
                            [-1.3015, 60.4824],
                            [-1.287, 60.4883],
                            [-1.2808, 60.4849],
                            [-1.2756, 60.4719],
                            [-1.2444, 60.4911],
                            [-1.2372, 60.4939],
                            [-1.2211, 60.4888],
                            [-1.2113, 60.481],
                            [-1.2108, 60.4736],
                            [-1.2192, 60.4562],
                            [-1.1921, 60.464],
                            [-1.1832, 60.4584],
                            [-1.1845, 60.4511],
                            [-1.2212, 60.4421],
                            [-1.2095, 60.4405],
                            [-1.1863, 60.4459],
                            [-1.1751, 60.4422],
                            [-1.1758, 60.4369],
                            [-1.1953, 60.4335],
                            [-1.2276, 60.4173],
                            [-1.2231, 60.4148],
                            [-1.2021, 60.4168],
                            [-1.1984, 60.4128],
                            [-1.229, 60.3999],
                            [-1.1763, 60.4118],
                            [-1.1701, 60.3866],
                            [-1.1588, 60.3955],
                            [-1.138, 60.4041],
                            [-1.1382, 60.4137],
                            [-1.1208, 60.4297],
                            [-1.1198, 60.4165],
                            [-1.1092, 60.4177],
                            [-1.1032, 60.4312],
                            [-1.0758, 60.4457],
                            [-1.0617, 60.4502],
                            [-1.0549, 60.4475],
                            [-1.0551, 60.439],
                            [-1.0695, 60.4276],
                            [-1.0916, 60.4173],
                            [-1.0949, 60.4097],
                            [-1.1209, 60.4004],
                            [-1.1301, 60.3991],
                            [-1.1496, 60.3836],
                            [-1.1365, 60.3803],
                            [-1.1247, 60.3828],
                            [-1.1136, 60.3921],
                            [-1.0983, 60.3861],
                            [-1.0837, 60.3735],
                            [-1.0851, 60.3564],
                            [-1.1046, 60.3546],
                            [-1.1189, 60.3474],
                            [-1.1753, 60.3524],
                            [-1.1825, 60.3458],
                            [-1.1798, 60.3397],
                            [-1.1829, 60.3288],
                            [-1.1712, 60.3272],
                            [-1.16, 60.3351],
                            [-1.151, 60.326],
                            [-1.1399, 60.3204],
                            [-1.1047, 60.3198],
                            [-1.1019, 60.3103],
                            [-1.0924, 60.3019],
                            [-1.1209, 60.3008],
                            [-1.1371, 60.2956],
                            [-1.1568, 60.285],
                            [-1.1608, 60.2723],
                            [-1.1294, 60.2699],
                            [-1.1275, 60.2756],
                            [-1.1065, 60.2688],
                            [-1.1057, 60.2643],
                            [-1.1173, 60.2565],
                            [-1.1323, 60.2616],
                            [-1.1527, 60.2598],
                            [-1.163, 60.244],
                            [-1.1912, 60.2401],
                            [-1.1909, 60.2452],
                            [-1.1751, 60.259],
                            [-1.2008, 60.258],
                            [-1.215, 60.2605],
                            [-1.2167, 60.2516],
                            [-1.2078, 60.2501],
                            [-1.2172, 60.2361],
                            [-1.2306, 60.236],
                            [-1.2296, 60.2285],
                            [-1.2104, 60.2318],
                            [-1.211, 60.2196],
                            [-1.2358, 60.1986],
                            [-1.2093, 60.2054],
                            [-1.205, 60.2114],
                            [-1.1883, 60.2231],
                            [-1.1804, 60.216],
                            [-1.192, 60.2099],
                            [-1.1961, 60.1984],
                            [-1.2092, 60.1825],
                            [-1.1681, 60.2013],
                            [-1.1703, 60.1883],
                            [-1.1567, 60.1891],
                            [-1.1742, 60.1706],
                            [-1.1573, 60.1626],
                            [-1.1449, 60.1531],
                            [-1.1507, 60.1478],
                            [-1.1665, 60.1506],
                            [-1.1632, 60.1276],
                            [-1.1861, 60.1361],
                            [-1.1974, 60.1273],
                            [-1.2117, 60.1277],
                            [-1.2063, 60.1193],
                            [-1.2106, 60.1089],
                            [-1.2329, 60.0987],
                            [-1.2241, 60.095],
                            [-1.217, 60.0818],
                            [-1.2203, 60.076],
                            [-1.2188, 60.063],
                            [-1.2057, 60.0578],
                            [-1.2107, 60.0464],
                            [-1.1825, 60.0433],
                            [-1.1847, 60.036],
                            [-1.2162, 60.0351],
                            [-1.2391, 60.0316],
                            [-1.2402, 60.0192],
                            [-1.2322, 60.0083],
                            [-1.2058, 59.9899],
                            [-1.2042, 59.9715],
                            [-1.2191, 59.9746],
                            [-1.2303, 59.9824],
                            [-1.2474, 59.9829],
                            [-1.2514, 59.9929],
                            [-1.2713, 59.989],
                            [-1.2686, 59.9787],
                            [-1.2525, 59.9762],
                            [-1.2581, 59.9624],
                            [-1.2536, 59.9571],
                            [-1.2636, 59.9504],
                            [-1.2581, 59.9443],
                            [-1.2586, 59.9343],
                            [-1.2725, 59.919],
                            [-1.2836, 59.9146],
                            [-1.272, 59.9101],
                            [-1.2692, 59.889],
                            [-1.2831, 59.8829],
                            [-1.2692, 59.8696],
                            [-1.2692, 59.8576],
                            [-1.278, 59.8576],
                            [-1.293, 59.8687],
                            [-1.3008, 59.8701],
                            [-1.3092, 59.8612],
                            [-1.317, 59.8701],
                            [-1.3075, 59.8818],
                            [-1.318, 59.8899],
                            [-1.3197, 59.8976],
                            [-1.3369, 59.899],
                            [-1.3458, 59.8949],
                            [-1.3797, 59.8874],
                            [-1.3864, 59.8915],
                            [-1.3858, 59.9015],
                            [-1.3919, 59.9154],
                            [-1.3681, 59.9174],
                            [-1.3714, 59.9313],
                            [-1.3647, 59.9401],
                            [-1.3658, 59.9468],
                            [-1.3486, 59.9443],
                            [-1.3303, 59.9482],
                            [-1.3392, 59.9532],
                            [-1.3392, 59.9638],
                            [-1.3625, 59.9685],
                            [-1.3553, 59.9768],
                            [-1.3392, 59.9746],
                            [-1.3504, 59.9878],
                            [-1.3509, 60.0043],
                            [-1.3394, 60.0041],
                            [-1.329, 60.0093],
                            [-1.3321, 60.0157],
                            [-1.3228, 60.0241],
                            [-1.3151, 60.0371],
                            [-1.3122, 60.0516],
                            [-1.288, 60.0957],
                            [-1.2831, 60.0987],
                            [-1.2833, 60.1135],
                            [-1.2742, 60.1286],
                            [-1.2763, 60.1355],
                            [-1.292, 60.1355],
                            [-1.3137, 60.1312],
                            [-1.3072, 60.1414],
                            [-1.2978, 60.1441],
                            [-1.3102, 60.1538],
                            [-1.3101, 60.1617],
                            [-1.2935, 60.1817],
                            [-1.3033, 60.1932],
                            [-1.3206, 60.163],
                            [-1.3367, 60.163],
                            [-1.3252, 60.2005],
                            [-1.3149, 60.2105],
                            [-1.3157, 60.2269],
                            [-1.3084, 60.241],
                            [-1.3012, 60.246],
                            [-1.3017, 60.2557],
                            [-1.3248, 60.2314],
                            [-1.3207, 60.223],
                            [-1.3441, 60.2046],
                            [-1.3572, 60.201],
                            [-1.3576, 60.2157],
                            [-1.3703, 60.2329],
                            [-1.3627, 60.2396],
                            [-1.3665, 60.2449],
                            [-1.3923, 60.2494],
                            [-1.3988, 60.2454],
                            [-1.4204, 60.248],
                            [-1.4134, 60.2404],
                            [-1.3988, 60.2336],
                            [-1.3873, 60.2334],
                            [-1.3844, 60.2198],
                            [-1.3695, 60.2144],
                            [-1.4011, 60.1979],
                            [-1.4099, 60.1978],
                            [-1.4169, 60.1875],
                            [-1.4083, 60.1808],
                            [-1.4291, 60.1673],
                            [-1.4473, 60.1743],
                            [-1.4614, 60.173],
                            [-1.457, 60.1603],
                            [-1.4679, 60.1473],
                            [-1.4762, 60.1552],
                            [-1.4915, 60.1609],
                            [-1.499, 60.1565],
                            [-1.5203, 60.1639],
                            [-1.5144, 60.1738],
                            [-1.5377, 60.1809],
                            [-1.5463, 60.1777],
                            [-1.5559, 60.1904],
                            [-1.5444, 60.202],
                            [-1.5271, 60.207],
                            [-1.5185, 60.2061],
                            [-1.4839, 60.2156],
                            [-1.5133, 60.2148],
                            [-1.5148, 60.2241],
                            [-1.5264, 60.228],
                            [-1.5325, 60.2177],
                            [-1.5505, 60.21],
                            [-1.5652, 60.1963],
                            [-1.563, 60.2179],
                            [-1.5765, 60.2156],
                            [-1.5983, 60.2231],
                            [-1.6058, 60.2128],
                            [-1.6319, 60.2079],
                            [-1.6348, 60.2134],
                            [-1.6571, 60.219],
                            [-1.6515, 60.2293],
                            [-1.6674, 60.2265],
                            [-1.6901, 60.2367],
                            [-1.7026, 60.2388],
                            [-1.7014, 60.2524],
                            [-1.7115, 60.2568],
                            [-1.697, 60.2697],
                            [-1.689, 60.2808],
                            [-1.7065, 60.2831],
                            [-1.7073, 60.2921],
                            [-1.6908, 60.3035],
                            [-1.6834, 60.3015],
                            [-1.6689, 60.3062],
                            [-1.6417, 60.3054],
                            [-1.6125, 60.3077],
                            [-1.5772, 60.2934],
                            [-1.5592, 60.2959],
                            [-1.5583, 60.3071],
                            [-1.5461, 60.306],
                            [-1.5376, 60.3126],
                            [-1.5153, 60.3188],
                            [-1.5056, 60.3124],
                            [-1.5014, 60.3004],
                            [-1.4918, 60.2879],
                            [-1.4858, 60.2898],
                            [-1.4915, 60.3052],
                            [-1.4706, 60.3033],
                            [-1.4653, 60.3143],
                            [-1.4466, 60.3206],
                            [-1.4353, 60.3195],
                            [-1.4259, 60.3121],
                            [-1.4167, 60.3159],
                            [-1.3982, 60.3132],
                            [-1.3902, 60.298],
                            [-1.3915, 60.2846],
                            [-1.3785, 60.2846],
                            [-1.3727, 60.3016],
                            [-1.3761, 60.3168],
                            [-1.3811, 60.3209],
                            [-1.3762, 60.3341],
                            [-1.3596, 60.3415],
                            [-1.3484, 60.3339],
                            [-1.3414, 60.3536],
                            [-1.303, 60.3587],
                            [-1.2943, 60.364],
                            [-1.3081, 60.3687],
                            [-1.3376, 60.3676],
                            [-1.3477, 60.3646],
                            [-1.3706, 60.3696],
                            [-1.354, 60.379],
                            [-1.36, 60.3911],
                            [-1.3743, 60.3876],
                            [-1.3879, 60.3755],
                            [-1.3909, 60.3567],
                            [-1.4163, 60.3471],
                            [-1.4318, 60.3482],
                            [-1.4519, 60.3459],
                            [-1.4708, 60.3546],
                            [-1.4753, 60.3712],
                            [-1.4569, 60.3863],
                            [-1.4338, 60.3894],
                            [-1.431, 60.3839],
                            [-1.4152, 60.3856],
                            [-1.4092, 60.3935],
                            [-1.39, 60.3969]
                        ]
                    ],
                    [
                        [
                            [-1.186, 60.0001],
                            [-1.1564, 59.9987],
                            [-1.1581, 59.9929],
                            [-1.1703, 59.9893],
                            [-1.1952, 59.992],
                            [-1.186, 60.0001]
                        ]
                    ],
                    [
                        [
                            [-2.9303, 59.1712],
                            [-2.9175, 59.1699],
                            [-2.9081, 59.1629],
                            [-2.9164, 59.1315],
                            [-2.9219, 59.124],
                            [-2.9369, 59.1365],
                            [-2.9425, 59.1496],
                            [-2.9414, 59.1662],
                            [-2.9303, 59.1712]
                        ]
                    ],
                    [
                        [
                            [-1.39, 60.3969],
                            [-1.4104, 60.3961],
                            [-1.4232, 60.4012],
                            [-1.4124, 60.4115],
                            [-1.4151, 60.416],
                            [-1.4343, 60.4134],
                            [-1.4608, 60.4175],
                            [-1.4625, 60.4363],
                            [-1.4527, 60.4382],
                            [-1.4543, 60.4461],
                            [-1.4705, 60.454],
                            [-1.4709, 60.47],
                            [-1.4616, 60.4878],
                            [-1.4946, 60.4731],
                            [-1.4893, 60.4669],
                            [-1.5052, 60.4569],
                            [-1.5149, 60.4653],
                            [-1.5034, 60.4827],
                            [-1.5307, 60.4775],
                            [-1.5405, 60.4795],
                            [-1.5578, 60.4887],
                            [-1.5647, 60.4878],
                            [-1.5778, 60.4776],
                            [-1.5938, 60.4811],
                            [-1.6045, 60.4771],
                            [-1.6136, 60.4801],
                            [-1.6388, 60.4818],
                            [-1.6386, 60.4868],
                            [-1.618, 60.5073],
                            [-1.5813, 60.5069],
                            [-1.5699, 60.5238],
                            [-1.5748, 60.5271],
                            [-1.5665, 60.543],
                            [-1.537, 60.5552],
                            [-1.5226, 60.5426],
                            [-1.5288, 60.5381],
                            [-1.5242, 60.5319],
                            [-1.4545, 60.5044],
                            [-1.4455, 60.5069],
                            [-1.4132, 60.5076],
                            [-1.4135, 60.5122],
                            [-1.4621, 60.5101],
                            [-1.4876, 60.5286],
                            [-1.4997, 60.5328],
                            [-1.5046, 60.5398],
                            [-1.4951, 60.5464],
                            [-1.4765, 60.5519],
                            [-1.4805, 60.5571],
                            [-1.4597, 60.564],
                            [-1.4493, 60.5703],
                            [-1.4411, 60.5696],
                            [-1.4418, 60.5814],
                            [-1.4478, 60.5827],
                            [-1.4482, 60.5931],
                            [-1.4279, 60.6005],
                            [-1.4252, 60.6154],
                            [-1.407, 60.6109],
                            [-1.3939, 60.611],
                            [-1.3765, 60.6054],
                            [-1.3446, 60.6043],
                            [-1.3559, 60.6151],
                            [-1.3446, 60.6255],
                            [-1.3308, 60.6222],
                            [-1.3182, 60.6259],
                            [-1.307, 60.6104],
                            [-1.3128, 60.5978],
                            [-1.3076, 60.5961],
                            [-1.3268, 60.5843],
                            [-1.3392, 60.5832],
                            [-1.3352, 60.5762],
                            [-1.3211, 60.5724],
                            [-1.3199, 60.562],
                            [-1.3227, 60.5425],
                            [-1.3301, 60.5351],
                            [-1.3588, 60.5379],
                            [-1.3618, 60.5293],
                            [-1.3407, 60.5279],
                            [-1.3307, 60.5086],
                            [-1.3384, 60.5001],
                            [-1.3166, 60.4964],
                            [-1.3195, 60.4905],
                            [-1.3117, 60.4859],
                            [-1.3314, 60.4805],
                            [-1.3327, 60.4694],
                            [-1.3406, 60.4611],
                            [-1.3295, 60.4508],
                            [-1.3495, 60.4453],
                            [-1.3626, 60.4391],
                            [-1.3643, 60.4318],
                            [-1.3726, 60.4265],
                            [-1.3663, 60.4194],
                            [-1.3683, 60.4112],
                            [-1.3798, 60.4098],
                            [-1.3784, 60.4035],
                            [-1.39, 60.3969]
                        ]
                    ],
                    [
                        [
                            [-2.0303, 55.8044],
                            [-2.0803, 55.7944],
                            [-2.0885, 55.7585],
                            [-2.1167, 55.7419],
                            [-2.1383, 55.7366],
                            [-2.1725, 55.7192],
                            [-2.1772, 55.7025],
                            [-2.1942, 55.6936],
                            [-2.22, 55.665],
                            [-2.2386, 55.6519],
                            [-2.3309, 55.6406],
                            [-2.3258, 55.6222],
                            [-2.2994, 55.6139],
                            [-2.3014, 55.6047],
                            [-2.2783, 55.5897],
                            [-2.2578, 55.5495],
                            [-2.2169, 55.5094],
                            [-2.2139, 55.4903],
                            [-2.1867, 55.4694],
                            [-2.1825, 55.4589],
                            [-2.2161, 55.4253],
                            [-2.2733, 55.4197],
                            [-2.2942, 55.4031],
                            [-2.3308, 55.3983],
                            [-2.3417, 55.3853],
                            [-2.3497, 55.3647],
                            [-2.385, 55.3442],
                            [-2.4022, 55.3614],
                            [-2.4278, 55.3669],
                            [-2.4631, 55.3611],
                            [-2.4967, 55.345],
                            [-2.5228, 55.3256],
                            [-2.5522, 55.3155],
                            [-2.57, 55.2922],
                            [-2.6283, 55.2655],
                            [-2.6306, 55.255],
                            [-2.6183, 55.2442],
                            [-2.6261, 55.2233],
                            [-2.6597, 55.2164],
                            [-2.6856, 55.1913],
                            [-2.6995, 55.1772],
                            [-2.7461, 55.1542],
                            [-2.7711, 55.1461],
                            [-2.82, 55.1397],
                            [-2.8356, 55.12],
                            [-2.8697, 55.1025],
                            [-2.8842, 55.0814],
                            [-2.9283, 55.0714],
                            [-2.9505, 55.0405],
                            [-2.9778, 55.04],
                            [-3.015, 55.0522],
                            [-3.0333, 55.0525],
                            [-3.0308, 55.0167],
                            [-3.0455, 55.0017],
                            [-3.0497, 54.9851],
                            [-3.0642, 54.9862],
                            [-3.0753, 54.9804],
                            [-3.0931, 54.9754],
                            [-3.1069, 54.9782],
                            [-3.1175, 54.9765],
                            [-3.1269, 54.9704],
                            [-3.1497, 54.9629],
                            [-3.1642, 54.9685],
                            [-3.1886, 54.9735],
                            [-3.2097, 54.976],
                            [-3.2347, 54.9715],
                            [-3.2403, 54.9687],
                            [-3.2553, 54.9721],
                            [-3.2714, 54.9651],
                            [-3.2964, 54.969],
                            [-3.3114, 54.9751],
                            [-3.3303, 54.9779],
                            [-3.3442, 54.9732],
                            [-3.3547, 54.9743],
                            [-3.3681, 54.9704],
                            [-3.3886, 54.9721],
                            [-3.4064, 54.976],
                            [-3.4286, 54.9865],
                            [-3.4408, 54.9846],
                            [-3.4514, 54.9751],
                            [-3.4636, 54.9701],
                            [-3.4803, 54.9674],
                            [-3.5058, 54.9687],
                            [-3.5281, 54.9674],
                            [-3.5558, 54.9782],
                            [-3.5603, 54.9854],
                            [-3.578, 54.9951],
                            [-3.5753, 54.9799],
                            [-3.5847, 54.9746],
                            [-3.5775, 54.9629],
                            [-3.5775, 54.9535],
                            [-3.5858, 54.9415],
                            [-3.5853, 54.9271],
                            [-3.5725, 54.924],
                            [-3.5708, 54.916],
                            [-3.5625, 54.9043],
                            [-3.5753, 54.8918],
                            [-3.5942, 54.8851],
                            [-3.5942, 54.8715],
                            [-3.6392, 54.8782],
                            [-3.6964, 54.8796],
                            [-3.7031, 54.884],
                            [-3.7169, 54.8796],
                            [-3.7397, 54.8685],
                            [-3.7408, 54.864],
                            [-3.7608, 54.8571],
                            [-3.7886, 54.8529],
                            [-3.7947, 54.8635],
                            [-3.8125, 54.8715],
                            [-3.8231, 54.8665],
                            [-3.8247, 54.861],
                            [-3.8058, 54.8485],
                            [-3.8147, 54.8435],
                            [-3.8236, 54.8465],
                            [-3.8369, 54.8607],
                            [-3.8464, 54.8585],
                            [-3.8358, 54.8476],
                            [-3.8536, 54.8493],
                            [-3.8603, 54.8446],
                            [-3.8414, 54.834],
                            [-3.8353, 54.8271],
                            [-3.8247, 54.8237],
                            [-3.8392, 54.8151],
                            [-3.8597, 54.8138],
                            [-3.8686, 54.8051],
                            [-3.9036, 54.7965],
                            [-3.9064, 54.7937],
                            [-3.9392, 54.7871],
                            [-3.9569, 54.7785],
                            [-3.9631, 54.7715],
                            [-3.9797, 54.7685],
                            [-3.9936, 54.7687],
                            [-4.0053, 54.7721],
                            [-4.0164, 54.7699],
                            [-4.0292, 54.7724],
                            [-4.0464, 54.7696],
                            [-4.0658, 54.7807],
                            [-4.0642, 54.794],
                            [-4.0481, 54.8138],
                            [-4.072, 54.8115],
                            [-4.0725, 54.8193],
                            [-4.0619, 54.826],
                            [-4.0714, 54.8299],
                            [-4.0831, 54.8171],
                            [-4.0897, 54.8135],
                            [-4.0875, 54.8049],
                            [-4.0908, 54.7924],
                            [-4.0897, 54.7704],
                            [-4.0958, 54.7654],
                            [-4.1103, 54.7699],
                            [-4.1103, 54.7749],
                            [-4.1231, 54.7771],
                            [-4.1425, 54.7757],
                            [-4.1597, 54.779],
                            [-4.1636, 54.7874],
                            [-4.1786, 54.7918],
                            [-4.1869, 54.8035],
                            [-4.2097, 54.8132],
                            [-4.2092, 54.8196],
                            [-4.2192, 54.8246],
                            [-4.2169, 54.8335],
                            [-4.2242, 54.8412],
                            [-4.2214, 54.8515],
                            [-4.2119, 54.8568],
                            [-4.2081, 54.8638],
                            [-4.2247, 54.8646],
                            [-4.2303, 54.8549],
                            [-4.2547, 54.844],
                            [-4.2558, 54.8365],
                            [-4.2664, 54.8351],
                            [-4.2753, 54.8396],
                            [-4.3214, 54.8487],
                            [-4.3631, 54.8629],
                            [-4.3742, 54.8771],
                            [-4.3819, 54.8796],
                            [-4.3853, 54.8935],
                            [-4.397, 54.8999],
                            [-4.4008, 54.8904],
                            [-4.4158, 54.8865],
                            [-4.4225, 54.8818],
                            [-4.4236, 54.8682],
                            [-4.4197, 54.864],
                            [-4.4203, 54.8521],
                            [-4.4103, 54.8279],
                            [-4.3897, 54.821],
                            [-4.3758, 54.8199],
                            [-4.3497, 54.811],
                            [-4.3403, 54.7979],
                            [-4.3442, 54.7896],
                            [-4.3664, 54.7949],
                            [-4.3586, 54.7776],
                            [-4.3675, 54.7701],
                            [-4.3547, 54.7671],
                            [-4.3553, 54.7571],
                            [-4.3653, 54.7407],
                            [-4.3664, 54.7282],
                            [-4.3625, 54.7179],
                            [-4.3519, 54.7177],
                            [-4.3508, 54.7051],
                            [-4.3664, 54.6996],
                            [-4.3642, 54.691],
                            [-4.3797, 54.6818],
                            [-4.3947, 54.6771],
                            [-4.4075, 54.6776],
                            [-4.4442, 54.6924],
                            [-4.4814, 54.6985],
                            [-4.5208, 54.7132],
                            [-4.5297, 54.7212],
                            [-4.5442, 54.7257],
                            [-4.5447, 54.7324],
                            [-4.5542, 54.736],
                            [-4.5714, 54.7374],
                            [-4.5853, 54.7593],
                            [-4.5858, 54.7657],
                            [-4.6019, 54.7765],
                            [-4.6247, 54.7812],
                            [-4.6486, 54.7918],
                            [-4.6697, 54.7985],
                            [-4.6825, 54.8054],
                            [-4.7086, 54.8237],
                            [-4.7164, 54.8257],
                            [-4.7453, 54.8274],
                            [-4.7631, 54.8268],
                            [-4.7881, 54.8357],
                            [-4.7936, 54.8457],
                            [-4.8031, 54.8499],
                            [-4.8092, 54.8604],
                            [-4.8153, 54.8626],
                            [-4.8364, 54.8635],
                            [-4.8503, 54.8665],
                            [-4.8503, 54.8576],
                            [-4.8847, 54.8496],
                            [-4.9214, 54.8349],
                            [-4.9358, 54.8318],
                            [-4.9525, 54.8157],
                            [-4.9608, 54.8029],
                            [-4.9519, 54.799],
                            [-4.9369, 54.7746],
                            [-4.9392, 54.7637],
                            [-4.9331, 54.7632],
                            [-4.9264, 54.751],
                            [-4.9186, 54.7449],
                            [-4.9075, 54.7149],
                            [-4.9036, 54.7107],
                            [-4.9064, 54.7015],
                            [-4.8964, 54.6924],
                            [-4.8864, 54.6921],
                            [-4.883, 54.6865],
                            [-4.8658, 54.6818],
                            [-4.8814, 54.6685],
                            [-4.8781, 54.664],
                            [-4.8836, 54.6532],
                            [-4.8764, 54.6396],
                            [-4.8564, 54.639],
                            [-4.8569, 54.6335],
                            [-4.8786, 54.6335],
                            [-4.8853, 54.6374],
                            [-4.9086, 54.6424],
                            [-4.9219, 54.6426],
                            [-4.9564, 54.6618],
                            [-4.963, 54.6632],
                            [-4.9725, 54.6896],
                            [-4.9481, 54.701],
                            [-4.9603, 54.7079],
                            [-4.9669, 54.7177],
                            [-4.9558, 54.7276],
                            [-4.9925, 54.7346],
                            [-4.9875, 54.7502],
                            [-5.0036, 54.7535],
                            [-5.0069, 54.7624],
                            [-4.9992, 54.7693],
                            [-5.0319, 54.7899],
                            [-5.0436, 54.7918],
                            [-5.0408, 54.7996],
                            [-5.0531, 54.8085],
                            [-5.077, 54.8149],
                            [-5.0886, 54.8276],
                            [-5.1058, 54.8296],
                            [-5.1181, 54.8412],
                            [-5.1253, 54.8426],
                            [-5.1308, 54.8501],
                            [-5.1397, 54.8504],
                            [-5.1486, 54.8596],
                            [-5.1458, 54.8676],
                            [-5.1642, 54.8938],
                            [-5.1808, 54.9071],
                            [-5.1853, 54.9132],
                            [-5.1875, 54.9257],
                            [-5.1881, 54.9507],
                            [-5.1792, 54.9662],
                            [-5.1875, 54.9765],
                            [-5.1786, 54.9904],
                            [-5.162, 55.0071],
                            [-5.1419, 55.0071],
                            [-5.1236, 55.0121],
                            [-5.113, 55.0174],
                            [-5.0964, 55.0182],
                            [-5.0914, 55.014],
                            [-5.0858, 55.001],
                            [-5.0753, 54.9962],
                            [-5.0697, 54.9851],
                            [-5.0708, 54.9796],
                            [-5.0633, 54.9679],
                            [-5.0725, 54.9643],
                            [-5.0736, 54.9587],
                            [-5.0642, 54.9276],
                            [-5.0325, 54.9082],
                            [-5.0242, 54.9099],
                            [-5.0125, 54.9068],
                            [-4.9958, 54.9129],
                            [-4.9914, 54.9179],
                            [-4.997, 54.9379],
                            [-5.0019, 54.9393],
                            [-5.0192, 54.9699],
                            [-5.0319, 54.9757],
                            [-5.0369, 54.9835],
                            [-5.0392, 54.996],
                            [-5.0558, 55.0126],
                            [-5.0614, 55.0279],
                            [-5.0536, 55.0424],
                            [-5.0536, 55.0501],
                            [-5.0358, 55.0704],
                            [-5.0281, 55.0815],
                            [-5.0147, 55.0879],
                            [-5.0097, 55.1035],
                            [-5.0025, 55.1085],
                            [-4.9953, 55.129],
                            [-4.9936, 55.1434],
                            [-4.9503, 55.1629],
                            [-4.9431, 55.1643],
                            [-4.9331, 55.1726],
                            [-4.9269, 55.1846],
                            [-4.9114, 55.1988],
                            [-4.8936, 55.2104],
                            [-4.8725, 55.2179],
                            [-4.8614, 55.2265],
                            [-4.8608, 55.2526],
                            [-4.8547, 55.2551],
                            [-4.8469, 55.2729],
                            [-4.8381, 55.2768],
                            [-4.8375, 55.2951],
                            [-4.8403, 55.3035],
                            [-4.8375, 55.3112],
                            [-4.8464, 55.3246],
                            [-4.8414, 55.3299],
                            [-4.8092, 55.341],
                            [-4.8097, 55.3482],
                            [-4.7731, 55.3618],
                            [-4.7692, 55.3729],
                            [-4.7736, 55.3885],
                            [-4.7714, 55.4007],
                            [-4.7614, 55.406],
                            [-4.757, 55.4135],
                            [-4.7469, 55.421],
                            [-4.7225, 55.4274],
                            [-4.7147, 55.4335],
                            [-4.7019, 55.4351],
                            [-4.6925, 55.4329],
                            [-4.6786, 55.4379],
                            [-4.657, 55.4396],
                            [-4.6503, 55.4429],
                            [-4.642, 55.4568],
                            [-4.6408, 55.4679],
                            [-4.6281, 55.4782],
                            [-4.6281, 55.4907],
                            [-4.6192, 55.4918],
                            [-4.6236, 55.5096],
                            [-4.6325, 55.519],
                            [-4.6497, 55.5276],
                            [-4.6581, 55.5401],
                            [-4.6719, 55.5396],
                            [-4.6864, 55.5451],
                            [-4.6836, 55.5501],
                            [-4.6697, 55.5457],
                            [-4.6592, 55.5479],
                            [-4.6564, 55.554],
                            [-4.6575, 55.5768],
                            [-4.6681, 55.5871],
                            [-4.6947, 55.606],
                            [-4.7303, 55.6204],
                            [-4.7458, 55.6249],
                            [-4.7525, 55.631],
                            [-4.7614, 55.6301],
                            [-4.7781, 55.6335],
                            [-4.7964, 55.6304],
                            [-4.7969, 55.6376],
                            [-4.8053, 55.6401],
                            [-4.8181, 55.6354],
                            [-4.8236, 55.6413],
                            [-4.8136, 55.646],
                            [-4.8247, 55.6526],
                            [-4.8308, 55.6604],
                            [-4.8503, 55.6712],
                            [-4.862, 55.6749],
                            [-4.8664, 55.686],
                            [-4.887, 55.6946],
                            [-4.902, 55.6951],
                            [-4.9053, 55.6993],
                            [-4.9042, 55.731],
                            [-4.8864, 55.7276],
                            [-4.8758, 55.7346],
                            [-4.868, 55.7446],
                            [-4.8592, 55.746],
                            [-4.8564, 55.7585],
                            [-4.862, 55.7724],
                            [-4.8586, 55.7774],
                            [-4.8647, 55.7865],
                            [-4.8731, 55.7915],
                            [-4.8903, 55.8229],
                            [-4.8931, 55.8396],
                            [-4.8897, 55.8471],
                            [-4.892, 55.8687],
                            [-4.8897, 55.8796],
                            [-4.8997, 55.891],
                            [-4.8964, 55.8968],
                            [-4.8836, 55.9018],
                            [-4.8781, 55.9087],
                            [-4.8836, 55.9157],
                            [-4.8758, 55.9204],
                            [-4.8814, 55.9321],
                            [-4.8797, 55.9426],
                            [-4.8547, 55.9507],
                            [-4.8325, 55.9554],
                            [-4.8164, 55.9632],
                            [-4.8125, 55.9579],
                            [-4.7908, 55.9638],
                            [-4.7619, 55.9571],
                            [-4.7542, 55.951],
                            [-4.7392, 55.9454],
                            [-4.7247, 55.9471],
                            [-4.7136, 55.9426],
                            [-4.6692, 55.9332],
                            [-4.6492, 55.9338],
                            [-4.642, 55.9318],
                            [-4.6214, 55.9321],
                            [-4.5792, 55.924],
                            [-4.5492, 55.9243],
                            [-4.5303, 55.9226],
                            [-4.5158, 55.926],
                            [-4.5164, 55.931],
                            [-4.5414, 55.9324],
                            [-4.5647, 55.9385],
                            [-4.5764, 55.9376],
                            [-4.6353, 55.9513],
                            [-4.6531, 55.9593],
                            [-4.6697, 55.9576],
                            [-4.6836, 55.9696],
                            [-4.7019, 55.9665],
                            [-4.7036, 55.9746],
                            [-4.6908, 55.9735],
                            [-4.7019, 55.9918],
                            [-4.7103, 55.9924],
                            [-4.7236, 56.0001],
                            [-4.7536, 56.0043],
                            [-4.7664, 56.0115],
                            [-4.7853, 56.0149],
                            [-4.7886, 56.0257],
                            [-4.7992, 56.0329],
                            [-4.807, 56.0435],
                            [-4.8208, 56.0515],
                            [-4.8214, 56.0621],
                            [-4.828, 56.0696],
                            [-4.8286, 56.0782],
                            [-4.8364, 56.0785],
                            [-4.8414, 56.0585],
                            [-4.8247, 56.0326],
                            [-4.8058, 56.0135],
                            [-4.7958, 56.0135],
                            [-4.7908, 56.0026],
                            [-4.7758, 56.0029],
                            [-4.7664, 55.9976],
                            [-4.7675, 55.9874],
                            [-4.7808, 55.9876],
                            [-4.8058, 55.9821],
                            [-4.8186, 55.9843],
                            [-4.8369, 55.9829],
                            [-4.853, 55.9893],
                            [-4.8542, 56.0026],
                            [-4.8669, 56.0115],
                            [-4.8692, 56.039],
                            [-4.8825, 56.0515],
                            [-4.8758, 56.0665],
                            [-4.8703, 56.0699],
                            [-4.8519, 56.0982],
                            [-4.8469, 56.101],
                            [-4.8386, 56.1165],
                            [-4.8225, 56.1218],
                            [-4.813, 56.141],
                            [-4.7975, 56.1579],
                            [-4.7853, 56.1682],
                            [-4.7825, 56.1749],
                            [-4.7603, 56.1962],
                            [-4.7769, 56.1918],
                            [-4.7847, 56.1854],
                            [-4.7986, 56.1679],
                            [-4.8158, 56.1535],
                            [-4.8242, 56.1429],
                            [-4.828, 56.1265],
                            [-4.8381, 56.1232],
                            [-4.8519, 56.1135],
                            [-4.8608, 56.0996],
                            [-4.8836, 56.104],
                            [-4.8925, 56.1254],
                            [-4.8842, 56.136],
                            [-4.8875, 56.1504],
                            [-4.8969, 56.1576],
                            [-4.9008, 56.1693],
                            [-4.9158, 56.1665],
                            [-4.9119, 56.1571],
                            [-4.9003, 56.1477],
                            [-4.9014, 56.1329],
                            [-4.9058, 56.131],
                            [-4.9108, 56.1176],
                            [-4.9086, 56.1112],
                            [-4.8992, 56.104],
                            [-4.877, 56.0949],
                            [-4.8736, 56.0868],
                            [-4.8953, 56.0601],
                            [-4.9108, 56.0507],
                            [-4.9025, 56.0243],
                            [-4.902, 56.0104],
                            [-4.8936, 55.9907],
                            [-4.9036, 55.9829],
                            [-4.9464, 55.9954],
                            [-4.9603, 55.9904],
                            [-4.9525, 55.984],
                            [-4.9292, 55.9813],
                            [-4.9136, 55.976],
                            [-4.9075, 55.9696],
                            [-4.9086, 55.9596],
                            [-4.9308, 55.944],
                            [-4.9375, 55.926],
                            [-4.9469, 55.9118],
                            [-4.9492, 55.8979],
                            [-4.9692, 55.8835],
                            [-4.9747, 55.8751],
                            [-4.9792, 55.8604],
                            [-4.9864, 55.8626],
                            [-5.0158, 55.8654],
                            [-5.027, 55.8685],
                            [-5.0381, 55.8671],
                            [-5.0458, 55.8718],
                            [-5.0425, 55.8821],
                            [-5.0481, 55.8949],
                            [-5.0492, 55.9051],
                            [-5.0569, 55.9207],
                            [-5.0558, 55.9276],
                            [-5.0669, 55.9446],
                            [-5.0686, 55.9518],
                            [-5.0819, 55.9607],
                            [-5.0958, 55.9638],
                            [-5.1058, 55.9724],
                            [-5.1119, 55.9879],
                            [-5.1219, 55.9996],
                            [-5.128, 55.9946],
                            [-5.1192, 55.9815],
                            [-5.1175, 55.9718],
                            [-5.1031, 55.9587],
                            [-5.0947, 55.9551],
                            [-5.0825, 55.9382],
                            [-5.0731, 55.9024],
                            [-5.0786, 55.8971],
                            [-5.1008, 55.8982],
                            [-5.1142, 55.9029],
                            [-5.1436, 55.9204],
                            [-5.1508, 55.9215],
                            [-5.1775, 55.9365],
                            [-5.1897, 55.9487],
                            [-5.1864, 55.9551],
                            [-5.1842, 55.9726],
                            [-5.1925, 55.9796],
                            [-5.1981, 55.9674],
                            [-5.1969, 55.9571],
                            [-5.2019, 55.9418],
                            [-5.1942, 55.9371],
                            [-5.2058, 55.9206],
                            [-5.2164, 55.916],
                            [-5.2264, 55.9076],
                            [-5.2392, 55.9026],
                            [-5.2408, 55.8929],
                            [-5.2131, 55.8599],
                            [-5.2069, 55.8574],
                            [-5.2075, 55.8432],
                            [-5.1997, 55.8318],
                            [-5.2158, 55.826],
                            [-5.2258, 55.8376],
                            [-5.2486, 55.8401],
                            [-5.2564, 55.8512],
                            [-5.2675, 55.8476],
                            [-5.2897, 55.8493],
                            [-5.2942, 55.8568],
                            [-5.3047, 55.8512],
                            [-5.3175, 55.8568],
                            [-5.3164, 55.8701],
                            [-5.327, 55.8843],
                            [-5.3442, 55.8862],
                            [-5.3519, 55.8971],
                            [-5.3519, 55.9085],
                            [-5.3436, 55.9185],
                            [-5.3492, 55.9268],
                            [-5.3431, 55.9315],
                            [-5.3436, 55.9399],
                            [-5.3303, 55.9582],
                            [-5.3419, 55.9626],
                            [-5.3481, 55.9729],
                            [-5.3408, 55.9857],
                            [-5.3414, 55.9968],
                            [-5.3336, 56.0038],
                            [-5.3147, 56.0118],
                            [-5.303, 56.0223],
                            [-5.3025, 56.0276],
                            [-5.2931, 56.0388],
                            [-5.2914, 56.0473],
                            [-5.2831, 56.0557],
                            [-5.2708, 56.0618],
                            [-5.2658, 56.0707],
                            [-5.2447, 56.081],
                            [-5.2336, 56.0904],
                            [-5.2192, 56.096],
                            [-5.2097, 56.1107],
                            [-5.2086, 56.1215],
                            [-5.2031, 56.1287],
                            [-5.1836, 56.1354],
                            [-5.1669, 56.1382],
                            [-5.1508, 56.1382],
                            [-5.0992, 56.1568],
                            [-5.0803, 56.1682],
                            [-5.0847, 56.176],
                            [-5.0714, 56.1968],
                            [-5.0614, 56.2076],
                            [-5.033, 56.2232],
                            [-4.9842, 56.2354],
                            [-4.9697, 56.2443],
                            [-4.9586, 56.2474],
                            [-4.9458, 56.256],
                            [-4.9364, 56.2582],
                            [-4.9258, 56.2665],
                            [-4.9314, 56.269],
                            [-4.9469, 56.259],
                            [-4.9725, 56.2526],
                            [-4.9892, 56.2449],
                            [-5.0475, 56.234],
                            [-5.0464, 56.2457],
                            [-5.0542, 56.2462],
                            [-5.0725, 56.2343],
                            [-5.0781, 56.2224],
                            [-5.0892, 56.2182],
                            [-5.0981, 56.2051],
                            [-5.1047, 56.2021],
                            [-5.1081, 56.1796],
                            [-5.1164, 56.1712],
                            [-5.1403, 56.1582],
                            [-5.1625, 56.1562],
                            [-5.1736, 56.1507],
                            [-5.1936, 56.1493],
                            [-5.2358, 56.129],
                            [-5.2542, 56.1135],
                            [-5.2564, 56.0971],
                            [-5.2831, 56.089],
                            [-5.2908, 56.081],
                            [-5.2975, 56.0649],
                            [-5.3158, 56.0579],
                            [-5.3242, 56.0604],
                            [-5.3236, 56.0676],
                            [-5.3347, 56.0671],
                            [-5.3381, 56.0532],
                            [-5.3375, 56.031],
                            [-5.3442, 56.0223],
                            [-5.3647, 56.0223],
                            [-5.3664, 56.0151],
                            [-5.3814, 56.0043],
                            [-5.4081, 56.006],
                            [-5.4231, 56.009],
                            [-5.4297, 56.016],
                            [-5.4314, 56.0349],
                            [-5.4419, 56.0337],
                            [-5.4503, 56.0062],
                            [-5.4464, 56.0001],
                            [-5.4442, 55.981],
                            [-5.4497, 55.9715],
                            [-5.4442, 55.9596],
                            [-5.4336, 55.9546],
                            [-5.4286, 55.9474],
                            [-5.4219, 55.9154],
                            [-5.4192, 55.9124],
                            [-5.4186, 55.8962],
                            [-5.4031, 55.8887],
                            [-5.4058, 55.8804],
                            [-5.3997, 55.8751],
                            [-5.4014, 55.8665],
                            [-5.3847, 55.8629],
                            [-5.377, 55.8524],
                            [-5.3697, 55.851],
                            [-5.3558, 55.8349],
                            [-5.3403, 55.8276],
                            [-5.3319, 55.8196],
                            [-5.3331, 55.8143],
                            [-5.3192, 55.799],
                            [-5.3142, 55.784],
                            [-5.3192, 55.769],
                            [-5.3264, 55.7643],
                            [-5.3508, 55.7651],
                            [-5.3642, 55.7571],
                            [-5.3942, 55.7501],
                            [-5.4075, 55.7413],
                            [-5.4092, 55.7363],
                            [-5.4214, 55.7321],
                            [-5.4492, 55.7054],
                            [-5.4458, 55.7012],
                            [-5.4492, 55.6863],
                            [-5.4564, 55.6782],
                            [-5.4675, 55.6557],
                            [-5.468, 55.6507],
                            [-5.4831, 55.6435],
                            [-5.4775, 55.6379],
                            [-5.4753, 55.6229],
                            [-5.4781, 55.6193],
                            [-5.4753, 55.6046],
                            [-5.4675, 55.5937],
                            [-5.4597, 55.5918],
                            [-5.4603, 55.5746],
                            [-5.472, 55.5818],
                            [-5.4864, 55.5787],
                            [-5.4914, 55.5712],
                            [-5.4892, 55.5646],
                            [-5.4931, 55.5435],
                            [-5.4897, 55.5287],
                            [-5.5014, 55.5276],
                            [-5.5025, 55.516],
                            [-5.5131, 55.4971],
                            [-5.5092, 55.4896],
                            [-5.5219, 55.4829],
                            [-5.5225, 55.4776],
                            [-5.5425, 55.4693],
                            [-5.5397, 55.461],
                            [-5.5475, 55.4432],
                            [-5.5686, 55.4271],
                            [-5.582, 55.424],
                            [-5.5997, 55.4282],
                            [-5.5992, 55.4218],
                            [-5.5792, 55.414],
                            [-5.5619, 55.4185],
                            [-5.5486, 55.4179],
                            [-5.5447, 55.4071],
                            [-5.5258, 55.3926],
                            [-5.5153, 55.3699],
                            [-5.5192, 55.3604],
                            [-5.5386, 55.346],
                            [-5.5503, 55.3346],
                            [-5.5586, 55.3312],
                            [-5.5619, 55.3229],
                            [-5.5786, 55.3193],
                            [-5.6014, 55.3077],
                            [-5.6208, 55.3062],
                            [-5.6536, 55.3101],
                            [-5.6703, 55.3068],
                            [-5.6836, 55.3082],
                            [-5.7103, 55.2987],
                            [-5.7225, 55.2921],
                            [-5.7625, 55.289],
                            [-5.7981, 55.2982],
                            [-5.8042, 55.3129],
                            [-5.7986, 55.321],
                            [-5.8014, 55.3287],
                            [-5.7969, 55.3376],
                            [-5.8047, 55.3488],
                            [-5.8008, 55.3554],
                            [-5.7986, 55.3754],
                            [-5.7953, 55.3818],
                            [-5.7981, 55.3918],
                            [-5.7758, 55.4043],
                            [-5.7736, 55.4079],
                            [-5.7553, 55.4143],
                            [-5.7547, 55.4232],
                            [-5.7292, 55.4243],
                            [-5.7208, 55.4307],
                            [-5.7147, 55.4504],
                            [-5.7125, 55.4738],
                            [-5.7136, 55.4896],
                            [-5.7114, 55.4976],
                            [-5.7142, 55.5118],
                            [-5.7119, 55.5268],
                            [-5.7053, 55.529],
                            [-5.7031, 55.5432],
                            [-5.7053, 55.5521],
                            [-5.7164, 55.5679],
                            [-5.717, 55.5776],
                            [-5.6958, 55.5862],
                            [-5.6869, 55.5971],
                            [-5.683, 55.6124],
                            [-5.6742, 55.6312],
                            [-5.6725, 55.6454],
                            [-5.6636, 55.6679],
                            [-5.6736, 55.6785],
                            [-5.6692, 55.684],
                            [-5.6392, 55.696],
                            [-5.6325, 55.7001],
                            [-5.6058, 55.7265],
                            [-5.5992, 55.7376],
                            [-5.588, 55.7476],
                            [-5.5714, 55.7665],
                            [-5.5536, 55.7674],
                            [-5.5458, 55.7726],
                            [-5.5175, 55.7843],
                            [-5.5103, 55.7943],
                            [-5.5008, 55.7954],
                            [-5.4792, 55.804],
                            [-5.4725, 55.8193],
                            [-5.4658, 55.8274],
                            [-5.447, 55.8415],
                            [-5.4508, 55.8471],
                            [-5.4658, 55.8349],
                            [-5.4753, 55.8349],
                            [-5.4775, 55.8265],
                            [-5.4875, 55.8182],
                            [-5.4964, 55.8171],
                            [-5.5147, 55.8029],
                            [-5.5214, 55.7954],
                            [-5.5375, 55.7868],
                            [-5.5681, 55.7757],
                            [-5.5803, 55.7735],
                            [-5.5914, 55.7663],
                            [-5.6153, 55.7599],
                            [-5.6169, 55.771],
                            [-5.6092, 55.7738],
                            [-5.6214, 55.7804],
                            [-5.6081, 55.789],
                            [-5.6108, 55.7938],
                            [-5.6264, 55.7879],
                            [-5.6397, 55.7865],
                            [-5.6664, 55.8001],
                            [-5.6719, 55.8151],
                            [-5.6653, 55.8251],
                            [-5.6631, 55.8476],
                            [-5.6553, 55.8546],
                            [-5.6525, 55.8635],
                            [-5.6275, 55.8824],
                            [-5.6203, 55.8927],
                            [-5.6225, 55.8974],
                            [-5.6042, 55.9157],
                            [-5.5869, 55.919],
                            [-5.5842, 55.9262],
                            [-5.5753, 55.9318],
                            [-5.5836, 55.9374],
                            [-5.5953, 55.9301],
                            [-5.6086, 55.929],
                            [-5.6225, 55.9182],
                            [-5.6308, 55.9151],
                            [-5.6481, 55.9032],
                            [-5.6569, 55.9029],
                            [-5.6742, 55.8879],
                            [-5.6825, 55.886],
                            [-5.6869, 55.899],
                            [-5.6819, 55.909],
                            [-5.6886, 55.9104],
                            [-5.6819, 55.9257],
                            [-5.6736, 55.9351],
                            [-5.6664, 55.9485],
                            [-5.6386, 55.9665],
                            [-5.6347, 55.9732],
                            [-5.6214, 55.9821],
                            [-5.6158, 55.9924],
                            [-5.5997, 56.0071],
                            [-5.5853, 56.0101],
                            [-5.5719, 56.0168],
                            [-5.5719, 56.0251],
                            [-5.5931, 56.014],
                            [-5.5914, 56.0229],
                            [-5.5725, 56.0337],
                            [-5.5936, 56.031],
                            [-5.5947, 56.0265],
                            [-5.6169, 56.0235],
                            [-5.6108, 56.0176],
                            [-5.6292, 56.0029],
                            [-5.6364, 55.9907],
                            [-5.6558, 55.9904],
                            [-5.6647, 55.9821],
                            [-5.6503, 55.9796],
                            [-5.6653, 55.9665],
                            [-5.6814, 55.9554],
                            [-5.6747, 55.9504],
                            [-5.6875, 55.9354],
                            [-5.7031, 55.9318],
                            [-5.7053, 55.9426],
                            [-5.698, 55.9551],
                            [-5.7081, 55.9657],
                            [-5.6969, 55.9765],
                            [-5.6842, 55.9851],
                            [-5.6858, 55.9907],
                            [-5.6658, 56.0118],
                            [-5.6581, 56.0154],
                            [-5.6564, 56.026],
                            [-5.6436, 56.0293],
                            [-5.6375, 56.0388],
                            [-5.6442, 56.0424],
                            [-5.6331, 56.0524],
                            [-5.6158, 56.0601],
                            [-5.6086, 56.071],
                            [-5.5847, 56.0921],
                            [-5.5664, 56.0876],
                            [-5.5592, 56.0921],
                            [-5.5492, 56.0888],
                            [-5.5503, 56.0807],
                            [-5.5308, 56.0765],
                            [-5.5408, 56.0879],
                            [-5.5303, 56.0963],
                            [-5.533, 56.1018],
                            [-5.5525, 56.1021],
                            [-5.5686, 56.1143],
                            [-5.5564, 56.1318],
                            [-5.5314, 56.1579],
                            [-5.5181, 56.1696],
                            [-5.5203, 56.1746],
                            [-5.5136, 56.1807],
                            [-5.5019, 56.1846],
                            [-5.5147, 56.1907],
                            [-5.5447, 56.176],
                            [-5.548, 56.1707],
                            [-5.5792, 56.156],
                            [-5.5808, 56.146],
                            [-5.5919, 56.1374],
                            [-5.6064, 56.1301],
                            [-5.6147, 56.1315],
                            [-5.6042, 56.1432],
                            [-5.5931, 56.1485],
                            [-5.6003, 56.1557],
                            [-5.5836, 56.1807],
                            [-5.5764, 56.1826],
                            [-5.5714, 56.1946],
                            [-5.5636, 56.1993],
                            [-5.5564, 56.2146],
                            [-5.5464, 56.2193],
                            [-5.5486, 56.2307],
                            [-5.5675, 56.2368],
                            [-5.5447, 56.239],
                            [-5.5364, 56.2446],
                            [-5.5108, 56.2471],
                            [-5.5103, 56.2526],
                            [-5.4981, 56.2574],
                            [-5.4969, 56.269],
                            [-5.5058, 56.2696],
                            [-5.5125, 56.2618],
                            [-5.5242, 56.2624],
                            [-5.5364, 56.2576],
                            [-5.5614, 56.2604],
                            [-5.5853, 56.2485],
                            [-5.5964, 56.249],
                            [-5.5992, 56.256],
                            [-5.5953, 56.2649],
                            [-5.5803, 56.2849],
                            [-5.5919, 56.2838],
                            [-5.588, 56.2988],
                            [-5.6017, 56.2998],
                            [-5.5986, 56.2796],
                            [-5.6114, 56.2768],
                            [-5.612, 56.2715],
                            [-5.6214, 56.2651],
                            [-5.6331, 56.2693],
                            [-5.6369, 56.2751],
                            [-5.6364, 56.2874],
                            [-5.6503, 56.2982],
                            [-5.6458, 56.3063],
                            [-5.6208, 56.3213],
                            [-5.6125, 56.3188],
                            [-5.5958, 56.324],
                            [-5.5719, 56.3357],
                            [-5.5586, 56.346],
                            [-5.5308, 56.3479],
                            [-5.5136, 56.3429],
                            [-5.4964, 56.3526],
                            [-5.4731, 56.3529],
                            [-5.4453, 56.3621],
                            [-5.4486, 56.3676],
                            [-5.4675, 56.3624],
                            [-5.4808, 56.3549],
                            [-5.4981, 56.3579],
                            [-5.5069, 56.3551],
                            [-5.5153, 56.3468],
                            [-5.5353, 56.3538],
                            [-5.5386, 56.3613],
                            [-5.5342, 56.3721],
                            [-5.5247, 56.3782],
                            [-5.5242, 56.3863],
                            [-5.5064, 56.3987],
                            [-5.5036, 56.4032],
                            [-5.4753, 56.4174],
                            [-5.4864, 56.4279],
                            [-5.4781, 56.4357],
                            [-5.4692, 56.4376],
                            [-5.4631, 56.4474],
                            [-5.4453, 56.4543],
                            [-5.4386, 56.4507],
                            [-5.4153, 56.451],
                            [-5.3886, 56.4557],
                            [-5.3753, 56.454],
                            [-5.3486, 56.4599],
                            [-5.327, 56.4504],
                            [-5.2992, 56.4557],
                            [-5.2825, 56.4504],
                            [-5.2664, 56.4579],
                            [-5.2519, 56.4443],
                            [-5.2403, 56.4371],
                            [-5.2258, 56.4451],
                            [-5.1897, 56.4487],
                            [-5.1714, 56.4571],
                            [-5.1581, 56.471],
                            [-5.1419, 56.4785],
                            [-5.1442, 56.4824],
                            [-5.1192, 56.4976],
                            [-5.0986, 56.5199],
                            [-5.0958, 56.5312],
                            [-5.0836, 56.5382],
                            [-5.0758, 56.5518],
                            [-5.0669, 56.5582],
                            [-5.0764, 56.5607],
                            [-5.0886, 56.5451],
                            [-5.1042, 56.529],
                            [-5.1075, 56.5218],
                            [-5.1325, 56.504],
                            [-5.1542, 56.501],
                            [-5.1636, 56.4837],
                            [-5.1736, 56.4807],
                            [-5.1747, 56.4715],
                            [-5.1814, 56.4687],
                            [-5.1853, 56.4599],
                            [-5.2097, 56.4529],
                            [-5.2303, 56.4507],
                            [-5.2442, 56.454],
                            [-5.2553, 56.4626],
                            [-5.2764, 56.464],
                            [-5.2825, 56.4604],
                            [-5.3203, 56.4635],
                            [-5.3392, 56.4707],
                            [-5.3619, 56.4701],
                            [-5.3608, 56.4615],
                            [-5.3758, 56.4576],
                            [-5.4008, 56.4571],
                            [-5.4003, 56.4701],
                            [-5.4064, 56.4851],
                            [-5.4125, 56.4915],
                            [-5.4269, 56.4962],
                            [-5.4336, 56.4943],
                            [-5.447, 56.4793],
                            [-5.4742, 56.4818],
                            [-5.4625, 56.4935],
                            [-5.453, 56.4962],
                            [-5.4514, 56.5065],
                            [-5.4369, 56.5201],
                            [-5.4286, 56.5179],
                            [-5.4219, 56.5257],
                            [-5.4125, 56.526],
                            [-5.4019, 56.516],
                            [-5.3814, 56.5101],
                            [-5.3642, 56.5168],
                            [-5.3492, 56.5201],
                            [-5.3331, 56.5207],
                            [-5.3264, 56.5265],
                            [-5.3136, 56.529],
                            [-5.3047, 56.5401],
                            [-5.2936, 56.5463],
                            [-5.2736, 56.5438],
                            [-5.2514, 56.5479],
                            [-5.2503, 56.5579],
                            [-5.2892, 56.5474],
                            [-5.3036, 56.5507],
                            [-5.3236, 56.5468],
                            [-5.3342, 56.5376],
                            [-5.3647, 56.524],
                            [-5.3869, 56.5271],
                            [-5.3986, 56.5438],
                            [-5.4158, 56.5532],
                            [-5.4069, 56.5557],
                            [-5.4025, 56.564],
                            [-5.3764, 56.5654],
                            [-5.3825, 56.5754],
                            [-5.3742, 56.5901],
                            [-5.3658, 56.5951],
                            [-5.3636, 56.6021],
                            [-5.3381, 56.616],
                            [-5.318, 56.624],
                            [-5.3169, 56.6282],
                            [-5.3003, 56.6368],
                            [-5.2997, 56.6457],
                            [-5.3131, 56.6474],
                            [-5.3203, 56.6521],
                            [-5.3008, 56.6618],
                            [-5.2758, 56.6704],
                            [-5.2536, 56.6701],
                            [-5.2269, 56.6849],
                            [-5.1969, 56.686],
                            [-5.1858, 56.6885],
                            [-5.147, 56.6771],
                            [-5.1325, 56.6821],
                            [-5.1164, 56.6801],
                            [-5.1069, 56.691],
                            [-5.0886, 56.6946],
                            [-5.0969, 56.7001],
                            [-5.1086, 56.6954],
                            [-5.1236, 56.6949],
                            [-5.1475, 56.6868],
                            [-5.1658, 56.691],
                            [-5.1853, 56.6901],
                            [-5.1847, 56.699],
                            [-5.2081, 56.7018],
                            [-5.2231, 56.701],
                            [-5.2475, 56.7032],
                            [-5.2392, 56.711],
                            [-5.2408, 56.7168],
                            [-5.2303, 56.7286],
                            [-5.2086, 56.7399],
                            [-5.1908, 56.7568],
                            [-5.1731, 56.7693],
                            [-5.1636, 56.7821],
                            [-5.1425, 56.7951],
                            [-5.1247, 56.8115],
                            [-5.1103, 56.819],
                            [-5.1019, 56.8349],
                            [-5.1253, 56.8421],
                            [-5.1492, 56.8385],
                            [-5.1647, 56.844],
                            [-5.1658, 56.8485],
                            [-5.1886, 56.8543],
                            [-5.2081, 56.8551],
                            [-5.2558, 56.8532],
                            [-5.3075, 56.856],
                            [-5.3303, 56.859],
                            [-5.3325, 56.8549],
                            [-5.3197, 56.8493],
                            [-5.2325, 56.8424],
                            [-5.1842, 56.8465],
                            [-5.1692, 56.8443],
                            [-5.1558, 56.8385],
                            [-5.1219, 56.8338],
                            [-5.1225, 56.8257],
                            [-5.1386, 56.8132],
                            [-5.1508, 56.8065],
                            [-5.153, 56.801],
                            [-5.1647, 56.7979],
                            [-5.1725, 56.791],
                            [-5.1897, 56.7832],
                            [-5.2158, 56.7671],
                            [-5.2281, 56.7668],
                            [-5.2331, 56.7618],
                            [-5.2297, 56.751],
                            [-5.2536, 56.7374],
                            [-5.2558, 56.7299],
                            [-5.2431, 56.7235],
                            [-5.2431, 56.7196],
                            [-5.263, 56.7162],
                            [-5.2736, 56.7121],
                            [-5.2825, 56.7012],
                            [-5.2903, 56.7107],
                            [-5.3036, 56.7118],
                            [-5.3192, 56.6979],
                            [-5.3536, 56.6837],
                            [-5.3558, 56.6743],
                            [-5.3675, 56.6654],
                            [-5.3886, 56.6551],
                            [-5.3975, 56.6471],
                            [-5.4114, 56.6421],
                            [-5.4186, 56.6468],
                            [-5.4331, 56.6424],
                            [-5.4436, 56.6326],
                            [-5.468, 56.6157],
                            [-5.4969, 56.6151],
                            [-5.5231, 56.6171],
                            [-5.5192, 56.6124],
                            [-5.4931, 56.6057],
                            [-5.5003, 56.5963],
                            [-5.5153, 56.586],
                            [-5.5225, 56.574],
                            [-5.5458, 56.5585],
                            [-5.5475, 56.5532],
                            [-5.5586, 56.5496],
                            [-5.5592, 56.5446],
                            [-5.5892, 56.5299],
                            [-5.6125, 56.5201],
                            [-5.6225, 56.5193],
                            [-5.6436, 56.509],
                            [-5.6736, 56.5018],
                            [-5.6908, 56.4993],
                            [-5.6942, 56.511],
                            [-5.7097, 56.5149],
                            [-5.732, 56.5168],
                            [-5.7458, 56.5246],
                            [-5.7603, 56.5232],
                            [-5.7753, 56.5337],
                            [-5.7858, 56.5318],
                            [-5.8042, 56.5332],
                            [-5.8186, 56.5379],
                            [-5.8325, 56.5385],
                            [-5.8442, 56.5429],
                            [-5.8742, 56.5454],
                            [-5.8842, 56.5513],
                            [-5.9047, 56.5507],
                            [-5.9064, 56.5546],
                            [-5.9258, 56.5615],
                            [-5.9597, 56.5826],
                            [-5.9631, 56.5901],
                            [-5.9731, 56.5954],
                            [-5.9792, 56.6104],
                            [-5.9886, 56.6132],
                            [-6.0053, 56.6243],
                            [-6.0025, 56.6343],
                            [-6.0075, 56.646],
                            [-6.0047, 56.6496],
                            [-5.9725, 56.6493],
                            [-5.9497, 56.6557],
                            [-5.9514, 56.6596],
                            [-5.9425, 56.6688],
                            [-5.9253, 56.6688],
                            [-5.9225, 56.6635],
                            [-5.907, 56.6604],
                            [-5.8964, 56.6615],
                            [-5.8814, 56.6707],
                            [-5.8703, 56.6618],
                            [-5.8814, 56.6526],
                            [-5.8908, 56.651],
                            [-5.8914, 56.6432],
                            [-5.8797, 56.6421],
                            [-5.842, 56.6304],
                            [-5.8458, 56.6363],
                            [-5.8592, 56.6365],
                            [-5.8753, 56.6438],
                            [-5.8792, 56.6535],
                            [-5.8586, 56.6613],
                            [-5.8431, 56.6599],
                            [-5.8225, 56.6674],
                            [-5.8075, 56.6754],
                            [-5.7892, 56.6804],
                            [-5.7825, 56.6874],
                            [-5.7664, 56.6943],
                            [-5.7564, 56.6954],
                            [-5.7453, 56.7012],
                            [-5.7208, 56.6971],
                            [-5.7019, 56.6821],
                            [-5.6836, 56.6832],
                            [-5.6781, 56.6793],
                            [-5.6592, 56.6762],
                            [-5.6358, 56.6782],
                            [-5.6275, 56.676],
                            [-5.6086, 56.6771],
                            [-5.597, 56.6824],
                            [-5.5442, 56.6835],
                            [-5.5703, 56.6915],
                            [-5.5942, 56.6874],
                            [-5.5981, 56.6904],
                            [-5.6164, 56.689],
                            [-5.6342, 56.684],
                            [-5.6486, 56.6832],
                            [-5.6719, 56.6887],
                            [-5.6853, 56.6896],
                            [-5.692, 56.6982],
                            [-5.7025, 56.6999],
                            [-5.7203, 56.7099],
                            [-5.7342, 56.7112],
                            [-5.7575, 56.7074],
                            [-5.7636, 56.7099],
                            [-5.7842, 56.7051],
                            [-5.7925, 56.6968],
                            [-5.8103, 56.686],
                            [-5.8219, 56.6832],
                            [-5.8425, 56.6724],
                            [-5.8586, 56.6799],
                            [-5.8858, 56.6743],
                            [-5.9025, 56.6732],
                            [-5.9197, 56.6765],
                            [-5.9392, 56.6871],
                            [-5.9703, 56.6785],
                            [-5.9808, 56.6732],
                            [-5.9875, 56.6815],
                            [-6.0131, 56.6824],
                            [-6.0308, 56.6799],
                            [-6.0525, 56.6929],
                            [-6.0647, 56.6935],
                            [-6.0936, 56.6901],
                            [-6.1081, 56.6918],
                            [-6.1169, 56.6962],
                            [-6.1424, 56.6824],
                            [-6.1869, 56.6871],
                            [-6.1942, 56.6924],
                            [-6.2092, 56.6962],
                            [-6.2258, 56.7101],
                            [-6.2281, 56.7165],
                            [-6.2219, 56.7235],
                            [-6.1986, 56.7382],
                            [-6.1869, 56.736],
                            [-6.182, 56.7426],
                            [-6.1914, 56.7535],
                            [-6.1753, 56.7557],
                            [-6.1581, 56.7546],
                            [-6.1458, 56.7618],
                            [-6.1136, 56.7649],
                            [-6.0975, 56.7629],
                            [-6.0619, 56.7649],
                            [-6.0219, 56.7643],
                            [-6.0114, 56.7707],
                            [-5.9892, 56.769],
                            [-5.9703, 56.7784],
                            [-5.9647, 56.7846],
                            [-5.9514, 56.7815],
                            [-5.9292, 56.7646],
                            [-5.9181, 56.7612],
                            [-5.9147, 56.7532],
                            [-5.9019, 56.7543],
                            [-5.8803, 56.7615],
                            [-5.8703, 56.7565],
                            [-5.8708, 56.7426],
                            [-5.848, 56.7476],
                            [-5.8619, 56.7582],
                            [-5.8886, 56.7654],
                            [-5.8936, 56.779],
                            [-5.888, 56.7849],
                            [-5.8736, 56.7837],
                            [-5.8581, 56.7779],
                            [-5.8375, 56.7782],
                            [-5.8231, 56.7857],
                            [-5.8042, 56.7843],
                            [-5.7997, 56.7901],
                            [-5.7608, 56.7826],
                            [-5.7664, 56.7885],
                            [-5.7931, 56.7943],
                            [-5.8114, 56.7965],
                            [-5.8336, 56.804],
                            [-5.867, 56.811],
                            [-5.8603, 56.8296],
                            [-5.8469, 56.8343],
                            [-5.8314, 56.8326],
                            [-5.8147, 56.8343],
                            [-5.8075, 56.8379],
                            [-5.7942, 56.8363],
                            [-5.7742, 56.8401],
                            [-5.7642, 56.8474],
                            [-5.7514, 56.8488],
                            [-5.7431, 56.8446],
                            [-5.7281, 56.8429],
                            [-5.7103, 56.8476],
                            [-5.7069, 56.8607],
                            [-5.6942, 56.8685],
                            [-5.6731, 56.871],
                            [-5.6781, 56.8793],
                            [-5.6908, 56.8776],
                            [-5.7142, 56.8632],
                            [-5.7186, 56.851],
                            [-5.738, 56.8512],
                            [-5.7631, 56.8588],
                            [-5.7781, 56.8604],
                            [-5.7864, 56.8663],
                            [-5.7642, 56.8765],
                            [-5.7347, 56.8882],
                            [-5.7386, 56.896],
                            [-5.7569, 56.8926],
                            [-5.7703, 56.894],
                            [-5.8153, 56.886],
                            [-5.8342, 56.8865],
                            [-5.8503, 56.8813],
                            [-5.8653, 56.8835],
                            [-5.8886, 56.874],
                            [-5.9192, 56.8813],
                            [-5.9242, 56.8918],
                            [-5.8976, 56.8963],
                            [-5.9003, 56.9018],
                            [-5.8853, 56.9054],
                            [-5.8781, 56.8988],
                            [-5.8658, 56.8976],
                            [-5.8503, 56.9007],
                            [-5.8442, 56.9079],
                            [-5.8542, 56.9113],
                            [-5.8714, 56.9096],
                            [-5.8825, 56.9154],
                            [-5.8836, 56.9226],
                            [-5.8658, 56.9271],
                            [-5.867, 56.9357],
                            [-5.8525, 56.941],
                            [-5.8564, 56.9446],
                            [-5.8469, 56.9579],
                            [-5.8436, 56.9904],
                            [-5.8319, 56.9951],
                            [-5.8325, 57.0068],
                            [-5.8069, 57.0143],
                            [-5.7831, 57.0146],
                            [-5.7419, 57.0182],
                            [-5.7275, 57.0182],
                            [-5.7175, 57.0057],
                            [-5.7103, 56.9921],
                            [-5.6714, 56.9776],
                            [-5.6558, 56.9779],
                            [-5.6403, 56.9737],
                            [-5.6164, 56.9768],
                            [-5.6092, 56.9826],
                            [-5.5886, 56.9804],
                            [-5.5469, 56.9904],
                            [-5.5114, 56.9968],
                            [-5.5353, 57.0015],
                            [-5.5447, 56.9976],
                            [-5.5842, 56.9926],
                            [-5.6197, 56.9826],
                            [-5.6392, 56.9921],
                            [-5.6569, 56.9926],
                            [-5.6792, 57.0093],
                            [-5.6858, 57.0218],
                            [-5.6692, 57.029],
                            [-5.6725, 57.0332],
                            [-5.6892, 57.0387],
                            [-5.7108, 57.0404],
                            [-5.7342, 57.0343],
                            [-5.7353, 57.029],
                            [-5.7497, 57.029],
                            [-5.7569, 57.034],
                            [-5.7653, 57.0499],
                            [-5.7825, 57.0446],
                            [-5.7975, 57.0604],
                            [-5.7886, 57.066],
                            [-5.7886, 57.0724],
                            [-5.7586, 57.0901],
                            [-5.7458, 57.0913],
                            [-5.7314, 57.0985],
                            [-5.7231, 57.1182],
                            [-5.6947, 57.1201],
                            [-5.6758, 57.1199],
                            [-5.6536, 57.1276],
                            [-5.6347, 57.1232],
                            [-5.5981, 57.1185],
                            [-5.5708, 57.1029],
                            [-5.5669, 57.096],
                            [-5.5569, 57.0976],
                            [-5.5353, 57.0874],
                            [-5.5164, 57.0863],
                            [-5.5114, 57.0979],
                            [-5.4964, 57.0971],
                            [-5.4842, 57.1007],
                            [-5.4592, 57.1029],
                            [-5.4503, 57.1057],
                            [-5.4269, 57.1065],
                            [-5.4147, 57.1121],
                            [-5.4264, 57.1151],
                            [-5.4536, 57.1101],
                            [-5.4553, 57.1079],
                            [-5.4819, 57.1049],
                            [-5.5031, 57.1049],
                            [-5.5197, 57.0999],
                            [-5.5525, 57.1118],
                            [-5.5508, 57.1171],
                            [-5.5603, 57.1257],
                            [-5.5603, 57.1324],
                            [-5.5708, 57.1337],
                            [-5.5964, 57.1421],
                            [-5.6208, 57.1451],
                            [-5.6558, 57.1418],
                            [-5.6792, 57.1476],
                            [-5.6892, 57.1562],
                            [-5.6881, 57.1674],
                            [-5.6931, 57.1718],
                            [-5.683, 57.1763],
                            [-5.6803, 57.1824],
                            [-5.6431, 57.1971],
                            [-5.6364, 57.2071],
                            [-5.6253, 57.2157],
                            [-5.6392, 57.2249],
                            [-5.6564, 57.2268],
                            [-5.6536, 57.2382],
                            [-5.6353, 57.2507],
                            [-5.6097, 57.2535],
                            [-5.5986, 57.259],
                            [-5.5886, 57.2568],
                            [-5.5492, 57.2651],
                            [-5.5303, 57.2715],
                            [-5.5219, 57.269],
                            [-5.5075, 57.2535],
                            [-5.4864, 57.2421],
                            [-5.4814, 57.236],
                            [-5.4458, 57.2224],
                            [-5.4353, 57.2146],
                            [-5.4203, 57.2182],
                            [-5.4169, 57.2318],
                            [-5.4508, 57.2371],
                            [-5.4614, 57.2407],
                            [-5.4781, 57.2546],
                            [-5.5025, 57.2637],
                            [-5.5169, 57.2737],
                            [-5.5153, 57.2824],
                            [-5.4986, 57.2887],
                            [-5.5064, 57.2915],
                            [-5.5242, 57.2801],
                            [-5.5392, 57.2801],
                            [-5.5508, 57.2762],
                            [-5.5614, 57.2796],
                            [-5.5725, 57.2735],
                            [-5.5953, 57.2707],
                            [-5.5953, 57.2771],
                            [-5.6064, 57.2782],
                            [-5.618, 57.274],
                            [-5.6292, 57.2815],
                            [-5.6531, 57.2851],
                            [-5.6603, 57.2818],
                            [-5.7269, 57.2793],
                            [-5.7292, 57.2946],
                            [-5.7275, 57.3043],
                            [-5.7158, 57.3179],
                            [-5.6842, 57.3293],
                            [-5.6858, 57.3418],
                            [-5.6592, 57.341],
                            [-5.6564, 57.3474],
                            [-5.6431, 57.346],
                            [-5.6453, 57.3396],
                            [-5.6164, 57.3382],
                            [-5.5892, 57.344],
                            [-5.5775, 57.3543],
                            [-5.5375, 57.3524],
                            [-5.5064, 57.3649],
                            [-5.5014, 57.3715],
                            [-5.4736, 57.3821],
                            [-5.4608, 57.3893],
                            [-5.4547, 57.4037],
                            [-5.4403, 57.4143],
                            [-5.4631, 57.419],
                            [-5.4747, 57.4124],
                            [-5.4797, 57.4032],
                            [-5.4958, 57.3985],
                            [-5.5064, 57.3921],
                            [-5.5347, 57.369],
                            [-5.5503, 57.3618],
                            [-5.5664, 57.3574],
                            [-5.5825, 57.3593],
                            [-5.603, 57.3549],
                            [-5.6125, 57.3588],
                            [-5.6131, 57.3643],
                            [-5.6358, 57.3665],
                            [-5.6392, 57.376],
                            [-5.6331, 57.3804],
                            [-5.6103, 57.3838],
                            [-5.5953, 57.3899],
                            [-5.597, 57.3937],
                            [-5.6158, 57.4007],
                            [-5.6353, 57.3962],
                            [-5.6392, 57.391],
                            [-5.6608, 57.3876],
                            [-5.6714, 57.3818],
                            [-5.6892, 57.3779],
                            [-5.6986, 57.3704],
                            [-5.717, 57.3635],
                            [-5.7225, 57.3576],
                            [-5.7486, 57.3504],
                            [-5.7847, 57.3462],
                            [-5.8031, 57.3574],
                            [-5.8081, 57.3732],
                            [-5.8214, 57.3618],
                            [-5.8286, 57.381],
                            [-5.8203, 57.3899],
                            [-5.8208, 57.4004],
                            [-5.8108, 57.406],
                            [-5.8242, 57.4112],
                            [-5.8253, 57.419],
                            [-5.8169, 57.4332],
                            [-5.8064, 57.4393],
                            [-5.8186, 57.4435],
                            [-5.8431, 57.4407],
                            [-5.8547, 57.4426],
                            [-5.8614, 57.4524],
                            [-5.8664, 57.4692],
                            [-5.8731, 57.4765],
                            [-5.8714, 57.4901],
                            [-5.8619, 57.5168],
                            [-5.8547, 57.5268],
                            [-5.8547, 57.5504],
                            [-5.8381, 57.5615],
                            [-5.8408, 57.5743],
                            [-5.8375, 57.5793],
                            [-5.8242, 57.5774],
                            [-5.8214, 57.5835],
                            [-5.8108, 57.586],
                            [-5.7931, 57.5735],
                            [-5.7686, 57.5645],
                            [-5.7569, 57.5571],
                            [-5.7425, 57.5532],
                            [-5.7436, 57.5446],
                            [-5.717, 57.5504],
                            [-5.7092, 57.5565],
                            [-5.7003, 57.5521],
                            [-5.6986, 57.5315],
                            [-5.6736, 57.5265],
                            [-5.6653, 57.5207],
                            [-5.6525, 57.5201],
                            [-5.6553, 57.5424],
                            [-5.6453, 57.5424],
                            [-5.6303, 57.5335],
                            [-5.6314, 57.5226],
                            [-5.6203, 57.5213],
                            [-5.6086, 57.5354],
                            [-5.5958, 57.5307],
                            [-5.5775, 57.5332],
                            [-5.5708, 57.5368],
                            [-5.5469, 57.5351],
                            [-5.542, 57.5313],
                            [-5.5208, 57.5301],
                            [-5.5175, 57.5493],
                            [-5.5503, 57.554],
                            [-5.5831, 57.5535],
                            [-5.6042, 57.5557],
                            [-5.6142, 57.5524],
                            [-5.6331, 57.5549],
                            [-5.6353, 57.5496],
                            [-5.6519, 57.5521],
                            [-5.6564, 57.5487],
                            [-5.6753, 57.554],
                            [-5.6853, 57.5543],
                            [-5.6925, 57.5624],
                            [-5.7036, 57.5624],
                            [-5.7025, 57.5715],
                            [-5.6814, 57.5685],
                            [-5.6858, 57.5771],
                            [-5.7058, 57.5779],
                            [-5.7257, 57.584],
                            [-5.7369, 57.596],
                            [-5.7364, 57.6068],
                            [-5.7553, 57.6232],
                            [-5.7742, 57.6324],
                            [-5.8031, 57.6407],
                            [-5.8192, 57.6399],
                            [-5.8197, 57.6482],
                            [-5.8114, 57.6504],
                            [-5.8108, 57.6632],
                            [-5.7869, 57.684],
                            [-5.7908, 57.6968],
                            [-5.7697, 57.6982],
                            [-5.7575, 57.7074],
                            [-5.7386, 57.7085],
                            [-5.7225, 57.7057],
                            [-5.7042, 57.6954],
                            [-5.6881, 57.6996],
                            [-5.6731, 57.7004],
                            [-5.6875, 57.7146],
                            [-5.6897, 57.724],
                            [-5.7019, 57.7304],
                            [-5.7281, 57.7299],
                            [-5.762, 57.7315],
                            [-5.7814, 57.7429],
                            [-5.8086, 57.7462],
                            [-5.8142, 57.7524],
                            [-5.8081, 57.7587],
                            [-5.8114, 57.7665],
                            [-5.8036, 57.781],
                            [-5.8014, 57.7938],
                            [-5.8092, 57.8132],
                            [-5.8136, 57.8168],
                            [-5.8142, 57.8304],
                            [-5.8092, 57.8396],
                            [-5.8153, 57.8529],
                            [-5.8136, 57.859],
                            [-5.8042, 57.8626],
                            [-5.7953, 57.8596],
                            [-5.7792, 57.8593],
                            [-5.7758, 57.8637],
                            [-5.7586, 57.8704],
                            [-5.7375, 57.8657],
                            [-5.6997, 57.8699],
                            [-5.6825, 57.8635],
                            [-5.6908, 57.8554],
                            [-5.6903, 57.8454],
                            [-5.6797, 57.8418],
                            [-5.6836, 57.8351],
                            [-5.6664, 57.8329],
                            [-5.6603, 57.8193],
                            [-5.6669, 57.8151],
                            [-5.6642, 57.8054],
                            [-5.6669, 57.7988],
                            [-5.6542, 57.7885],
                            [-5.6364, 57.7793],
                            [-5.6175, 57.7665],
                            [-5.597, 57.7701],
                            [-5.5981, 57.7746],
                            [-5.6131, 57.7818],
                            [-5.618, 57.7929],
                            [-5.6042, 57.7965],
                            [-5.5942, 57.789],
                            [-5.5797, 57.7904],
                            [-5.5814, 57.7982],
                            [-5.5942, 57.7985],
                            [-5.5975, 57.8035],
                            [-5.5847, 57.8163],
                            [-5.5814, 57.8304],
                            [-5.5847, 57.8396],
                            [-5.6008, 57.8429],
                            [-5.6014, 57.849],
                            [-5.6436, 57.8565],
                            [-5.6386, 57.8626],
                            [-5.6481, 57.8665],
                            [-5.6564, 57.8799],
                            [-5.6442, 57.8832],
                            [-5.6525, 57.8913],
                            [-5.6447, 57.8968],
                            [-5.6369, 57.9138],
                            [-5.6225, 57.9196],
                            [-5.622, 57.9238],
                            [-5.603, 57.9251],
                            [-5.5847, 57.9196],
                            [-5.5764, 57.9146],
                            [-5.5625, 57.919],
                            [-5.5514, 57.9093],
                            [-5.5597, 57.9015],
                            [-5.5486, 57.8996],
                            [-5.5525, 57.891],
                            [-5.5508, 57.8832],
                            [-5.542, 57.8762],
                            [-5.5397, 57.869],
                            [-5.4747, 57.8582],
                            [-5.4686, 57.8535],
                            [-5.4547, 57.8515],
                            [-5.4514, 57.8618],
                            [-5.4542, 57.8693],
                            [-5.4414, 57.8721],
                            [-5.4375, 57.8943],
                            [-5.4331, 57.9018],
                            [-5.4214, 57.9082],
                            [-5.3975, 57.9049],
                            [-5.3897, 57.8996],
                            [-5.3464, 57.8851],
                            [-5.3364, 57.879],
                            [-5.3286, 57.8674],
                            [-5.2858, 57.8551],
                            [-5.2614, 57.8535],
                            [-5.2597, 57.8499],
                            [-5.2253, 57.8429],
                            [-5.2225, 57.8487],
                            [-5.2408, 57.8549],
                            [-5.2414, 57.8637],
                            [-5.2551, 57.8688],
                            [-5.2958, 57.8737],
                            [-5.3103, 57.8774],
                            [-5.3158, 57.8896],
                            [-5.3381, 57.906],
                            [-5.3614, 57.9074],
                            [-5.3953, 57.9135],
                            [-5.3947, 57.9207],
                            [-5.4053, 57.9265],
                            [-5.4047, 57.9315],
                            [-5.3775, 57.9321],
                            [-5.3697, 57.9379],
                            [-5.3575, 57.9388],
                            [-5.3503, 57.9324],
                            [-5.3553, 57.9279],
                            [-5.3325, 57.9157],
                            [-5.3175, 57.9118],
                            [-5.2892, 57.9107],
                            [-5.2575, 57.9176],
                            [-5.2397, 57.9179],
                            [-5.2347, 57.9135],
                            [-5.2153, 57.9087],
                            [-5.2081, 57.9018],
                            [-5.1953, 57.8968],
                            [-5.1808, 57.8871],
                            [-5.1731, 57.8871],
                            [-5.1486, 57.8749],
                            [-5.1269, 57.8746],
                            [-5.1203, 57.8707],
                            [-5.0992, 57.8426],
                            [-5.0853, 57.8282],
                            [-5.0731, 57.8204],
                            [-5.0692, 57.8301],
                            [-5.0819, 57.8524],
                            [-5.0953, 57.861],
                            [-5.0997, 57.8696],
                            [-5.1192, 57.8782],
                            [-5.1347, 57.8801],
                            [-5.1369, 57.8868],
                            [-5.1536, 57.8962],
                            [-5.168, 57.8988],
                            [-5.1792, 57.9071],
                            [-5.1947, 57.9101],
                            [-5.1975, 57.9143],
                            [-5.2225, 57.9274],
                            [-5.1975, 57.9324],
                            [-5.1775, 57.9449],
                            [-5.1919, 57.9482],
                            [-5.1986, 57.9574],
                            [-5.2264, 57.9576],
                            [-5.2414, 57.9618],
                            [-5.248, 57.9704],
                            [-5.2731, 57.9751],
                            [-5.3125, 57.9793],
                            [-5.3097, 57.9899],
                            [-5.3219, 57.9951],
                            [-5.3308, 58.006],
                            [-5.3508, 58.0049],
                            [-5.3514, 58.0201],
                            [-5.3714, 58.0307],
                            [-5.3847, 58.0282],
                            [-5.4136, 58.0337],
                            [-5.4253, 58.0401],
                            [-5.4197, 58.0501],
                            [-5.4247, 58.0579],
                            [-5.4408, 58.0599],
                            [-5.4508, 58.0688],
                            [-5.4586, 58.0685],
                            [-5.4536, 58.089],
                            [-5.4475, 58.0974],
                            [-5.4325, 58.1063],
                            [-5.4214, 58.1057],
                            [-5.4008, 58.0974],
                            [-5.3986, 58.0929],
                            [-5.3803, 58.0871],
                            [-5.3747, 58.0778],
                            [-5.3675, 58.0779],
                            [-5.3614, 58.0671],
                            [-5.3497, 58.0779],
                            [-5.3297, 58.0768],
                            [-5.3253, 58.069],
                            [-5.3064, 58.0682],
                            [-5.2897, 58.0743],
                            [-5.2819, 58.0918],
                            [-5.2736, 58.0993],
                            [-5.2825, 58.1082],
                            [-5.2958, 58.1132],
                            [-5.3025, 58.1199],
                            [-5.2842, 58.1221],
                            [-5.2942, 58.1351],
                            [-5.2525, 58.144],
                            [-5.2786, 58.1476],
                            [-5.2864, 58.1518],
                            [-5.3103, 58.1543],
                            [-5.3125, 58.1635],
                            [-5.3058, 58.1735],
                            [-5.3153, 58.1796],
                            [-5.3319, 58.1799],
                            [-5.3436, 58.1888],
                            [-5.3403, 58.1985],
                            [-5.3597, 58.2026],
                            [-5.3625, 58.2162],
                            [-5.3858, 58.2301],
                            [-5.4053, 58.2343],
                            [-5.3986, 58.2432],
                            [-5.3958, 58.2551],
                            [-5.3719, 58.2649],
                            [-5.3697, 58.2546],
                            [-5.3414, 58.2515],
                            [-5.3392, 58.2443],
                            [-5.318, 58.239],
                            [-5.3097, 58.2299],
                            [-5.2964, 58.2304],
                            [-5.2919, 58.2363],
                            [-5.2764, 58.2399],
                            [-5.2586, 58.2474],
                            [-5.2725, 58.2565],
                            [-5.2808, 58.2588],
                            [-5.263, 58.2693],
                            [-5.2575, 58.2624],
                            [-5.2392, 58.2562],
                            [-5.2269, 58.2588],
                            [-5.2031, 58.254],
                            [-5.1931, 58.2493],
                            [-5.1853, 58.2524],
                            [-5.1714, 58.2515],
                            [-5.1603, 58.259],
                            [-5.1486, 58.2585],
                            [-5.1325, 58.2626],
                            [-5.1342, 58.2671],
                            [-5.1058, 58.2699],
                            [-5.0981, 58.2624],
                            [-5.077, 58.2529],
                            [-5.0547, 58.2471],
                            [-5.0386, 58.2488],
                            [-5.0292, 58.2535],
                            [-5.0408, 58.2588],
                            [-5.0819, 58.2632],
                            [-5.0997, 58.2743],
                            [-5.1125, 58.2787],
                            [-5.1369, 58.2787],
                            [-5.1397, 58.2837],
                            [-5.1308, 58.2887],
                            [-5.1486, 58.3001],
                            [-5.1414, 58.3104],
                            [-5.1631, 58.3176],
                            [-5.1708, 58.3238],
                            [-5.1689, 58.3357],
                            [-5.1775, 58.3421],
                            [-5.1864, 58.3543],
                            [-5.1669, 58.3565],
                            [-5.1725, 58.3629],
                            [-5.1664, 58.374],
                            [-5.1553, 58.3793],
                            [-5.1519, 58.4054],
                            [-5.1475, 58.4107],
                            [-5.1258, 58.4124],
                            [-5.1258, 58.4051],
                            [-5.1042, 58.3985],
                            [-5.0936, 58.401],
                            [-5.0636, 58.391],
                            [-5.0514, 58.3826],
                            [-5.0431, 58.3843],
                            [-5.0358, 58.3918],
                            [-5.0631, 58.3954],
                            [-5.0703, 58.401],
                            [-5.088, 58.4071],
                            [-5.1108, 58.4101],
                            [-5.1147, 58.426],
                            [-5.1258, 58.4304],
                            [-5.1097, 58.436],
                            [-5.0897, 58.4468],
                            [-5.0753, 58.4518],
                            [-5.0481, 58.4518],
                            [-5.0242, 58.4457],
                            [-5.0081, 58.436],
                            [-4.9936, 58.4399],
                            [-5.0158, 58.4446],
                            [-5.0203, 58.4515],
                            [-5.0792, 58.4562],
                            [-5.0692, 58.464],
                            [-5.0908, 58.4701],
                            [-5.0869, 58.4785],
                            [-5.1075, 58.481],
                            [-5.1181, 58.476],
                            [-5.1358, 58.4718],
                            [-5.1419, 58.4763],
                            [-5.1192, 58.4804],
                            [-5.1219, 58.4949],
                            [-5.1208, 58.5104],
                            [-5.1086, 58.5232],
                            [-5.1058, 58.5299],
                            [-5.0953, 58.5318],
                            [-5.0903, 58.5387],
                            [-5.0642, 58.5363],
                            [-5.0525, 58.5407],
                            [-5.0292, 58.5726],
                            [-5.0231, 58.574],
                            [-5.0208, 58.589],
                            [-5.012, 58.5935],
                            [-5.0169, 58.599],
                            [-5.012, 58.6232],
                            [-5.0036, 58.6276],
                            [-4.9769, 58.6193],
                            [-4.9747, 58.6168],
                            [-4.9481, 58.6113],
                            [-4.9314, 58.6176],
                            [-4.9253, 58.6154],
                            [-4.8881, 58.6124],
                            [-4.8803, 58.6154],
                            [-4.8525, 58.6021],
                            [-4.8397, 58.6018],
                            [-4.8258, 58.5976],
                            [-4.8164, 58.5901],
                            [-4.8208, 58.5718],
                            [-4.8192, 58.5624],
                            [-4.813, 58.5557],
                            [-4.7947, 58.5493],
                            [-4.7947, 58.5404],
                            [-4.8053, 58.5379],
                            [-4.8208, 58.5285],
                            [-4.8047, 58.5251],
                            [-4.7831, 58.539],
                            [-4.7786, 58.5518],
                            [-4.7903, 58.5526],
                            [-4.8042, 58.5601],
                            [-4.7981, 58.5782],
                            [-4.7764, 58.5782],
                            [-4.7658, 58.5835],
                            [-4.7769, 58.5929],
                            [-4.7942, 58.6007],
                            [-4.7792, 58.6021],
                            [-4.7603, 58.5979],
                            [-4.7636, 58.5887],
                            [-4.7425, 58.5849],
                            [-4.7375, 58.5685],
                            [-4.7231, 58.5707],
                            [-4.7053, 58.5668],
                            [-4.7086, 58.5607],
                            [-4.7025, 58.5557],
                            [-4.6897, 58.5565],
                            [-4.6675, 58.5524],
                            [-4.6536, 58.5454],
                            [-4.6508, 58.5332],
                            [-4.6614, 58.5254],
                            [-4.6725, 58.5232],
                            [-4.6808, 58.5115],
                            [-4.712, 58.4951],
                            [-4.7275, 58.4754],
                            [-4.7508, 58.4582],
                            [-4.7503, 58.4515],
                            [-4.7353, 58.4487],
                            [-4.7247, 58.4643],
                            [-4.7169, 58.4637],
                            [-4.6992, 58.4701],
                            [-4.6953, 58.4782],
                            [-4.6725, 58.4843],
                            [-4.6647, 58.4832],
                            [-4.6608, 58.5068],
                            [-4.6403, 58.5218],
                            [-4.6042, 58.5268],
                            [-4.5953, 58.5343],
                            [-4.5964, 58.5468],
                            [-4.6047, 58.5554],
                            [-4.5997, 58.5596],
                            [-4.5997, 58.5712],
                            [-4.5897, 58.5796],
                            [-4.5731, 58.5774],
                            [-4.5531, 58.5779],
                            [-4.5419, 58.5821],
                            [-4.5253, 58.5782],
                            [-4.5136, 58.5793],
                            [-4.4969, 58.5762],
                            [-4.4908, 58.5679],
                            [-4.4553, 58.5615],
                            [-4.4486, 58.554],
                            [-4.4381, 58.556],
                            [-4.4275, 58.5465],
                            [-4.4231, 58.5354],
                            [-4.4308, 58.5299],
                            [-4.4119, 58.5254],
                            [-4.4131, 58.5201],
                            [-4.4242, 58.5093],
                            [-4.4469, 58.5018],
                            [-4.4553, 58.4924],
                            [-4.452, 58.4835],
                            [-4.4608, 58.4771],
                            [-4.4658, 58.4674],
                            [-4.4681, 58.4479],
                            [-4.4547, 58.4624],
                            [-4.4464, 58.4654],
                            [-4.4425, 58.4738],
                            [-4.4247, 58.4807],
                            [-4.4192, 58.4946],
                            [-4.3992, 58.5085],
                            [-4.3847, 58.5101],
                            [-4.3831, 58.5157],
                            [-4.3581, 58.5365],
                            [-4.3436, 58.5412],
                            [-4.3219, 58.5407],
                            [-4.302, 58.5443],
                            [-4.2664, 58.5371],
                            [-4.2597, 58.5296],
                            [-4.2442, 58.5254],
                            [-4.2386, 58.5282],
                            [-4.2392, 58.5379],
                            [-4.2153, 58.5329],
                            [-4.2136, 58.5524],
                            [-4.1997, 58.5526],
                            [-4.1808, 58.5443],
                            [-4.1669, 58.546],
                            [-4.1586, 58.5515],
                            [-4.1497, 58.566],
                            [-4.132, 58.564],
                            [-4.1247, 58.5696],
                            [-4.0836, 58.5604],
                            [-4.0808, 58.5518],
                            [-4.072, 58.5512],
                            [-4.0725, 58.5637],
                            [-4.0503, 58.5721],
                            [-4.0525, 58.5801],
                            [-4.0436, 58.5915],
                            [-4.0147, 58.5943],
                            [-4.0031, 58.5657],
                            [-3.9803, 58.5712],
                            [-3.9653, 58.5699],
                            [-3.9531, 58.5746],
                            [-3.9469, 58.5685],
                            [-3.9331, 58.574],
                            [-3.9225, 58.5676],
                            [-3.9208, 58.5604],
                            [-3.8975, 58.5682],
                            [-3.8592, 58.5643],
                            [-3.842, 58.569],
                            [-3.8203, 58.569],
                            [-3.7992, 58.5737],
                            [-3.7919, 58.5654],
                            [-3.7792, 58.5632],
                            [-3.7742, 58.5749],
                            [-3.7425, 58.5835],
                            [-3.7258, 58.5949],
                            [-3.6964, 58.6054],
                            [-3.6781, 58.6099],
                            [-3.6525, 58.6243],
                            [-3.6408, 58.6165],
                            [-3.5836, 58.619],
                            [-3.558, 58.6235],
                            [-3.5375, 58.624],
                            [-3.5375, 58.6154],
                            [-3.5497, 58.606],
                            [-3.5242, 58.5971],
                            [-3.5081, 58.604],
                            [-3.4897, 58.6088],
                            [-3.4558, 58.6126],
                            [-3.4481, 58.6096],
                            [-3.4281, 58.611],
                            [-3.4353, 58.604],
                            [-3.4031, 58.6037],
                            [-3.3875, 58.601],
                            [-3.3781, 58.5954],
                            [-3.3658, 58.5951],
                            [-3.3547, 58.6012],
                            [-3.3464, 58.611],
                            [-3.3492, 58.6185],
                            [-3.373, 58.6224],
                            [-3.3853, 58.6288],
                            [-3.4114, 58.6379],
                            [-3.4142, 58.6429],
                            [-3.4064, 58.6615],
                            [-3.3875, 58.6696],
                            [-3.3742, 58.6724],
                            [-3.3558, 58.6657],
                            [-3.3458, 58.6488],
                            [-3.3142, 58.6482],
                            [-3.3097, 58.6443],
                            [-3.2953, 58.6457],
                            [-3.2775, 58.6543],
                            [-3.2614, 58.6526],
                            [-3.2453, 58.6549],
                            [-3.2247, 58.6504],
                            [-3.2203, 58.6557],
                            [-3.1986, 58.6563],
                            [-3.1886, 58.6604],
                            [-3.1797, 58.6513],
                            [-3.1719, 58.651],
                            [-3.1614, 58.6387],
                            [-3.1381, 58.6396],
                            [-3.1275, 58.6432],
                            [-3.0886, 58.6465],
                            [-3.0669, 58.6449],
                            [-3.0497, 58.6479],
                            [-3.0242, 58.6443],
                            [-3.0375, 58.6307],
                            [-3.0353, 58.6096],
                            [-3.0425, 58.5979],
                            [-3.0719, 58.5926],
                            [-3.0714, 58.5882],
                            [-3.0597, 58.5815],
                            [-3.0669, 58.5637],
                            [-3.0808, 58.556],
                            [-3.088, 58.5462],
                            [-3.1214, 58.5307],
                            [-3.1308, 58.5174],
                            [-3.1331, 58.5065],
                            [-3.1269, 58.486],
                            [-3.1208, 58.4796],
                            [-3.1069, 58.4746],
                            [-3.0814, 58.4751],
                            [-3.0503, 58.4799],
                            [-3.0497, 58.4685],
                            [-3.0547, 58.4588],
                            [-3.0497, 58.4515],
                            [-3.0564, 58.441],
                            [-3.0814, 58.4407],
                            [-3.0703, 58.4337],
                            [-3.0686, 58.4274],
                            [-3.0842, 58.4185],
                            [-3.0869, 58.4057],
                            [-3.0975, 58.3974],
                            [-3.0986, 58.3874],
                            [-3.1064, 58.3788],
                            [-3.1064, 58.371],
                            [-3.1225, 58.3643],
                            [-3.1308, 58.3576],
                            [-3.1425, 58.3557],
                            [-3.1725, 58.3354],
                            [-3.1842, 58.3307],
                            [-3.1925, 58.3213],
                            [-3.2192, 58.306],
                            [-3.2453, 58.299],
                            [-3.2586, 58.2996],
                            [-3.287, 58.2943],
                            [-3.297, 58.2893],
                            [-3.3203, 58.286],
                            [-3.333, 58.2804],
                            [-3.3681, 58.2749],
                            [-3.3942, 58.2624],
                            [-3.3997, 58.2551],
                            [-3.4179, 58.2443],
                            [-3.4281, 58.2446],
                            [-3.4375, 58.229],
                            [-3.4558, 58.2188],
                            [-3.4692, 58.2074],
                            [-3.4747, 58.1951],
                            [-3.4853, 58.1915],
                            [-3.4958, 58.179],
                            [-3.5164, 58.1674],
                            [-3.5464, 58.1585],
                            [-3.5708, 58.1435],
                            [-3.5992, 58.1335],
                            [-3.6136, 58.1312],
                            [-3.6225, 58.1237],
                            [-3.6419, 58.1149],
                            [-3.6592, 58.1129],
                            [-3.6714, 58.1026],
                            [-3.7147, 58.0821],
                            [-3.7258, 58.0813],
                            [-3.7375, 58.076],
                            [-3.7458, 58.0676],
                            [-3.7603, 58.0665],
                            [-3.7631, 58.0624],
                            [-3.7797, 58.0646],
                            [-3.8047, 58.0571],
                            [-3.8153, 58.0438],
                            [-3.8325, 58.0396],
                            [-3.8458, 58.0065],
                            [-3.8708, 58.0021],
                            [-3.8847, 57.9943],
                            [-3.8892, 57.9882],
                            [-3.9164, 57.984],
                            [-3.9364, 57.9826],
                            [-3.9492, 57.9771],
                            [-3.9697, 57.9746],
                            [-3.9858, 57.9676],
                            [-3.9931, 57.9504],
                            [-4.0053, 57.934],
                            [-4.0297, 57.9332],
                            [-4.0136, 57.9454],
                            [-4.0142, 57.949],
                            [-4.0481, 57.9443],
                            [-4.0514, 57.9493],
                            [-4.0731, 57.9568],
                            [-4.0814, 57.9507],
                            [-4.0675, 57.9371],
                            [-4.0336, 57.9304],
                            [-4.0075, 57.9321],
                            [-4.0019, 57.9263],
                            [-3.9986, 57.9129],
                            [-3.9908, 57.9026],
                            [-4.0003, 57.9015],
                            [-4.0042, 57.8935],
                            [-4.0131, 57.8868],
                            [-4.0153, 57.8757],
                            [-4.0108, 57.8649],
                            [-4.0253, 57.8637],
                            [-4.0497, 57.8676],
                            [-4.0758, 57.8665],
                            [-4.0897, 57.8635],
                            [-4.108, 57.8532],
                            [-4.1658, 57.859],
                            [-4.2025, 57.8707],
                            [-4.2331, 57.874],
                            [-4.2353, 57.871],
                            [-4.2719, 57.8693],
                            [-4.2686, 57.8615],
                            [-4.2914, 57.8615],
                            [-4.3064, 57.8729],
                            [-4.3347, 57.8804],
                            [-4.3453, 57.8876],
                            [-4.3486, 57.8954],
                            [-4.3619, 57.9062],
                            [-4.3786, 57.911],
                            [-4.3953, 57.9093],
                            [-4.3797, 57.9004],
                            [-4.3619, 57.9021],
                            [-4.3503, 57.8954],
                            [-4.3486, 57.8879],
                            [-4.3581, 57.8857],
                            [-4.3575, 57.8787],
                            [-4.3486, 57.8729],
                            [-4.3142, 57.8621],
                            [-4.3036, 57.8632],
                            [-4.3008, 57.8537],
                            [-4.2803, 57.8568],
                            [-4.2659, 57.8512],
                            [-4.2519, 57.8571],
                            [-4.2103, 57.8604],
                            [-4.1919, 57.8629],
                            [-4.1697, 57.8471],
                            [-4.1647, 57.8343],
                            [-4.1408, 57.8287],
                            [-4.1192, 57.8296],
                            [-4.1014, 57.8335],
                            [-4.0775, 57.8293],
                            [-4.0481, 57.8149],
                            [-4.0253, 57.8213],
                            [-4.0108, 57.8285],
                            [-3.9836, 57.8376],
                            [-3.9658, 57.8454],
                            [-3.9553, 57.8471],
                            [-3.9319, 57.8376],
                            [-3.9192, 57.8379],
                            [-3.8975, 57.829],
                            [-3.9231, 57.8246],
                            [-3.8964, 57.8207],
                            [-3.857, 57.8249],
                            [-3.8425, 57.8329],
                            [-3.8297, 57.8349],
                            [-3.8292, 57.8404],
                            [-3.8153, 57.854],
                            [-3.8136, 57.8601],
                            [-3.7981, 57.8654],
                            [-3.7725, 57.8676],
                            [-3.7769, 57.8532],
                            [-3.7897, 57.8374],
                            [-3.8036, 57.8287],
                            [-3.8236, 57.8129],
                            [-3.8342, 57.8024],
                            [-3.8436, 57.7982],
                            [-3.8508, 57.7888],
                            [-3.8775, 57.7715],
                            [-3.8853, 57.7707],
                            [-3.8958, 57.761],
                            [-3.9164, 57.7521],
                            [-3.9153, 57.7446],
                            [-3.9308, 57.7268],
                            [-3.9742, 57.6943],
                            [-3.9886, 57.691],
                            [-4.0081, 57.6943],
                            [-4.0214, 57.6915],
                            [-4.0353, 57.694],
                            [-4.0364, 57.699],
                            [-4.0264, 57.7196],
                            [-4.0125, 57.7265],
                            [-4.0108, 57.7335],
                            [-4.017, 57.7385],
                            [-4.0386, 57.7365],
                            [-4.0481, 57.7304],
                            [-4.0731, 57.7318],
                            [-4.102, 57.7207],
                            [-4.1136, 57.7115],
                            [-4.1486, 57.6951],
                            [-4.1564, 57.6899],
                            [-4.1753, 57.6849],
                            [-4.1803, 57.689],
                            [-4.2064, 57.6924],
                            [-4.2303, 57.6901],
                            [-4.2542, 57.6779],
                            [-4.2819, 57.6821],
                            [-4.3003, 57.6757],
                            [-4.2992, 57.6588],
                            [-4.3158, 57.6535],
                            [-4.3297, 57.6532],
                            [-4.3458, 57.6399],
                            [-4.4053, 57.6113],
                            [-4.418, 57.6026],
                            [-4.4103, 57.5918],
                            [-4.418, 57.5826],
                            [-4.3875, 57.5912],
                            [-4.3669, 57.6015],
                            [-4.3603, 57.6079],
                            [-4.3442, 57.6165],
                            [-4.3264, 57.6307],
                            [-4.2997, 57.6407],
                            [-4.2736, 57.6524],
                            [-4.2458, 57.6665],
                            [-4.2142, 57.674],
                            [-4.2069, 57.6724],
                            [-4.1669, 57.676],
                            [-4.163, 57.669],
                            [-4.1664, 57.6629],
                            [-4.1597, 57.6574],
                            [-4.1436, 57.6596],
                            [-4.1208, 57.6599],
                            [-4.1058, 57.6635],
                            [-4.0858, 57.6649],
                            [-4.0664, 57.6729],
                            [-4.0303, 57.681],
                            [-4.0002, 57.6804],
                            [-3.9953, 57.6732],
                            [-4.0081, 57.6632],
                            [-4.0253, 57.6582],
                            [-4.0419, 57.6488],
                            [-4.0619, 57.6341],
                            [-4.0681, 57.6268],
                            [-4.1008, 57.6074],
                            [-4.112, 57.5879],
                            [-4.1025, 57.5751],
                            [-4.133, 57.579],
                            [-4.1697, 57.5662],
                            [-4.1758, 57.5615],
                            [-4.1736, 57.5526],
                            [-4.1814, 57.5471],
                            [-4.2114, 57.5482],
                            [-4.2414, 57.5515],
                            [-4.2186, 57.5424],
                            [-4.2008, 57.544],
                            [-4.1931, 57.5362],
                            [-4.2019, 57.5257],
                            [-4.2308, 57.5074],
                            [-4.2342, 57.5007],
                            [-4.2481, 57.5004],
                            [-4.2725, 57.5049],
                            [-4.3092, 57.5018],
                            [-4.3219, 57.5046],
                            [-4.3458, 57.5051],
                            [-4.3553, 57.5104],
                            [-4.3769, 57.5118],
                            [-4.4158, 57.5043],
                            [-4.4003, 57.4954],
                            [-4.3875, 57.4851],
                            [-4.3742, 57.4799],
                            [-4.3264, 57.4849],
                            [-4.3147, 57.4801],
                            [-4.3047, 57.4838],
                            [-4.2842, 57.4818],
                            [-4.2769, 57.4854],
                            [-4.2186, 57.4968],
                            [-4.1997, 57.4893],
                            [-4.1808, 57.4851],
                            [-4.1592, 57.4932],
                            [-4.1492, 57.501],
                            [-4.1492, 57.5176],
                            [-4.1242, 57.5149],
                            [-4.1136, 57.516],
                            [-4.1142, 57.5232],
                            [-4.1042, 57.5351],
                            [-4.0975, 57.5387],
                            [-4.0519, 57.5529],
                            [-4.0414, 57.5604],
                            [-4.0386, 57.5687],
                            [-4.0575, 57.5812],
                            [-4.0769, 57.5818],
                            [-4.0525, 57.591],
                            [-4.0192, 57.5921],
                            [-4.0197, 57.5979],
                            [-4.0042, 57.6032],
                            [-3.9569, 57.5893],
                            [-3.9331, 57.586],
                            [-3.9053, 57.5865],
                            [-3.8808, 57.5901],
                            [-3.8692, 57.5893],
                            [-3.8275, 57.5987],
                            [-3.8119, 57.6062],
                            [-3.7992, 57.6093],
                            [-3.7931, 57.6224],
                            [-3.7681, 57.6282],
                            [-3.7514, 57.6351],
                            [-3.7414, 57.6326],
                            [-3.7064, 57.6446],
                            [-3.6997, 57.6507],
                            [-3.7008, 57.6579],
                            [-3.6436, 57.6635],
                            [-3.6325, 57.6624],
                            [-3.6197, 57.6551],
                            [-3.6247, 57.6443],
                            [-3.6386, 57.6443],
                            [-3.6447, 57.6401],
                            [-3.6025, 57.6321],
                            [-3.5825, 57.6349],
                            [-3.5831, 57.6446],
                            [-3.6192, 57.6615],
                            [-3.6142, 57.6643],
                            [-3.587, 57.6618],
                            [-3.5608, 57.6613],
                            [-3.5308, 57.6635],
                            [-3.5081, 57.6707],
                            [-3.4969, 57.6782],
                            [-3.4836, 57.7029],
                            [-3.4597, 57.704],
                            [-3.4386, 57.7118],
                            [-3.4114, 57.7135],
                            [-3.3864, 57.7201],
                            [-3.3469, 57.7246],
                            [-3.3303, 57.7249],
                            [-3.3047, 57.721],
                            [-3.2936, 57.7251],
                            [-3.278, 57.7254],
                            [-3.278, 57.7143],
                            [-3.2542, 57.7096],
                            [-3.2192, 57.6993],
                            [-3.1708, 57.6876],
                            [-3.1275, 57.6787],
                            [-3.0997, 57.6774],
                            [-3.0564, 57.6679],
                            [-3.0197, 57.664],
                            [-3.0053, 57.6668],
                            [-2.9981, 57.6724],
                            [-2.9703, 57.6796],
                            [-2.953, 57.6818],
                            [-2.9331, 57.6871],
                            [-2.9215, 57.6979],
                            [-2.8903, 57.7012],
                            [-2.8742, 57.7054],
                            [-2.8497, 57.7065],
                            [-2.8453, 57.6985],
                            [-2.8242, 57.6943],
                            [-2.7953, 57.7001],
                            [-2.7697, 57.6932],
                            [-2.7581, 57.694],
                            [-2.7364, 57.6843],
                            [-2.7186, 57.6921],
                            [-2.7058, 57.6874],
                            [-2.6842, 57.6843],
                            [-2.6658, 57.6907],
                            [-2.6442, 57.6837],
                            [-2.6142, 57.6804],
                            [-2.5986, 57.6826],
                            [-2.5831, 57.6787],
                            [-2.5725, 57.6824],
                            [-2.5664, 57.6763],
                            [-2.5531, 57.671],
                            [-2.5219, 57.6724],
                            [-2.5114, 57.6651],
                            [-2.4964, 57.6732],
                            [-2.4736, 57.6713],
                            [-2.4269, 57.6726],
                            [-2.4036, 57.6693],
                            [-2.3831, 57.6699],
                            [-2.3597, 57.676],
                            [-2.3503, 57.671],
                            [-2.3253, 57.6782],
                            [-2.3264, 57.6879],
                            [-2.2919, 57.6957],
                            [-2.2914, 57.6901],
                            [-2.2703, 57.6862],
                            [-2.2614, 57.6799],
                            [-2.2447, 57.6826],
                            [-2.2131, 57.6796],
                            [-2.1953, 57.6735],
                            [-2.1775, 57.6743],
                            [-2.1414, 57.689],
                            [-2.1353, 57.6946],
                            [-2.1203, 57.7004],
                            [-2.1069, 57.6974],
                            [-2.0775, 57.701],
                            [-2.0569, 57.6982],
                            [-2.0381, 57.6929],
                            [-2.0219, 57.6979],
                            [-1.9986, 57.6971],
                            [-1.9981, 57.6871],
                            [-1.9931, 57.6807],
                            [-1.974, 57.6763],
                            [-1.9581, 57.6754],
                            [-1.9414, 57.6818],
                            [-1.9175, 57.6743],
                            [-1.918, 57.6679],
                            [-1.9014, 57.6576],
                            [-1.8864, 57.6379],
                            [-1.8669, 57.6265],
                            [-1.8242, 57.6135],
                            [-1.8214, 57.6085],
                            [-1.8281, 57.5915],
                            [-1.8258, 57.5779],
                            [-1.8158, 57.5632],
                            [-1.8036, 57.5551],
                            [-1.802, 57.5435],
                            [-1.8064, 57.5301],
                            [-1.7953, 57.5163],
                            [-1.7853, 57.5154],
                            [-1.7664, 57.5071],
                            [-1.7669, 57.5015],
                            [-1.787, 57.5026],
                            [-1.7897, 57.4963],
                            [-1.7819, 57.489],
                            [-1.7947, 57.4835],
                            [-1.7731, 57.4743],
                            [-1.7803, 57.4624],
                            [-1.7964, 57.4515],
                            [-1.8153, 57.4276],
                            [-1.8275, 57.4204],
                            [-1.8381, 57.4093],
                            [-1.8492, 57.4129],
                            [-1.863, 57.4037],
                            [-1.8592, 57.3896],
                            [-1.8836, 57.3749],
                            [-1.9097, 57.3649],
                            [-1.9203, 57.3529],
                            [-1.9347, 57.3429],
                            [-1.9514, 57.3354],
                            [-1.9519, 57.331],
                            [-1.973, 57.3243],
                            [-1.9842, 57.3112],
                            [-2.0042, 57.2918],
                            [-2.0492, 57.234],
                            [-2.0675, 57.1985],
                            [-2.0758, 57.1782],
                            [-2.0786, 57.1601],
                            [-2.0714, 57.1449],
                            [-2.0464, 57.1407],
                            [-2.0575, 57.136],
                            [-2.0475, 57.1293],
                            [-2.0653, 57.1057],
                            [-2.0708, 57.1038],
                            [-2.0936, 57.0743],
                            [-2.0914, 57.0679],
                            [-2.1008, 57.0646],
                            [-2.1047, 57.0579],
                            [-2.1269, 57.0407],
                            [-2.133, 57.0335],
                            [-2.142, 57.0318],
                            [-2.1464, 57.0229],
                            [-2.1581, 57.0185],
                            [-2.1658, 57.0018],
                            [-2.1747, 56.9965],
                            [-2.1808, 56.9804],
                            [-2.2064, 56.9624],
                            [-2.1947, 56.9451],
                            [-2.1997, 56.9332],
                            [-2.1964, 56.9079],
                            [-2.2153, 56.8879],
                            [-2.2131, 56.8835],
                            [-2.2319, 56.8638],
                            [-2.2475, 56.8554],
                            [-2.2569, 56.8451],
                            [-2.2736, 56.8424],
                            [-2.2753, 56.8285],
                            [-2.2881, 56.8265],
                            [-2.3042, 56.8074],
                            [-2.3242, 56.7946],
                            [-2.3564, 56.7868],
                            [-2.3747, 56.7737],
                            [-2.388, 56.7754],
                            [-2.4014, 56.7735],
                            [-2.4236, 56.7571],
                            [-2.4425, 56.7271],
                            [-2.4464, 56.7132],
                            [-2.4536, 56.704],
                            [-2.4642, 56.7029],
                            [-2.4747, 56.7087],
                            [-2.4758, 56.7201],
                            [-2.5147, 56.7229],
                            [-2.5308, 56.706],
                            [-2.5153, 56.699],
                            [-2.4931, 56.6987],
                            [-2.4775, 56.7057],
                            [-2.4608, 56.7015],
                            [-2.4347, 56.7024],
                            [-2.4414, 56.6926],
                            [-2.4375, 56.689],
                            [-2.4458, 56.6807],
                            [-2.5003, 56.6621],
                            [-2.5086, 56.651],
                            [-2.5053, 56.6324],
                            [-2.4869, 56.6304],
                            [-2.4786, 56.6243],
                            [-2.503, 56.5985],
                            [-2.5175, 56.5918],
                            [-2.5225, 56.5793],
                            [-2.5319, 56.5782],
                            [-2.5386, 56.5723],
                            [-2.5369, 56.5668],
                            [-2.5464, 56.5618],
                            [-2.5686, 56.5593],
                            [-2.5919, 56.5507],
                            [-2.6081, 56.5496],
                            [-2.6264, 56.5374],
                            [-2.6442, 56.5224],
                            [-2.6525, 56.521],
                            [-2.6708, 56.5087],
                            [-2.7075, 56.499],
                            [-2.7136, 56.4935],
                            [-2.7203, 56.4776],
                            [-2.7325, 56.4649],
                            [-2.7486, 56.4654],
                            [-2.7864, 56.4782],
                            [-2.803, 56.4799],
                            [-2.8269, 56.4765],
                            [-2.8642, 56.4646],
                            [-2.8797, 56.4646],
                            [-2.8903, 56.4685],
                            [-2.9342, 56.4657],
                            [-2.9519, 56.4621],
                            [-2.9736, 56.454],
                            [-2.9925, 56.4507],
                            [-3.0419, 56.451],
                            [-3.0497, 56.4571],
                            [-3.0686, 56.4504],
                            [-3.0808, 56.451],
                            [-3.0986, 56.4385],
                            [-3.1136, 56.434],
                            [-3.1314, 56.4254],
                            [-3.1353, 56.4201],
                            [-3.1692, 56.3987],
                            [-3.1753, 56.3921],
                            [-3.2025, 56.3796],
                            [-3.2331, 56.3682],
                            [-3.2586, 56.3668],
                            [-3.2836, 56.3574],
                            [-3.2847, 56.3518],
                            [-3.2608, 56.351],
                            [-3.2369, 56.354],
                            [-3.1942, 56.3654],
                            [-3.1775, 56.3732],
                            [-3.1181, 56.391],
                            [-3.0959, 56.3937],
                            [-3.0808, 56.3999],
                            [-3.0608, 56.404],
                            [-3.0469, 56.409],
                            [-3.0369, 56.4162],
                            [-2.9919, 56.4201],
                            [-2.9692, 56.4307],
                            [-2.9464, 56.4362],
                            [-2.9375, 56.4465],
                            [-2.9108, 56.4524],
                            [-2.8836, 56.4529],
                            [-2.8753, 56.4482],
                            [-2.8507, 56.4399],
                            [-2.8303, 56.4437],
                            [-2.803, 56.4424],
                            [-2.8064, 56.4235],
                            [-2.8058, 56.4118],
                            [-2.8125, 56.3887],
                            [-2.8186, 56.3868],
                            [-2.8247, 56.3774],
                            [-2.8547, 56.3685],
                            [-2.8819, 56.3679],
                            [-2.8853, 56.3624],
                            [-2.8597, 56.3599],
                            [-2.8364, 56.3532],
                            [-2.8275, 56.3563],
                            [-2.8231, 56.3663],
                            [-2.8114, 56.36],
                            [-2.8036, 56.3432],
                            [-2.7897, 56.344],
                            [-2.7786, 56.3335],
                            [-2.748, 56.3326],
                            [-2.7386, 56.3288],
                            [-2.7042, 56.3251],
                            [-2.6908, 56.3271],
                            [-2.6753, 56.3201],
                            [-2.6597, 56.3196],
                            [-2.6564, 56.3126],
                            [-2.6397, 56.2998],
                            [-2.6131, 56.2888],
                            [-2.5969, 56.2879],
                            [-2.5964, 56.2832],
                            [-2.5836, 56.279],
                            [-2.6003, 56.2638],
                            [-2.6269, 56.2571],
                            [-2.6536, 56.2385],
                            [-2.672, 56.2329],
                            [-2.6875, 56.2221],
                            [-2.7008, 56.221],
                            [-2.727, 56.211],
                            [-2.7414, 56.2101],
                            [-2.7953, 56.1943],
                            [-2.8142, 56.1838],
                            [-2.8275, 56.1896],
                            [-2.8369, 56.1835],
                            [-2.8547, 56.1882],
                            [-2.8686, 56.1865],
                            [-2.8725, 56.1943],
                            [-2.8914, 56.2065],
                            [-2.9364, 56.2118],
                            [-2.958, 56.2096],
                            [-2.9853, 56.1987],
                            [-2.9947, 56.1893],
                            [-3.0175, 56.1743],
                            [-3.0353, 56.1665],
                            [-3.0453, 56.1676],
                            [-3.0653, 56.1568],
                            [-3.0836, 56.1399],
                            [-3.0947, 56.1396],
                            [-3.1142, 56.1293],
                            [-3.1192, 56.1235],
                            [-3.1325, 56.1193],
                            [-3.1436, 56.119],
                            [-3.1547, 56.1104],
                            [-3.1603, 56.091],
                            [-3.1581, 56.0835],
                            [-3.1631, 56.0751],
                            [-3.1736, 56.0671],
                            [-3.1719, 56.0629],
                            [-3.2158, 56.0638],
                            [-3.232, 56.0546],
                            [-3.2464, 56.0568],
                            [-3.2508, 56.061],
                            [-3.2825, 56.0563],
                            [-3.2886, 56.0496],
                            [-3.3114, 56.041],
                            [-3.3108, 56.0349],
                            [-3.3281, 56.0388],
                            [-3.3569, 56.026],
                            [-3.3769, 56.0288],
                            [-3.3881, 56.0248],
                            [-3.3886, 56.0074],
                            [-3.4019, 56.0085],
                            [-3.4103, 56.0154],
                            [-3.4447, 56.0232],
                            [-3.4564, 56.0201],
                            [-3.4708, 56.029],
                            [-3.4853, 56.0335],
                            [-3.5064, 56.0343],
                            [-3.5158, 56.0404],
                            [-3.5464, 56.0398],
                            [-3.5608, 56.051],
                            [-3.5758, 56.0582],
                            [-3.5925, 56.0457],
                            [-3.6097, 56.0463],
                            [-3.6175, 56.0554],
                            [-3.6381, 56.0543],
                            [-3.6647, 56.0468],
                            [-3.6864, 56.0473],
                            [-3.7031, 56.0532],
                            [-3.7236, 56.066],
                            [-3.7308, 56.0621],
                            [-3.7275, 56.0329],
                            [-3.7186, 56.0271],
                            [-3.6992, 56.0285],
                            [-3.6964, 56.0349],
                            [-3.6814, 56.0363],
                            [-3.6775, 56.026],
                            [-3.6819, 56.0215],
                            [-3.6708, 56.0163],
                            [-3.6531, 56.0138],
                            [-3.6347, 56.0149],
                            [-3.6236, 56.0193],
                            [-3.6075, 56.0204],
                            [-3.5786, 56.0188],
                            [-3.5653, 56.0124],
                            [-3.5192, 56.0046],
                            [-3.5092, 55.999],
                            [-3.4831, 55.9979],
                            [-3.4697, 56.0004],
                            [-3.4397, 55.9946],
                            [-3.4047, 55.9929],
                            [-3.3886, 55.9901],
                            [-3.3753, 55.9924],
                            [-3.3669, 55.999],
                            [-3.3514, 56.0015],
                            [-3.333, 55.9926],
                            [-3.3319, 55.9888],
                            [-3.317, 55.9835],
                            [-3.287, 55.9796],
                            [-3.2797, 55.9815],
                            [-3.2636, 55.9793],
                            [-3.2492, 55.984],
                            [-3.2336, 55.984],
                            [-3.1997, 55.9804],
                            [-3.1958, 55.9849],
                            [-3.1797, 55.9807],
                            [-3.1742, 55.9846],
                            [-3.1597, 55.9832],
                            [-3.1541, 55.9779],
                            [-3.1308, 55.9665],
                            [-3.1214, 55.9593],
                            [-3.0997, 55.9507],
                            [-3.0651, 55.9451],
                            [-3.0564, 55.9524],
                            [-3.0336, 55.9543],
                            [-3.018, 55.9515],
                            [-2.9897, 55.9579],
                            [-2.9797, 55.9624],
                            [-2.9725, 55.9701],
                            [-2.9519, 55.9738],
                            [-2.9231, 55.9729],
                            [-2.9019, 55.981],
                            [-2.8858, 55.9971],
                            [-2.8942, 56.0085],
                            [-2.8742, 56.0138],
                            [-2.8664, 56.0101],
                            [-2.8542, 56.0124],
                            [-2.8686, 56.0223],
                            [-2.8719, 56.0288],
                            [-2.8597, 56.0396],
                            [-2.8447, 56.0388],
                            [-2.8358, 56.0435],
                            [-2.8331, 56.051],
                            [-2.8247, 56.0524],
                            [-2.8169, 56.0629],
                            [-2.8058, 56.0629],
                            [-2.7747, 56.0671],
                            [-2.7519, 56.0599],
                            [-2.7447, 56.0632],
                            [-2.6997, 56.058],
                            [-2.6786, 56.0635],
                            [-2.673, 56.0601],
                            [-2.6547, 56.0601],
                            [-2.647, 56.0549],
                            [-2.6225, 56.0521],
                            [-2.6086, 56.0424],
                            [-2.6097, 56.034],
                            [-2.5953, 56.0248],
                            [-2.5808, 56.0237],
                            [-2.5886, 56.0165],
                            [-2.5731, 56.0129],
                            [-2.5581, 56.004],
                            [-2.5253, 56.0076],
                            [-2.5053, 55.9996],
                            [-2.4786, 55.9976],
                            [-2.4608, 55.9876],
                            [-2.4431, 55.9888],
                            [-2.442, 55.9829],
                            [-2.3986, 55.9699],
                            [-2.3992, 55.9632],
                            [-2.3919, 55.9554],
                            [-2.3719, 55.9471],
                            [-2.3381, 55.9379],
                            [-2.3369, 55.9332],
                            [-2.3008, 55.9312],
                            [-2.2786, 55.9265],
                            [-2.2558, 55.9249],
                            [-2.2381, 55.9315],
                            [-2.2231, 55.9329],
                            [-2.2053, 55.9296],
                            [-2.1975, 55.9243],
                            [-2.1742, 55.9174],
                            [-2.1514, 55.9151],
                            [-2.1364, 55.9168],
                            [-2.1269, 55.9074],
                            [-2.133, 55.904],
                            [-2.1264, 55.8962],
                            [-2.1308, 55.8918],
                            [-2.1253, 55.8854],
                            [-2.1058, 55.879],
                            [-2.0814, 55.876],
                            [-2.0731, 55.869],
                            [-2.0692, 55.849],
                            [-2.062, 55.8401],
                            [-2.0553, 55.8382],
                            [-2.0536, 55.8301],
                            [-2.0453, 55.8193],
                            [-2.0281, 55.8085],
                            [-2.0303, 55.8044]
                        ]
                    ],
                    [
                        [
                            [-5.1858, 55.9271],
                            [-5.1708, 55.9215],
                            [-5.1614, 55.9226],
                            [-5.1403, 55.9068],
                            [-5.1108, 55.8915],
                            [-5.0953, 55.8882],
                            [-5.088, 55.8824],
                            [-5.0786, 55.8821],
                            [-5.0742, 55.8743],
                            [-5.0897, 55.8618],
                            [-5.0614, 55.8599],
                            [-5.0625, 55.8476],
                            [-5.0586, 55.839],
                            [-5.0503, 55.8387],
                            [-5.0353, 55.8451],
                            [-5.0231, 55.8429],
                            [-5.0242, 55.8329],
                            [-5.0214, 55.809],
                            [-5.0125, 55.7996],
                            [-5.0131, 55.7888],
                            [-5.0014, 55.7729],
                            [-5.0081, 55.7629],
                            [-5.0214, 55.7629],
                            [-5.0325, 55.7543],
                            [-5.0131, 55.7463],
                            [-5.0058, 55.7393],
                            [-5.0036, 55.7296],
                            [-5.0192, 55.7268],
                            [-5.0308, 55.7212],
                            [-5.0542, 55.7332],
                            [-5.0519, 55.7374],
                            [-5.0619, 55.7468],
                            [-5.0631, 55.7618],
                            [-5.0725, 55.7607],
                            [-5.1031, 55.7793],
                            [-5.1208, 55.7718],
                            [-5.1214, 55.7796],
                            [-5.1292, 55.7893],
                            [-5.1247, 55.7946],
                            [-5.1269, 55.8085],
                            [-5.1386, 55.8082],
                            [-5.1442, 55.8126],
                            [-5.1408, 55.8201],
                            [-5.1397, 55.8357],
                            [-5.128, 55.8399],
                            [-5.132, 55.8479],
                            [-5.1458, 55.851],
                            [-5.1536, 55.846],
                            [-5.1703, 55.8515],
                            [-5.1797, 55.8624],
                            [-5.1925, 55.8665],
                            [-5.2053, 55.8818],
                            [-5.2136, 55.8862],
                            [-5.2136, 55.8965],
                            [-5.2197, 55.904],
                            [-5.2114, 55.9104],
                            [-5.1975, 55.914],
                            [-5.1858, 55.9271]
                        ]
                    ],
                    [
                        [
                            [-6.2264, 56.0288],
                            [-6.2175, 56.0268],
                            [-6.2186, 56.0199],
                            [-6.2342, 56.0163],
                            [-6.2353, 56.0076],
                            [-6.253, 56.0007],
                            [-6.2586, 56.0029],
                            [-6.2553, 56.016],
                            [-6.273, 56.0163],
                            [-6.2686, 56.0248],
                            [-6.2319, 56.026],
                            [-6.2264, 56.0288]
                        ]
                    ],
                    [
                        [
                            [-5.2603, 55.7215],
                            [-5.2042, 55.7043],
                            [-5.1908, 55.6943],
                            [-5.1603, 55.679],
                            [-5.1503, 55.666],
                            [-5.1536, 55.6629],
                            [-5.1369, 55.6426],
                            [-5.1364, 55.6304],
                            [-5.1286, 55.6162],
                            [-5.132, 55.6007],
                            [-5.1536, 55.5904],
                            [-5.1497, 55.5782],
                            [-5.1308, 55.5771],
                            [-5.1081, 55.5724],
                            [-5.0986, 55.5624],
                            [-5.0819, 55.5524],
                            [-5.1025, 55.5426],
                            [-5.1103, 55.5426],
                            [-5.128, 55.5312],
                            [-5.1253, 55.5249],
                            [-5.1092, 55.5201],
                            [-5.0992, 55.5146],
                            [-5.0786, 55.5093],
                            [-5.0814, 55.5032],
                            [-5.092, 55.4965],
                            [-5.0925, 55.4843],
                            [-5.0864, 55.479],
                            [-5.0786, 55.4646],
                            [-5.0847, 55.4526],
                            [-5.0947, 55.4493],
                            [-5.1053, 55.4404],
                            [-5.1236, 55.4424],
                            [-5.1569, 55.4418],
                            [-5.1736, 55.4343],
                            [-5.2064, 55.4337],
                            [-5.2242, 55.4371],
                            [-5.2503, 55.4388],
                            [-5.2681, 55.4476],
                            [-5.2892, 55.4526],
                            [-5.3053, 55.4621],
                            [-5.3158, 55.4649],
                            [-5.3292, 55.4896],
                            [-5.3258, 55.496],
                            [-5.3392, 55.5032],
                            [-5.3519, 55.5057],
                            [-5.3519, 55.5218],
                            [-5.3553, 55.5268],
                            [-5.3508, 55.5374],
                            [-5.3425, 55.5451],
                            [-5.3481, 55.5693],
                            [-5.3581, 55.5779],
                            [-5.3708, 55.584],
                            [-5.3869, 55.6037],
                            [-5.3975, 55.614],
                            [-5.3942, 55.6301],
                            [-5.3864, 55.6351],
                            [-5.3808, 55.6571],
                            [-5.3719, 55.6726],
                            [-5.3642, 55.6796],
                            [-5.3503, 55.6849],
                            [-5.3314, 55.6879],
                            [-5.3258, 55.6999],
                            [-5.3186, 55.7057],
                            [-5.3019, 55.7082],
                            [-5.2869, 55.719],
                            [-5.2603, 55.7215]
                        ]
                    ],
                    [
                        [
                            [-5.7225, 55.7304],
                            [-5.7125, 55.7185],
                            [-5.7297, 55.7107],
                            [-5.7258, 55.7046],
                            [-5.7292, 55.6893],
                            [-5.717, 55.684],
                            [-5.7358, 55.6765],
                            [-5.7292, 55.6635],
                            [-5.7419, 55.6585],
                            [-5.7547, 55.6474],
                            [-5.7697, 55.6546],
                            [-5.7642, 55.6621],
                            [-5.7758, 55.6746],
                            [-5.7631, 55.6896],
                            [-5.7481, 55.7021],
                            [-5.7503, 55.7074],
                            [-5.7397, 55.7118],
                            [-5.7364, 55.7185],
                            [-5.7225, 55.7304]
                        ]
                    ],
                    [
                        [
                            [-4.9031, 55.7932],
                            [-4.8975, 55.7915],
                            [-4.8992, 55.7696],
                            [-4.8931, 55.766],
                            [-4.8992, 55.7538],
                            [-4.9125, 55.744],
                            [-4.9175, 55.7526],
                            [-4.9281, 55.7529],
                            [-4.9386, 55.7435],
                            [-4.9469, 55.7421],
                            [-4.9519, 55.7493],
                            [-4.9431, 55.7665],
                            [-4.9319, 55.7771],
                            [-4.9308, 55.7843],
                            [-4.9164, 55.7921],
                            [-4.9031, 55.7932]
                        ]
                    ],
                    [
                        [
                            [-6.1464, 56.1326],
                            [-6.1342, 56.1224],
                            [-6.1508, 56.099],
                            [-6.1631, 56.0904],
                            [-6.1664, 56.0788],
                            [-6.1797, 56.0738],
                            [-6.1836, 56.0643],
                            [-6.192, 56.0629],
                            [-6.1836, 56.0432],
                            [-6.2047, 56.0296],
                            [-6.2186, 56.0279],
                            [-6.2269, 56.034],
                            [-6.2514, 56.034],
                            [-6.2497, 56.0443],
                            [-6.2708, 56.0346],
                            [-6.2692, 56.0449],
                            [-6.2564, 56.0485],
                            [-6.2614, 56.0582],
                            [-6.2486, 56.0618],
                            [-6.253, 56.0743],
                            [-6.2497, 56.081],
                            [-6.2331, 56.0946],
                            [-6.2158, 56.0993],
                            [-6.2136, 56.1057],
                            [-6.2042, 56.109],
                            [-6.1886, 56.1032],
                            [-6.1775, 56.1082],
                            [-6.1831, 56.1143],
                            [-6.1775, 56.1207],
                            [-6.1503, 56.1293],
                            [-6.1464, 56.1326]
                        ]
                    ],
                    [
                        [
                            [-5.6892, 56.2007],
                            [-5.6803, 56.1929],
                            [-5.6792, 56.1849],
                            [-5.6708, 56.1743],
                            [-5.6703, 56.1685],
                            [-5.6836, 56.1687],
                            [-5.6953, 56.161],
                            [-5.7236, 56.1587],
                            [-5.7453, 56.1604],
                            [-5.7519, 56.1676],
                            [-5.7481, 56.176],
                            [-5.732, 56.181],
                            [-5.7292, 56.189],
                            [-5.7108, 56.1929],
                            [-5.6892, 56.2007]
                        ]
                    ],
                    [
                        [
                            [-5.6092, 56.2296],
                            [-5.5914, 56.2235],
                            [-5.5925, 56.2101],
                            [-5.5886, 56.2051],
                            [-5.6114, 56.1957],
                            [-5.612, 56.2057],
                            [-5.6186, 56.2082],
                            [-5.6147, 56.226],
                            [-5.6092, 56.2296]
                        ]
                    ],
                    [
                        [
                            [-5.6908, 56.2351],
                            [-5.6908, 56.2165],
                            [-5.7008, 56.2107],
                            [-5.7164, 56.2101],
                            [-5.7119, 56.2182],
                            [-5.6908, 56.2351]
                        ]
                    ],
                    [
                        [
                            [-5.6369, 56.271],
                            [-5.6258, 56.254],
                            [-5.6114, 56.2657],
                            [-5.6069, 56.2565],
                            [-5.6186, 56.2496],
                            [-5.6169, 56.2426],
                            [-5.6264, 56.2237],
                            [-5.6342, 56.2029],
                            [-5.6281, 56.1979],
                            [-5.6297, 56.1896],
                            [-5.6358, 56.186],
                            [-5.6503, 56.1974],
                            [-5.6503, 56.2082],
                            [-5.6658, 56.2185],
                            [-5.6619, 56.2335],
                            [-5.6542, 56.239],
                            [-5.6614, 56.2432],
                            [-5.6481, 56.2649],
                            [-5.6369, 56.271]
                        ]
                    ],
                    [
                        [
                            [-6.3864, 56.3515],
                            [-6.3847, 56.3374],
                            [-6.4064, 56.3146],
                            [-6.4203, 56.3063],
                            [-6.4442, 56.3118],
                            [-6.4242, 56.3238],
                            [-6.4225, 56.329],
                            [-6.4314, 56.3349],
                            [-6.4153, 56.3413],
                            [-6.4064, 56.349],
                            [-6.3947, 56.3474],
                            [-6.3864, 56.3515]
                        ]
                    ],
                    [
                        [
                            [-5.4992, 56.4257],
                            [-5.4975, 56.4126],
                            [-5.5114, 56.4068],
                            [-5.5258, 56.3918],
                            [-5.5414, 56.3821],
                            [-5.5414, 56.3785],
                            [-5.5553, 56.3707],
                            [-5.5658, 56.381],
                            [-5.5897, 56.3801],
                            [-5.5831, 56.3904],
                            [-5.5664, 56.3979],
                            [-5.5681, 56.4037],
                            [-5.5581, 56.4096],
                            [-5.5425, 56.4082],
                            [-5.5136, 56.4143],
                            [-5.4992, 56.4257]
                        ]
                    ],
                    [
                        [
                            [-5.4064, 56.5371],
                            [-5.4003, 56.5346],
                            [-5.4081, 56.5265],
                            [-5.4281, 56.5282],
                            [-5.4175, 56.5349],
                            [-5.4064, 56.5371]
                        ]
                    ],
                    [
                        [
                            [-6.7542, 56.5565],
                            [-6.7464, 56.5457],
                            [-6.7258, 56.5396],
                            [-6.7258, 56.5268],
                            [-6.7453, 56.5268],
                            [-6.7647, 56.5238],
                            [-6.7742, 56.5279],
                            [-6.7886, 56.5274],
                            [-6.8053, 56.5235],
                            [-6.8136, 56.5132],
                            [-6.7981, 56.5054],
                            [-6.8081, 56.4993],
                            [-6.8131, 56.4887],
                            [-6.8275, 56.491],
                            [-6.8608, 56.4924],
                            [-6.8769, 56.489],
                            [-6.8825, 56.481],
                            [-6.8953, 56.4754],
                            [-6.8936, 56.4576],
                            [-6.8953, 56.4454],
                            [-6.9103, 56.4404],
                            [-6.9336, 56.4437],
                            [-6.9431, 56.4568],
                            [-6.9636, 56.4593],
                            [-6.9714, 56.4526],
                            [-6.9808, 56.4602],
                            [-6.9725, 56.4646],
                            [-6.9792, 56.4837],
                            [-6.9781, 56.4965],
                            [-6.9869, 56.5051],
                            [-6.9775, 56.5165],
                            [-6.9675, 56.521],
                            [-6.9536, 56.5207],
                            [-6.9514, 56.5288],
                            [-6.9336, 56.5296],
                            [-6.9231, 56.5257],
                            [-6.9108, 56.5301],
                            [-6.8986, 56.5213],
                            [-6.8731, 56.5182],
                            [-6.8586, 56.5254],
                            [-6.8597, 56.5293],
                            [-6.8308, 56.5401],
                            [-6.8081, 56.5429],
                            [-6.7925, 56.5346],
                            [-6.7764, 56.5368],
                            [-6.7731, 56.5471],
                            [-6.7592, 56.5474],
                            [-6.7542, 56.5565]
                        ]
                    ],
                    [
                        [
                            [-5.4275, 56.5615],
                            [-5.4331, 56.5513],
                            [-5.4625, 56.5335],
                            [-5.4664, 56.5288],
                            [-5.4864, 56.5179],
                            [-5.4919, 56.5096],
                            [-5.5053, 56.4985],
                            [-5.5342, 56.4885],
                            [-5.5514, 56.4754],
                            [-5.5725, 56.4685],
                            [-5.5869, 56.4615],
                            [-5.5958, 56.4649],
                            [-5.5769, 56.4746],
                            [-5.5725, 56.4949],
                            [-5.5531, 56.5024],
                            [-5.533, 56.5074],
                            [-5.5286, 56.5135],
                            [-5.5019, 56.5271],
                            [-5.4969, 56.5335],
                            [-5.4808, 56.5438],
                            [-5.4725, 56.5529],
                            [-5.4486, 56.5521],
                            [-5.4275, 56.5615]
                        ]
                    ],
                    [
                        [
                            [-6.1264, 56.6563],
                            [-6.1164, 56.654],
                            [-6.1169, 56.646],
                            [-6.0853, 56.6388],
                            [-6.0714, 56.639],
                            [-6.0597, 56.6351],
                            [-6.0581, 56.6274],
                            [-6.0625, 56.6185],
                            [-6.0347, 56.6115],
                            [-6.0169, 56.5982],
                            [-6.0136, 56.5893],
                            [-6.0008, 56.5815],
                            [-5.9903, 56.5801],
                            [-5.9836, 56.5729],
                            [-5.9864, 56.5657],
                            [-5.9708, 56.5543],
                            [-5.9636, 56.5326],
                            [-5.9569, 56.5232],
                            [-5.9497, 56.5201],
                            [-5.9403, 56.5254],
                            [-5.9247, 56.5204],
                            [-5.9225, 56.5157],
                            [-5.9058, 56.521],
                            [-5.8886, 56.5215],
                            [-5.8508, 56.5199],
                            [-5.8364, 56.509],
                            [-5.8253, 56.509],
                            [-5.8153, 56.5143],
                            [-5.8014, 56.5157],
                            [-5.7875, 56.5068],
                            [-5.7769, 56.5046],
                            [-5.7653, 56.489],
                            [-5.7414, 56.4821],
                            [-5.7186, 56.4857],
                            [-5.7019, 56.4693],
                            [-5.6958, 56.4704],
                            [-5.6775, 56.4607],
                            [-5.6775, 56.4529],
                            [-5.6669, 56.4496],
                            [-5.6525, 56.4568],
                            [-5.6453, 56.4476],
                            [-5.6481, 56.436],
                            [-5.6464, 56.4246],
                            [-5.6569, 56.424],
                            [-5.6642, 56.431],
                            [-5.6764, 56.4351],
                            [-5.6653, 56.4174],
                            [-5.6519, 56.4168],
                            [-5.6547, 56.4096],
                            [-5.6658, 56.3996],
                            [-5.6664, 56.3899],
                            [-5.6781, 56.3838],
                            [-5.6953, 56.3876],
                            [-5.7097, 56.3868],
                            [-5.7181, 56.391],
                            [-5.7114, 56.4132],
                            [-5.7308, 56.4132],
                            [-5.7358, 56.4071],
                            [-5.7297, 56.4004],
                            [-5.7419, 56.3915],
                            [-5.7536, 56.3932],
                            [-5.7597, 56.381],
                            [-5.7725, 56.3668],
                            [-5.7558, 56.3701],
                            [-5.7286, 56.3824],
                            [-5.7014, 56.384],
                            [-5.6892, 56.3796],
                            [-5.6953, 56.3699],
                            [-5.7058, 56.3604],
                            [-5.7275, 56.3535],
                            [-5.7436, 56.3421],
                            [-5.7664, 56.3354],
                            [-5.7869, 56.326],
                            [-5.8069, 56.3196],
                            [-5.8297, 56.316],
                            [-5.833, 56.3104],
                            [-5.8742, 56.314],
                            [-5.8836, 56.3168],
                            [-5.8775, 56.3248],
                            [-5.8642, 56.3335],
                            [-5.8642, 56.3404],
                            [-5.8492, 56.3423],
                            [-5.8464, 56.3513],
                            [-5.8597, 56.354],
                            [-5.8708, 56.3496],
                            [-5.8903, 56.3529],
                            [-5.9186, 56.3343],
                            [-5.9325, 56.3213],
                            [-5.9631, 56.3182],
                            [-5.9781, 56.3223],
                            [-5.9903, 56.3174],
                            [-6.0181, 56.3024],
                            [-6.0408, 56.2932],
                            [-6.0569, 56.2926],
                            [-6.0803, 56.3018],
                            [-6.0842, 56.2982],
                            [-6.1092, 56.296],
                            [-6.1269, 56.2965],
                            [-6.1364, 56.2865],
                            [-6.1603, 56.2854],
                            [-6.1642, 56.289],
                            [-6.2175, 56.2888],
                            [-6.2247, 56.2829],
                            [-6.2447, 56.2888],
                            [-6.2547, 56.2821],
                            [-6.2547, 56.2757],
                            [-6.2642, 56.2638],
                            [-6.2736, 56.2699],
                            [-6.2953, 56.2668],
                            [-6.3303, 56.2721],
                            [-6.332, 56.2835],
                            [-6.3503, 56.2818],
                            [-6.3836, 56.2863],
                            [-6.3747, 56.301],
                            [-6.3697, 56.3326],
                            [-6.3564, 56.3438],
                            [-6.3397, 56.3482],
                            [-6.3047, 56.3438],
                            [-6.2758, 56.3374],
                            [-6.2669, 56.3243],
                            [-6.2397, 56.3182],
                            [-6.2408, 56.326],
                            [-6.2508, 56.3351],
                            [-6.2486, 56.3432],
                            [-6.2314, 56.3438],
                            [-6.2131, 56.3349],
                            [-6.2014, 56.336],
                            [-6.1908, 56.3324],
                            [-6.1792, 56.3413],
                            [-6.1586, 56.3371],
                            [-6.1436, 56.3374],
                            [-6.1258, 56.3446],
                            [-6.1031, 56.3426],
                            [-6.0903, 56.351],
                            [-6.0686, 56.3568],
                            [-6.0564, 56.3574],
                            [-6.0408, 56.3626],
                            [-6.0192, 56.3651],
                            [-6.0081, 56.3743],
                            [-6.0164, 56.3857],
                            [-5.9986, 56.3865],
                            [-6.0036, 56.3932],
                            [-6.0164, 56.3912],
                            [-6.0231, 56.3943],
                            [-6.0408, 56.389],
                            [-6.0586, 56.3751],
                            [-6.0692, 56.3826],
                            [-6.0803, 56.3726],
                            [-6.1003, 56.3668],
                            [-6.1175, 56.3651],
                            [-6.1442, 56.3665],
                            [-6.1697, 56.3576],
                            [-6.1964, 56.3582],
                            [-6.2097, 56.3724],
                            [-6.2081, 56.3815],
                            [-6.2003, 56.3912],
                            [-6.1853, 56.3996],
                            [-6.1586, 56.4082],
                            [-6.1503, 56.4146],
                            [-6.1453, 56.4276],
                            [-6.1242, 56.451],
                            [-6.0975, 56.451],
                            [-6.0875, 56.4482],
                            [-6.0697, 56.4485],
                            [-6.0547, 56.4515],
                            [-6.0425, 56.4632],
                            [-6.0175, 56.4682],
                            [-6.0103, 56.4765],
                            [-6.0025, 56.4782],
                            [-5.9964, 56.489],
                            [-6.0053, 56.499],
                            [-6.0131, 56.4996],
                            [-6.0342, 56.4879],
                            [-6.0514, 56.4871],
                            [-6.0808, 56.4785],
                            [-6.1031, 56.4787],
                            [-6.1181, 56.4718],
                            [-6.1253, 56.4749],
                            [-6.1525, 56.469],
                            [-6.1586, 56.4635],
                            [-6.1764, 56.4657],
                            [-6.1942, 56.4646],
                            [-6.2042, 56.4599],
                            [-6.2131, 56.4701],
                            [-6.2397, 56.4654],
                            [-6.2475, 56.4724],
                            [-6.2625, 56.4743],
                            [-6.2819, 56.4818],
                            [-6.3058, 56.479],
                            [-6.3058, 56.494],
                            [-6.2781, 56.4974],
                            [-6.2742, 56.4912],
                            [-6.2497, 56.4971],
                            [-6.2303, 56.496],
                            [-6.2208, 56.5007],
                            [-6.1975, 56.4924],
                            [-6.1892, 56.4857],
                            [-6.1775, 56.4832],
                            [-6.1658, 56.4901],
                            [-6.1508, 56.4854],
                            [-6.1431, 56.4921],
                            [-6.1486, 56.4996],
                            [-6.1881, 56.5101],
                            [-6.2053, 56.5196],
                            [-6.2208, 56.5226],
                            [-6.2281, 56.529],
                            [-6.2614, 56.5249],
                            [-6.2858, 56.5232],
                            [-6.2958, 56.5288],
                            [-6.3331, 56.5326],
                            [-6.3408, 56.5374],
                            [-6.3392, 56.5507],
                            [-6.3331, 56.5557],
                            [-6.3075, 56.559],
                            [-6.2803, 56.5799],
                            [-6.2925, 56.5804],
                            [-6.3047, 56.5757],
                            [-6.3169, 56.5799],
                            [-6.3175, 56.5918],
                            [-6.3219, 56.5949],
                            [-6.3236, 56.6063],
                            [-6.2981, 56.604],
                            [-6.2825, 56.6068],
                            [-6.2664, 56.6049],
                            [-6.2536, 56.6135],
                            [-6.2431, 56.6082],
                            [-6.2247, 56.6049],
                            [-6.2275, 56.6154],
                            [-6.2269, 56.6321],
                            [-6.2181, 56.6349],
                            [-6.2069, 56.6304],
                            [-6.1992, 56.6413],
                            [-6.1664, 56.6418],
                            [-6.1653, 56.6454],
                            [-6.1475, 56.6532],
                            [-6.1319, 56.6507],
                            [-6.1264, 56.6563]
                        ]
                    ],
                    [
                        [
                            [-6.4675, 56.6915],
                            [-6.4508, 56.6862],
                            [-6.4542, 56.6715],
                            [-6.4647, 56.6604],
                            [-6.467, 56.6529],
                            [-6.4903, 56.6329],
                            [-6.4925, 56.6268],
                            [-6.5097, 56.6176],
                            [-6.5214, 56.6254],
                            [-6.5231, 56.6124],
                            [-6.5308, 56.606],
                            [-6.553, 56.594],
                            [-6.5658, 56.5932],
                            [-6.5658, 56.586],
                            [-6.5864, 56.586],
                            [-6.6208, 56.5779],
                            [-6.6181, 56.5863],
                            [-6.6292, 56.5893],
                            [-6.6308, 56.5774],
                            [-6.6375, 56.5721],
                            [-6.6481, 56.574],
                            [-6.6464, 56.5826],
                            [-6.6719, 56.5835],
                            [-6.6808, 56.5771],
                            [-6.6825, 56.5651],
                            [-6.6958, 56.5632],
                            [-6.7003, 56.5743],
                            [-6.7103, 56.5796],
                            [-6.6958, 56.5824],
                            [-6.6842, 56.5932],
                            [-6.6642, 56.5907],
                            [-6.6558, 56.5932],
                            [-6.6586, 56.6004],
                            [-6.6458, 56.6015],
                            [-6.6369, 56.6182],
                            [-6.6186, 56.6201],
                            [-6.6142, 56.624],
                            [-6.6181, 56.6315],
                            [-6.6125, 56.6379],
                            [-6.5997, 56.6382],
                            [-6.5947, 56.6449],
                            [-6.5836, 56.646],
                            [-6.5686, 56.6529],
                            [-6.5653, 56.6596],
                            [-6.5492, 56.6596],
                            [-6.5442, 56.6682],
                            [-6.5342, 56.6754],
                            [-6.5136, 56.6799],
                            [-6.4975, 56.6862],
                            [-6.4836, 56.6862],
                            [-6.4675, 56.6915]
                        ]
                    ],
                    [
                        [
                            [-7.6331, 56.7901],
                            [-7.6158, 56.7879],
                            [-7.6314, 56.7774],
                            [-7.6453, 56.7788],
                            [-7.6608, 56.7837],
                            [-7.6619, 56.789],
                            [-7.6331, 56.7901]
                        ]
                    ],
                    [
                        [
                            [-5.8764, 56.8112],
                            [-5.8631, 56.806],
                            [-5.8564, 56.8076],
                            [-5.8397, 56.8004],
                            [-5.8264, 56.8007],
                            [-5.8086, 56.7949],
                            [-5.8397, 56.7865],
                            [-5.8592, 56.7862],
                            [-5.8686, 56.7907],
                            [-5.888, 56.791],
                            [-5.8764, 56.8112]
                        ]
                    ],
                    [
                        [
                            [-7.6192, 56.8318],
                            [-7.6231, 56.8232],
                            [-7.6169, 56.8187],
                            [-7.6264, 56.809],
                            [-7.6208, 56.8018],
                            [-7.6369, 56.7962],
                            [-7.6531, 56.7954],
                            [-7.6642, 56.8024],
                            [-7.6603, 56.8226],
                            [-7.6331, 56.8249],
                            [-7.6319, 56.8315],
                            [-7.6192, 56.8318]
                        ]
                    ],
                    [
                        [
                            [-6.1369, 56.9446],
                            [-6.1186, 56.9357],
                            [-6.1136, 56.929],
                            [-6.1125, 56.9185],
                            [-6.118, 56.896],
                            [-6.1158, 56.8868],
                            [-6.1258, 56.8835],
                            [-6.1286, 56.8768],
                            [-6.1442, 56.8729],
                            [-6.1647, 56.8718],
                            [-6.192, 56.8793],
                            [-6.2103, 56.8885],
                            [-6.2069, 56.8926],
                            [-6.2081, 56.9071],
                            [-6.1858, 56.9157],
                            [-6.1614, 56.9132],
                            [-6.1569, 56.9324],
                            [-6.1625, 56.9363],
                            [-6.1503, 56.9424],
                            [-6.1369, 56.9446]
                        ]
                    ],
                    [
                        [
                            [-7.5675, 56.9499],
                            [-7.5508, 56.9457],
                            [-7.5319, 56.9465],
                            [-7.5314, 56.9379],
                            [-7.482, 56.9329],
                            [-7.4908, 56.9285],
                            [-7.5092, 56.9299],
                            [-7.5153, 56.9329],
                            [-7.5353, 56.926],
                            [-7.5347, 56.9218],
                            [-7.5019, 56.9218],
                            [-7.5019, 56.9168],
                            [-7.5175, 56.911],
                            [-7.5308, 56.9132],
                            [-7.5514, 56.9085],
                            [-7.5575, 56.9115],
                            [-7.5525, 56.9215],
                            [-7.5419, 56.9268],
                            [-7.582, 56.9315],
                            [-7.5842, 56.9346],
                            [-7.5669, 56.941],
                            [-7.5675, 56.9499]
                        ]
                    ],
                    [
                        [
                            [-7.3692, 57.0029],
                            [-7.3592, 56.9924],
                            [-7.3775, 56.9937],
                            [-7.3803, 57.0004],
                            [-7.3692, 57.0029]
                        ]
                    ],
                    [
                        [
                            [-7.3247, 57.0268],
                            [-7.3192, 57.0143],
                            [-7.3414, 57.0096],
                            [-7.3542, 57.009],
                            [-7.3642, 57.0143],
                            [-7.3247, 57.0268]
                        ]
                    ],
                    [
                        [
                            [-7.4475, 57.059],
                            [-7.4364, 57.0474],
                            [-7.4198, 57.044],
                            [-7.4253, 57.0307],
                            [-7.4492, 57.0246],
                            [-7.4442, 57.0193],
                            [-7.4269, 57.0137],
                            [-7.4175, 57.014],
                            [-7.3881, 57.0051],
                            [-7.3997, 56.999],
                            [-7.3775, 56.9904],
                            [-7.3847, 56.9804],
                            [-7.4031, 56.9799],
                            [-7.4147, 56.9724],
                            [-7.4181, 56.9643],
                            [-7.4286, 56.9521],
                            [-7.4442, 56.9499],
                            [-7.4542, 56.944],
                            [-7.482, 56.9454],
                            [-7.4886, 56.9526],
                            [-7.5014, 56.9499],
                            [-7.5042, 56.9454],
                            [-7.5292, 56.9465],
                            [-7.5575, 56.951],
                            [-7.5653, 56.9554],
                            [-7.5564, 56.9615],
                            [-7.5586, 56.9682],
                            [-7.5508, 56.9729],
                            [-7.5342, 56.9757],
                            [-7.5231, 56.974],
                            [-7.5153, 56.9793],
                            [-7.5281, 56.9849],
                            [-7.5097, 56.9921],
                            [-7.5069, 57.0026],
                            [-7.5169, 57.0151],
                            [-7.4853, 57.014],
                            [-7.4758, 57.019],
                            [-7.4558, 57.0246],
                            [-7.4486, 57.041],
                            [-7.4569, 57.0574],
                            [-7.4475, 57.059]
                        ]
                    ],
                    [
                        [
                            [-6.3292, 57.0607],
                            [-6.3236, 57.0562],
                            [-6.3114, 57.0554],
                            [-6.3058, 57.049],
                            [-6.2931, 57.0482],
                            [-6.2853, 57.0407],
                            [-6.273, 57.0412],
                            [-6.2592, 57.0365],
                            [-6.2464, 57.0199],
                            [-6.2581, 57.0165],
                            [-6.2747, 57.0162],
                            [-6.2758, 57.0104],
                            [-6.2425, 57.0085],
                            [-6.2375, 57.0051],
                            [-6.2492, 56.9915],
                            [-6.2486, 56.9721],
                            [-6.2708, 56.9549],
                            [-6.2875, 56.951],
                            [-6.2969, 56.939],
                            [-6.3125, 56.9351],
                            [-6.3292, 56.9349],
                            [-6.3503, 56.9474],
                            [-6.3697, 56.9524],
                            [-6.3703, 56.9624],
                            [-6.3764, 56.9732],
                            [-6.3936, 56.9743],
                            [-6.4114, 56.9851],
                            [-6.4403, 56.9982],
                            [-6.4531, 57.0021],
                            [-6.4603, 57.0082],
                            [-6.4458, 57.0096],
                            [-6.4369, 57.0193],
                            [-6.4086, 57.0302],
                            [-6.3975, 57.0427],
                            [-6.3692, 57.0537],
                            [-6.3486, 57.0518],
                            [-6.3375, 57.0596],
                            [-6.3292, 57.0607]
                        ]
                    ],
                    [
                        [
                            [-7.3881, 57.0624],
                            [-7.3769, 57.0593],
                            [-7.3708, 57.0532],
                            [-7.3869, 57.0418],
                            [-7.4008, 57.0435],
                            [-7.4031, 57.0487],
                            [-7.3931, 57.0537],
                            [-7.3997, 57.0585],
                            [-7.3881, 57.0624]
                        ]
                    ],
                    [
                        [
                            [-7.2781, 57.0921],
                            [-7.2675, 57.0907],
                            [-7.2708, 57.0765],
                            [-7.2847, 57.0654],
                            [-7.2808, 57.0568],
                            [-7.2914, 57.0521],
                            [-7.3103, 57.0599],
                            [-7.3108, 57.0685],
                            [-7.3047, 57.0743],
                            [-7.3142, 57.0799],
                            [-7.3097, 57.0896],
                            [-7.3008, 57.0871],
                            [-7.2781, 57.0921]
                        ]
                    ],
                    [
                        [
                            [-6.2042, 57.166],
                            [-6.1869, 57.1646],
                            [-6.1786, 57.1571],
                            [-6.182, 57.1512],
                            [-6.1931, 57.1474],
                            [-6.2119, 57.1465],
                            [-6.2019, 57.136],
                            [-6.2181, 57.129],
                            [-6.2319, 57.129],
                            [-6.2514, 57.1387],
                            [-6.2564, 57.1496],
                            [-6.2297, 57.1582],
                            [-6.2214, 57.1576],
                            [-6.2142, 57.1654],
                            [-6.2042, 57.166]
                        ]
                    ],
                    [
                        [
                            [-5.9986, 57.3254],
                            [-5.9619, 57.3215],
                            [-5.9392, 57.3143],
                            [-5.9242, 57.3074],
                            [-5.9203, 57.2954],
                            [-5.9275, 57.2896],
                            [-5.9253, 57.2821],
                            [-5.9408, 57.2754],
                            [-5.9592, 57.2732],
                            [-5.9875, 57.2768],
                            [-6.0186, 57.2985],
                            [-6.0236, 57.3043],
                            [-6.0192, 57.3182],
                            [-5.9986, 57.3254]
                        ]
                    ],
                    [
                        [
                            [-6.1242, 55.9382],
                            [-6.1208, 55.9351],
                            [-6.1208, 55.9196],
                            [-6.1247, 55.9049],
                            [-6.1319, 55.8899],
                            [-6.1197, 55.8832],
                            [-6.1092, 55.8626],
                            [-6.1092, 55.8554],
                            [-6.1019, 55.846],
                            [-6.1042, 55.8351],
                            [-6.1019, 55.8235],
                            [-6.1036, 55.8129],
                            [-6.0925, 55.8004],
                            [-6.0925, 55.7913],
                            [-6.0847, 55.7832],
                            [-6.0608, 55.7746],
                            [-6.047, 55.7623],
                            [-6.047, 55.7518],
                            [-6.0519, 55.7443],
                            [-6.047, 55.7338],
                            [-6.0336, 55.731],
                            [-6.0292, 55.7257],
                            [-6.0336, 55.7135],
                            [-6.0408, 55.7088],
                            [-6.0353, 55.6938],
                            [-6.0247, 55.6954],
                            [-6.0197, 55.6826],
                            [-6.0264, 55.6771],
                            [-6.0447, 55.671],
                            [-6.0531, 55.6587],
                            [-6.0686, 55.6585],
                            [-6.0747, 55.6515],
                            [-6.0731, 55.6435],
                            [-6.0831, 55.641],
                            [-6.0919, 55.646],
                            [-6.1014, 55.6404],
                            [-6.1219, 55.6329],
                            [-6.1308, 55.6335],
                            [-6.1492, 55.6254],
                            [-6.1653, 55.6304],
                            [-6.177, 55.624],
                            [-6.1897, 55.6243],
                            [-6.1903, 55.6326],
                            [-6.2158, 55.6301],
                            [-6.2169, 55.6177],
                            [-6.2258, 55.6062],
                            [-6.2358, 55.6007],
                            [-6.2386, 55.5927],
                            [-6.2586, 55.5882],
                            [-6.2669, 55.5787],
                            [-6.2842, 55.5807],
                            [-6.2958, 55.5796],
                            [-6.3131, 55.5882],
                            [-6.3364, 55.5887],
                            [-6.3325, 55.596],
                            [-6.3336, 55.606],
                            [-6.3281, 55.6262],
                            [-6.312, 55.6396],
                            [-6.3108, 55.6438],
                            [-6.2975, 55.6501],
                            [-6.2703, 55.651],
                            [-6.2603, 55.6576],
                            [-6.2619, 55.6707],
                            [-6.2675, 55.684],
                            [-6.2869, 55.7026],
                            [-6.3025, 55.7126],
                            [-6.3142, 55.7165],
                            [-6.3281, 55.7132],
                            [-6.3386, 55.7199],
                            [-6.3408, 55.7298],
                            [-6.3336, 55.7335],
                            [-6.3336, 55.7404],
                            [-6.3069, 55.7479],
                            [-6.2919, 55.7571],
                            [-6.2614, 55.7643],
                            [-6.2525, 55.7768],
                            [-6.2592, 55.7826],
                            [-6.2819, 55.7815],
                            [-6.2997, 55.7849],
                            [-6.3064, 55.7824],
                            [-6.3242, 55.7868],
                            [-6.3419, 55.7854],
                            [-6.3519, 55.7807],
                            [-6.3597, 55.7638],
                            [-6.3686, 55.7568],
                            [-6.3719, 55.7443],
                            [-6.3775, 55.7413],
                            [-6.3836, 55.7301],
                            [-6.4197, 55.7021],
                            [-6.4392, 55.6918],
                            [-6.4886, 55.6707],
                            [-6.5064, 55.6751],
                            [-6.5142, 55.6815],
                            [-6.5169, 55.6957],
                            [-6.5008, 55.7093],
                            [-6.5058, 55.721],
                            [-6.5042, 55.7268],
                            [-6.4858, 55.7448],
                            [-6.4714, 55.7507],
                            [-6.4703, 55.7615],
                            [-6.4558, 55.7729],
                            [-6.4597, 55.7871],
                            [-6.4742, 55.7857],
                            [-6.4881, 55.791],
                            [-6.4808, 55.7993],
                            [-6.4631, 55.8082],
                            [-6.4597, 55.8138],
                            [-6.4603, 55.831],
                            [-6.4547, 55.8437],
                            [-6.4553, 55.8532],
                            [-6.4369, 55.8565],
                            [-6.4225, 55.856],
                            [-6.3925, 55.8582],
                            [-6.3875, 55.8654],
                            [-6.3708, 55.8751],
                            [-6.3331, 55.8918],
                            [-6.3253, 55.8915],
                            [-6.3219, 55.884],
                            [-6.3264, 55.8765],
                            [-6.3375, 55.8674],
                            [-6.3364, 55.8535],
                            [-6.3458, 55.8346],
                            [-6.3353, 55.8243],
                            [-6.3236, 55.8285],
                            [-6.3292, 55.8351],
                            [-6.3203, 55.8421],
                            [-6.3208, 55.8501],
                            [-6.3069, 55.8604],
                            [-6.3058, 55.8674],
                            [-6.3114, 55.8746],
                            [-6.2858, 55.8763],
                            [-6.2692, 55.8824],
                            [-6.2642, 55.8915],
                            [-6.2464, 55.8968],
                            [-6.2314, 55.9043],
                            [-6.2275, 55.9099],
                            [-6.2086, 55.9157],
                            [-6.2064, 55.9207],
                            [-6.192, 55.9251],
                            [-6.1736, 55.926],
                            [-6.1619, 55.934],
                            [-6.1419, 55.9343],
                            [-6.1242, 55.9382]
                        ]
                    ],
                    [
                        [
                            [-7.1886, 57.4115],
                            [-7.1864, 57.3957],
                            [-7.197, 57.3926],
                            [-7.2097, 57.3832],
                            [-7.2264, 57.3871],
                            [-7.2292, 57.3935],
                            [-7.2236, 57.4026],
                            [-7.2086, 57.4087],
                            [-7.1886, 57.4115]
                        ]
                    ],
                    [
                        [
                            [-7.3658, 57.4126],
                            [-7.3736, 57.399],
                            [-7.3608, 57.399],
                            [-7.3392, 57.4032],
                            [-7.3164, 57.3924],
                            [-7.3158, 57.3885],
                            [-7.2825, 57.3846],
                            [-7.2703, 57.3801],
                            [-7.2692, 57.3715],
                            [-7.2619, 57.3599],
                            [-7.2497, 57.3568],
                            [-7.2219, 57.3413],
                            [-7.2319, 57.3351],
                            [-7.2431, 57.3346],
                            [-7.2358, 57.3251],
                            [-7.2219, 57.3218],
                            [-7.2242, 57.3138],
                            [-7.2203, 57.3037],
                            [-7.1975, 57.3063],
                            [-7.1908, 57.2988],
                            [-7.2025, 57.2801],
                            [-7.2186, 57.2782],
                            [-7.2375, 57.2704],
                            [-7.2514, 57.2593],
                            [-7.2425, 57.2482],
                            [-7.253, 57.2454],
                            [-7.258, 57.2288],
                            [-7.2736, 57.2229],
                            [-7.2858, 57.2221],
                            [-7.3053, 57.226],
                            [-7.2997, 57.2157],
                            [-7.2903, 57.2135],
                            [-7.2736, 57.2157],
                            [-7.2603, 57.2079],
                            [-7.2647, 57.1949],
                            [-7.2492, 57.1826],
                            [-7.2458, 57.1713],
                            [-7.2542, 57.1532],
                            [-7.2675, 57.1493],
                            [-7.2853, 57.1496],
                            [-7.3008, 57.1562],
                            [-7.3047, 57.1421],
                            [-7.2681, 57.1418],
                            [-7.2442, 57.1346],
                            [-7.2442, 57.1282],
                            [-7.2281, 57.1257],
                            [-7.2236, 57.119],
                            [-7.2097, 57.1165],
                            [-7.2242, 57.1035],
                            [-7.2269, 57.0949],
                            [-7.258, 57.0985],
                            [-7.2781, 57.1074],
                            [-7.3019, 57.1065],
                            [-7.3058, 57.1015],
                            [-7.3469, 57.1032],
                            [-7.3514, 57.1013],
                            [-7.3781, 57.1051],
                            [-7.3886, 57.1135],
                            [-7.3936, 57.124],
                            [-7.4047, 57.1312],
                            [-7.4025, 57.1382],
                            [-7.4131, 57.1504],
                            [-7.4075, 57.1599],
                            [-7.4175, 57.174],
                            [-7.4247, 57.1907],
                            [-7.4225, 57.1965],
                            [-7.423, 57.2165],
                            [-7.4336, 57.2188],
                            [-7.4319, 57.2332],
                            [-7.4381, 57.2421],
                            [-7.4253, 57.254],
                            [-7.4219, 57.289],
                            [-7.4103, 57.2921],
                            [-7.3986, 57.3037],
                            [-7.4003, 57.3099],
                            [-7.3958, 57.3312],
                            [-7.4036, 57.3579],
                            [-7.4131, 57.371],
                            [-7.4319, 57.3851],
                            [-7.4258, 57.3899],
                            [-7.4114, 57.3879],
                            [-7.4003, 57.399],
                            [-7.3792, 57.3987],
                            [-7.3658, 57.4126]
                        ]
                    ],
                    [
                        [
                            [-5.7086, 56.1493],
                            [-5.7031, 56.1482],
                            [-5.6914, 56.1362],
                            [-5.6936, 56.1232],
                            [-5.6869, 56.1154],
                            [-5.6969, 56.101],
                            [-5.7081, 56.0946],
                            [-5.7247, 56.076],
                            [-5.7303, 56.0732],
                            [-5.7464, 56.0538],
                            [-5.7542, 56.0473],
                            [-5.7558, 56.0376],
                            [-5.7692, 56.0288],
                            [-5.7686, 56.0232],
                            [-5.7786, 56.0143],
                            [-5.7914, 56.014],
                            [-5.7964, 56.004],
                            [-5.8042, 55.9988],
                            [-5.8081, 55.9879],
                            [-5.8219, 55.971],
                            [-5.8347, 55.964],
                            [-5.8386, 55.9538],
                            [-5.8503, 55.9424],
                            [-5.848, 55.9368],
                            [-5.8525, 55.9279],
                            [-5.8675, 55.9171],
                            [-5.8758, 55.9054],
                            [-5.8781, 55.8935],
                            [-5.897, 55.8899],
                            [-5.9003, 55.8815],
                            [-5.8942, 55.871],
                            [-5.9225, 55.8721],
                            [-5.9364, 55.8671],
                            [-5.9508, 55.8351],
                            [-5.9425, 55.8312],
                            [-5.9419, 55.8226],
                            [-5.9531, 55.816],
                            [-5.9631, 55.7924],
                            [-5.9992, 55.7946],
                            [-6.0131, 55.7979],
                            [-6.0281, 55.7946],
                            [-6.0414, 55.8015],
                            [-6.0647, 55.8057],
                            [-6.0792, 55.8176],
                            [-6.0875, 55.831],
                            [-6.0908, 55.8451],
                            [-6.0869, 55.8637],
                            [-6.0969, 55.8712],
                            [-6.0919, 55.8782],
                            [-6.0931, 55.8912],
                            [-6.0875, 55.899],
                            [-6.0742, 55.9054],
                            [-6.0658, 55.9199],
                            [-6.0436, 55.9399],
                            [-5.9986, 55.9526],
                            [-5.9814, 55.9493],
                            [-5.9614, 55.9538],
                            [-5.9392, 55.9551],
                            [-5.9297, 55.9599],
                            [-5.9192, 55.959],
                            [-5.8931, 55.9657],
                            [-5.8886, 55.9746],
                            [-5.9164, 55.9735],
                            [-5.9242, 55.9621],
                            [-5.9481, 55.9632],
                            [-5.9592, 55.9679],
                            [-5.9714, 55.9671],
                            [-5.9908, 55.9743],
                            [-6.0075, 55.9732],
                            [-5.9992, 55.9829],
                            [-6.0025, 55.9879],
                            [-5.9914, 56.0004],
                            [-5.9642, 56.0154],
                            [-5.9636, 56.0282],
                            [-5.9536, 56.0357],
                            [-5.9175, 56.0493],
                            [-5.9047, 56.0554],
                            [-5.9042, 56.0607],
                            [-5.8919, 56.0671],
                            [-5.8547, 56.0813],
                            [-5.8442, 56.083],
                            [-5.8375, 56.089],
                            [-5.8219, 56.0893],
                            [-5.8175, 56.101],
                            [-5.8036, 56.1037],
                            [-5.8042, 56.1096],
                            [-5.7914, 56.1121],
                            [-5.7553, 56.1268],
                            [-5.7486, 56.1357],
                            [-5.7386, 56.1412],
                            [-5.7219, 56.1418],
                            [-5.7208, 56.1482],
                            [-5.7086, 56.1493]
                        ]
                    ],
                    [
                        [
                            [-7.2753, 57.4832],
                            [-7.2569, 57.4787],
                            [-7.2575, 57.4699],
                            [-7.2708, 57.4715],
                            [-7.2753, 57.4832]
                        ]
                    ],
                    [
                        [
                            [-7.3175, 57.4951],
                            [-7.3181, 57.4857],
                            [-7.3003, 57.4888],
                            [-7.2764, 57.4782],
                            [-7.2669, 57.466],
                            [-7.2558, 57.4668],
                            [-7.2553, 57.4774],
                            [-7.2381, 57.4746],
                            [-7.2003, 57.4596],
                            [-7.2108, 57.4543],
                            [-7.2347, 57.461],
                            [-7.2347, 57.4538],
                            [-7.2219, 57.451],
                            [-7.2175, 57.4457],
                            [-7.2431, 57.4465],
                            [-7.2647, 57.4412],
                            [-7.2647, 57.4376],
                            [-7.2236, 57.4385],
                            [-7.2025, 57.4285],
                            [-7.2075, 57.4218],
                            [-7.2014, 57.4174],
                            [-7.2075, 57.4104],
                            [-7.2353, 57.4085],
                            [-7.2397, 57.4012],
                            [-7.2619, 57.4076],
                            [-7.2686, 57.4043],
                            [-7.2381, 57.3951],
                            [-7.2475, 57.3899],
                            [-7.2647, 57.3874],
                            [-7.2619, 57.3971],
                            [-7.2892, 57.4001],
                            [-7.3014, 57.3974],
                            [-7.3175, 57.401],
                            [-7.3308, 57.4085],
                            [-7.3414, 57.409],
                            [-7.3653, 57.4218],
                            [-7.3942, 57.4246],
                            [-7.3931, 57.4351],
                            [-7.3975, 57.4435],
                            [-7.4114, 57.4496],
                            [-7.4119, 57.4546],
                            [-7.4014, 57.4582],
                            [-7.4119, 57.469],
                            [-7.4008, 57.4749],
                            [-7.3819, 57.4743],
                            [-7.3719, 57.4824],
                            [-7.3669, 57.4918],
                            [-7.3447, 57.4938],
                            [-7.3408, 57.4907],
                            [-7.3208, 57.489],
                            [-7.3175, 57.4951]
                        ]
                    ],
                    [
                        [
                            [-7.2047, 57.5032],
                            [-7.1714, 57.5029],
                            [-7.1597, 57.4946],
                            [-7.1575, 57.4851],
                            [-7.1681, 57.4724],
                            [-7.1797, 57.4679],
                            [-7.1947, 57.4724],
                            [-7.1881, 57.4793],
                            [-7.2075, 57.4913],
                            [-7.1936, 57.4976],
                            [-7.2047, 57.5032]
                        ]
                    ],
                    [
                        [
                            [-7.2664, 57.511],
                            [-7.2586, 57.5074],
                            [-7.2597, 57.5004],
                            [-7.2519, 57.5004],
                            [-7.2536, 57.5057],
                            [-7.2408, 57.506],
                            [-7.2197, 57.5015],
                            [-7.2114, 57.4868],
                            [-7.2053, 57.4863],
                            [-7.2042, 57.4729],
                            [-7.2492, 57.479],
                            [-7.2636, 57.4901],
                            [-7.2758, 57.4868],
                            [-7.2797, 57.4924],
                            [-7.273, 57.5035],
                            [-7.2869, 57.5099],
                            [-7.2664, 57.511]
                        ]
                    ],
                    [
                        [
                            [-6.0036, 57.5165],
                            [-5.9947, 57.5115],
                            [-5.9836, 57.4963],
                            [-5.9781, 57.4926],
                            [-5.9986, 57.4549],
                            [-6.0147, 57.4443],
                            [-6.0253, 57.4421],
                            [-6.0314, 57.4287],
                            [-6.0219, 57.4201],
                            [-6.0131, 57.3815],
                            [-6.0008, 57.3701],
                            [-5.9914, 57.3679],
                            [-5.9942, 57.3549],
                            [-6.0119, 57.3429],
                            [-6.0203, 57.3326],
                            [-6.0525, 57.3282],
                            [-6.0686, 57.3335],
                            [-6.0686, 57.346],
                            [-6.0819, 57.3501],
                            [-6.0831, 57.3704],
                            [-6.0753, 57.3776],
                            [-6.0775, 57.3937],
                            [-6.0831, 57.4001],
                            [-6.0853, 57.4215],
                            [-6.0808, 57.4357],
                            [-6.0647, 57.4551],
                            [-6.0547, 57.4621],
                            [-6.0425, 57.4588],
                            [-6.0308, 57.4596],
                            [-6.0197, 57.4557],
                            [-6.0119, 57.464],
                            [-6.0319, 57.4796],
                            [-6.0347, 57.491],
                            [-6.0247, 57.496],
                            [-6.0119, 57.4899],
                            [-5.9925, 57.494],
                            [-5.9942, 57.5021],
                            [-6.0058, 57.5088],
                            [-6.0036, 57.5165]
                        ]
                    ],
                    [
                        [
                            [-6.4281, 58.1104],
                            [-6.4308, 58.1032],
                            [-6.4436, 58.0985],
                            [-6.4525, 58.1021],
                            [-6.4403, 58.1085],
                            [-6.4281, 58.1104]
                        ]
                    ]
                ]
            },
            'properties': {
                'name': 'Scotland',
                'id': 'GB-SCT',
                'TYPE': 'Scotland',
                'CNTRY': 'United Kingdom'
            },
            'id': 'GB-SCT'
        },
        // {
        //     'type': 'Feature',
        //     'geometry': {
        //         'type': 'MultiPolygon',
        //         'coordinates': [
        //             [
        //                 [
        //                     [-1.8003, 55.6885],
        //                     [-1.7858, 55.6851],
        //                     [-1.7797, 55.6704],
        //                     [-1.8025, 55.6679],
        //                     [-1.8069, 55.6779],
        //                     [-1.8197, 55.6826],
        //                     [-1.8314, 55.6826],
        //                     [-1.8392, 55.6776],
        //                     [-1.8525, 55.6801],
        //                     [-1.8542, 55.6879],
        //                     [-1.8447, 55.6887],
        //                     [-1.8269, 55.6849],
        //                     [-1.8003, 55.6885]
        //                 ]
        //             ],
        //             [
        //                 [
        //                     [-2.0303, 55.8044],
        //                     [-2.0219, 55.8018],
        //                     [-2.0136, 55.7924],
        //                     [-2.0008, 55.7865],
        //                     [-1.9897, 55.7693],
        //                     [-1.9925, 55.7613],
        //                     [-1.9892, 55.7554],
        //                     [-1.9631, 55.7388],
        //                     [-1.9614, 55.7343],
        //                     [-1.9347, 55.7182],
        //                     [-1.9214, 55.7132],
        //                     [-1.9119, 55.7054],
        //                     [-1.8875, 55.6971],
        //                     [-1.873, 55.6835],
        //                     [-1.8708, 55.6749],
        //                     [-1.863, 55.6674],
        //                     [-1.8603, 55.659],
        //                     [-1.847, 55.6524],
        //                     [-1.8314, 55.6393],
        //                     [-1.808, 55.6346],
        //                     [-1.8008, 55.6385],
        //                     [-1.7908, 55.6546],
        //                     [-1.7819, 55.6418],
        //                     [-1.7642, 55.6271],
        //                     [-1.777, 55.6143],
        //                     [-1.7686, 55.6054],
        //                     [-1.7425, 55.6187],
        //                     [-1.7208, 55.6165],
        //                     [-1.7203, 55.6129],
        //                     [-1.6931, 55.6065],
        //                     [-1.6747, 55.5943],
        //                     [-1.6664, 55.586],
        //                     [-1.6392, 55.5787],
        //                     [-1.6464, 55.5751],
        //                     [-1.6419, 55.5665],
        //                     [-1.6242, 55.5521],
        //                     [-1.6325, 55.5507],
        //                     [-1.6392, 55.5401],
        //                     [-1.6197, 55.5226],
        //                     [-1.6142, 55.5101],
        //                     [-1.6153, 55.4982],
        //                     [-1.592, 55.4907],
        //                     [-1.592, 55.4554],
        //                     [-1.587, 55.4468],
        //                     [-1.5925, 55.4393],
        //                     [-1.5786, 55.4313],
        //                     [-1.5825, 55.4187],
        //                     [-1.5792, 55.4071],
        //                     [-1.5908, 55.4043],
        //                     [-1.5975, 55.3938],
        //                     [-1.6103, 55.3879],
        //                     [-1.6014, 55.3601],
        //                     [-1.5819, 55.3393],
        //                     [-1.5725, 55.3362],
        //                     [-1.5508, 55.3224],
        //                     [-1.5503, 55.3115],
        //                     [-1.5592, 55.3065],
        //                     [-1.5708, 55.2904],
        //                     [-1.572, 55.2754],
        //                     [-1.5603, 55.2526],
        //                     [-1.5475, 55.2396],
        //                     [-1.5336, 55.2335],
        //                     [-1.5275, 55.2157],
        //                     [-1.5108, 55.1996],
        //                     [-1.5031, 55.1974],
        //                     [-1.5081, 55.1851],
        //                     [-1.5147, 55.181],
        //                     [-1.5131, 55.1749],
        //                     [-1.5253, 55.1626],
        //                     [-1.5197, 55.1457],
        //                     [-1.4975, 55.129],
        //                     [-1.4931, 55.119],
        //                     [-1.4992, 55.1121],
        //                     [-1.4975, 55.1043],
        //                     [-1.4881, 55.0935],
        //                     [-1.477, 55.0854],
        //                     [-1.4692, 55.0849],
        //                     [-1.4631, 55.0757],
        //                     [-1.4519, 55.0696],
        //                     [-1.4553, 55.0651],
        //                     [-1.4519, 55.0554],
        //                     [-1.4419, 55.0451],
        //                     [-1.4303, 55.0407],
        //                     [-1.4264, 55.024],
        //                     [-1.4203, 55.0229],
        //                     [-1.4186, 55.0135],
        //                     [-1.4292, 55.0135],
        //                     [-1.4219, 55.0029],
        //                     [-1.4058, 54.9943],
        //                     [-1.3803, 54.9868],
        //                     [-1.3809, 54.9801],
        //                     [-1.3592, 54.9721],
        //                     [-1.3525, 54.9565],
        //                     [-1.3564, 54.9485],
        //                     [-1.3642, 54.9443],
        //                     [-1.3681, 54.936],
        //                     [-1.3647, 54.9224],
        //                     [-1.3508, 54.9068],
        //                     [-1.3597, 54.8999],
        //                     [-1.3608, 54.891],
        //                     [-1.3536, 54.8807],
        //                     [-1.3547, 54.8729],
        //                     [-1.3469, 54.864],
        //                     [-1.3436, 54.8524],
        //                     [-1.3236, 54.8357],
        //                     [-1.3203, 54.8199],
        //                     [-1.3125, 54.8129],
        //                     [-1.3086, 54.7996],
        //                     [-1.3103, 54.7896],
        //                     [-1.3014, 54.771],
        //                     [-1.2886, 54.7582],
        //                     [-1.2686, 54.7465],
        //                     [-1.2625, 54.7385],
        //                     [-1.2397, 54.721],
        //                     [-1.2258, 54.714],
        //                     [-1.1803, 54.7004],
        //                     [-1.1786, 54.6935],
        //                     [-1.1975, 54.6918],
        //                     [-1.1958, 54.6754],
        //                     [-1.1875, 54.6643],
        //                     [-1.1686, 54.6457],
        //                     [-1.1697, 54.6326],
        //                     [-1.1881, 54.6324],
        //                     [-1.2008, 54.6218],
        //                     [-1.1714, 54.6213],
        //                     [-1.1519, 54.6285],
        //                     [-1.1369, 54.6276],
        //                     [-1.1386, 54.639],
        //                     [-1.1225, 54.6299],
        //                     [-1.0897, 54.6204],
        //                     [-1.0731, 54.621],
        //                     [-1.0525, 54.6165],
        //                     [-1.0403, 54.6068],
        //                     [-1.0025, 54.5938],
        //                     [-0.9703, 54.5868],
        //                     [-0.9592, 54.586],
        //                     [-0.9436, 54.5893],
        //                     [-0.9258, 54.5871],
        //                     [-0.8992, 54.5721],
        //                     [-0.8714, 54.5701],
        //                     [-0.8497, 54.5715],
        //                     [-0.8325, 54.5671],
        //                     [-0.8247, 54.5624],
        //                     [-0.8092, 54.559],
        //                     [-0.7831, 54.5593],
        //                     [-0.7788, 54.5574],
        //                     [-0.7883, 54.5472],
        //                     [-0.8147, 54.5406],
        //                     [-0.8294, 54.53],
        //                     [-0.8378, 54.5158],
        //                     [-0.8383, 54.4872],
        //                     [-0.8808, 54.4958],
        //                     [-0.9325, 54.4867],
        //                     [-0.9553, 54.4975],
        //                     [-0.9761, 54.5],
        //                     [-1.0292, 54.4925],
        //                     [-1.0744, 54.505],
        //                     [-1.1142, 54.498],
        //                     [-1.2017, 54.5058],
        //                     [-1.235, 54.4997],
        //                     [-1.2483, 54.4875],
        //                     [-1.3267, 54.4622],
        //                     [-1.3333, 54.4675],
        //                     [-1.3619, 54.4675],
        //                     [-1.3697, 54.4889],
        //                     [-1.382, 54.4936],
        //                     [-1.388, 54.4889],
        //                     [-1.4083, 54.4925],
        //                     [-1.4167, 54.4778],
        //                     [-1.4319, 54.4812],
        //                     [-1.4361, 54.4905],
        //                     [-1.4469, 54.4978],
        //                     [-1.4594, 54.4986],
        //                     [-1.4669, 54.4942],
        //                     [-1.4667, 54.4828],
        //                     [-1.4461, 54.4511],
        //                     [-1.4492, 54.4444],
        //                     [-1.4603, 54.4417],
        //                     [-1.4722, 54.4481],
        //                     [-1.4844, 54.4711],
        //                     [-1.495, 54.4789],
        //                     [-1.5255, 54.4808],
        //                     [-1.5203, 54.4667],
        //                     [-1.5325, 54.4653],
        //                     [-1.5778, 54.4897],
        //                     [-1.5908, 54.5086],
        //                     [-1.6003, 54.5125],
        //                     [-1.63, 54.5083],
        //                     [-1.6353, 54.5097],
        //                     [-1.6422, 54.5233],
        //                     [-1.6622, 54.5308],
        //                     [-1.7136, 54.5317],
        //                     [-1.7247, 54.525],
        //                     [-1.7489, 54.5305],
        //                     [-1.7669, 54.5286],
        //                     [-1.7672, 54.5139],
        //                     [-1.7794, 54.5011],
        //                     [-1.7872, 54.4817],
        //                     [-1.8244, 54.5028],
        //                     [-1.8358, 54.5044],
        //                     [-1.8497, 54.4933],
        //                     [-1.8508, 54.4805],
        //                     [-1.9305, 54.4547],
        //                     [-1.9561, 54.4544],
        //                     [-2.0069, 54.4725],
        //                     [-2.0456, 54.4797],
        //                     [-2.0997, 54.4681],
        //                     [-2.1389, 54.4497],
        //                     [-2.1552, 54.4557],
        //                     [-2.1503, 54.473],
        //                     [-2.1581, 54.4856],
        //                     [-2.163, 54.5281],
        //                     [-2.1917, 54.5314],
        //                     [-2.2094, 54.5522],
        //                     [-2.2853, 54.5881],
        //                     [-2.2964, 54.6031],
        //                     [-2.3056, 54.6278],
        //                     [-2.2861, 54.6403],
        //                     [-2.2792, 54.6503],
        //                     [-2.2806, 54.6578],
        //                     [-2.2908, 54.6658],
        //                     [-2.3447, 54.6822],
        //                     [-2.3539, 54.6908],
        //                     [-2.3272, 54.7275],
        //                     [-2.305, 54.7833],
        //                     [-2.362, 54.8108],
        //                     [-2.4, 54.8472],
        //                     [-2.4122, 54.8456],
        //                     [-2.4308, 54.8331],
        //                     [-2.5, 54.8053],
        //                     [-2.5336, 54.8081],
        //                     [-2.5636, 54.8236],
        //                     [-2.5703, 54.8364],
        //                     [-2.5633, 54.8469],
        //                     [-2.5664, 54.8583],
        //                     [-2.5875, 54.8731],
        //                     [-2.5936, 54.8828],
        //                     [-2.5703, 54.8931],
        //                     [-2.5594, 54.9158],
        //                     [-2.5417, 54.923],
        //                     [-2.5572, 54.9375],
        //                     [-2.565, 54.9578],
        //                     [-2.5919, 54.9667],
        //                     [-2.5678, 54.9861],
        //                     [-2.5669, 55.0058],
        //                     [-2.56, 55.0119],
        //                     [-2.4819, 55.0392],
        //                     [-2.4947, 55.058],
        //                     [-2.4914, 55.0653],
        //                     [-2.4958, 55.0719],
        //                     [-2.4853, 55.0794],
        //                     [-2.5053, 55.0869],
        //                     [-2.5472, 55.08],
        //                     [-2.555, 55.0894],
        //                     [-2.5875, 55.103],
        //                     [-2.5978, 55.1236],
        //                     [-2.6408, 55.1322],
        //                     [-2.6542, 55.1433],
        //                     [-2.6775, 55.1858],
        //                     [-2.6856, 55.1913],
        //                     [-2.6597, 55.2164],
        //                     [-2.6261, 55.2233],
        //                     [-2.6183, 55.2442],
        //                     [-2.6306, 55.255],
        //                     [-2.6283, 55.2655],
        //                     [-2.57, 55.2922],
        //                     [-2.5522, 55.3155],
        //                     [-2.5228, 55.3256],
        //                     [-2.4967, 55.345],
        //                     [-2.4631, 55.3611],
        //                     [-2.4278, 55.3669],
        //                     [-2.4022, 55.3614],
        //                     [-2.385, 55.3442],
        //                     [-2.3497, 55.3647],
        //                     [-2.3417, 55.3853],
        //                     [-2.3308, 55.3983],
        //                     [-2.2942, 55.4031],
        //                     [-2.2733, 55.4197],
        //                     [-2.2161, 55.4253],
        //                     [-2.1825, 55.4589],
        //                     [-2.1867, 55.4694],
        //                     [-2.2139, 55.4903],
        //                     [-2.2169, 55.5094],
        //                     [-2.2578, 55.5495],
        //                     [-2.2783, 55.5897],
        //                     [-2.3014, 55.6047],
        //                     [-2.2994, 55.6139],
        //                     [-2.3258, 55.6222],
        //                     [-2.3309, 55.6406],
        //                     [-2.2386, 55.6519],
        //                     [-2.22, 55.665],
        //                     [-2.1942, 55.6936],
        //                     [-2.1772, 55.7025],
        //                     [-2.1725, 55.7192],
        //                     [-2.1383, 55.7366],
        //                     [-2.1167, 55.7419],
        //                     [-2.0885, 55.7585],
        //                     [-2.0803, 55.7944],
        //                     [-2.0303, 55.8044]
        //                 ]
        //             ]
        //         ]
        //     },
        //     'properties': {
        //         'name': 'North East England',
        //         'id': 'GB-UKC',
        //         'TYPE': 'England',
        //         'CNTRY': 'United Kingdom'
        //     },
        //     'id': 'GB-UKC'
        // }, {
        //     'type': 'Feature',
        //     'geometry': {
        //         'type': 'MultiPolygon',
        //         'coordinates': [
        //             [
        //                 [
        //                     [-3.2553, 54.1529],
        //                     [-3.2658, 54.1432],
        //                     [-3.2531, 54.1312],
        //                     [-3.2497, 54.1157],
        //                     [-3.2453, 54.1112],
        //                     [-3.2425, 54.0987],
        //                     [-3.2458, 54.0935],
        //                     [-3.2286, 54.0879],
        //                     [-3.2231, 54.0804],
        //                     [-3.2236, 54.0715],
        //                     [-3.2103, 54.0651],
        //                     [-3.2075, 54.054],
        //                     [-3.1981, 54.0488],
        //                     [-3.1775, 54.0549],
        //                     [-3.1731, 54.0468],
        //                     [-3.1942, 54.0443],
        //                     [-3.2086, 54.0465],
        //                     [-3.2325, 54.0699],
        //                     [-3.2436, 54.0779],
        //                     [-3.2592, 54.0943],
        //                     [-3.273, 54.116],
        //                     [-3.2769, 54.1437],
        //                     [-3.2697, 54.1493],
        //                     [-3.2553, 54.1529]
        //                 ]
        //             ],
        //             [
        //                 [
        //                     [-2.6856, 55.1913],
        //                     [-2.6775, 55.1858],
        //                     [-2.6542, 55.1433],
        //                     [-2.6408, 55.1322],
        //                     [-2.5978, 55.1236],
        //                     [-2.5875, 55.103],
        //                     [-2.555, 55.0894],
        //                     [-2.5472, 55.08],
        //                     [-2.5053, 55.0869],
        //                     [-2.4853, 55.0794],
        //                     [-2.4958, 55.0719],
        //                     [-2.4914, 55.0653],
        //                     [-2.4947, 55.058],
        //                     [-2.4819, 55.0392],
        //                     [-2.56, 55.0119],
        //                     [-2.5669, 55.0058],
        //                     [-2.5678, 54.9861],
        //                     [-2.5919, 54.9667],
        //                     [-2.565, 54.9578],
        //                     [-2.5572, 54.9375],
        //                     [-2.5417, 54.923],
        //                     [-2.5594, 54.9158],
        //                     [-2.5703, 54.8931],
        //                     [-2.5936, 54.8828],
        //                     [-2.5875, 54.8731],
        //                     [-2.5664, 54.8583],
        //                     [-2.5633, 54.8469],
        //                     [-2.5703, 54.8364],
        //                     [-2.5636, 54.8236],
        //                     [-2.5336, 54.8081],
        //                     [-2.5, 54.8053],
        //                     [-2.4308, 54.8331],
        //                     [-2.4122, 54.8456],
        //                     [-2.4, 54.8472],
        //                     [-2.362, 54.8108],
        //                     [-2.305, 54.7833],
        //                     [-2.3272, 54.7275],
        //                     [-2.3539, 54.6908],
        //                     [-2.3447, 54.6822],
        //                     [-2.2908, 54.6658],
        //                     [-2.2806, 54.6578],
        //                     [-2.2792, 54.6503],
        //                     [-2.2861, 54.6403],
        //                     [-2.3056, 54.6278],
        //                     [-2.2964, 54.6031],
        //                     [-2.2853, 54.5881],
        //                     [-2.2094, 54.5522],
        //                     [-2.1917, 54.5314],
        //                     [-2.163, 54.5281],
        //                     [-2.1581, 54.4856],
        //                     [-2.1503, 54.473],
        //                     [-2.1552, 54.4557],
        //                     [-2.1683, 54.4597],
        //                     [-2.1942, 54.4467],
        //                     [-2.2447, 54.4481],
        //                     [-2.2767, 54.4355],
        //                     [-2.2956, 54.4178],
        //                     [-2.2833, 54.3947],
        //                     [-2.2833, 54.3828],
        //                     [-2.3472, 54.3503],
        //                     [-2.3411, 54.3422],
        //                     [-2.3128, 54.33],
        //                     [-2.3061, 54.3206],
        //                     [-2.3056, 54.2925],
        //                     [-2.3114, 54.2814],
        //                     [-2.3003, 54.2653],
        //                     [-2.3039, 54.2486],
        //                     [-2.3097, 54.2433],
        //                     [-2.3294, 54.2408],
        //                     [-2.3525, 54.2506],
        //                     [-2.3828, 54.2417],
        //                     [-2.4006, 54.2283],
        //                     [-2.4475, 54.2303],
        //                     [-2.4533, 54.2172],
        //                     [-2.5117, 54.1717],
        //                     [-2.5189, 54.1603],
        //                     [-2.5475, 54.1511],
        //                     [-2.5514, 54.1283],
        //                     [-2.545, 54.1136],
        //                     [-2.5192, 54.0972],
        //                     [-2.4678, 54.0797],
        //                     [-2.4595, 54.0717],
        //                     [-2.4583, 54.0472],
        //                     [-2.4486, 54.04],
        //                     [-2.4269, 54.0381],
        //                     [-2.3805, 54.0456],
        //                     [-2.3547, 54.0425],
        //                     [-2.3489, 54.037],
        //                     [-2.3458, 54.0219],
        //                     [-2.3369, 54.0181],
        //                     [-2.3475, 54.0022],
        //                     [-2.335, 53.9911],
        //                     [-2.3, 53.9892],
        //                     [-2.2872, 53.9711],
        //                     [-2.2742, 53.97],
        //                     [-2.2275, 53.9828],
        //                     [-2.2283, 53.9728],
        //                     [-2.2222, 53.9681],
        //                     [-2.1905, 53.9658],
        //                     [-2.1786, 53.9547],
        //                     [-2.1742, 53.9361],
        //                     [-2.105, 53.9147],
        //                     [-2.0975, 53.8886],
        //                     [-2.0661, 53.8628],
        //                     [-2.0325, 53.8477],
        //                     [-2.0372, 53.8333],
        //                     [-2.0472, 53.8244],
        //                     [-2.0955, 53.8105],
        //                     [-2.1205, 53.7914],
        //                     [-2.1214, 53.7553],
        //                     [-2.1597, 53.7256],
        //                     [-2.1492, 53.7053],
        //                     [-2.1513, 53.6966],
        //                     [-2.1422, 53.6942],
        //                     [-2.1317, 53.6822],
        //                     [-2.118, 53.683],
        //                     [-2.0986, 53.6719],
        //                     [-2.0811, 53.6747],
        //                     [-2.065, 53.6836],
        //                     [-2.0464, 53.6842],
        //                     [-2.0436, 53.6739],
        //                     [-2.0314, 53.6633],
        //                     [-2.035, 53.6469],
        //                     [-2.0239, 53.6394],
        //                     [-2.0169, 53.6186],
        //                     [-1.988, 53.6147],
        //                     [-1.9769, 53.5939],
        //                     [-1.9378, 53.5681],
        //                     [-1.8972, 53.533],
        //                     [-1.91, 53.5205],
        //                     [-1.9189, 53.5008],
        //                     [-1.9325, 53.4958],
        //                     [-1.9636, 53.4947],
        //                     [-1.9778, 53.4689],
        //                     [-1.9825, 53.4439],
        //                     [-2.0092, 53.4275],
        //                     [-2.0131, 53.42],
        //                     [-2.0116, 53.4125],
        //                     [-1.9906, 53.4064],
        //                     [-1.9814, 53.3983],
        //                     [-2.0044, 53.3742],
        //                     [-2.0167, 53.3705],
        //                     [-2.0186, 53.3633],
        //                     [-2.0011, 53.3472],
        //                     [-1.9981, 53.3358],
        //                     [-1.9956, 53.2642],
        //                     [-1.9906, 53.2417],
        //                     [-1.9708, 53.2303],
        //                     [-1.9768, 53.2074],
        //                     [-2.0056, 53.1861],
        //                     [-2.0306, 53.1847],
        //                     [-2.0683, 53.1658],
        //                     [-2.1017, 53.1658],
        //                     [-2.125, 53.175],
        //                     [-2.14, 53.17],
        //                     [-2.1308, 53.1578],
        //                     [-2.1347, 53.1503],
        //                     [-2.1578, 53.1475],
        //                     [-2.2464, 53.0839],
        //                     [-2.2722, 53.0775],
        //                     [-2.3056, 53.0792],
        //                     [-2.3356, 53.0561],
        //                     [-2.3658, 53.0522],
        //                     [-2.3739, 53.0372],
        //                     [-2.3664, 53.0003],
        //                     [-2.3788, 52.9896],
        //                     [-2.4236, 52.9786],
        //                     [-2.4308, 52.965],
        //                     [-2.4494, 52.9569],
        //                     [-2.4789, 52.9542],
        //                     [-2.5128, 52.9617],
        //                     [-2.5272, 52.9472],
        //                     [-2.5581, 52.9564],
        //                     [-2.5778, 52.9536],
        //                     [-2.5895, 52.9769],
        //                     [-2.6228, 52.9858],
        //                     [-2.7277, 52.9666],
        //                     [-2.7744, 52.985],
        //                     [-2.8128, 52.9842],
        //                     [-2.8275, 53.0022],
        //                     [-2.8605, 53.0219],
        //                     [-2.8569, 53.0325],
        //                     [-2.8644, 53.0536],
        //                     [-2.8955, 53.1008],
        //                     [-2.8939, 53.1041],
        //                     [-2.9383, 53.1247],
        //                     [-2.9592, 53.1472],
        //                     [-2.9575, 53.1517],
        //                     [-2.9092, 53.1714],
        //                     [-2.9125, 53.1864],
        //                     [-2.9553, 53.2155],
        //                     [-3.0014, 53.2394],
        //                     [-3.0372, 53.2511],
        //                     [-3.0811, 53.2505],
        //                     [-3.0925, 53.2567],
        //                     [-3.1014, 53.2637],
        //                     [-3.1031, 53.271],
        //                     [-3.0875, 53.2787],
        //                     [-3.1103, 53.2876],
        //                     [-3.1131, 53.2957],
        //                     [-3.1225, 53.3049],
        //                     [-3.1297, 53.3257],
        //                     [-3.1475, 53.3415],
        //                     [-3.1592, 53.3462],
        //                     [-3.1731, 53.3554],
        //                     [-3.1925, 53.3751],
        //                     [-3.1964, 53.3874],
        //                     [-3.1792, 53.3982],
        //                     [-3.1569, 53.4074],
        //                     [-3.1314, 53.4146],
        //                     [-3.0992, 53.4221],
        //                     [-3.0753, 53.4346],
        //                     [-3.0386, 53.4413],
        //                     [-3.0286, 53.4276],
        //                     [-3.0258, 53.4193],
        //                     [-3.0142, 53.4101],
        //                     [-3.0086, 53.3901],
        //                     [-2.9981, 53.3704],
        //                     [-2.9886, 53.3618],
        //                     [-2.9747, 53.3562],
        //                     [-2.9519, 53.326],
        //                     [-2.9397, 53.3154],
        //                     [-2.9225, 53.3057],
        //                     [-2.9108, 53.3054],
        //                     [-2.8764, 53.289],
        //                     [-2.8386, 53.294],
        //                     [-2.8119, 53.3049],
        //                     [-2.7792, 53.3051],
        //                     [-2.7464, 53.3121],
        //                     [-2.763, 53.3276],
        //                     [-2.7786, 53.3279],
        //                     [-2.7853, 53.3226],
        //                     [-2.7947, 53.3221],
        //                     [-2.8186, 53.3324],
        //                     [-2.8375, 53.3265],
        //                     [-2.8575, 53.3279],
        //                     [-2.8803, 53.3343],
        //                     [-2.9119, 53.3496],
        //                     [-2.9269, 53.3596],
        //                     [-2.9681, 53.3746],
        //                     [-2.9875, 53.3879],
        //                     [-2.9992, 53.4079],
        //                     [-3.0064, 53.4238],
        //                     [-3.0092, 53.4399],
        //                     [-3.0197, 53.451],
        //                     [-3.0425, 53.466],
        //                     [-3.0403, 53.4746],
        //                     [-3.0542, 53.4882],
        //                     [-3.0614, 53.5013],
        //                     [-3.0647, 53.5243],
        //                     [-3.0753, 53.5268],
        //                     [-3.0819, 53.5332],
        //                     [-3.1008, 53.5435],
        //                     [-3.1036, 53.551],
        //                     [-3.1003, 53.5665],
        //                     [-3.0864, 53.5843],
        //                     [-3.0603, 53.609],
        //                     [-3.0431, 53.6321],
        //                     [-3.0308, 53.6396],
        //                     [-3.0253, 53.6465],
        //                     [-3.0125, 53.6554],
        //                     [-2.9908, 53.6674],
        //                     [-2.9897, 53.6749],
        //                     [-2.9808, 53.6874],
        //                     [-2.9725, 53.694],
        //                     [-2.9597, 53.6971],
        //                     [-2.9486, 53.7079],
        //                     [-2.953, 53.7149],
        //                     [-2.9381, 53.7224],
        //                     [-2.9431, 53.7315],
        //                     [-2.978, 53.734],
        //                     [-3.0075, 53.7373],
        //                     [-3.032, 53.7457],
        //                     [-3.0458, 53.7576],
        //                     [-3.058, 53.7785],
        //                     [-3.0564, 53.7996],
        //                     [-3.0575, 53.8151],
        //                     [-3.0553, 53.8446],
        //                     [-3.0469, 53.8762],
        //                     [-3.0475, 53.8929],
        //                     [-3.0514, 53.9193],
        //                     [-3.0464, 53.9232],
        //                     [-3.0097, 53.9304],
        //                     [-3.003, 53.9243],
        //                     [-3.0069, 53.9179],
        //                     [-3.0058, 53.8974],
        //                     [-2.9936, 53.8854],
        //                     [-2.9742, 53.8799],
        //                     [-2.9919, 53.8957],
        //                     [-2.9975, 53.9168],
        //                     [-2.9964, 53.9287],
        //                     [-2.9708, 53.934],
        //                     [-2.9519, 53.9401],
        //                     [-2.9147, 53.9465],
        //                     [-2.8964, 53.9415],
        //                     [-2.877, 53.9488],
        //                     [-2.8753, 53.9554],
        //                     [-2.8619, 53.9582],
        //                     [-2.8536, 53.9665],
        //                     [-2.8742, 53.9715],
        //                     [-2.8825, 53.9921],
        //                     [-2.8886, 53.9954],
        //                     [-2.8992, 54.0085],
        //                     [-2.9014, 54.0165],
        //                     [-2.9231, 54.0307],
        //                     [-2.9175, 54.0365],
        //                     [-2.9058, 54.039],
        //                     [-2.9064, 54.0479],
        //                     [-2.8981, 54.0488],
        //                     [-2.8931, 54.0599],
        //                     [-2.8603, 54.0774],
        //                     [-2.8481, 54.0768],
        //                     [-2.8342, 54.0851],
        //                     [-2.8181, 54.089],
        //                     [-2.8114, 54.1074],
        //                     [-2.8036, 54.1104],
        //                     [-2.7953, 54.1246],
        //                     [-2.8147, 54.1335],
        //                     [-2.8225, 54.1485],
        //                     [-2.8353, 54.1601],
        //                     [-2.8364, 54.1735],
        //                     [-2.8497, 54.1799],
        //                     [-2.8658, 54.1832],
        //                     [-2.8608, 54.194],
        //                     [-2.8342, 54.2035],
        //                     [-2.8225, 54.2035],
        //                     [-2.8175, 54.2101],
        //                     [-2.788, 54.2274],
        //                     [-2.7953, 54.2346],
        //                     [-2.8053, 54.2351],
        //                     [-2.8047, 54.2254],
        //                     [-2.8336, 54.2182],
        //                     [-2.8414, 54.2062],
        //                     [-2.8558, 54.2065],
        //                     [-2.8708, 54.2038],
        //                     [-2.9014, 54.1954],
        //                     [-2.9147, 54.1843],
        //                     [-2.9197, 54.1593],
        //                     [-2.9347, 54.1537],
        //                     [-2.9392, 54.159],
        //                     [-2.9603, 54.1518],
        //                     [-2.9814, 54.1493],
        //                     [-2.993, 54.1532],
        //                     [-3.0036, 54.1601],
        //                     [-2.9975, 54.1637],
        //                     [-2.9964, 54.176],
        //                     [-3.0347, 54.196],
        //                     [-3.0142, 54.2029],
        //                     [-3.0164, 54.2087],
        //                     [-3.0325, 54.2279],
        //                     [-3.0514, 54.2271],
        //                     [-3.0542, 54.2204],
        //                     [-3.0386, 54.2171],
        //                     [-3.0347, 54.2121],
        //                     [-3.0397, 54.2029],
        //                     [-3.0531, 54.1982],
        //                     [-3.0569, 54.1865],
        //                     [-3.0631, 54.1804],
        //                     [-3.0586, 54.1729],
        //                     [-3.0608, 54.1615],
        //                     [-3.0753, 54.1549],
        //                     [-3.0875, 54.1376],
        //                     [-3.1036, 54.1251],
        //                     [-3.1053, 54.1187],
        //                     [-3.1197, 54.1135],
        //                     [-3.1308, 54.1026],
        //                     [-3.1575, 54.089],
        //                     [-3.1675, 54.0804],
        //                     [-3.1847, 54.089],
        //                     [-3.1869, 54.099],
        //                     [-3.202, 54.1087],
        //                     [-3.2131, 54.1057],
        //                     [-3.2097, 54.0996],
        //                     [-3.2275, 54.0937],
        //                     [-3.2414, 54.106],
        //                     [-3.2458, 54.1174],
        //                     [-3.2447, 54.134],
        //                     [-3.2369, 54.1551],
        //                     [-3.2492, 54.156],
        //                     [-3.258, 54.1646],
        //                     [-3.2447, 54.1721],
        //                     [-3.2269, 54.1707],
        //                     [-3.2147, 54.1801],
        //                     [-3.2136, 54.1949],
        //                     [-3.2058, 54.1996],
        //                     [-3.2075, 54.2076],
        //                     [-3.1986, 54.2296],
        //                     [-3.202, 54.2396],
        //                     [-3.2131, 54.2468],
        //                     [-3.2131, 54.2543],
        //                     [-3.2236, 54.2593],
        //                     [-3.2247, 54.2418],
        //                     [-3.2375, 54.2274],
        //                     [-3.2453, 54.2254],
        //                     [-3.2536, 54.2171],
        //                     [-3.2403, 54.2029],
        //                     [-3.2464, 54.1957],
        //                     [-3.2642, 54.1899],
        //                     [-3.2742, 54.191],
        //                     [-3.2803, 54.1963],
        //                     [-3.3014, 54.1874],
        //                     [-3.3225, 54.1896],
        //                     [-3.3319, 54.1971],
        //                     [-3.3675, 54.2351],
        //                     [-3.4042, 54.2638],
        //                     [-3.4203, 54.2835],
        //                     [-3.4231, 54.2946],
        //                     [-3.4164, 54.2985],
        //                     [-3.4181, 54.3165],
        //                     [-3.4247, 54.3263],
        //                     [-3.4231, 54.3404],
        //                     [-3.4069, 54.3513],
        //                     [-3.4136, 54.3568],
        //                     [-3.4242, 54.359],
        //                     [-3.4214, 54.3474],
        //                     [-3.4336, 54.3438],
        //                     [-3.4508, 54.3554],
        //                     [-3.4686, 54.3732],
        //                     [-3.4731, 54.3829],
        //                     [-3.5219, 54.4237],
        //                     [-3.547, 54.4429],
        //                     [-3.563, 54.451],
        //                     [-3.5697, 54.4601],
        //                     [-3.5953, 54.484],
        //                     [-3.6081, 54.491],
        //                     [-3.6208, 54.4907],
        //                     [-3.6292, 54.5035],
        //                     [-3.6364, 54.506],
        //                     [-3.6408, 54.5151],
        //                     [-3.612, 54.5262],
        //                     [-3.6047, 54.5349],
        //                     [-3.5986, 54.5496],
        //                     [-3.5914, 54.5499],
        //                     [-3.5908, 54.5596],
        //                     [-3.5842, 54.564],
        //                     [-3.5831, 54.591],
        //                     [-3.5714, 54.6038],
        //                     [-3.5703, 54.6243],
        //                     [-3.5758, 54.634],
        //                     [-3.5747, 54.6493],
        //                     [-3.5614, 54.6579],
        //                     [-3.5625, 54.6615],
        //                     [-3.5453, 54.6751],
        //                     [-3.5314, 54.6804],
        //                     [-3.5175, 54.6935],
        //                     [-3.5075, 54.7157],
        //                     [-3.4986, 54.719],
        //                     [-3.4947, 54.7257],
        //                     [-3.4753, 54.7354],
        //                     [-3.4614, 54.7399],
        //                     [-3.4358, 54.7599],
        //                     [-3.4319, 54.7818],
        //                     [-3.4386, 54.8032],
        //                     [-3.4103, 54.8421],
        //                     [-3.4047, 54.8596],
        //                     [-3.3986, 54.8693],
        //                     [-3.3842, 54.8768],
        //                     [-3.3697, 54.891],
        //                     [-3.3475, 54.8996],
        //                     [-3.3364, 54.9001],
        //                     [-3.3369, 54.8924],
        //                     [-3.3131, 54.8887],
        //                     [-3.2858, 54.8787],
        //                     [-3.2831, 54.8929],
        //                     [-3.2697, 54.8907],
        //                     [-3.2503, 54.9021],
        //                     [-3.2492, 54.9129],
        //                     [-3.2603, 54.9107],
        //                     [-3.2703, 54.9026],
        //                     [-3.2842, 54.9026],
        //                     [-3.2986, 54.9068],
        //                     [-3.303, 54.9138],
        //                     [-3.2997, 54.9221],
        //                     [-3.2875, 54.9332],
        //                     [-3.2542, 54.944],
        //                     [-3.2419, 54.9454],
        //                     [-3.2314, 54.9515],
        //                     [-3.2036, 54.9543],
        //                     [-3.1881, 54.951],
        //                     [-3.1769, 54.9413],
        //                     [-3.1575, 54.9382],
        //                     [-3.1525, 54.9326],
        //                     [-3.1358, 54.9279],
        //                     [-3.1142, 54.9271],
        //                     [-3.0986, 54.9321],
        //                     [-3.0703, 54.9385],
        //                     [-3.0636, 54.9457],
        //                     [-3.0703, 54.9543],
        //                     [-3.0847, 54.9485],
        //                     [-3.0903, 54.9565],
        //                     [-3.0781, 54.9624],
        //                     [-3.0658, 54.9718],
        //                     [-3.0614, 54.9804],
        //                     [-3.0497, 54.9851],
        //                     [-3.0455, 55.0017],
        //                     [-3.0308, 55.0167],
        //                     [-3.0333, 55.0525],
        //                     [-3.015, 55.0522],
        //                     [-2.9778, 55.04],
        //                     [-2.9505, 55.0405],
        //                     [-2.9283, 55.0714],
        //                     [-2.8842, 55.0814],
        //                     [-2.8697, 55.1025],
        //                     [-2.8356, 55.12],
        //                     [-2.82, 55.1397],
        //                     [-2.7711, 55.1461],
        //                     [-2.7461, 55.1542],
        //                     [-2.6995, 55.1772],
        //                     [-2.6856, 55.1913]
        //                 ]
        //             ]
        //         ]
        //     },
        //     'properties': {
        //         'name': 'North West England',
        //         'id': 'GB-UKD',
        //         'TYPE': 'England',
        //         'CNTRY': 'United Kingdom'
        //     },
        //     'id': 'GB-UKD'
        // }, {
        //     'type': 'Feature',
        //     'geometry': {
        //         'type': 'MultiPolygon',
        //         'coordinates': [
        //             [
        //                 [
        //                     [-0.6597, 53.7207],
        //                     [-0.6586, 53.7146],
        //                     [-0.6775, 53.7068],
        //                     [-0.6803, 53.7113],
        //                     [-0.6736, 53.7182],
        //                     [-0.6597, 53.7207]
        //                 ]
        //             ],
        //             [
        //                 [
        //                     [0.0169, 53.5225],
        //                     [0, 53.5166],
        //                     [-0.0239, 53.513],
        //                     [-0.0442, 53.5158],
        //                     [-0.0581, 53.5103],
        //                     [-0.0925, 53.4619],
        //                     [-0.0905, 53.4547],
        //                     [-0.0728, 53.4425],
        //                     [-0.1017, 53.4275],
        //                     [-0.1136, 53.4269],
        //                     [-0.137, 53.4411],
        //                     [-0.1422, 53.4508],
        //                     [-0.1586, 53.4561],
        //                     [-0.165, 53.4644],
        //                     [-0.1905, 53.4775],
        //                     [-0.1842, 53.5014],
        //                     [-0.1978, 53.5355],
        //                     [-0.1703, 53.5575],
        //                     [-0.1708, 53.5647],
        //                     [-0.2086, 53.5661],
        //                     [-0.2375, 53.5897],
        //                     [-0.2867, 53.6081],
        //                     [-0.2922, 53.6017],
        //                     [-0.2908, 53.583],
        //                     [-0.3275, 53.558],
        //                     [-0.3525, 53.5558],
        //                     [-0.4167, 53.5661],
        //                     [-0.4769, 53.5383],
        //                     [-0.4764, 53.5344],
        //                     [-0.4006, 53.5314],
        //                     [-0.3883, 53.5247],
        //                     [-0.3872, 53.5167],
        //                     [-0.3992, 53.51],
        //                     [-0.4589, 53.5039],
        //                     [-0.4714, 53.4864],
        //                     [-0.465, 53.4769],
        //                     [-0.4669, 53.4725],
        //                     [-0.5078, 53.4619],
        //                     [-0.5689, 53.4511],
        //                     [-0.6033, 53.4528],
        //                     [-0.6136, 53.4561],
        //                     [-0.6214, 53.465],
        //                     [-0.6094, 53.488],
        //                     [-0.6094, 53.5],
        //                     [-0.6158, 53.5053],
        //                     [-0.7397, 53.5139],
        //                     [-0.7472, 53.4867],
        //                     [-0.7658, 53.4742],
        //                     [-0.7855, 53.4519],
        //                     [-0.905, 53.4578],
        //                     [-0.91, 53.4606],
        //                     [-0.8911, 53.4669],
        //                     [-0.8908, 53.4714],
        //                     [-0.9193, 53.4875],
        //                     [-0.9697, 53.4631],
        //                     [-0.9775, 53.4344],
        //                     [-1.0047, 53.4122],
        //                     [-1.0131, 53.4083],
        //                     [-1.0292, 53.4139],
        //                     [-1.0664, 53.4131],
        //                     [-1.0875, 53.4028],
        //                     [-1.1181, 53.3786],
        //                     [-1.1139, 53.3561],
        //                     [-1.1211, 53.3456],
        //                     [-1.1447, 53.3378],
        //                     [-1.135, 53.3258],
        //                     [-1.1661, 53.3064],
        //                     [-1.176, 53.293],
        //                     [-1.2425, 53.2908],
        //                     [-1.2614, 53.2986],
        //                     [-1.2819, 53.2994],
        //                     [-1.2772, 53.3133],
        //                     [-1.2867, 53.3169],
        //                     [-1.3114, 53.3139],
        //                     [-1.3222, 53.3022],
        //                     [-1.3325, 53.2989],
        //                     [-1.3592, 53.3003],
        //                     [-1.3809, 53.3069],
        //                     [-1.3828, 53.3217],
        //                     [-1.3936, 53.3253],
        //                     [-1.4319, 53.3236],
        //                     [-1.4589, 53.3069],
        //                     [-1.5314, 53.2897],
        //                     [-1.5706, 53.305],
        //                     [-1.5875, 53.3022],
        //                     [-1.61, 53.3058],
        //                     [-1.61, 53.315],
        //                     [-1.5828, 53.3264],
        //                     [-1.5819, 53.3303],
        //                     [-1.5925, 53.3378],
        //                     [-1.6503, 53.3519],
        //                     [-1.6536, 53.3592],
        //                     [-1.6458, 53.3692],
        //                     [-1.6464, 53.3767],
        //                     [-1.6758, 53.3872],
        //                     [-1.6906, 53.3875],
        //                     [-1.7017, 53.4036],
        //                     [-1.7342, 53.4108],
        //                     [-1.7369, 53.4217],
        //                     [-1.7311, 53.4411],
        //                     [-1.7872, 53.4686],
        //                     [-1.7931, 53.4778],
        //                     [-1.7956, 53.4969],
        //                     [-1.8161, 53.5161],
        //                     [-1.8708, 53.5322],
        //                     [-1.8972, 53.533],
        //                     [-1.9378, 53.5681],
        //                     [-1.9769, 53.5939],
        //                     [-1.988, 53.6147],
        //                     [-2.0169, 53.6186],
        //                     [-2.0239, 53.6394],
        //                     [-2.035, 53.6469],
        //                     [-2.0314, 53.6633],
        //                     [-2.0436, 53.6739],
        //                     [-2.0464, 53.6842],
        //                     [-2.065, 53.6836],
        //                     [-2.0811, 53.6747],
        //                     [-2.0986, 53.6719],
        //                     [-2.118, 53.683],
        //                     [-2.1317, 53.6822],
        //                     [-2.1422, 53.6942],
        //                     [-2.1513, 53.6966],
        //                     [-2.1492, 53.7053],
        //                     [-2.1597, 53.7256],
        //                     [-2.1214, 53.7553],
        //                     [-2.1205, 53.7914],
        //                     [-2.0955, 53.8105],
        //                     [-2.0472, 53.8244],
        //                     [-2.0372, 53.8333],
        //                     [-2.0325, 53.8477],
        //                     [-2.0661, 53.8628],
        //                     [-2.0975, 53.8886],
        //                     [-2.105, 53.9147],
        //                     [-2.1742, 53.9361],
        //                     [-2.1786, 53.9547],
        //                     [-2.1905, 53.9658],
        //                     [-2.2222, 53.9681],
        //                     [-2.2283, 53.9728],
        //                     [-2.2275, 53.9828],
        //                     [-2.2742, 53.97],
        //                     [-2.2872, 53.9711],
        //                     [-2.3, 53.9892],
        //                     [-2.335, 53.9911],
        //                     [-2.3475, 54.0022],
        //                     [-2.3369, 54.0181],
        //                     [-2.3458, 54.0219],
        //                     [-2.3489, 54.037],
        //                     [-2.3547, 54.0425],
        //                     [-2.3805, 54.0456],
        //                     [-2.4269, 54.0381],
        //                     [-2.4486, 54.04],
        //                     [-2.4583, 54.0472],
        //                     [-2.4595, 54.0717],
        //                     [-2.4678, 54.0797],
        //                     [-2.5192, 54.0972],
        //                     [-2.545, 54.1136],
        //                     [-2.5514, 54.1283],
        //                     [-2.5475, 54.1511],
        //                     [-2.5189, 54.1603],
        //                     [-2.5117, 54.1717],
        //                     [-2.4533, 54.2172],
        //                     [-2.4475, 54.2303],
        //                     [-2.4006, 54.2283],
        //                     [-2.3828, 54.2417],
        //                     [-2.3525, 54.2506],
        //                     [-2.3294, 54.2408],
        //                     [-2.3097, 54.2433],
        //                     [-2.3039, 54.2486],
        //                     [-2.3003, 54.2653],
        //                     [-2.3114, 54.2814],
        //                     [-2.3056, 54.2925],
        //                     [-2.3061, 54.3206],
        //                     [-2.3128, 54.33],
        //                     [-2.3411, 54.3422],
        //                     [-2.3472, 54.3503],
        //                     [-2.2833, 54.3828],
        //                     [-2.2833, 54.3947],
        //                     [-2.2956, 54.4178],
        //                     [-2.2767, 54.4355],
        //                     [-2.2447, 54.4481],
        //                     [-2.1942, 54.4467],
        //                     [-2.1683, 54.4597],
        //                     [-2.1552, 54.4557],
        //                     [-2.1389, 54.4497],
        //                     [-2.0997, 54.4681],
        //                     [-2.0456, 54.4797],
        //                     [-2.0069, 54.4725],
        //                     [-1.9561, 54.4544],
        //                     [-1.9305, 54.4547],
        //                     [-1.8508, 54.4805],
        //                     [-1.8497, 54.4933],
        //                     [-1.8358, 54.5044],
        //                     [-1.8244, 54.5028],
        //                     [-1.7872, 54.4817],
        //                     [-1.7794, 54.5011],
        //                     [-1.7672, 54.5139],
        //                     [-1.7669, 54.5286],
        //                     [-1.7489, 54.5305],
        //                     [-1.7247, 54.525],
        //                     [-1.7136, 54.5317],
        //                     [-1.6622, 54.5308],
        //                     [-1.6422, 54.5233],
        //                     [-1.6353, 54.5097],
        //                     [-1.63, 54.5083],
        //                     [-1.6003, 54.5125],
        //                     [-1.5908, 54.5086],
        //                     [-1.5778, 54.4897],
        //                     [-1.5325, 54.4653],
        //                     [-1.5203, 54.4667],
        //                     [-1.5255, 54.4808],
        //                     [-1.495, 54.4789],
        //                     [-1.4844, 54.4711],
        //                     [-1.4722, 54.4481],
        //                     [-1.4603, 54.4417],
        //                     [-1.4492, 54.4444],
        //                     [-1.4461, 54.4511],
        //                     [-1.4667, 54.4828],
        //                     [-1.4669, 54.4942],
        //                     [-1.4594, 54.4986],
        //                     [-1.4469, 54.4978],
        //                     [-1.4361, 54.4905],
        //                     [-1.4319, 54.4812],
        //                     [-1.4167, 54.4778],
        //                     [-1.4083, 54.4925],
        //                     [-1.388, 54.4889],
        //                     [-1.382, 54.4936],
        //                     [-1.3697, 54.4889],
        //                     [-1.3619, 54.4675],
        //                     [-1.3333, 54.4675],
        //                     [-1.3267, 54.4622],
        //                     [-1.2483, 54.4875],
        //                     [-1.235, 54.4997],
        //                     [-1.2017, 54.5058],
        //                     [-1.1142, 54.498],
        //                     [-1.0744, 54.505],
        //                     [-1.0292, 54.4925],
        //                     [-0.9761, 54.5],
        //                     [-0.9553, 54.4975],
        //                     [-0.9325, 54.4867],
        //                     [-0.8808, 54.4958],
        //                     [-0.8383, 54.4872],
        //                     [-0.8378, 54.5158],
        //                     [-0.8294, 54.53],
        //                     [-0.8147, 54.5406],
        //                     [-0.7883, 54.5472],
        //                     [-0.7788, 54.5574],
        //                     [-0.7625, 54.544],
        //                     [-0.7514, 54.5426],
        //                     [-0.748, 54.5313],
        //                     [-0.7358, 54.5271],
        //                     [-0.7142, 54.534],
        //                     [-0.6936, 54.5213],
        //                     [-0.6808, 54.5196],
        //                     [-0.6736, 54.5057],
        //                     [-0.6581, 54.4982],
        //                     [-0.6386, 54.4957],
        //                     [-0.6264, 54.4918],
        //                     [-0.6047, 54.491],
        //                     [-0.5736, 54.4824],
        //                     [-0.5658, 54.4779],
        //                     [-0.5536, 54.4635],
        //                     [-0.5425, 54.4599],
        //                     [-0.533, 54.4515],
        //                     [-0.5208, 54.4474],
        //                     [-0.5219, 54.4399],
        //                     [-0.5297, 54.4365],
        //                     [-0.5314, 54.4265],
        //                     [-0.5253, 54.4182],
        //                     [-0.4992, 54.4071],
        //                     [-0.4914, 54.4082],
        //                     [-0.4725, 54.3979],
        //                     [-0.463, 54.3904],
        //                     [-0.4453, 54.3688],
        //                     [-0.4447, 54.3588],
        //                     [-0.4386, 54.3579],
        //                     [-0.4225, 54.3401],
        //                     [-0.4192, 54.3335],
        //                     [-0.4186, 54.3151],
        //                     [-0.4064, 54.2921],
        //                     [-0.4003, 54.2885],
        //                     [-0.3875, 54.2904],
        //                     [-0.3836, 54.2851],
        //                     [-0.3975, 54.2788],
        //                     [-0.3958, 54.2726],
        //                     [-0.3647, 54.2526],
        //                     [-0.3653, 54.2457],
        //                     [-0.3536, 54.2407],
        //                     [-0.3375, 54.2432],
        //                     [-0.3358, 54.239],
        //                     [-0.3147, 54.2329],
        //                     [-0.3108, 54.229],
        //                     [-0.2858, 54.2232],
        //                     [-0.2731, 54.2185],
        //                     [-0.2819, 54.2132],
        //                     [-0.2847, 54.2007],
        //                     [-0.2825, 54.1929],
        //                     [-0.2719, 54.1815],
        //                     [-0.2597, 54.1738],
        //                     [-0.2231, 54.1587],
        //                     [-0.1731, 54.1524],
        //                     [-0.1475, 54.1435],
        //                     [-0.132, 54.1365],
        //                     [-0.1136, 54.1321],
        //                     [-0.0986, 54.1312],
        //                     [-0.0814, 54.1229],
        //                     [-0.0753, 54.1135],
        //                     [-0.0853, 54.1082],
        //                     [-0.1042, 54.1032],
        //                     [-0.1386, 54.1032],
        //                     [-0.1686, 54.0976],
        //                     [-0.1808, 54.0888],
        //                     [-0.1869, 54.0799],
        //                     [-0.1981, 54.0774],
        //                     [-0.2097, 54.064],
        //                     [-0.2153, 54.0448],
        //                     [-0.2164, 54.0221],
        //                     [-0.2125, 54.0049],
        //                     [-0.1725, 53.9313],
        //                     [-0.1603, 53.9165],
        //                     [-0.1558, 53.9024],
        //                     [-0.1342, 53.8762],
        //                     [-0.1125, 53.8554],
        //                     [-0.0758, 53.8265],
        //                     [-0.0581, 53.8082],
        //                     [-0.0364, 53.7907],
        //                     [-0.0242, 53.7785],
        //                     [0.0431, 53.7263],
        //                     [0.0508, 53.7176],
        //                     [0.0864, 53.6876],
        //                     [0.0936, 53.6843],
        //                     [0.1186, 53.6618],
        //                     [0.1308, 53.646],
        //                     [0.1436, 53.621],
        //                     [0.1475, 53.6085],
        //                     [0.1064, 53.631],
        //                     [0.0814, 53.6399],
        //                     [0.0658, 53.6435],
        //                     [0.0314, 53.6474],
        //                     [0.0147, 53.6435],
        //                     [-0.0097, 53.6407],
        //                     [-0.0492, 53.6315],
        //                     [-0.0542, 53.629],
        //                     [-0.0847, 53.6313],
        //                     [-0.108, 53.636],
        //                     [-0.1347, 53.651],
        //                     [-0.1564, 53.6663],
        //                     [-0.1675, 53.6713],
        //                     [-0.1725, 53.6796],
        //                     [-0.2019, 53.6949],
        //                     [-0.2114, 53.7029],
        //                     [-0.2275, 53.7093],
        //                     [-0.2364, 53.7201],
        //                     [-0.2364, 53.726],
        //                     [-0.2447, 53.7324],
        //                     [-0.2814, 53.7415],
        //                     [-0.2997, 53.7424],
        //                     [-0.3225, 53.7398],
        //                     [-0.3497, 53.7321],
        //                     [-0.3903, 53.7232],
        //                     [-0.4053, 53.7221],
        //                     [-0.4336, 53.7157],
        //                     [-0.4514, 53.7138],
        //                     [-0.4597, 53.7165],
        //                     [-0.4792, 53.7171],
        //                     [-0.5264, 53.7099],
        //                     [-0.5514, 53.7085],
        //                     [-0.5686, 53.7149],
        //                     [-0.5836, 53.7243],
        //                     [-0.5958, 53.7285],
        //                     [-0.6258, 53.7299],
        //                     [-0.6692, 53.7224],
        //                     [-0.6786, 53.7174],
        //                     [-0.6831, 53.709],
        //                     [-0.6936, 53.7035],
        //                     [-0.7003, 53.6943],
        //                     [-0.6964, 53.6815],
        //                     [-0.6847, 53.6782],
        //                     [-0.6953, 53.6951],
        //                     [-0.6897, 53.6982],
        //                     [-0.6392, 53.7107],
        //                     [-0.6197, 53.7143],
        //                     [-0.6081, 53.7132],
        //                     [-0.5947, 53.7018],
        //                     [-0.5781, 53.6954],
        //                     [-0.5703, 53.6893],
        //                     [-0.5508, 53.6796],
        //                     [-0.5397, 53.6782],
        //                     [-0.5042, 53.6804],
        //                     [-0.4714, 53.6985],
        //                     [-0.4475, 53.6971],
        //                     [-0.4103, 53.6979],
        //                     [-0.3508, 53.7071],
        //                     [-0.3358, 53.7107],
        //                     [-0.3025, 53.7143],
        //                     [-0.2847, 53.7118],
        //                     [-0.2725, 53.7026],
        //                     [-0.2619, 53.6882],
        //                     [-0.2403, 53.6674],
        //                     [-0.233, 53.6646],
        //                     [-0.2247, 53.6538],
        //                     [-0.2108, 53.6426],
        //                     [-0.2014, 53.6426],
        //                     [-0.1981, 53.6349],
        //                     [-0.1503, 53.6146],
        //                     [-0.1097, 53.589],
        //                     [-0.0819, 53.5801],
        //                     [-0.0731, 53.584],
        //                     [-0.0597, 53.5824],
        //                     [-0.0503, 53.5726],
        //                     [-0.0319, 53.5662],
        //                     [-0.0192, 53.5532],
        //                     [-0.0019, 53.5449],
        //                     [0.0036, 53.5379],
        //                     [0.0169, 53.5282],
        //                     [0.0169, 53.5225]
        //                 ]
        //             ]
        //         ]
        //     },
        //     'properties': {
        //         'name': 'Yorkshire and the Humber',
        //         'id': 'GB-UKE',
        //         'TYPE': 'England',
        //         'CNTRY': 'United Kingdom'
        //     },
        //     'id': 'GB-UKE'
        // }, {
        //     'type': 'Feature',
        //     'geometry': {
        //         'type': 'Polygon',
        //         'coordinates': [
        //             [
        //                 [-1.8972, 53.533],
        //                 [-1.8708, 53.5322],
        //                 [-1.8161, 53.5161],
        //                 [-1.7956, 53.4969],
        //                 [-1.7931, 53.4778],
        //                 [-1.7872, 53.4686],
        //                 [-1.7311, 53.4411],
        //                 [-1.7369, 53.4217],
        //                 [-1.7342, 53.4108],
        //                 [-1.7017, 53.4036],
        //                 [-1.6906, 53.3875],
        //                 [-1.6758, 53.3872],
        //                 [-1.6464, 53.3767],
        //                 [-1.6458, 53.3692],
        //                 [-1.6536, 53.3592],
        //                 [-1.6503, 53.3519],
        //                 [-1.5925, 53.3378],
        //                 [-1.5819, 53.3303],
        //                 [-1.5828, 53.3264],
        //                 [-1.61, 53.315],
        //                 [-1.61, 53.3058],
        //                 [-1.5875, 53.3022],
        //                 [-1.5706, 53.305],
        //                 [-1.5314, 53.2897],
        //                 [-1.4589, 53.3069],
        //                 [-1.4319, 53.3236],
        //                 [-1.3936, 53.3253],
        //                 [-1.3828, 53.3217],
        //                 [-1.3809, 53.3069],
        //                 [-1.3592, 53.3003],
        //                 [-1.3325, 53.2989],
        //                 [-1.3222, 53.3022],
        //                 [-1.3114, 53.3139],
        //                 [-1.2867, 53.3169],
        //                 [-1.2772, 53.3133],
        //                 [-1.2819, 53.2994],
        //                 [-1.2614, 53.2986],
        //                 [-1.2425, 53.2908],
        //                 [-1.176, 53.293],
        //                 [-1.1661, 53.3064],
        //                 [-1.135, 53.3258],
        //                 [-1.1447, 53.3378],
        //                 [-1.1211, 53.3456],
        //                 [-1.1139, 53.3561],
        //                 [-1.1181, 53.3786],
        //                 [-1.0875, 53.4028],
        //                 [-1.0664, 53.4131],
        //                 [-1.0292, 53.4139],
        //                 [-1.0131, 53.4083],
        //                 [-1.0047, 53.4122],
        //                 [-0.9775, 53.4344],
        //                 [-0.9697, 53.4631],
        //                 [-0.9193, 53.4875],
        //                 [-0.8908, 53.4714],
        //                 [-0.8911, 53.4669],
        //                 [-0.91, 53.4606],
        //                 [-0.905, 53.4578],
        //                 [-0.7855, 53.4519],
        //                 [-0.7658, 53.4742],
        //                 [-0.7472, 53.4867],
        //                 [-0.7397, 53.5139],
        //                 [-0.6158, 53.5053],
        //                 [-0.6094, 53.5],
        //                 [-0.6094, 53.488],
        //                 [-0.6214, 53.465],
        //                 [-0.6136, 53.4561],
        //                 [-0.6033, 53.4528],
        //                 [-0.5689, 53.4511],
        //                 [-0.5078, 53.4619],
        //                 [-0.4669, 53.4725],
        //                 [-0.465, 53.4769],
        //                 [-0.4714, 53.4864],
        //                 [-0.4589, 53.5039],
        //                 [-0.3992, 53.51],
        //                 [-0.3872, 53.5167],
        //                 [-0.3883, 53.5247],
        //                 [-0.4006, 53.5314],
        //                 [-0.4764, 53.5344],
        //                 [-0.4769, 53.5383],
        //                 [-0.4167, 53.5661],
        //                 [-0.3525, 53.5558],
        //                 [-0.3275, 53.558],
        //                 [-0.2908, 53.583],
        //                 [-0.2922, 53.6017],
        //                 [-0.2867, 53.6081],
        //                 [-0.2375, 53.5897],
        //                 [-0.2086, 53.5661],
        //                 [-0.1708, 53.5647],
        //                 [-0.1703, 53.5575],
        //                 [-0.1978, 53.5355],
        //                 [-0.1842, 53.5014],
        //                 [-0.1905, 53.4775],
        //                 [-0.165, 53.4644],
        //                 [-0.1586, 53.4561],
        //                 [-0.1422, 53.4508],
        //                 [-0.137, 53.4411],
        //                 [-0.1136, 53.4269],
        //                 [-0.1017, 53.4275],
        //                 [-0.0728, 53.4425],
        //                 [-0.0905, 53.4547],
        //                 [-0.0925, 53.4619],
        //                 [-0.0581, 53.5103],
        //                 [-0.0442, 53.5158],
        //                 [-0.0239, 53.513],
        //                 [0, 53.5166],
        //                 [0.0169, 53.5225],
        //                 [0.0181, 53.5185],
        //                 [0.0336, 53.5121],
        //                 [0.0569, 53.5132],
        //                 [0.0697, 53.5079],
        //                 [0.0797, 53.4957],
        //                 [0.1053, 53.4871],
        //                 [0.1197, 53.4885],
        //                 [0.1353, 53.4774],
        //                 [0.1542, 53.4765],
        //                 [0.1714, 53.4579],
        //                 [0.1764, 53.4413],
        //                 [0.2008, 53.4249],
        //                 [0.2008, 53.419],
        //                 [0.2164, 53.4093],
        //                 [0.2169, 53.3982],
        //                 [0.2369, 53.3735],
        //                 [0.2464, 53.3679],
        //                 [0.2514, 53.3596],
        //                 [0.2731, 53.3343],
        //                 [0.2747, 53.329],
        //                 [0.2903, 53.3051],
        //                 [0.3158, 53.2779],
        //                 [0.3314, 53.2476],
        //                 [0.3386, 53.2385],
        //                 [0.3397, 53.221],
        //                 [0.3486, 53.2085],
        //                 [0.3564, 53.1835],
        //                 [0.3497, 53.1582],
        //                 [0.3492, 53.131],
        //                 [0.3453, 53.1121],
        //                 [0.3414, 53.1093],
        //                 [0.3375, 53.0943],
        //                 [0.3297, 53.0907],
        //                 [0.3186, 53.091],
        //                 [0.3036, 53.0846],
        //                 [0.2947, 53.0843],
        //                 [0.2719, 53.071],
        //                 [0.2664, 53.064],
        //                 [0.2336, 53.0504],
        //                 [0.2214, 53.0401],
        //                 [0.1864, 53.0268],
        //                 [0.1814, 53.0218],
        //                 [0.1569, 53.0093],
        //                 [0.153, 53.0046],
        //                 [0.1292, 52.989],
        //                 [0.1247, 52.9793],
        //                 [0.1158, 52.9749],
        //                 [0.1119, 52.9626],
        //                 [0.0992, 52.956],
        //                 [0.0803, 52.9404],
        //                 [0.0803, 52.9318],
        //                 [0.0647, 52.9238],
        //                 [0.0742, 52.921],
        //                 [0.0708, 52.9135],
        //                 [0.0786, 52.9021],
        //                 [0.0908, 52.9013],
        //                 [0.0953, 52.896],
        //                 [0.1153, 52.8965],
        //                 [0.1197, 52.9001],
        //                 [0.1358, 52.8882],
        //                 [0.1458, 52.8879],
        //                 [0.1586, 52.8763],
        //                 [0.1792, 52.8749],
        //                 [0.1819, 52.8613],
        //                 [0.1958, 52.8557],
        //                 [0.1953, 52.8504],
        //                 [0.2064, 52.8468],
        //                 [0.2069, 52.8413],
        //                 [0.2247, 52.8232],
        //                 [0.2447, 52.824],
        //                 [0.2486, 52.8207],
        //                 [0.2681, 52.8185],
        //                 [0.2884, 52.8224],
        //                 [0.2625, 52.7758],
        //                 [0.2789, 52.7625],
        //                 [0.2764, 52.7564],
        //                 [0.1997, 52.7217],
        //                 [0.1724, 52.7244],
        //                 [0.1495, 52.7253],
        //                 [0.0975, 52.708],
        //                 [0.0603, 52.7055],
        //                 [0.0528, 52.7005],
        //                 [0.0572, 52.6706],
        //                 [0.0481, 52.6567],
        //                 [0.0322, 52.648],
        //                 [0, 52.6475],
        //                 [-0.0514, 52.6583],
        //                 [-0.0828, 52.65],
        //                 [-0.1014, 52.6519],
        //                 [-0.1375, 52.6386],
        //                 [-0.1603, 52.6444],
        //                 [-0.1831, 52.6419],
        //                 [-0.1995, 52.6563],
        //                 [-0.2619, 52.6475],
        //                 [-0.315, 52.6636],
        //                 [-0.402, 52.6369],
        //                 [-0.4355, 52.6367],
        //                 [-0.4667, 52.6433],
        //                 [-0.4907, 52.6365],
        //                 [-0.4747, 52.625],
        //                 [-0.4661, 52.6092],
        //                 [-0.4739, 52.5681],
        //                 [-0.4608, 52.5619],
        //                 [-0.4138, 52.566],
        //                 [-0.4151, 52.5502],
        //                 [-0.3983, 52.5374],
        //                 [-0.4071, 52.5118],
        //                 [-0.3481, 52.49],
        //                 [-0.3356, 52.4555],
        //                 [-0.3397, 52.4475],
        //                 [-0.3828, 52.4122],
        //                 [-0.4164, 52.3958],
        //                 [-0.4258, 52.3825],
        //                 [-0.4844, 52.3655],
        //                 [-0.4856, 52.3486],
        //                 [-0.4614, 52.3236],
        //                 [-0.4587, 52.3088],
        //                 [-0.5031, 52.3031],
        //                 [-0.5253, 52.2833],
        //                 [-0.5253, 52.2606],
        //                 [-0.5319, 52.2497],
        //                 [-0.5411, 52.2458],
        //                 [-0.5586, 52.2481],
        //                 [-0.5775, 52.2636],
        //                 [-0.5906, 52.2661],
        //                 [-0.6414, 52.2592],
        //                 [-0.6439, 52.2519],
        //                 [-0.6364, 52.2383],
        //                 [-0.6345, 52.2161],
        //                 [-0.6544, 52.1925],
        //                 [-0.7289, 52.1617],
        //                 [-0.7619, 52.1625],
        //                 [-0.7761, 52.1469],
        //                 [-0.8067, 52.1522],
        //                 [-0.8136, 52.1458],
        //                 [-0.8131, 52.1378],
        //                 [-0.8259, 52.1275],
        //                 [-0.8783, 52.1161],
        //                 [-0.8778, 52.1061],
        //                 [-0.8664, 52.1025],
        //                 [-0.8517, 52.0858],
        //                 [-0.8278, 52.0722],
        //                 [-0.8275, 52.0644],
        //                 [-0.8558, 52.0586],
        //                 [-0.8564, 52.0405],
        //                 [-0.8901, 52.0201],
        //                 [-0.9014, 52.0186],
        //                 [-0.9406, 52.0719],
        //                 [-0.95, 52.0739],
        //                 [-0.9908, 52.063],
        //                 [-1.0233, 52.0647],
        //                 [-1.0367, 52.0536],
        //                 [-1.0967, 52.0439],
        //                 [-1.1189, 52.035],
        //                 [-1.1417, 52.0177],
        //                 [-1.1082, 52.0093],
        //                 [-1.1189, 52.0061],
        //                 [-1.1383, 51.9897],
        //                 [-1.1622, 51.9881],
        //                 [-1.1836, 51.9783],
        //                 [-1.2342, 51.9803],
        //                 [-1.2561, 51.9764],
        //                 [-1.265, 51.9797],
        //                 [-1.288, 52.0303],
        //                 [-1.2967, 52.0389],
        //                 [-1.2939, 52.0714],
        //                 [-1.3067, 52.0775],
        //                 [-1.2736, 52.088],
        //                 [-1.2436, 52.0905],
        //                 [-1.2372, 52.0961],
        //                 [-1.3212, 52.1616],
        //                 [-1.3175, 52.1708],
        //                 [-1.303, 52.1811],
        //                 [-1.2486, 52.1953],
        //                 [-1.2453, 52.2058],
        //                 [-1.2653, 52.2208],
        //                 [-1.2658, 52.2278],
        //                 [-1.2081, 52.25],
        //                 [-1.2089, 52.2725],
        //                 [-1.2242, 52.2825],
        //                 [-1.2025, 52.3014],
        //                 [-1.2081, 52.3064],
        //                 [-1.2417, 52.3111],
        //                 [-1.2495, 52.3197],
        //                 [-1.2333, 52.3275],
        //                 [-1.1811, 52.3383],
        //                 [-1.1653, 52.348],
        //                 [-1.1672, 52.3589],
        //                 [-1.1866, 52.3814],
        //                 [-1.2117, 52.4158],
        //                 [-1.2411, 52.4261],
        //                 [-1.2933, 52.4794],
        //                 [-1.3958, 52.5125],
        //                 [-1.4042, 52.5258],
        //                 [-1.4172, 52.5353],
        //                 [-1.495, 52.5564],
        //                 [-1.5178, 52.5744],
        //                 [-1.5458, 52.5808],
        //                 [-1.5422, 52.6008],
        //                 [-1.5589, 52.6217],
        //                 [-1.5367, 52.63],
        //                 [-1.5339, 52.6417],
        //                 [-1.58, 52.677],
        //                 [-1.5831, 52.685],
        //                 [-1.5997, 52.6855],
        //                 [-1.6078, 52.6939],
        //                 [-1.6219, 52.6836],
        //                 [-1.64, 52.685],
        //                 [-1.6458, 52.7067],
        //                 [-1.6814, 52.7147],
        //                 [-1.7004, 52.7262],
        //                 [-1.6725, 52.7583],
        //                 [-1.6292, 52.7722],
        //                 [-1.615, 52.7981],
        //                 [-1.5908, 52.8108],
        //                 [-1.6083, 52.8306],
        //                 [-1.6306, 52.8411],
        //                 [-1.7208, 52.8453],
        //                 [-1.7356, 52.8506],
        //                 [-1.755, 52.8661],
        //                 [-1.7878, 52.8666],
        //                 [-1.8, 52.8736],
        //                 [-1.8239, 52.8756],
        //                 [-1.8269, 52.8906],
        //                 [-1.8408, 52.9047],
        //                 [-1.8403, 52.9244],
        //                 [-1.8239, 52.925],
        //                 [-1.817, 52.93],
        //                 [-1.8111, 52.9461],
        //                 [-1.8122, 52.9614],
        //                 [-1.7578, 52.9825],
        //                 [-1.7456, 53],
        //                 [-1.7475, 53.0222],
        //                 [-1.7639, 53.0319],
        //                 [-1.7692, 53.0417],
        //                 [-1.7761, 53.0708],
        //                 [-1.7717, 53.0903],
        //                 [-1.7995, 53.1186],
        //                 [-1.7989, 53.1417],
        //                 [-1.8036, 53.1486],
        //                 [-1.8242, 53.1631],
        //                 [-1.8567, 53.1764],
        //                 [-1.9322, 53.195],
        //                 [-1.9525, 53.2139],
        //                 [-1.9768, 53.2074],
        //                 [-1.9708, 53.2303],
        //                 [-1.9906, 53.2417],
        //                 [-1.9956, 53.2642],
        //                 [-1.9981, 53.3358],
        //                 [-2.0011, 53.3472],
        //                 [-2.0186, 53.3633],
        //                 [-2.0167, 53.3705],
        //                 [-2.0044, 53.3742],
        //                 [-1.9814, 53.3983],
        //                 [-1.9906, 53.4064],
        //                 [-2.0116, 53.4125],
        //                 [-2.0131, 53.42],
        //                 [-2.0092, 53.4275],
        //                 [-1.9825, 53.4439],
        //                 [-1.9778, 53.4689],
        //                 [-1.9636, 53.4947],
        //                 [-1.9325, 53.4958],
        //                 [-1.9189, 53.5008],
        //                 [-1.91, 53.5205],
        //                 [-1.8972, 53.533]
        //             ]
        //         ]
        //     },
        //     'properties': {
        //         'name': 'East Midlands',
        //         'id': 'GB-UKF',
        //         'TYPE': 'England',
        //         'CNTRY': 'United Kingdom'
        //     },
        //     'id': 'GB-UKF'
        // }, {
        //     'type': 'Feature',
        //     'geometry': {
        //         'type': 'Polygon',
        //         'coordinates': [
        //             [
        //                 [-1.9768, 53.2074],
        //                 [-1.9525, 53.2139],
        //                 [-1.9322, 53.195],
        //                 [-1.8567, 53.1764],
        //                 [-1.8242, 53.1631],
        //                 [-1.8036, 53.1486],
        //                 [-1.7989, 53.1417],
        //                 [-1.7995, 53.1186],
        //                 [-1.7717, 53.0903],
        //                 [-1.7761, 53.0708],
        //                 [-1.7692, 53.0417],
        //                 [-1.7639, 53.0319],
        //                 [-1.7475, 53.0222],
        //                 [-1.7456, 53],
        //                 [-1.7578, 52.9825],
        //                 [-1.8122, 52.9614],
        //                 [-1.8111, 52.9461],
        //                 [-1.817, 52.93],
        //                 [-1.8239, 52.925],
        //                 [-1.8403, 52.9244],
        //                 [-1.8408, 52.9047],
        //                 [-1.8269, 52.8906],
        //                 [-1.8239, 52.8756],
        //                 [-1.8, 52.8736],
        //                 [-1.7878, 52.8666],
        //                 [-1.755, 52.8661],
        //                 [-1.7356, 52.8506],
        //                 [-1.7208, 52.8453],
        //                 [-1.6306, 52.8411],
        //                 [-1.6083, 52.8306],
        //                 [-1.5908, 52.8108],
        //                 [-1.615, 52.7981],
        //                 [-1.6292, 52.7722],
        //                 [-1.6725, 52.7583],
        //                 [-1.7004, 52.7262],
        //                 [-1.6814, 52.7147],
        //                 [-1.6458, 52.7067],
        //                 [-1.64, 52.685],
        //                 [-1.6219, 52.6836],
        //                 [-1.6078, 52.6939],
        //                 [-1.5997, 52.6855],
        //                 [-1.5831, 52.685],
        //                 [-1.58, 52.677],
        //                 [-1.5339, 52.6417],
        //                 [-1.5367, 52.63],
        //                 [-1.5589, 52.6217],
        //                 [-1.5422, 52.6008],
        //                 [-1.5458, 52.5808],
        //                 [-1.5178, 52.5744],
        //                 [-1.495, 52.5564],
        //                 [-1.4172, 52.5353],
        //                 [-1.4042, 52.5258],
        //                 [-1.3958, 52.5125],
        //                 [-1.2933, 52.4794],
        //                 [-1.2411, 52.4261],
        //                 [-1.2117, 52.4158],
        //                 [-1.1866, 52.3814],
        //                 [-1.1672, 52.3589],
        //                 [-1.1653, 52.348],
        //                 [-1.1811, 52.3383],
        //                 [-1.2333, 52.3275],
        //                 [-1.2495, 52.3197],
        //                 [-1.2417, 52.3111],
        //                 [-1.2081, 52.3064],
        //                 [-1.2025, 52.3014],
        //                 [-1.2242, 52.2825],
        //                 [-1.2089, 52.2725],
        //                 [-1.2081, 52.25],
        //                 [-1.2658, 52.2278],
        //                 [-1.2653, 52.2208],
        //                 [-1.2453, 52.2058],
        //                 [-1.2486, 52.1953],
        //                 [-1.303, 52.1811],
        //                 [-1.3175, 52.1708],
        //                 [-1.3212, 52.1616],
        //                 [-1.3336, 52.1522],
        //                 [-1.3414, 52.1344],
        //                 [-1.3736, 52.1183],
        //                 [-1.3511, 52.1044],
        //                 [-1.3578, 52.0953],
        //                 [-1.3794, 52.0919],
        //                 [-1.4075, 52.1078],
        //                 [-1.4261, 52.1089],
        //                 [-1.4375, 52.1075],
        //                 [-1.4364, 52.093],
        //                 [-1.4406, 52.0908],
        //                 [-1.4703, 52.0886],
        //                 [-1.475, 52.0767],
        //                 [-1.4953, 52.0608],
        //                 [-1.4958, 52.0405],
        //                 [-1.5097, 51.9983],
        //                 [-1.518, 51.9883],
        //                 [-1.5455, 51.9847],
        //                 [-1.5497, 51.9692],
        //                 [-1.5861, 51.9672],
        //                 [-1.5933, 51.9558],
        //                 [-1.6039, 51.955],
        //                 [-1.6526, 51.984],
        //                 [-1.6519, 51.9892],
        //                 [-1.6342, 52.0011],
        //                 [-1.6122, 52.0267],
        //                 [-1.6211, 52.0306],
        //                 [-1.6572, 52.0269],
        //                 [-1.6744, 52.0311],
        //                 [-1.7067, 52.0653],
        //                 [-1.7158, 52.085],
        //                 [-1.7369, 52.0894],
        //                 [-1.7578, 52.1058],
        //                 [-1.7783, 52.0989],
        //                 [-1.8139, 52.0689],
        //                 [-1.8431, 52.073],
        //                 [-1.8633, 52.0628],
        //                 [-1.8642, 52.0583],
        //                 [-1.8486, 52.0533],
        //                 [-1.8278, 52.0344],
        //                 [-1.8253, 52.0194],
        //                 [-1.832, 52.0081],
        //                 [-1.8436, 52.0078],
        //                 [-1.8789, 52.0281],
        //                 [-1.9042, 52.0314],
        //                 [-1.9186, 52.0269],
        //                 [-1.9422, 52.0303],
        //                 [-1.9708, 52.0261],
        //                 [-2.0308, 52],
        //                 [-2.0717, 52.0078],
        //                 [-2.1058, 52.0078],
        //                 [-2.13, 51.9953],
        //                 [-2.1433, 52.0063],
        //                 [-2.1149, 52.0422],
        //                 [-2.1647, 52.0405],
        //                 [-2.1706, 52.0339],
        //                 [-2.1763, 52.0073],
        //                 [-2.1599, 51.995],
        //                 [-2.1747, 51.9878],
        //                 [-2.2081, 51.9908],
        //                 [-2.2342, 51.9641],
        //                 [-2.2517, 51.9628],
        //                 [-2.3078, 51.9736],
        //                 [-2.3192, 51.9925],
        //                 [-2.3417, 52.015],
        //                 [-2.3689, 52.0122],
        //                 [-2.3933, 51.9947],
        //                 [-2.4131, 51.9894],
        //                 [-2.4295, 51.9944],
        //                 [-2.4414, 52.0133],
        //                 [-2.4608, 52.0197],
        //                 [-2.4722, 51.9972],
        //                 [-2.4675, 51.9867],
        //                 [-2.4789, 51.975],
        //                 [-2.4814, 51.958],
        //                 [-2.4603, 51.9478],
        //                 [-2.4547, 51.93],
        //                 [-2.4339, 51.9155],
        //                 [-2.4308, 51.9036],
        //                 [-2.4345, 51.8967],
        //                 [-2.4703, 51.8828],
        //                 [-2.5058, 51.88],
        //                 [-2.5197, 51.8589],
        //                 [-2.5506, 51.8617],
        //                 [-2.5786, 51.8544],
        //                 [-2.5855, 51.8447],
        //                 [-2.5981, 51.8467],
        //                 [-2.62, 51.8378],
        //                 [-2.6294, 51.8536],
        //                 [-2.6419, 51.8472],
        //                 [-2.6475, 51.8222],
        //                 [-2.6584, 51.8149],
        //                 [-2.6648, 51.8236],
        //                 [-2.6823, 51.8259],
        //                 [-2.6978, 51.8395],
        //                 [-2.7372, 51.8395],
        //                 [-2.7667, 51.8664],
        //                 [-2.7672, 51.8742],
        //                 [-2.7786, 51.8858],
        //                 [-2.8208, 51.9017],
        //                 [-2.8664, 51.9289],
        //                 [-2.8956, 51.9264],
        //                 [-2.9439, 51.9067],
        //                 [-2.9611, 51.9097],
        //                 [-2.9675, 51.9194],
        //                 [-2.9889, 51.9256],
        //                 [-2.9944, 51.9433],
        //                 [-3.0289, 51.9633],
        //                 [-3.0514, 51.9833],
        //                 [-3.0867, 52.0222],
        //                 [-3.0792, 52.0358],
        //                 [-3.0822, 52.0467],
        //                 [-3.1125, 52.0694],
        //                 [-3.1274, 52.0706],
        //                 [-3.1159, 52.0983],
        //                 [-3.1, 52.1125],
        //                 [-3.1272, 52.1197],
        //                 [-3.1297, 52.1269],
        //                 [-3.0756, 52.148],
        //                 [-3.0761, 52.1578],
        //                 [-3.1044, 52.1542],
        //                 [-3.1125, 52.1589],
        //                 [-3.1136, 52.1661],
        //                 [-3.0617, 52.215],
        //                 [-3.055, 52.2311],
        //                 [-3.0289, 52.2422],
        //                 [-3.0131, 52.2556],
        //                 [-2.9539, 52.2614],
        //                 [-2.9589, 52.2706],
        //                 [-2.9903, 52.2758],
        //                 [-3.0011, 52.2872],
        //                 [-2.9922, 52.3103],
        //                 [-2.9569, 52.3247],
        //                 [-2.9533, 52.3322],
        //                 [-2.9573, 52.3413],
        //                 [-2.9755, 52.3464],
        //                 [-3.0219, 52.3403],
        //                 [-3.0678, 52.345],
        //                 [-3.1039, 52.3686],
        //                 [-3.1403, 52.3839],
        //                 [-3.1664, 52.4036],
        //                 [-3.1961, 52.4103],
        //                 [-3.2092, 52.4203],
        //                 [-3.2142, 52.4314],
        //                 [-3.2142, 52.4511],
        //                 [-3.1961, 52.4672],
        //                 [-3.1494, 52.4783],
        //                 [-3.1086, 52.4944],
        //                 [-3.0295, 52.4969],
        //                 [-3.0197, 52.5136],
        //                 [-2.9914, 52.5192],
        //                 [-2.9745, 52.5419],
        //                 [-2.9808, 52.5511],
        //                 [-3.0108, 52.5697],
        //                 [-3.0681, 52.5461],
        //                 [-3.0864, 52.5289],
        //                 [-3.11, 52.5258],
        //                 [-3.1192, 52.5289],
        //                 [-3.1078, 52.5456],
        //                 [-3.125, 52.5661],
        //                 [-3.1242, 52.5822],
        //                 [-3.0806, 52.6011],
        //                 [-3.0722, 52.61],
        //                 [-3.0639, 52.6383],
        //                 [-3.0292, 52.6533],
        //                 [-3.0261, 52.6614],
        //                 [-3.0328, 52.6822],
        //                 [-3.0111, 52.7117],
        //                 [-2.9689, 52.7161],
        //                 [-2.9561, 52.7267],
        //                 [-2.9572, 52.7328],
        //                 [-2.9922, 52.7453],
        //                 [-3.0011, 52.7578],
        //                 [-3.0589, 52.7658],
        //                 [-3.0681, 52.7703],
        //                 [-3.0755, 52.7815],
        //                 [-3.1139, 52.7844],
        //                 [-3.1317, 52.7889],
        //                 [-3.1408, 52.7964],
        //                 [-3.1558, 52.8219],
        //                 [-3.1514, 52.8339],
        //                 [-3.1192, 52.8561],
        //                 [-3.1317, 52.8833],
        //                 [-3.0967, 52.8942],
        //                 [-3.0894, 52.9131],
        //                 [-3.0652, 52.9259],
        //                 [-3.0589, 52.9244],
        //                 [-2.9939, 52.9536],
        //                 [-2.9627, 52.9527],
        //                 [-2.9283, 52.9328],
        //                 [-2.8792, 52.942],
        //                 [-2.8536, 52.9397],
        //                 [-2.7833, 52.8986],
        //                 [-2.75, 52.9147],
        //                 [-2.7197, 52.9172],
        //                 [-2.717, 52.9461],
        //                 [-2.7277, 52.9666],
        //                 [-2.6228, 52.9858],
        //                 [-2.5895, 52.9769],
        //                 [-2.5778, 52.9536],
        //                 [-2.5581, 52.9564],
        //                 [-2.5272, 52.9472],
        //                 [-2.5128, 52.9617],
        //                 [-2.4789, 52.9542],
        //                 [-2.4494, 52.9569],
        //                 [-2.4308, 52.965],
        //                 [-2.4236, 52.9786],
        //                 [-2.3788, 52.9896],
        //                 [-2.3664, 53.0003],
        //                 [-2.3739, 53.0372],
        //                 [-2.3658, 53.0522],
        //                 [-2.3356, 53.0561],
        //                 [-2.3056, 53.0792],
        //                 [-2.2722, 53.0775],
        //                 [-2.2464, 53.0839],
        //                 [-2.1578, 53.1475],
        //                 [-2.1347, 53.1503],
        //                 [-2.1308, 53.1578],
        //                 [-2.14, 53.17],
        //                 [-2.125, 53.175],
        //                 [-2.1017, 53.1658],
        //                 [-2.0683, 53.1658],
        //                 [-2.0306, 53.1847],
        //                 [-2.0056, 53.1861],
        //                 [-1.9768, 53.2074]
        //             ]
        //         ]
        //     },
        //     'properties': {
        //         'name': 'West Midlands',
        //         'id': 'GB-UKG',
        //         'TYPE': 'England',
        //         'CNTRY': 'United Kingdom'
        //     },
        //     'id': 'GB-UKG'
        // }, {
        //     'type': 'Feature',
        //     'geometry': {
        //         'type': 'MultiPolygon',
        //         'coordinates': [
        //             [
        //                 [
        //                     [0.7692, 51.7271],
        //                     [0.7786, 51.7268],
        //                     [0.7886, 51.7221],
        //                     [0.7714, 51.7185],
        //                     [0.7569, 51.7224],
        //                     [0.7692, 51.7271]
        //                 ]
        //             ],
        //             [
        //                 [
        //                     [0.722, 51.7307],
        //                     [0.7308, 51.7224],
        //                     [0.7269, 51.7168],
        //                     [0.7114, 51.7179],
        //                     [0.722, 51.7307]
        //                 ]
        //             ],
        //             [
        //                 [
        //                     [0.9686, 51.8087],
        //                     [0.982, 51.8037],
        //                     [1.007, 51.7999],
        //                     [0.9953, 51.7896],
        //                     [0.9719, 51.7821],
        //                     [0.9581, 51.7799],
        //                     [0.9475, 51.7746],
        //                     [0.9203, 51.7729],
        //                     [0.8992, 51.7754],
        //                     [0.8986, 51.7807],
        //                     [0.9075, 51.7904],
        //                     [0.9192, 51.794],
        //                     [0.9253, 51.8015],
        //                     [0.9425, 51.8068],
        //                     [0.9686, 51.8087]
        //                 ]
        //             ],
        //             [
        //                 [
        //                     [0.4142, 51.45],
        //                     [0.3868, 51.4485],
        //                     [0.3661, 51.4433],
        //                     [0.3414, 51.4464],
        //                     [0.3122, 51.4655],
        //                     [0.2655, 51.4567],
        //                     [0.2236, 51.4733],
        //                     [0.2167, 51.4778],
        //                     [0.2189, 51.4858],
        //                     [0.2422, 51.4989],
        //                     [0.2478, 51.52],
        //                     [0.2728, 51.5167],
        //                     [0.28, 51.5269],
        //                     [0.3361, 51.54],
        //                     [0.3161, 51.5622],
        //                     [0.3083, 51.5789],
        //                     [0.2844, 51.5839],
        //                     [0.2706, 51.5936],
        //                     [0.2511, 51.6169],
        //                     [0.2481, 51.6275],
        //                     [0.2314, 51.6292],
        //                     [0.1847, 51.6194],
        //                     [0.1122, 51.6155],
        //                     [0.0956, 51.6028],
        //                     [0.0839, 51.6011],
        //                     [0.0308, 51.6211],
        //                     [0.0214, 51.6369],
        //                     [-0.0128, 51.65],
        //                     [-0.007, 51.6661],
        //                     [-0.0112, 51.6773],
        //                     [-0.148, 51.6892],
        //                     [-0.1583, 51.6758],
        //                     [-0.1733, 51.6664],
        //                     [-0.2006, 51.6622],
        //                     [-0.2175, 51.6542],
        //                     [-0.2289, 51.6686],
        //                     [-0.2383, 51.6722],
        //                     [-0.2453, 51.6675],
        //                     [-0.2542, 51.6442],
        //                     [-0.3208, 51.6344],
        //                     [-0.3739, 51.6144],
        //                     [-0.432, 51.6153],
        //                     [-0.4589, 51.6108],
        //                     [-0.47, 51.6175],
        //                     [-0.4814, 51.6161],
        //                     [-0.4861, 51.5978],
        //                     [-0.4934, 51.591],
        //                     [-0.5186, 51.6078],
        //                     [-0.5256, 51.625],
        //                     [-0.5239, 51.6411],
        //                     [-0.4981, 51.6678],
        //                     [-0.4969, 51.6756],
        //                     [-0.5067, 51.6792],
        //                     [-0.5372, 51.675],
        //                     [-0.5394, 51.6936],
        //                     [-0.5508, 51.7086],
        //                     [-0.5483, 51.7164],
        //                     [-0.5236, 51.7283],
        //                     [-0.5267, 51.735],
        //                     [-0.5414, 51.7392],
        //                     [-0.5647, 51.7322],
        //                     [-0.5889, 51.7492],
        //                     [-0.6314, 51.7489],
        //                     [-0.662, 51.7586],
        //                     [-0.6736, 51.7694],
        //                     [-0.6733, 51.7861],
        //                     [-0.6783, 51.7958],
        //                     [-0.6967, 51.808],
        //                     [-0.7097, 51.8092],
        //                     [-0.73, 51.8278],
        //                     [-0.7131, 51.8483],
        //                     [-0.7014, 51.8497],
        //                     [-0.6745, 51.843],
        //                     [-0.6717, 51.8367],
        //                     [-0.6764, 51.8292],
        //                     [-0.6539, 51.8114],
        //                     [-0.6139, 51.8097],
        //                     [-0.5794, 51.8014],
        //                     [-0.5519, 51.8217],
        //                     [-0.5336, 51.8194],
        //                     [-0.5342, 51.8269],
        //                     [-0.5508, 51.8389],
        //                     [-0.5611, 51.8547],
        //                     [-0.6031, 51.88],
        //                     [-0.6256, 51.8764],
        //                     [-0.6611, 51.8964],
        //                     [-0.6881, 51.9028],
        //                     [-0.6703, 51.9361],
        //                     [-0.6417, 51.9619],
        //                     [-0.6542, 51.9881],
        //                     [-0.6345, 52.0044],
        //                     [-0.63, 52.0283],
        //                     [-0.6381, 52.0369],
        //                     [-0.6583, 52.0389],
        //                     [-0.64, 52.0558],
        //                     [-0.615, 52.0628],
        //                     [-0.6219, 52.0717],
        //                     [-0.5736, 52.0967],
        //                     [-0.5881, 52.118],
        //                     [-0.6316, 52.1465],
        //                     [-0.6212, 52.1749],
        //                     [-0.6544, 52.1925],
        //                     [-0.6345, 52.2161],
        //                     [-0.6364, 52.2383],
        //                     [-0.6439, 52.2519],
        //                     [-0.6414, 52.2592],
        //                     [-0.5906, 52.2661],
        //                     [-0.5775, 52.2636],
        //                     [-0.5586, 52.2481],
        //                     [-0.5411, 52.2458],
        //                     [-0.5319, 52.2497],
        //                     [-0.5253, 52.2606],
        //                     [-0.5253, 52.2833],
        //                     [-0.5031, 52.3031],
        //                     [-0.4587, 52.3088],
        //                     [-0.4614, 52.3236],
        //                     [-0.4856, 52.3486],
        //                     [-0.4844, 52.3655],
        //                     [-0.4258, 52.3825],
        //                     [-0.4164, 52.3958],
        //                     [-0.3828, 52.4122],
        //                     [-0.3397, 52.4475],
        //                     [-0.3356, 52.4555],
        //                     [-0.3481, 52.49],
        //                     [-0.4071, 52.5118],
        //                     [-0.3983, 52.5374],
        //                     [-0.4151, 52.5502],
        //                     [-0.4138, 52.566],
        //                     [-0.4608, 52.5619],
        //                     [-0.4739, 52.5681],
        //                     [-0.4661, 52.6092],
        //                     [-0.4747, 52.625],
        //                     [-0.4907, 52.6365],
        //                     [-0.4667, 52.6433],
        //                     [-0.4355, 52.6367],
        //                     [-0.402, 52.6369],
        //                     [-0.315, 52.6636],
        //                     [-0.2619, 52.6475],
        //                     [-0.1995, 52.6563],
        //                     [-0.1831, 52.6419],
        //                     [-0.1603, 52.6444],
        //                     [-0.1375, 52.6386],
        //                     [-0.1014, 52.6519],
        //                     [-0.0828, 52.65],
        //                     [-0.0514, 52.6583],
        //                     [0, 52.6475],
        //                     [0.0322, 52.648],
        //                     [0.0481, 52.6567],
        //                     [0.0572, 52.6706],
        //                     [0.0528, 52.7005],
        //                     [0.0603, 52.7055],
        //                     [0.0975, 52.708],
        //                     [0.1495, 52.7253],
        //                     [0.1724, 52.7244],
        //                     [0.1997, 52.7217],
        //                     [0.2764, 52.7564],
        //                     [0.2789, 52.7625],
        //                     [0.2625, 52.7758],
        //                     [0.2884, 52.8224],
        //                     [0.3225, 52.8204],
        //                     [0.3242, 52.8163],
        //                     [0.3408, 52.8079],
        //                     [0.352, 52.8049],
        //                     [0.3581, 52.811],
        //                     [0.3675, 52.8126],
        //                     [0.3747, 52.8204],
        //                     [0.3925, 52.8312],
        //                     [0.4108, 52.8399],
        //                     [0.4258, 52.8401],
        //                     [0.4447, 52.8501],
        //                     [0.4481, 52.8579],
        //                     [0.443, 52.8665],
        //                     [0.4508, 52.8846],
        //                     [0.4603, 52.8904],
        //                     [0.4719, 52.9076],
        //                     [0.4792, 52.9321],
        //                     [0.4858, 52.9396],
        //                     [0.4881, 52.9485],
        //                     [0.4964, 52.9562],
        //                     [0.5114, 52.9637],
        //                     [0.5286, 52.9752],
        //                     [0.5658, 52.9749],
        //                     [0.5753, 52.9718],
        //                     [0.5892, 52.9762],
        //                     [0.6014, 52.974],
        //                     [0.6297, 52.9737],
        //                     [0.6653, 52.9787],
        //                     [0.6792, 52.976],
        //                     [0.6797, 52.9851],
        //                     [0.6592, 52.9807],
        //                     [0.6569, 52.9874],
        //                     [0.6897, 52.9882],
        //                     [0.7603, 52.9793],
        //                     [0.7986, 52.9765],
        //                     [0.8342, 52.9765],
        //                     [0.8458, 52.9732],
        //                     [0.8381, 52.9674],
        //                     [0.8503, 52.964],
        //                     [0.8625, 52.9712],
        //                     [0.8647, 52.9779],
        //                     [0.8797, 52.9782],
        //                     [0.8797, 52.971],
        //                     [0.9064, 52.9715],
        //                     [0.9364, 52.9632],
        //                     [0.9492, 52.9651],
        //                     [0.9619, 52.9612],
        //                     [0.9836, 52.9662],
        //                     [1.0092, 52.9665],
        //                     [1.0075, 52.9715],
        //                     [0.9814, 52.9699],
        //                     [0.9869, 52.9774],
        //                     [0.9975, 52.9768],
        //                     [1.0281, 52.9712],
        //                     [1.0581, 52.964],
        //                     [1.1014, 52.9554],
        //                     [1.1436, 52.949],
        //                     [1.1786, 52.9468],
        //                     [1.2114, 52.946],
        //                     [1.2647, 52.9404],
        //                     [1.3142, 52.9299],
        //                     [1.3242, 52.9251],
        //                     [1.3425, 52.9207],
        //                     [1.3642, 52.909],
        //                     [1.3692, 52.9085],
        //                     [1.3942, 52.8979],
        //                     [1.4081, 52.8938],
        //                     [1.4392, 52.8788],
        //                     [1.4564, 52.8665],
        //                     [1.4969, 52.8443],
        //                     [1.5264, 52.8304],
        //                     [1.548, 52.8176],
        //                     [1.5614, 52.8124],
        //                     [1.5925, 52.7962],
        //                     [1.6303, 52.7726],
        //                     [1.6453, 52.7651],
        //                     [1.6836, 52.736],
        //                     [1.6981, 52.7218],
        //                     [1.7064, 52.7018],
        //                     [1.7364, 52.6482],
        //                     [1.7386, 52.6379],
        //                     [1.7453, 52.6274],
        //                     [1.7419, 52.6068],
        //                     [1.7375, 52.5974],
        //                     [1.7364, 52.581],
        //                     [1.7392, 52.5721],
        //                     [1.7319, 52.5693],
        //                     [1.733, 52.5546],
        //                     [1.7375, 52.5374],
        //                     [1.7431, 52.5296],
        //                     [1.7547, 52.5029],
        //                     [1.7597, 52.4962],
        //                     [1.7625, 52.4765],
        //                     [1.7497, 52.4704],
        //                     [1.737, 52.4526],
        //                     [1.7297, 52.4321],
        //                     [1.7292, 52.4196],
        //                     [1.733, 52.4107],
        //                     [1.7275, 52.3949],
        //                     [1.7136, 52.3804],
        //                     [1.7058, 52.3665],
        //                     [1.6925, 52.3521],
        //                     [1.6825, 52.3246],
        //                     [1.6731, 52.314],
        //                     [1.6592, 52.3068],
        //                     [1.6419, 52.2915],
        //                     [1.633, 52.2771],
        //                     [1.6303, 52.2646],
        //                     [1.6297, 52.2432],
        //                     [1.6258, 52.2285],
        //                     [1.6225, 52.1957],
        //                     [1.6242, 52.1888],
        //                     [1.6103, 52.1699],
        //                     [1.6003, 52.1399],
        //                     [1.5942, 52.1274],
        //                     [1.5892, 52.1054],
        //                     [1.5792, 52.0849],
        //                     [1.5203, 52.066],
        //                     [1.4925, 52.0585],
        //                     [1.4736, 52.0499],
        //                     [1.4619, 52.0374],
        //                     [1.4436, 52.026],
        //                     [1.4303, 52.0038],
        //                     [1.4136, 51.994],
        //                     [1.3942, 51.9865],
        //                     [1.3942, 51.994],
        //                     [1.3858, 52.0013],
        //                     [1.3642, 52.0093],
        //                     [1.3658, 52.0165],
        //                     [1.3592, 52.0257],
        //                     [1.3458, 52.0298],
        //                     [1.3519, 52.0379],
        //                     [1.3519, 52.0457],
        //                     [1.3436, 52.0493],
        //                     [1.3436, 52.064],
        //                     [1.3325, 52.0626],
        //                     [1.3347, 52.049],
        //                     [1.3481, 52.0426],
        //                     [1.3408, 52.0346],
        //                     [1.3453, 52.0263],
        //                     [1.3603, 52.0179],
        //                     [1.363, 52.0048],
        //                     [1.3764, 52.0004],
        //                     [1.3914, 51.9901],
        //                     [1.3897, 51.9804],
        //                     [1.3758, 51.969],
        //                     [1.3625, 51.9618],
        //                     [1.3436, 51.9565],
        //                     [1.3297, 51.9435],
        //                     [1.3153, 51.9524],
        //                     [1.2864, 51.9649],
        //                     [1.2808, 51.979],
        //                     [1.283, 51.9926],
        //                     [1.2564, 51.9965],
        //                     [1.2308, 52.006],
        //                     [1.2147, 52.0065],
        //                     [1.1992, 52.0149],
        //                     [1.1886, 52.0146],
        //                     [1.1725, 52.0249],
        //                     [1.1675, 52.0182],
        //                     [1.1881, 52.0068],
        //                     [1.1997, 52.0068],
        //                     [1.2108, 51.9971],
        //                     [1.2303, 51.9965],
        //                     [1.268, 51.9876],
        //                     [1.2714, 51.9829],
        //                     [1.2714, 51.9696],
        //                     [1.2792, 51.9601],
        //                     [1.2675, 51.9546],
        //                     [1.2453, 51.9607],
        //                     [1.2203, 51.9526],
        //                     [1.1969, 51.956],
        //                     [1.1864, 51.9554],
        //                     [1.1769, 51.9654],
        //                     [1.1614, 51.9671],
        //                     [1.1319, 51.9571],
        //                     [1.0992, 51.954],
        //                     [1.0847, 51.9585],
        //                     [1.0792, 51.9551],
        //                     [1.063, 51.9529],
        //                     [1.0625, 51.9465],
        //                     [1.0903, 51.946],
        //                     [1.1025, 51.9426],
        //                     [1.1364, 51.9404],
        //                     [1.148, 51.9454],
        //                     [1.1681, 51.9485],
        //                     [1.1775, 51.9426],
        //                     [1.1992, 51.941],
        //                     [1.2203, 51.9446],
        //                     [1.2281, 51.9424],
        //                     [1.2431, 51.9485],
        //                     [1.2675, 51.9454],
        //                     [1.2758, 51.939],
        //                     [1.2881, 51.9501],
        //                     [1.2903, 51.9379],
        //                     [1.2708, 51.9287],
        //                     [1.2619, 51.9185],
        //                     [1.2414, 51.8862],
        //                     [1.2725, 51.8818],
        //                     [1.2914, 51.8726],
        //                     [1.2903, 51.8632],
        //                     [1.2669, 51.8424],
        //                     [1.2481, 51.829],
        //                     [1.2364, 51.8185],
        //                     [1.2181, 51.809],
        //                     [1.1997, 51.8018],
        //                     [1.1742, 51.794],
        //                     [1.1308, 51.7763],
        //                     [1.1119, 51.7729],
        //                     [1.0831, 51.7724],
        //                     [1.0686, 51.7699],
        //                     [1.0458, 51.7693],
        //                     [1.0325, 51.7771],
        //                     [1.0297, 51.7846],
        //                     [1.037, 51.7899],
        //                     [1.0214, 51.8046],
        //                     [1.0097, 51.8065],
        //                     [0.9942, 51.8154],
        //                     [0.9825, 51.8304],
        //                     [0.9758, 51.826],
        //                     [0.9853, 51.811],
        //                     [0.9808, 51.8074],
        //                     [0.9692, 51.8132],
        //                     [0.9442, 51.8101],
        //                     [0.9258, 51.8026],
        //                     [0.9114, 51.7943],
        //                     [0.8964, 51.7885],
        //                     [0.8931, 51.7788],
        //                     [0.8842, 51.776],
        //                     [0.8903, 51.7682],
        //                     [0.8836, 51.7635],
        //                     [0.8719, 51.7671],
        //                     [0.8603, 51.7649],
        //                     [0.8797, 51.7554],
        //                     [0.8525, 51.7415],
        //                     [0.8364, 51.7388],
        //                     [0.8136, 51.7382],
        //                     [0.7942, 51.7424],
        //                     [0.7892, 51.7368],
        //                     [0.7775, 51.7404],
        //                     [0.752, 51.7351],
        //                     [0.7464, 51.7307],
        //                     [0.7331, 51.7299],
        //                     [0.7203, 51.7365],
        //                     [0.708, 51.7276],
        //                     [0.698, 51.7235],
        //                     [0.7125, 51.7151],
        //                     [0.7175, 51.7163],
        //                     [0.7514, 51.709],
        //                     [0.7642, 51.7082],
        //                     [0.7664, 51.7026],
        //                     [0.7936, 51.709],
        //                     [0.7958, 51.7188],
        //                     [0.8064, 51.7179],
        //                     [0.8253, 51.7204],
        //                     [0.8347, 51.7149],
        //                     [0.8592, 51.7179],
        //                     [0.8736, 51.7249],
        //                     [0.9019, 51.7457],
        //                     [0.9303, 51.7474],
        //                     [0.9397, 51.7421],
        //                     [0.9503, 51.7301],
        //                     [0.9492, 51.7215],
        //                     [0.9436, 51.7121],
        //                     [0.9419, 51.6968],
        //                     [0.9497, 51.6829],
        //                     [0.9403, 51.6543],
        //                     [0.937, 51.6499],
        //                     [0.937, 51.6362],
        //                     [0.9297, 51.6299],
        //                     [0.9397, 51.6199],
        //                     [0.9603, 51.6207],
        //                     [0.9564, 51.614],
        //                     [0.9425, 51.6021],
        //                     [0.9186, 51.5857],
        //                     [0.8603, 51.5565],
        //                     [0.8258, 51.541],
        //                     [0.8219, 51.541],
        //                     [0.7964, 51.5276],
        //                     [0.7886, 51.5215],
        //                     [0.7797, 51.5212],
        //                     [0.7642, 51.5279],
        //                     [0.7314, 51.5299],
        //                     [0.723, 51.5326],
        //                     [0.7008, 51.5329],
        //                     [0.6664, 51.5387],
        //                     [0.6469, 51.5404],
        //                     [0.6392, 51.5326],
        //                     [0.6142, 51.5321],
        //                     [0.6353, 51.5226],
        //                     [0.6169, 51.514],
        //                     [0.5709, 51.5079],
        //                     [0.5536, 51.5101],
        //                     [0.5464, 51.5185],
        //                     [0.5286, 51.5179],
        //                     [0.5336, 51.5093],
        //                     [0.5192, 51.5096],
        //                     [0.5103, 51.5051],
        //                     [0.4758, 51.5054],
        //                     [0.4586, 51.5068],
        //                     [0.4453, 51.4996],
        //                     [0.4408, 51.4918],
        //                     [0.4392, 51.4726],
        //                     [0.4314, 51.4593],
        //                     [0.4114, 51.4551],
        //                     [0.4142, 51.45]
        //                 ]
        //             ]
        //         ]
        //     },
        //     'properties': {
        //         'name': 'East of England',
        //         'id': 'GB-UKH',
        //         'TYPE': 'England',
        //         'CNTRY': 'United Kingdom'
        //     },
        //     'id': 'GB-UKH'
        // }, {
        //     'type': 'Feature',
        //     'geometry': {
        //         'type': 'Polygon',
        //         'coordinates': [
        //             [
        //                 [-0.4934, 51.591],
        //                 [-0.4861, 51.5978],
        //                 [-0.4814, 51.6161],
        //                 [-0.47, 51.6175],
        //                 [-0.4589, 51.6108],
        //                 [-0.432, 51.6153],
        //                 [-0.3739, 51.6144],
        //                 [-0.3208, 51.6344],
        //                 [-0.2542, 51.6442],
        //                 [-0.2453, 51.6675],
        //                 [-0.2383, 51.6722],
        //                 [-0.2289, 51.6686],
        //                 [-0.2175, 51.6542],
        //                 [-0.2006, 51.6622],
        //                 [-0.1733, 51.6664],
        //                 [-0.1583, 51.6758],
        //                 [-0.148, 51.6892],
        //                 [-0.0112, 51.6773],
        //                 [-0.007, 51.6661],
        //                 [-0.0128, 51.65],
        //                 [0.0214, 51.6369],
        //                 [0.0308, 51.6211],
        //                 [0.0839, 51.6011],
        //                 [0.0956, 51.6028],
        //                 [0.1122, 51.6155],
        //                 [0.1847, 51.6194],
        //                 [0.2314, 51.6292],
        //                 [0.2481, 51.6275],
        //                 [0.2511, 51.6169],
        //                 [0.2706, 51.5936],
        //                 [0.2844, 51.5839],
        //                 [0.3083, 51.5789],
        //                 [0.3161, 51.5622],
        //                 [0.3361, 51.54],
        //                 [0.28, 51.5269],
        //                 [0.2728, 51.5167],
        //                 [0.2478, 51.52],
        //                 [0.2422, 51.4989],
        //                 [0.2189, 51.4858],
        //                 [0.2167, 51.4778],
        //                 [0.2236, 51.4733],
        //                 [0.2114, 51.4569],
        //                 [0.1811, 51.4378],
        //                 [0.1608, 51.4172],
        //                 [0.1692, 51.3886],
        //                 [0.1553, 51.3547],
        //                 [0.1311, 51.3411],
        //                 [0.12, 51.3242],
        //                 [0.0967, 51.3111],
        //                 [0.0939, 51.2883],
        //                 [0.0689, 51.2825],
        //                 [0.0483, 51.295],
        //                 [0.0225, 51.2897],
        //                 [0.0164, 51.3186],
        //                 [0, 51.3295],
        //                 [-0.0267, 51.3308],
        //                 [-0.0467, 51.3156],
        //                 [-0.0656, 51.3164],
        //                 [-0.0847, 51.3111],
        //                 [-0.102, 51.2928],
        //                 [-0.1281, 51.2892],
        //                 [-0.1511, 51.303],
        //                 [-0.1783, 51.3392],
        //                 [-0.1886, 51.3397],
        //                 [-0.2194, 51.3283],
        //                 [-0.218, 51.3531],
        //                 [-0.2431, 51.3736],
        //                 [-0.2683, 51.3617],
        //                 [-0.2933, 51.3289],
        //                 [-0.3122, 51.3242],
        //                 [-0.315, 51.3472],
        //                 [-0.2981, 51.3705],
        //                 [-0.3117, 51.3925],
        //                 [-0.3433, 51.3942],
        //                 [-0.3749, 51.407],
        //                 [-0.4003, 51.425],
        //                 [-0.4317, 51.4303],
        //                 [-0.4403, 51.4381],
        //                 [-0.4414, 51.4539],
        //                 [-0.4736, 51.4589],
        //                 [-0.4972, 51.4779],
        //                 [-0.4844, 51.4944],
        //                 [-0.4714, 51.55],
        //                 [-0.4934, 51.591]
        //             ]
        //         ]
        //     },
        //     'properties': {
        //         'name': 'Greater London',
        //         'id': 'GB-UKI',
        //         'TYPE': 'England',
        //         'CNTRY': 'United Kingdom'
        //     },
        //     'id': 'GB-UKI'
        // }, {
        //     'type': 'Feature',
        //     'geometry': {
        //         'type': 'MultiPolygon',
        //         'coordinates': [
        //             [
        //                 [
        //                     [-1.3036, 50.7676],
        //                     [-1.2925, 50.7593],
        //                     [-1.2753, 50.7668],
        //                     [-1.2647, 50.7637],
        //                     [-1.2564, 50.7549],
        //                     [-1.247, 50.7521],
        //                     [-1.2386, 50.7438],
        //                     [-1.2308, 50.7435],
        //                     [-1.2158, 50.7349],
        //                     [-1.1936, 50.7329],
        //                     [-1.1786, 50.7346],
        //                     [-1.1536, 50.7338],
        //                     [-1.1375, 50.7268],
        //                     [-1.1069, 50.7207],
        //                     [-1.1014, 50.7082],
        //                     [-1.0925, 50.6965],
        //                     [-1.0803, 50.6937],
        //                     [-1.0692, 50.6865],
        //                     [-1.0697, 50.6829],
        //                     [-1.0964, 50.6707],
        //                     [-1.0981, 50.664],
        //                     [-1.1192, 50.6649],
        //                     [-1.1392, 50.6601],
        //                     [-1.1525, 50.654],
        //                     [-1.1675, 50.6413],
        //                     [-1.1686, 50.6332],
        //                     [-1.1747, 50.6221],
        //                     [-1.1714, 50.6146],
        //                     [-1.1786, 50.5999],
        //                     [-1.1847, 50.5965],
        //                     [-1.2114, 50.5913],
        //                     [-1.2414, 50.5821],
        //                     [-1.2586, 50.5788],
        //                     [-1.272, 50.5793],
        //                     [-1.2992, 50.5746],
        //                     [-1.3092, 50.5779],
        //                     [-1.312, 50.584],
        //                     [-1.3381, 50.601],
        //                     [-1.3542, 50.6082],
        //                     [-1.363, 50.6096],
        //                     [-1.3692, 50.6157],
        //                     [-1.3903, 50.6274],
        //                     [-1.4092, 50.634],
        //                     [-1.4442, 50.6415],
        //                     [-1.4553, 50.6471],
        //                     [-1.4847, 50.6662],
        //                     [-1.4953, 50.6679],
        //                     [-1.5286, 50.6668],
        //                     [-1.5703, 50.6585],
        //                     [-1.5697, 50.6737],
        //                     [-1.5475, 50.6787],
        //                     [-1.5425, 50.6885],
        //                     [-1.5336, 50.6943],
        //                     [-1.5353, 50.7004],
        //                     [-1.523, 50.7076],
        //                     [-1.5097, 50.706],
        //                     [-1.4853, 50.7071],
        //                     [-1.4692, 50.7101],
        //                     [-1.4553, 50.7174],
        //                     [-1.4253, 50.7271],
        //                     [-1.4125, 50.7254],
        //                     [-1.363, 50.7385],
        //                     [-1.3475, 50.7435],
        //                     [-1.3453, 50.7512],
        //                     [-1.3292, 50.7579],
        //                     [-1.3231, 50.7649],
        //                     [-1.3036, 50.7676]
        //                 ]
        //             ],
        //             [
        //                 [
        //                     [-0.9708, 50.8379],
        //                     [-0.9519, 50.8285],
        //                     [-0.9453, 50.7971],
        //                     [-0.9475, 50.7899],
        //                     [-0.9353, 50.7824],
        //                     [-0.9458, 50.776],
        //                     [-0.977, 50.7824],
        //                     [-1.0192, 50.7849],
        //                     [-1.0242, 50.7871],
        //                     [-1.0258, 50.7965],
        //                     [-1.0036, 50.7943],
        //                     [-0.9903, 50.8029],
        //                     [-0.9897, 50.8113],
        //                     [-0.9842, 50.821],
        //                     [-0.9897, 50.8282],
        //                     [-0.9692, 50.8349],
        //                     [-0.9708, 50.8379]
        //                 ]
        //             ],
        //             [
        //                 [
        //                     [0.7458, 51.4488],
        //                     [0.7508, 51.4454],
        //                     [0.7736, 51.4401],
        //                     [0.7903, 51.4399],
        //                     [0.8192, 51.4268],
        //                     [0.8681, 51.421],
        //                     [0.8803, 51.4218],
        //                     [0.9019, 51.4171],
        //                     [0.9108, 51.4063],
        //                     [0.9375, 51.3915],
        //                     [0.9503, 51.3746],
        //                     [0.9442, 51.3662],
        //                     [0.9375, 51.3682],
        //                     [0.9203, 51.3576],
        //                     [0.8947, 51.354],
        //                     [0.8664, 51.3621],
        //                     [0.8375, 51.3635],
        //                     [0.8147, 51.3699],
        //                     [0.7981, 51.3685],
        //                     [0.7914, 51.3707],
        //                     [0.778, 51.3676],
        //                     [0.7647, 51.3707],
        //                     [0.7675, 51.384],
        //                     [0.7547, 51.3885],
        //                     [0.7408, 51.3987],
        //                     [0.7308, 51.4007],
        //                     [0.7275, 51.4087],
        //                     [0.7403, 51.4104],
        //                     [0.7353, 51.4263],
        //                     [0.7392, 51.4385],
        //                     [0.7458, 51.4488]
        //                 ]
        //             ],
        //             [
        //                 [
        //                     [-0.6544, 52.1925],
        //                     [-0.6212, 52.1749],
        //                     [-0.6316, 52.1465],
        //                     [-0.5881, 52.118],
        //                     [-0.5736, 52.0967],
        //                     [-0.6219, 52.0717],
        //                     [-0.615, 52.0628],
        //                     [-0.64, 52.0558],
        //                     [-0.6583, 52.0389],
        //                     [-0.6381, 52.0369],
        //                     [-0.63, 52.0283],
        //                     [-0.6345, 52.0044],
        //                     [-0.6542, 51.9881],
        //                     [-0.6417, 51.9619],
        //                     [-0.6703, 51.9361],
        //                     [-0.6881, 51.9028],
        //                     [-0.6611, 51.8964],
        //                     [-0.6256, 51.8764],
        //                     [-0.6031, 51.88],
        //                     [-0.5611, 51.8547],
        //                     [-0.5508, 51.8389],
        //                     [-0.5342, 51.8269],
        //                     [-0.5336, 51.8194],
        //                     [-0.5519, 51.8217],
        //                     [-0.5794, 51.8014],
        //                     [-0.6139, 51.8097],
        //                     [-0.6539, 51.8114],
        //                     [-0.6764, 51.8292],
        //                     [-0.6717, 51.8367],
        //                     [-0.6745, 51.843],
        //                     [-0.7014, 51.8497],
        //                     [-0.7131, 51.8483],
        //                     [-0.73, 51.8278],
        //                     [-0.7097, 51.8092],
        //                     [-0.6967, 51.808],
        //                     [-0.6783, 51.7958],
        //                     [-0.6733, 51.7861],
        //                     [-0.6736, 51.7694],
        //                     [-0.662, 51.7586],
        //                     [-0.6314, 51.7489],
        //                     [-0.5889, 51.7492],
        //                     [-0.5647, 51.7322],
        //                     [-0.5414, 51.7392],
        //                     [-0.5267, 51.735],
        //                     [-0.5236, 51.7283],
        //                     [-0.5483, 51.7164],
        //                     [-0.5508, 51.7086],
        //                     [-0.5394, 51.6936],
        //                     [-0.5372, 51.675],
        //                     [-0.5067, 51.6792],
        //                     [-0.4969, 51.6756],
        //                     [-0.4981, 51.6678],
        //                     [-0.5239, 51.6411],
        //                     [-0.5256, 51.625],
        //                     [-0.5186, 51.6078],
        //                     [-0.4934, 51.591],
        //                     [-0.4714, 51.55],
        //                     [-0.4844, 51.4944],
        //                     [-0.4972, 51.4779],
        //                     [-0.4736, 51.4589],
        //                     [-0.4414, 51.4539],
        //                     [-0.4403, 51.4381],
        //                     [-0.4317, 51.4303],
        //                     [-0.4003, 51.425],
        //                     [-0.3749, 51.407],
        //                     [-0.3433, 51.3942],
        //                     [-0.3117, 51.3925],
        //                     [-0.2981, 51.3705],
        //                     [-0.315, 51.3472],
        //                     [-0.3122, 51.3242],
        //                     [-0.2933, 51.3289],
        //                     [-0.2683, 51.3617],
        //                     [-0.2431, 51.3736],
        //                     [-0.218, 51.3531],
        //                     [-0.2194, 51.3283],
        //                     [-0.1886, 51.3397],
        //                     [-0.1783, 51.3392],
        //                     [-0.1511, 51.303],
        //                     [-0.1281, 51.2892],
        //                     [-0.102, 51.2928],
        //                     [-0.0847, 51.3111],
        //                     [-0.0656, 51.3164],
        //                     [-0.0467, 51.3156],
        //                     [-0.0267, 51.3308],
        //                     [0, 51.3295],
        //                     [0.0164, 51.3186],
        //                     [0.0225, 51.2897],
        //                     [0.0483, 51.295],
        //                     [0.0689, 51.2825],
        //                     [0.0939, 51.2883],
        //                     [0.0967, 51.3111],
        //                     [0.12, 51.3242],
        //                     [0.1311, 51.3411],
        //                     [0.1553, 51.3547],
        //                     [0.1692, 51.3886],
        //                     [0.1608, 51.4172],
        //                     [0.1811, 51.4378],
        //                     [0.2114, 51.4569],
        //                     [0.2236, 51.4733],
        //                     [0.2655, 51.4567],
        //                     [0.3122, 51.4655],
        //                     [0.3414, 51.4464],
        //                     [0.3661, 51.4433],
        //                     [0.3868, 51.4485],
        //                     [0.4142, 51.45],
        //                     [0.4175, 51.4443],
        //                     [0.4403, 51.4476],
        //                     [0.4581, 51.454],
        //                     [0.4547, 51.464],
        //                     [0.468, 51.4826],
        //                     [0.4814, 51.4874],
        //                     [0.5225, 51.4843],
        //                     [0.5481, 51.4874],
        //                     [0.5547, 51.4846],
        //                     [0.5764, 51.484],
        //                     [0.6086, 51.4801],
        //                     [0.6142, 51.4751],
        //                     [0.6292, 51.4779],
        //                     [0.6608, 51.4776],
        //                     [0.6719, 51.4715],
        //                     [0.6836, 51.4751],
        //                     [0.7008, 51.4726],
        //                     [0.7186, 51.4613],
        //                     [0.723, 51.4546],
        //                     [0.7236, 51.4432],
        //                     [0.7114, 51.4349],
        //                     [0.6747, 51.4324],
        //                     [0.6758, 51.4366],
        //                     [0.6625, 51.4476],
        //                     [0.6564, 51.4376],
        //                     [0.6497, 51.4349],
        //                     [0.6331, 51.4382],
        //                     [0.6197, 51.4349],
        //                     [0.6208, 51.4215],
        //                     [0.6108, 51.4171],
        //                     [0.5931, 51.4146],
        //                     [0.5769, 51.4157],
        //                     [0.5642, 51.4093],
        //                     [0.5458, 51.4118],
        //                     [0.5553, 51.3987],
        //                     [0.5769, 51.391],
        //                     [0.5925, 51.3907],
        //                     [0.6053, 51.386],
        //                     [0.6053, 51.3815],
        //                     [0.6186, 51.3793],
        //                     [0.6214, 51.3868],
        //                     [0.6414, 51.3904],
        //                     [0.6492, 51.3971],
        //                     [0.6597, 51.3924],
        //                     [0.6725, 51.3774],
        //                     [0.6825, 51.3804],
        //                     [0.6869, 51.3918],
        //                     [0.6975, 51.3938],
        //                     [0.698, 51.3863],
        //                     [0.7042, 51.3829],
        //                     [0.7158, 51.386],
        //                     [0.7025, 51.3951],
        //                     [0.6958, 51.4049],
        //                     [0.6964, 51.4196],
        //                     [0.7175, 51.4204],
        //                     [0.7169, 51.4124],
        //                     [0.7269, 51.3987],
        //                     [0.7458, 51.3932],
        //                     [0.7525, 51.3871],
        //                     [0.7642, 51.384],
        //                     [0.7608, 51.3749],
        //                     [0.7642, 51.3638],
        //                     [0.7842, 51.3607],
        //                     [0.808, 51.3601],
        //                     [0.8225, 51.3549],
        //                     [0.8369, 51.3537],
        //                     [0.8631, 51.3563],
        //                     [0.8769, 51.354],
        //                     [0.8897, 51.3462],
        //                     [0.9025, 51.3429],
        //                     [0.9381, 51.3471],
        //                     [0.9619, 51.3449],
        //                     [0.967, 51.3465],
        //                     [0.9897, 51.3462],
        //                     [1.0119, 51.3518],
        //                     [1.0242, 51.3638],
        //                     [1.032, 51.366],
        //                     [1.0575, 51.3654],
        //                     [1.0664, 51.3693],
        //                     [1.0936, 51.3682],
        //                     [1.0997, 51.3726],
        //                     [1.1197, 51.3721],
        //                     [1.1664, 51.374],
        //                     [1.1775, 51.3771],
        //                     [1.2069, 51.3807],
        //                     [1.2458, 51.3774],
        //                     [1.2775, 51.3776],
        //                     [1.2892, 51.3826],
        //                     [1.3269, 51.3821],
        //                     [1.3336, 51.3863],
        //                     [1.3436, 51.3849],
        //                     [1.378, 51.3871],
        //                     [1.3858, 51.3929],
        //                     [1.4236, 51.3926],
        //                     [1.4425, 51.3868],
        //                     [1.4497, 51.3776],
        //                     [1.4442, 51.3521],
        //                     [1.4325, 51.3374],
        //                     [1.4203, 51.3296],
        //                     [1.4092, 51.3268],
        //                     [1.3914, 51.326],
        //                     [1.3736, 51.3279],
        //                     [1.3625, 51.3201],
        //                     [1.3714, 51.314],
        //                     [1.3769, 51.2887],
        //                     [1.3908, 51.2637],
        //                     [1.4042, 51.2349],
        //                     [1.4053, 51.2224],
        //                     [1.4042, 51.1799],
        //                     [1.4058, 51.1729],
        //                     [1.3986, 51.1587],
        //                     [1.3853, 51.1501],
        //                     [1.3825, 51.144],
        //                     [1.3647, 51.1354],
        //                     [1.3436, 51.1312],
        //                     [1.3419, 51.1257],
        //                     [1.3153, 51.1224],
        //                     [1.3164, 51.1137],
        //                     [1.302, 51.1135],
        //                     [1.2936, 51.1093],
        //                     [1.2692, 51.1015],
        //                     [1.2253, 51.0993],
        //                     [1.2058, 51.0926],
        //                     [1.2003, 51.0832],
        //                     [1.1919, 51.0762],
        //                     [1.1792, 51.0768],
        //                     [1.1658, 51.0729],
        //                     [1.1503, 51.0732],
        //                     [1.0975, 51.0682],
        //                     [1.0747, 51.0635],
        //                     [1.0458, 51.0538],
        //                     [1.0197, 51.0376],
        //                     [1.0058, 51.0315],
        //                     [0.9886, 51.0176],
        //                     [0.9797, 51.0079],
        //                     [0.9708, 50.9824],
        //                     [0.9642, 50.9685],
        //                     [0.9642, 50.961],
        //                     [0.9725, 50.9368],
        //                     [0.983, 50.9185],
        //                     [0.9736, 50.9104],
        //                     [0.9453, 50.911],
        //                     [0.8919, 50.9174],
        //                     [0.8853, 50.9196],
        //                     [0.8069, 50.9304],
        //                     [0.7797, 50.9332],
        //                     [0.7708, 50.9271],
        //                     [0.7525, 50.9229],
        //                     [0.7292, 50.9129],
        //                     [0.6942, 50.8926],
        //                     [0.6831, 50.8851],
        //                     [0.6675, 50.8713],
        //                     [0.6514, 50.8668],
        //                     [0.6325, 50.8646],
        //                     [0.6269, 50.861],
        //                     [0.6075, 50.859],
        //                     [0.5897, 50.8532],
        //                     [0.5786, 50.8537],
        //                     [0.5608, 50.8501],
        //                     [0.5408, 50.8501],
        //                     [0.5142, 50.8465],
        //                     [0.5097, 50.8432],
        //                     [0.477, 50.8365],
        //                     [0.4447, 50.834],
        //                     [0.4169, 50.8307],
        //                     [0.3625, 50.8154],
        //                     [0.3486, 50.8088],
        //                     [0.3286, 50.7888],
        //                     [0.3297, 50.7846],
        //                     [0.3075, 50.7776],
        //                     [0.2936, 50.7676],
        //                     [0.2881, 50.7607],
        //                     [0.278, 50.756],
        //                     [0.2669, 50.7468],
        //                     [0.2619, 50.7382],
        //                     [0.2419, 50.7338],
        //                     [0.2181, 50.7363],
        //                     [0.2036, 50.7396],
        //                     [0.1886, 50.7476],
        //                     [0.1742, 50.7504],
        //                     [0.1542, 50.7576],
        //                     [0.1364, 50.7551],
        //                     [0.1203, 50.7579],
        //                     [0.0903, 50.7735],
        //                     [0.0664, 50.7821],
        //                     [0.0353, 50.7804],
        //                     [-0.0147, 50.7918],
        //                     [-0.0375, 50.799],
        //                     [-0.0581, 50.8015],
        //                     [-0.0908, 50.8113],
        //                     [-0.1075, 50.8085],
        //                     [-0.108, 50.8126],
        //                     [-0.1575, 50.8224],
        //                     [-0.2281, 50.8282],
        //                     [-0.2825, 50.8262],
        //                     [-0.3258, 50.819],
        //                     [-0.3647, 50.809],
        //                     [-0.3914, 50.8057],
        //                     [-0.4586, 50.8015],
        //                     [-0.4786, 50.8026],
        //                     [-0.5403, 50.8018],
        //                     [-0.5742, 50.7974],
        //                     [-0.5991, 50.7904],
        //                     [-0.6153, 50.7904],
        //                     [-0.6275, 50.7876],
        //                     [-0.6475, 50.7868],
        //                     [-0.6608, 50.7824],
        //                     [-0.693, 50.779],
        //                     [-0.7303, 50.7707],
        //                     [-0.7586, 50.7524],
        //                     [-0.7625, 50.7424],
        //                     [-0.7853, 50.7224],
        //                     [-0.7964, 50.7237],
        //                     [-0.8153, 50.7379],
        //                     [-0.8458, 50.7546],
        //                     [-0.8669, 50.7632],
        //                     [-0.9075, 50.7746],
        //                     [-0.9169, 50.7799],
        //                     [-0.9175, 50.7876],
        //                     [-0.9075, 50.7863],
        //                     [-0.8947, 50.7918],
        //                     [-0.8897, 50.8057],
        //                     [-0.8692, 50.8088],
        //                     [-0.8714, 50.8171],
        //                     [-0.8592, 50.8274],
        //                     [-0.8603, 50.8376],
        //                     [-0.8697, 50.8363],
        //                     [-0.8647, 50.8262],
        //                     [-0.8742, 50.8174],
        //                     [-0.8758, 50.8115],
        //                     [-0.8903, 50.8107],
        //                     [-0.892, 50.8235],
        //                     [-0.8975, 50.8285],
        //                     [-0.8936, 50.8374],
        //                     [-0.9042, 50.8382],
        //                     [-0.9131, 50.8346],
        //                     [-0.9064, 50.8218],
        //                     [-0.9075, 50.8035],
        //                     [-0.9147, 50.8029],
        //                     [-0.9314, 50.8132],
        //                     [-0.9425, 50.8149],
        //                     [-0.9431, 50.8251],
        //                     [-0.932, 50.8401],
        //                     [-0.9486, 50.8424],
        //                     [-0.962, 50.8399],
        //                     [-0.9903, 50.8374],
        //                     [-1.0086, 50.844],
        //                     [-1.0192, 50.8432],
        //                     [-1.0158, 50.8365],
        //                     [-1.0236, 50.8338],
        //                     [-1.0247, 50.8265],
        //                     [-1.0442, 50.8313],
        //                     [-1.0414, 50.8235],
        //                     [-1.0425, 50.8071],
        //                     [-1.0381, 50.7968],
        //                     [-1.0303, 50.7938],
        //                     [-1.0325, 50.7863],
        //                     [-1.0742, 50.7785],
        //                     [-1.0897, 50.7774],
        //                     [-1.1097, 50.7904],
        //                     [-1.1131, 50.8071],
        //                     [-1.1069, 50.8076],
        //                     [-1.0986, 50.8207],
        //                     [-1.0975, 50.8335],
        //                     [-1.1069, 50.8379],
        //                     [-1.1036, 50.8468],
        //                     [-1.1142, 50.8465],
        //                     [-1.1131, 50.8357],
        //                     [-1.1236, 50.8354],
        //                     [-1.1342, 50.8388],
        //                     [-1.1497, 50.8393],
        //                     [-1.1447, 50.8257],
        //                     [-1.1369, 50.8146],
        //                     [-1.1231, 50.8054],
        //                     [-1.1203, 50.7979],
        //                     [-1.1114, 50.7899],
        //                     [-1.1247, 50.7826],
        //                     [-1.1336, 50.7749],
        //                     [-1.1453, 50.7743],
        //                     [-1.1536, 50.7812],
        //                     [-1.1658, 50.7854],
        //                     [-1.1908, 50.7899],
        //                     [-1.2103, 50.8068],
        //                     [-1.238, 50.8179],
        //                     [-1.248, 50.8174],
        //                     [-1.2614, 50.8257],
        //                     [-1.303, 50.8376],
        //                     [-1.3114, 50.8482],
        //                     [-1.3242, 50.8521],
        //                     [-1.3425, 50.8651],
        //                     [-1.3475, 50.8665],
        //                     [-1.3697, 50.8846],
        //                     [-1.3847, 50.8904],
        //                     [-1.3969, 50.8829],
        //                     [-1.4019, 50.8929],
        //                     [-1.4131, 50.8993],
        //                     [-1.4392, 50.9079],
        //                     [-1.4419, 50.9021],
        //                     [-1.4264, 50.8982],
        //                     [-1.4081, 50.8813],
        //                     [-1.3992, 50.8765],
        //                     [-1.3964, 50.8696],
        //                     [-1.3697, 50.8532],
        //                     [-1.3319, 50.8412],
        //                     [-1.333, 50.8315],
        //                     [-1.3142, 50.819],
        //                     [-1.3108, 50.8118],
        //                     [-1.3219, 50.8074],
        //                     [-1.3319, 50.799],
        //                     [-1.3414, 50.786],
        //                     [-1.3519, 50.7837],
        //                     [-1.3769, 50.7851],
        //                     [-1.3897, 50.7801],
        //                     [-1.3947, 50.774],
        //                     [-1.4147, 50.7671],
        //                     [-1.4586, 50.7618],
        //                     [-1.4775, 50.7549],
        //                     [-1.4925, 50.7549],
        //                     [-1.4986, 50.7476],
        //                     [-1.5069, 50.7457],
        //                     [-1.5264, 50.7471],
        //                     [-1.5314, 50.7365],
        //                     [-1.5458, 50.7271],
        //                     [-1.5475, 50.7215],
        //                     [-1.5608, 50.7157],
        //                     [-1.5642, 50.7079],
        //                     [-1.5853, 50.7193],
        //                     [-1.6253, 50.7276],
        //                     [-1.6336, 50.7304],
        //                     [-1.6716, 50.7354],
        //                     [-1.6767, 50.7544],
        //                     [-1.7342, 50.7544],
        //                     [-1.7311, 50.7755],
        //                     [-1.735, 50.778],
        //                     [-1.7865, 50.7687],
        //                     [-1.7997, 50.7825],
        //                     [-1.8094, 50.8022],
        //                     [-1.8067, 50.8192],
        //                     [-1.7961, 50.8317],
        //                     [-1.8057, 50.8677],
        //                     [-1.8328, 50.8658],
        //                     [-1.8392, 50.8914],
        //                     [-1.8114, 50.9055],
        //                     [-1.805, 50.9294],
        //                     [-1.8369, 50.9336],
        //                     [-1.8625, 50.9228],
        //                     [-1.8797, 50.9247],
        //                     [-1.9072, 50.9439],
        //                     [-1.95, 50.9883],
        //                     [-1.9264, 50.9995],
        //                     [-1.8689, 51.0058],
        //                     [-1.8686, 50.9961],
        //                     [-1.8578, 50.9947],
        //                     [-1.8472, 51.0072],
        //                     [-1.8375, 51.0092],
        //                     [-1.8108, 50.9928],
        //                     [-1.7667, 50.9867],
        //                     [-1.7406, 50.978],
        //                     [-1.6981, 50.975],
        //                     [-1.6708, 50.9547],
        //                     [-1.655, 50.9503],
        //                     [-1.6106, 50.9597],
        //                     [-1.5997, 50.9769],
        //                     [-1.6214, 50.9947],
        //                     [-1.6156, 51.0053],
        //                     [-1.5967, 51.0175],
        //                     [-1.6028, 51.0264],
        //                     [-1.6219, 51.0342],
        //                     [-1.6203, 51.0542],
        //                     [-1.6314, 51.0861],
        //                     [-1.6219, 51.1083],
        //                     [-1.6289, 51.1172],
        //                     [-1.6528, 51.1264],
        //                     [-1.6478, 51.15],
        //                     [-1.655, 51.1714],
        //                     [-1.6853, 51.2053],
        //                     [-1.6964, 51.2367],
        //                     [-1.6806, 51.24],
        //                     [-1.6281, 51.2342],
        //                     [-1.6147, 51.2386],
        //                     [-1.6, 51.2525],
        //                     [-1.5797, 51.2578],
        //                     [-1.5383, 51.245],
        //                     [-1.5278, 51.2525],
        //                     [-1.5392, 51.2756],
        //                     [-1.52, 51.3025],
        //                     [-1.5267, 51.3297],
        //                     [-1.487, 51.3325],
        //                     [-1.4858, 51.3439],
        //                     [-1.4969, 51.3544],
        //                     [-1.4981, 51.3661],
        //                     [-1.5333, 51.3775],
        //                     [-1.5633, 51.4122],
        //                     [-1.5533, 51.4203],
        //                     [-1.5219, 51.4258],
        //                     [-1.5211, 51.4342],
        //                     [-1.5283, 51.4514],
        //                     [-1.5505, 51.4614],
        //                     [-1.5764, 51.4889],
        //                     [-1.5845, 51.5174],
        //                     [-1.6028, 51.5203],
        //                     [-1.6467, 51.5686],
        //                     [-1.6683, 51.568],
        //                     [-1.6753, 51.5728],
        //                     [-1.6778, 51.5997],
        //                     [-1.6597, 51.6111],
        //                     [-1.6544, 51.6319],
        //                     [-1.6839, 51.6506],
        //                     [-1.6867, 51.6692],
        //                     [-1.6833, 51.6787],
        //                     [-1.6492, 51.6738],
        //                     [-1.6442, 51.6797],
        //                     [-1.6472, 51.6864],
        //                     [-1.6761, 51.7047],
        //                     [-1.68, 51.7314],
        //                     [-1.6925, 51.7625],
        //                     [-1.7092, 51.775],
        //                     [-1.6792, 51.7972],
        //                     [-1.6758, 51.8553],
        //                     [-1.6578, 51.8831],
        //                     [-1.6375, 51.8939],
        //                     [-1.6461, 51.91],
        //                     [-1.6128, 51.9317],
        //                     [-1.6125, 51.9394],
        //                     [-1.6189, 51.945],
        //                     [-1.6569, 51.9592],
        //                     [-1.6526, 51.984],
        //                     [-1.6039, 51.955],
        //                     [-1.5933, 51.9558],
        //                     [-1.5861, 51.9672],
        //                     [-1.5497, 51.9692],
        //                     [-1.5455, 51.9847],
        //                     [-1.518, 51.9883],
        //                     [-1.5097, 51.9983],
        //                     [-1.4958, 52.0405],
        //                     [-1.4953, 52.0608],
        //                     [-1.475, 52.0767],
        //                     [-1.4703, 52.0886],
        //                     [-1.4406, 52.0908],
        //                     [-1.4364, 52.093],
        //                     [-1.4375, 52.1075],
        //                     [-1.4261, 52.1089],
        //                     [-1.4075, 52.1078],
        //                     [-1.3794, 52.0919],
        //                     [-1.3578, 52.0953],
        //                     [-1.3511, 52.1044],
        //                     [-1.3736, 52.1183],
        //                     [-1.3414, 52.1344],
        //                     [-1.3336, 52.1522],
        //                     [-1.3212, 52.1616],
        //                     [-1.2372, 52.0961],
        //                     [-1.2436, 52.0905],
        //                     [-1.2736, 52.088],
        //                     [-1.3067, 52.0775],
        //                     [-1.2939, 52.0714],
        //                     [-1.2967, 52.0389],
        //                     [-1.288, 52.0303],
        //                     [-1.265, 51.9797],
        //                     [-1.2561, 51.9764],
        //                     [-1.2342, 51.9803],
        //                     [-1.1836, 51.9783],
        //                     [-1.1622, 51.9881],
        //                     [-1.1383, 51.9897],
        //                     [-1.1189, 52.0061],
        //                     [-1.1082, 52.0093],
        //                     [-1.1417, 52.0177],
        //                     [-1.1189, 52.035],
        //                     [-1.0967, 52.0439],
        //                     [-1.0367, 52.0536],
        //                     [-1.0233, 52.0647],
        //                     [-0.9908, 52.063],
        //                     [-0.95, 52.0739],
        //                     [-0.9406, 52.0719],
        //                     [-0.9014, 52.0186],
        //                     [-0.8901, 52.0201],
        //                     [-0.8564, 52.0405],
        //                     [-0.8558, 52.0586],
        //                     [-0.8275, 52.0644],
        //                     [-0.8278, 52.0722],
        //                     [-0.8517, 52.0858],
        //                     [-0.8664, 52.1025],
        //                     [-0.8778, 52.1061],
        //                     [-0.8783, 52.1161],
        //                     [-0.8259, 52.1275],
        //                     [-0.8131, 52.1378],
        //                     [-0.8136, 52.1458],
        //                     [-0.8067, 52.1522],
        //                     [-0.7761, 52.1469],
        //                     [-0.7619, 52.1625],
        //                     [-0.7289, 52.1617],
        //                     [-0.6544, 52.1925]
        //                 ]
        //             ]
        //         ]
        //     },
        //     'properties': {
        //         'name': 'South East England',
        //         'id': 'GB-UKJ',
        //         'TYPE': 'England',
        //         'CNTRY': 'United Kingdom'
        //     },
        //     'id': 'GB-UKJ'
        // }, {
        //     'type': 'Feature',
        //     'geometry': {
        //         'type': 'MultiPolygon',
        //         'coordinates': [
        //             [
        //                 [
        //                     [-6.3021, 49.9799],
        //                     [-6.2926, 49.974],
        //                     [-6.2896, 49.9671],
        //                     [-6.2768, 49.9643],
        //                     [-6.2646, 49.9676],
        //                     [-6.2612, 49.9626],
        //                     [-6.2843, 49.9557],
        //                     [-6.2896, 49.9618],
        //                     [-6.3051, 49.9638],
        //                     [-6.3021, 49.9799]
        //                 ]
        //             ],
        //             [
        //                 [
        //                     [-6.3537, 49.9388],
        //                     [-6.3474, 49.9299],
        //                     [-6.3588, 49.9296],
        //                     [-6.3537, 49.9388]
        //                 ]
        //             ],
        //             [
        //                 [
        //                     [-6.296, 49.9371],
        //                     [-6.286, 49.931],
        //                     [-6.2762, 49.9293],
        //                     [-6.2749, 49.9212],
        //                     [-6.2865, 49.909],
        //                     [-6.2976, 49.9101],
        //                     [-6.3037, 49.9026],
        //                     [-6.3107, 49.9096],
        //                     [-6.3235, 49.9079],
        //                     [-6.3276, 49.9129],
        //                     [-6.316, 49.9154],
        //                     [-6.3099, 49.9201],
        //                     [-6.314, 49.9265],
        //                     [-6.3099, 49.9338],
        //                     [-6.296, 49.9371]
        //                 ]
        //             ],
        //             [
        //                 [
        //                     [-6.3465, 49.9685],
        //                     [-6.3337, 49.964],
        //                     [-6.3187, 49.954],
        //                     [-6.3215, 49.9437],
        //                     [-6.3293, 49.9426],
        //                     [-6.3396, 49.9465],
        //                     [-6.3385, 49.9543],
        //                     [-6.3501, 49.9615],
        //                     [-6.3465, 49.9685]
        //                 ]
        //             ],
        //             [
        //                 [
        //                     [-6.359, 49.9674],
        //                     [-6.3479, 49.9549],
        //                     [-6.3518, 49.9496],
        //                     [-6.3663, 49.9515],
        //                     [-6.359, 49.9674]
        //                 ]
        //             ],
        //             [
        //                 [
        //                     [-2.6475, 51.8222],
        //                     [-2.6419, 51.8472],
        //                     [-2.6294, 51.8536],
        //                     [-2.62, 51.8378],
        //                     [-2.5981, 51.8467],
        //                     [-2.5855, 51.8447],
        //                     [-2.5786, 51.8544],
        //                     [-2.5506, 51.8617],
        //                     [-2.5197, 51.8589],
        //                     [-2.5058, 51.88],
        //                     [-2.4703, 51.8828],
        //                     [-2.4345, 51.8967],
        //                     [-2.4308, 51.9036],
        //                     [-2.4339, 51.9155],
        //                     [-2.4547, 51.93],
        //                     [-2.4603, 51.9478],
        //                     [-2.4814, 51.958],
        //                     [-2.4789, 51.975],
        //                     [-2.4675, 51.9867],
        //                     [-2.4722, 51.9972],
        //                     [-2.4608, 52.0197],
        //                     [-2.4414, 52.0133],
        //                     [-2.4295, 51.9944],
        //                     [-2.4131, 51.9894],
        //                     [-2.3933, 51.9947],
        //                     [-2.3689, 52.0122],
        //                     [-2.3417, 52.015],
        //                     [-2.3192, 51.9925],
        //                     [-2.3078, 51.9736],
        //                     [-2.2517, 51.9628],
        //                     [-2.2342, 51.9641],
        //                     [-2.2081, 51.9908],
        //                     [-2.1747, 51.9878],
        //                     [-2.1599, 51.995],
        //                     [-2.1763, 52.0073],
        //                     [-2.1706, 52.0339],
        //                     [-2.1647, 52.0405],
        //                     [-2.1149, 52.0422],
        //                     [-2.1433, 52.0063],
        //                     [-2.13, 51.9953],
        //                     [-2.1058, 52.0078],
        //                     [-2.0717, 52.0078],
        //                     [-2.0308, 52],
        //                     [-1.9708, 52.0261],
        //                     [-1.9422, 52.0303],
        //                     [-1.9186, 52.0269],
        //                     [-1.9042, 52.0314],
        //                     [-1.8789, 52.0281],
        //                     [-1.8436, 52.0078],
        //                     [-1.832, 52.0081],
        //                     [-1.8253, 52.0194],
        //                     [-1.8278, 52.0344],
        //                     [-1.8486, 52.0533],
        //                     [-1.8642, 52.0583],
        //                     [-1.8633, 52.0628],
        //                     [-1.8431, 52.073],
        //                     [-1.8139, 52.0689],
        //                     [-1.7783, 52.0989],
        //                     [-1.7578, 52.1058],
        //                     [-1.7369, 52.0894],
        //                     [-1.7158, 52.085],
        //                     [-1.7067, 52.0653],
        //                     [-1.6744, 52.0311],
        //                     [-1.6572, 52.0269],
        //                     [-1.6211, 52.0306],
        //                     [-1.6122, 52.0267],
        //                     [-1.6342, 52.0011],
        //                     [-1.6519, 51.9892],
        //                     [-1.6526, 51.984],
        //                     [-1.6569, 51.9592],
        //                     [-1.6189, 51.945],
        //                     [-1.6125, 51.9394],
        //                     [-1.6128, 51.9317],
        //                     [-1.6461, 51.91],
        //                     [-1.6375, 51.8939],
        //                     [-1.6578, 51.8831],
        //                     [-1.6758, 51.8553],
        //                     [-1.6792, 51.7972],
        //                     [-1.7092, 51.775],
        //                     [-1.6925, 51.7625],
        //                     [-1.68, 51.7314],
        //                     [-1.6761, 51.7047],
        //                     [-1.6472, 51.6864],
        //                     [-1.6442, 51.6797],
        //                     [-1.6492, 51.6738],
        //                     [-1.6833, 51.6787],
        //                     [-1.6867, 51.6692],
        //                     [-1.6839, 51.6506],
        //                     [-1.6544, 51.6319],
        //                     [-1.6597, 51.6111],
        //                     [-1.6778, 51.5997],
        //                     [-1.6753, 51.5728],
        //                     [-1.6683, 51.568],
        //                     [-1.6467, 51.5686],
        //                     [-1.6028, 51.5203],
        //                     [-1.5845, 51.5174],
        //                     [-1.5764, 51.4889],
        //                     [-1.5505, 51.4614],
        //                     [-1.5283, 51.4514],
        //                     [-1.5211, 51.4342],
        //                     [-1.5219, 51.4258],
        //                     [-1.5533, 51.4203],
        //                     [-1.5633, 51.4122],
        //                     [-1.5333, 51.3775],
        //                     [-1.4981, 51.3661],
        //                     [-1.4969, 51.3544],
        //                     [-1.4858, 51.3439],
        //                     [-1.487, 51.3325],
        //                     [-1.5267, 51.3297],
        //                     [-1.52, 51.3025],
        //                     [-1.5392, 51.2756],
        //                     [-1.5278, 51.2525],
        //                     [-1.5383, 51.245],
        //                     [-1.5797, 51.2578],
        //                     [-1.6, 51.2525],
        //                     [-1.6147, 51.2386],
        //                     [-1.6281, 51.2342],
        //                     [-1.6806, 51.24],
        //                     [-1.6964, 51.2367],
        //                     [-1.6853, 51.2053],
        //                     [-1.655, 51.1714],
        //                     [-1.6478, 51.15],
        //                     [-1.6528, 51.1264],
        //                     [-1.6289, 51.1172],
        //                     [-1.6219, 51.1083],
        //                     [-1.6314, 51.0861],
        //                     [-1.6203, 51.0542],
        //                     [-1.6219, 51.0342],
        //                     [-1.6028, 51.0264],
        //                     [-1.5967, 51.0175],
        //                     [-1.6156, 51.0053],
        //                     [-1.6214, 50.9947],
        //                     [-1.5997, 50.9769],
        //                     [-1.6106, 50.9597],
        //                     [-1.655, 50.9503],
        //                     [-1.6708, 50.9547],
        //                     [-1.6981, 50.975],
        //                     [-1.7406, 50.978],
        //                     [-1.7667, 50.9867],
        //                     [-1.8108, 50.9928],
        //                     [-1.8375, 51.0092],
        //                     [-1.8472, 51.0072],
        //                     [-1.8578, 50.9947],
        //                     [-1.8686, 50.9961],
        //                     [-1.8689, 51.0058],
        //                     [-1.9264, 50.9995],
        //                     [-1.95, 50.9883],
        //                     [-1.9072, 50.9439],
        //                     [-1.8797, 50.9247],
        //                     [-1.8625, 50.9228],
        //                     [-1.8369, 50.9336],
        //                     [-1.805, 50.9294],
        //                     [-1.8114, 50.9055],
        //                     [-1.8392, 50.8914],
        //                     [-1.8328, 50.8658],
        //                     [-1.8057, 50.8677],
        //                     [-1.7961, 50.8317],
        //                     [-1.8067, 50.8192],
        //                     [-1.8094, 50.8022],
        //                     [-1.7997, 50.7825],
        //                     [-1.7865, 50.7687],
        //                     [-1.735, 50.778],
        //                     [-1.7311, 50.7755],
        //                     [-1.7342, 50.7544],
        //                     [-1.6767, 50.7544],
        //                     [-1.6716, 50.7354],
        //                     [-1.6908, 50.7376],
        //                     [-1.7219, 50.7349],
        //                     [-1.7397, 50.7246],
        //                     [-1.7481, 50.7121],
        //                     [-1.7653, 50.716],
        //                     [-1.7992, 50.7201],
        //                     [-1.8292, 50.721],
        //                     [-1.8475, 50.7199],
        //                     [-1.8853, 50.714],
        //                     [-1.9042, 50.7082],
        //                     [-1.9236, 50.699],
        //                     [-1.9425, 50.7021],
        //                     [-1.9514, 50.7118],
        //                     [-1.9614, 50.7157],
        //                     [-1.9692, 50.7124],
        //                     [-1.9997, 50.7101],
        //                     [-2.0147, 50.7104],
        //                     [-2.0425, 50.7179],
        //                     [-2.062, 50.7165],
        //                     [-2.0692, 50.7107],
        //                     [-2.0781, 50.6937],
        //                     [-2.0703, 50.6871],
        //                     [-2.0592, 50.691],
        //                     [-2.0558, 50.6993],
        //                     [-2.0425, 50.7032],
        //                     [-2.0297, 50.7032],
        //                     [-2.0247, 50.696],
        //                     [-2.0258, 50.6793],
        //                     [-2.0153, 50.6829],
        //                     [-1.9958, 50.6737],
        //                     [-1.9858, 50.6737],
        //                     [-1.9819, 50.6679],
        //                     [-1.9564, 50.6732],
        //                     [-1.9519, 50.6785],
        //                     [-1.9419, 50.6724],
        //                     [-1.9519, 50.6587],
        //                     [-1.9531, 50.6507],
        //                     [-1.9419, 50.6413],
        //                     [-1.9264, 50.6424],
        //                     [-1.9247, 50.6385],
        //                     [-1.9325, 50.6307],
        //                     [-1.9442, 50.6288],
        //                     [-1.9569, 50.6179],
        //                     [-1.9558, 50.609],
        //                     [-1.9503, 50.6043],
        //                     [-1.9514, 50.5938],
        //                     [-1.9592, 50.5907],
        //                     [-1.9914, 50.5901],
        //                     [-2.0053, 50.5913],
        //                     [-2.0264, 50.5885],
        //                     [-2.0442, 50.5782],
        //                     [-2.0575, 50.5765],
        //                     [-2.0653, 50.5899],
        //                     [-2.0969, 50.5976],
        //                     [-2.1053, 50.5963],
        //                     [-2.1297, 50.6049],
        //                     [-2.1297, 50.6107],
        //                     [-2.1475, 50.6101],
        //                     [-2.1575, 50.6151],
        //                     [-2.1686, 50.6135],
        //                     [-2.1825, 50.6151],
        //                     [-2.188, 50.6201],
        //                     [-2.2075, 50.6221],
        //                     [-2.2292, 50.6154],
        //                     [-2.2619, 50.6182],
        //                     [-2.2664, 50.621],
        //                     [-2.2908, 50.6218],
        //                     [-2.3058, 50.6251],
        //                     [-2.3242, 50.6246],
        //                     [-2.3375, 50.6318],
        //                     [-2.3653, 50.6307],
        //                     [-2.3797, 50.6351],
        //                     [-2.3942, 50.6365],
        //                     [-2.412, 50.634],
        //                     [-2.4236, 50.6357],
        //                     [-2.4425, 50.6254],
        //                     [-2.4525, 50.6135],
        //                     [-2.448, 50.601],
        //                     [-2.4592, 50.5971],
        //                     [-2.4703, 50.5849],
        //                     [-2.463, 50.5726],
        //                     [-2.4475, 50.5688],
        //                     [-2.4269, 50.5682],
        //                     [-2.4158, 50.5529],
        //                     [-2.4175, 50.5421],
        //                     [-2.4369, 50.5299],
        //                     [-2.4436, 50.5199],
        //                     [-2.4592, 50.5135],
        //                     [-2.4525, 50.5471],
        //                     [-2.4486, 50.5568],
        //                     [-2.4625, 50.5701],
        //                     [-2.5064, 50.5982],
        //                     [-2.5281, 50.6104],
        //                     [-2.6047, 50.6501],
        //                     [-2.6642, 50.6743],
        //                     [-2.6669, 50.6762],
        //                     [-2.7386, 50.7024],
        //                     [-2.7647, 50.7107],
        //                     [-2.7925, 50.7179],
        //                     [-2.8119, 50.7177],
        //                     [-2.8342, 50.7237],
        //                     [-2.8419, 50.7226],
        //                     [-2.8614, 50.7279],
        //                     [-2.8953, 50.7329],
        //                     [-2.9103, 50.7338],
        //                     [-2.9264, 50.7299],
        //                     [-2.9375, 50.7207],
        //                     [-2.958, 50.7124],
        //                     [-2.9669, 50.7126],
        //                     [-2.9831, 50.704],
        //                     [-2.9958, 50.7054],
        //                     [-3.0092, 50.6993],
        //                     [-3.0258, 50.6982],
        //                     [-3.0597, 50.7024],
        //                     [-3.0769, 50.7026],
        //                     [-3.0914, 50.6954],
        //                     [-3.0953, 50.6849],
        //                     [-3.1281, 50.6868],
        //                     [-3.1464, 50.6843],
        //                     [-3.1931, 50.684],
        //                     [-3.2331, 50.6785],
        //                     [-3.2642, 50.6707],
        //                     [-3.2675, 50.6646],
        //                     [-3.2842, 50.6537],
        //                     [-3.288, 50.6407],
        //                     [-3.3047, 50.6288],
        //                     [-3.317, 50.6293],
        //                     [-3.3525, 50.6188],
        //                     [-3.3642, 50.6096],
        //                     [-3.3864, 50.6068],
        //                     [-3.3886, 50.6093],
        //                     [-3.4086, 50.6113],
        //                     [-3.4169, 50.6207],
        //                     [-3.4169, 50.6307],
        //                     [-3.4231, 50.639],
        //                     [-3.4331, 50.6454],
        //                     [-3.4358, 50.6551],
        //                     [-3.4447, 50.6682],
        //                     [-3.4642, 50.6779],
        //                     [-3.4675, 50.6707],
        //                     [-3.4664, 50.661],
        //                     [-3.4575, 50.6571],
        //                     [-3.4514, 50.6485],
        //                     [-3.4519, 50.6399],
        //                     [-3.4464, 50.6263],
        //                     [-3.4442, 50.6046],
        //                     [-3.4386, 50.599],
        //                     [-3.4447, 50.5915],
        //                     [-3.4569, 50.5854],
        //                     [-3.4669, 50.5771],
        //                     [-3.4686, 50.5621],
        //                     [-3.4747, 50.5613],
        //                     [-3.4858, 50.5526],
        //                     [-3.4947, 50.5424],
        //                     [-3.5058, 50.5224],
        //                     [-3.5125, 50.5063],
        //                     [-3.5114, 50.5004],
        //                     [-3.5147, 50.4824],
        //                     [-3.5008, 50.4779],
        //                     [-3.4914, 50.4704],
        //                     [-3.4897, 50.4579],
        //                     [-3.5047, 50.4593],
        //                     [-3.517, 50.4538],
        //                     [-3.5397, 50.4607],
        //                     [-3.5575, 50.444],
        //                     [-3.5592, 50.4207],
        //                     [-3.5536, 50.4146],
        //                     [-3.5558, 50.4074],
        //                     [-3.5453, 50.4026],
        //                     [-3.5286, 50.4051],
        //                     [-3.5136, 50.399],
        //                     [-3.4981, 50.4015],
        //                     [-3.4831, 50.4004],
        //                     [-3.4881, 50.3937],
        //                     [-3.5031, 50.3882],
        //                     [-3.4958, 50.3807],
        //                     [-3.5069, 50.3793],
        //                     [-3.5153, 50.3726],
        //                     [-3.5153, 50.364],
        //                     [-3.5203, 50.3571],
        //                     [-3.5142, 50.354],
        //                     [-3.5164, 50.3474],
        //                     [-3.5336, 50.3368],
        //                     [-3.5442, 50.3349],
        //                     [-3.5547, 50.3413],
        //                     [-3.5736, 50.3474],
        //                     [-3.5708, 50.3554],
        //                     [-3.5786, 50.3665],
        //                     [-3.578, 50.3754],
        //                     [-3.5925, 50.3824],
        //                     [-3.578, 50.3893],
        //                     [-3.588, 50.3946],
        //                     [-3.6136, 50.3932],
        //                     [-3.5808, 50.3746],
        //                     [-3.5831, 50.3613],
        //                     [-3.5747, 50.3557],
        //                     [-3.5769, 50.3471],
        //                     [-3.5647, 50.3424],
        //                     [-3.5653, 50.3338],
        //                     [-3.5758, 50.3243],
        //                     [-3.5858, 50.3257],
        //                     [-3.6081, 50.3196],
        //                     [-3.6214, 50.3085],
        //                     [-3.6314, 50.3043],
        //                     [-3.6408, 50.2935],
        //                     [-3.6508, 50.2726],
        //                     [-3.6586, 50.2415],
        //                     [-3.658, 50.2332],
        //                     [-3.6481, 50.2215],
        //                     [-3.658, 50.2176],
        //                     [-3.6825, 50.2212],
        //                     [-3.6886, 50.216],
        //                     [-3.7031, 50.211],
        //                     [-3.7075, 50.2046],
        //                     [-3.7197, 50.2018],
        //                     [-3.7325, 50.2074],
        //                     [-3.7381, 50.2143],
        //                     [-3.7475, 50.2176],
        //                     [-3.7714, 50.2215],
        //                     [-3.7736, 50.2257],
        //                     [-3.7631, 50.2365],
        //                     [-3.7558, 50.2379],
        //                     [-3.7581, 50.2507],
        //                     [-3.7475, 50.2579],
        //                     [-3.7631, 50.2607],
        //                     [-3.7642, 50.254],
        //                     [-3.7586, 50.2482],
        //                     [-3.7658, 50.2354],
        //                     [-3.7797, 50.229],
        //                     [-3.7797, 50.2157],
        //                     [-3.7836, 50.2096],
        //                     [-3.7969, 50.2107],
        //                     [-3.7997, 50.2146],
        //                     [-3.8136, 50.2143],
        //                     [-3.8231, 50.2168],
        //                     [-3.8347, 50.2268],
        //                     [-3.8608, 50.234],
        //                     [-3.8597, 50.2426],
        //                     [-3.8619, 50.2649],
        //                     [-3.8803, 50.2721],
        //                     [-3.8792, 50.2843],
        //                     [-3.8958, 50.2815],
        //                     [-3.897, 50.2874],
        //                     [-3.9175, 50.2954],
        //                     [-3.9453, 50.2963],
        //                     [-3.9481, 50.3065],
        //                     [-3.9614, 50.3029],
        //                     [-3.9703, 50.306],
        //                     [-3.9931, 50.3068],
        //                     [-4.0008, 50.3018],
        //                     [-4.0158, 50.3013],
        //                     [-4.0175, 50.296],
        //                     [-4.0319, 50.2926],
        //                     [-4.0519, 50.2943],
        //                     [-4.0603, 50.3001],
        //                     [-4.0758, 50.3029],
        //                     [-4.0725, 50.309],
        //                     [-4.0597, 50.3129],
        //                     [-4.1014, 50.3171],
        //                     [-4.1114, 50.3154],
        //                     [-4.1192, 50.3196],
        //                     [-4.1208, 50.336],
        //                     [-4.1242, 50.3454],
        //                     [-4.1253, 50.364],
        //                     [-4.1614, 50.3613],
        //                     [-4.1725, 50.3654],
        //                     [-4.1864, 50.3668],
        //                     [-4.1836, 50.3771],
        //                     [-4.1903, 50.3885],
        //                     [-4.2047, 50.3999],
        //                     [-4.1869, 50.434],
        //                     [-4.1997, 50.4451],
        //                     [-4.2014, 50.4557],
        //                     [-4.2114, 50.4574],
        //                     [-4.2081, 50.4457],
        //                     [-4.1986, 50.4371],
        //                     [-4.2097, 50.4262],
        //                     [-4.2108, 50.414],
        //                     [-4.2058, 50.4071],
        //                     [-4.2119, 50.3987],
        //                     [-4.2386, 50.3926],
        //                     [-4.2475, 50.3846],
        //                     [-4.2681, 50.3868],
        //                     [-4.2697, 50.3796],
        //                     [-4.2486, 50.3776],
        //                     [-4.2386, 50.381],
        //                     [-4.2319, 50.3904],
        //                     [-4.2097, 50.3929],
        //                     [-4.2019, 50.3887],
        //                     [-4.1925, 50.3737],
        //                     [-4.2236, 50.3676],
        //                     [-4.2153, 50.3593],
        //                     [-4.2069, 50.3615],
        //                     [-4.1836, 50.3571],
        //                     [-4.1708, 50.3585],
        //                     [-4.1664, 50.3454],
        //                     [-4.1886, 50.3404],
        //                     [-4.1997, 50.3335],
        //                     [-4.1886, 50.3232],
        //                     [-4.1886, 50.3174],
        //                     [-4.2086, 50.3179],
        //                     [-4.2175, 50.3149],
        //                     [-4.2275, 50.3196],
        //                     [-4.2197, 50.3246],
        //                     [-4.2269, 50.3318],
        //                     [-4.2436, 50.3413],
        //                     [-4.2714, 50.3524],
        //                     [-4.2969, 50.3593],
        //                     [-4.3286, 50.3618],
        //                     [-4.3364, 50.3588],
        //                     [-4.3492, 50.361],
        //                     [-4.3669, 50.3599],
        //                     [-4.3869, 50.3643],
        //                     [-4.4097, 50.3635],
        //                     [-4.4364, 50.3607],
        //                     [-4.4475, 50.3543],
        //                     [-4.4575, 50.3415],
        //                     [-4.4731, 50.3379],
        //                     [-4.4742, 50.3321],
        //                     [-4.4986, 50.336],
        //                     [-4.5097, 50.3304],
        //                     [-4.5336, 50.324],
        //                     [-4.5497, 50.3235],
        //                     [-4.5781, 50.3318],
        //                     [-4.5858, 50.3318],
        //                     [-4.6025, 50.3243],
        //                     [-4.6169, 50.3238],
        //                     [-4.6386, 50.3257],
        //                     [-4.6692, 50.3204],
        //                     [-4.6753, 50.314],
        //                     [-4.6825, 50.3226],
        //                     [-4.6819, 50.3379],
        //                     [-4.6958, 50.3471],
        //                     [-4.7053, 50.3404],
        //                     [-4.7297, 50.3374],
        //                     [-4.7447, 50.3315],
        //                     [-4.7525, 50.3315],
        //                     [-4.7664, 50.3226],
        //                     [-4.7608, 50.3082],
        //                     [-4.7642, 50.2999],
        //                     [-4.7842, 50.286],
        //                     [-4.7775, 50.2788],
        //                     [-4.7836, 50.2748],
        //                     [-4.7836, 50.2624],
        //                     [-4.7708, 50.2582],
        //                     [-4.7686, 50.2521],
        //                     [-4.7853, 50.2454],
        //                     [-4.7836, 50.2346],
        //                     [-4.7981, 50.2304],
        //                     [-4.7981, 50.2193],
        //                     [-4.8053, 50.2179],
        //                     [-4.8136, 50.2299],
        //                     [-4.828, 50.2299],
        //                     [-4.8403, 50.2349],
        //                     [-4.8653, 50.2346],
        //                     [-4.8753, 50.2271],
        //                     [-4.9014, 50.2129],
        //                     [-4.9042, 50.2046],
        //                     [-4.9231, 50.1954],
        //                     [-4.9236, 50.2015],
        //                     [-4.9331, 50.2068],
        //                     [-4.9481, 50.2057],
        //                     [-4.9586, 50.2012],
        //                     [-4.9686, 50.1915],
        //                     [-4.9675, 50.1854],
        //                     [-4.9736, 50.1738],
        //                     [-4.9725, 50.164],
        //                     [-4.9842, 50.1576],
        //                     [-4.9842, 50.1493],
        //                     [-4.9953, 50.1487],
        //                     [-5.0075, 50.1393],
        //                     [-5.0164, 50.1401],
        //                     [-5.018, 50.1496],
        //                     [-5.0136, 50.1585],
        //                     [-5.0286, 50.1574],
        //                     [-5.0197, 50.1776],
        //                     [-5.0281, 50.1851],
        //                     [-5.0303, 50.1968],
        //                     [-5.0353, 50.2026],
        //                     [-5.0486, 50.2026],
        //                     [-5.0586, 50.199],
        //                     [-5.0547, 50.1782],
        //                     [-5.0447, 50.1754],
        //                     [-5.0453, 50.1693],
        //                     [-5.0542, 50.161],
        //                     [-5.0697, 50.1618],
        //                     [-5.0681, 50.1549],
        //                     [-5.0475, 50.1526],
        //                     [-5.0542, 50.1477],
        //                     [-5.0764, 50.1376],
        //                     [-5.0725, 50.134],
        //                     [-5.0864, 50.1268],
        //                     [-5.0903, 50.114],
        //                     [-5.0831, 50.1118],
        //                     [-5.0864, 50.1043],
        //                     [-5.0981, 50.0993],
        //                     [-5.1108, 50.1035],
        //                     [-5.1275, 50.0996],
        //                     [-5.1047, 50.0949],
        //                     [-5.0869, 50.0865],
        //                     [-5.077, 50.0793],
        //                     [-5.0792, 50.0682],
        //                     [-5.0686, 50.0679],
        //                     [-5.0608, 50.0596],
        //                     [-5.0592, 50.0507],
        //                     [-5.0664, 50.0476],
        //                     [-5.0692, 50.0338],
        //                     [-5.0869, 50.0318],
        //                     [-5.0953, 50.0274],
        //                     [-5.0953, 50.0157],
        //                     [-5.1003, 50.004],
        //                     [-5.113, 50.0026],
        //                     [-5.128, 50.0082],
        //                     [-5.1564, 50.0073],
        //                     [-5.1664, 50.0032],
        //                     [-5.1693, 49.991],
        //                     [-5.1846, 49.9796],
        //                     [-5.1849, 49.9626],
        //                     [-5.1976, 49.9585],
        //                     [-5.2088, 49.959],
        //                     [-5.2162, 49.9554],
        //                     [-5.2196, 49.9707],
        //                     [-5.234, 49.9718],
        //                     [-5.2485, 49.9757],
        //                     [-5.254, 49.9863],
        //                     [-5.2532, 49.9915],
        //                     [-5.2674, 49.9993],
        //                     [-5.2692, 50.0065],
        //                     [-5.2564, 50.0213],
        //                     [-5.2653, 50.0282],
        //                     [-5.2669, 50.0379],
        //                     [-5.2803, 50.0415],
        //                     [-5.278, 50.0501],
        //                     [-5.2831, 50.0599],
        //                     [-5.3164, 50.0818],
        //                     [-5.3336, 50.0904],
        //                     [-5.3486, 50.0915],
        //                     [-5.3631, 50.0885],
        //                     [-5.3669, 50.0932],
        //                     [-5.3892, 50.1032],
        //                     [-5.398, 50.1001],
        //                     [-5.4108, 50.104],
        //                     [-5.4286, 50.0968],
        //                     [-5.4286, 50.1046],
        //                     [-5.4447, 50.1118],
        //                     [-5.4636, 50.1232],
        //                     [-5.4742, 50.1227],
        //                     [-5.4808, 50.1265],
        //                     [-5.4992, 50.1285],
        //                     [-5.527, 50.1254],
        //                     [-5.5292, 50.1157],
        //                     [-5.5458, 50.1093],
        //                     [-5.5375, 50.0924],
        //                     [-5.5314, 50.089],
        //                     [-5.5375, 50.0821],
        //                     [-5.5414, 50.0715],
        //                     [-5.5503, 50.061],
        //                     [-5.563, 50.0576],
        //                     [-5.5764, 50.051],
        //                     [-5.5997, 50.0518],
        //                     [-5.6053, 50.0479],
        //                     [-5.6175, 50.0496],
        //                     [-5.6364, 50.0393],
        //                     [-5.6403, 50.0429],
        //                     [-5.6558, 50.0374],
        //                     [-5.6803, 50.0346],
        //                     [-5.6953, 50.049],
        //                     [-5.6947, 50.0538],
        //                     [-5.7069, 50.0549],
        //                     [-5.7153, 50.0624],
        //                     [-5.7164, 50.0685],
        //                     [-5.7103, 50.0765],
        //                     [-5.6931, 50.0826],
        //                     [-5.6897, 50.0926],
        //                     [-5.6969, 50.0971],
        //                     [-5.7014, 50.1127],
        //                     [-5.7008, 50.1193],
        //                     [-5.7069, 50.1227],
        //                     [-5.7047, 50.1354],
        //                     [-5.6942, 50.1379],
        //                     [-5.6925, 50.1507],
        //                     [-5.6814, 50.156],
        //                     [-5.6708, 50.1668],
        //                     [-5.6575, 50.164],
        //                     [-5.6519, 50.1679],
        //                     [-5.6281, 50.1687],
        //                     [-5.622, 50.1768],
        //                     [-5.6019, 50.1901],
        //                     [-5.5858, 50.1915],
        //                     [-5.5792, 50.1988],
        //                     [-5.5658, 50.1999],
        //                     [-5.5553, 50.2093],
        //                     [-5.5425, 50.2121],
        //                     [-5.5392, 50.216],
        //                     [-5.5258, 50.214],
        //                     [-5.5181, 50.2174],
        //                     [-5.4953, 50.2193],
        //                     [-5.4814, 50.2157],
        //                     [-5.4692, 50.2057],
        //                     [-5.468, 50.1996],
        //                     [-5.4519, 50.1951],
        //                     [-5.4375, 50.194],
        //                     [-5.4125, 50.2065],
        //                     [-5.4008, 50.216],
        //                     [-5.3914, 50.2299],
        //                     [-5.3958, 50.2401],
        //                     [-5.3775, 50.244],
        //                     [-5.3692, 50.2365],
        //                     [-5.3569, 50.2404],
        //                     [-5.3442, 50.2379],
        //                     [-5.3153, 50.2496],
        //                     [-5.3103, 50.2582],
        //                     [-5.3025, 50.2629],
        //                     [-5.2925, 50.2626],
        //                     [-5.2753, 50.2754],
        //                     [-5.2653, 50.2754],
        //                     [-5.2608, 50.2804],
        //                     [-5.2469, 50.2843],
        //                     [-5.2342, 50.3054],
        //                     [-5.2347, 50.3193],
        //                     [-5.2225, 50.3226],
        //                     [-5.2003, 50.3207],
        //                     [-5.1958, 50.3265],
        //                     [-5.1814, 50.3343],
        //                     [-5.1819, 50.3407],
        //                     [-5.1719, 50.3413],
        //                     [-5.1569, 50.349],
        //                     [-5.1497, 50.3624],
        //                     [-5.1475, 50.3751],
        //                     [-5.1547, 50.3862],
        //                     [-5.1436, 50.3943],
        //                     [-5.1497, 50.4012],
        //                     [-5.1297, 50.4051],
        //                     [-5.1253, 50.4104],
        //                     [-5.1114, 50.414],
        //                     [-5.1019, 50.4135],
        //                     [-5.0992, 50.4212],
        //                     [-5.0892, 50.4212],
        //                     [-5.0864, 50.4162],
        //                     [-5.0736, 50.4199],
        //                     [-5.0564, 50.429],
        //                     [-5.042, 50.444],
        //                     [-5.0414, 50.4657],
        //                     [-5.033, 50.4668],
        //                     [-5.0375, 50.4762],
        //                     [-5.0342, 50.4871],
        //                     [-5.0431, 50.499],
        //                     [-5.0358, 50.5076],
        //                     [-5.027, 50.5096],
        //                     [-5.0308, 50.5218],
        //                     [-5.0247, 50.5399],
        //                     [-5.0403, 50.5446],
        //                     [-5.0369, 50.5496],
        //                     [-5.0253, 50.5521],
        //                     [-5.018, 50.5451],
        //                     [-5.0042, 50.5468],
        //                     [-5.0014, 50.5404],
        //                     [-4.9908, 50.5438],
        //                     [-4.9747, 50.5524],
        //                     [-4.9708, 50.5588],
        //                     [-4.9625, 50.5596],
        //                     [-4.9536, 50.569],
        //                     [-4.9442, 50.569],
        //                     [-4.9486, 50.556],
        //                     [-4.9386, 50.554],
        //                     [-4.9336, 50.5463],
        //                     [-4.9364, 50.5404],
        //                     [-4.9314, 50.5282],
        //                     [-4.9219, 50.5315],
        //                     [-4.9103, 50.5307],
        //                     [-4.8997, 50.5263],
        //                     [-4.8792, 50.5307],
        //                     [-4.8514, 50.5288],
        //                     [-4.8497, 50.5321],
        //                     [-4.8842, 50.5337],
        //                     [-4.8969, 50.5299],
        //                     [-4.9153, 50.5371],
        //                     [-4.9158, 50.5413],
        //                     [-4.9275, 50.546],
        //                     [-4.9314, 50.564],
        //                     [-4.9236, 50.5735],
        //                     [-4.9153, 50.5751],
        //                     [-4.9258, 50.5832],
        //                     [-4.9219, 50.5915],
        //                     [-4.9081, 50.5849],
        //                     [-4.8958, 50.5857],
        //                     [-4.8886, 50.5826],
        //                     [-4.8753, 50.5874],
        //                     [-4.8697, 50.5954],
        //                     [-4.8631, 50.5932],
        //                     [-4.8469, 50.5979],
        //                     [-4.8258, 50.5951],
        //                     [-4.7953, 50.5988],
        //                     [-4.7858, 50.6063],
        //                     [-4.7703, 50.6257],
        //                     [-4.7686, 50.6432],
        //                     [-4.7614, 50.6446],
        //                     [-4.7603, 50.6524],
        //                     [-4.7675, 50.656],
        //                     [-4.7614, 50.6649],
        //                     [-4.7642, 50.6704],
        //                     [-4.7342, 50.6721],
        //                     [-4.7247, 50.6857],
        //                     [-4.7158, 50.6837],
        //                     [-4.7064, 50.6904],
        //                     [-4.6903, 50.6951],
        //                     [-4.6819, 50.7046],
        //                     [-4.6686, 50.7068],
        //                     [-4.6669, 50.7115],
        //                     [-4.6553, 50.716],
        //                     [-4.6497, 50.7312],
        //                     [-4.6542, 50.7399],
        //                     [-4.6408, 50.7385],
        //                     [-4.6397, 50.7457],
        //                     [-4.6319, 50.7504],
        //                     [-4.6203, 50.7512],
        //                     [-4.6131, 50.7615],
        //                     [-4.5914, 50.766],
        //                     [-4.5758, 50.7724],
        //                     [-4.5575, 50.7876],
        //                     [-4.5603, 50.806],
        //                     [-4.5569, 50.8168],
        //                     [-4.5586, 50.8237],
        //                     [-4.5564, 50.841],
        //                     [-4.5575, 50.8663],
        //                     [-4.568, 50.8851],
        //                     [-4.5653, 50.894],
        //                     [-4.5664, 50.911],
        //                     [-4.5569, 50.9218],
        //                     [-4.5464, 50.9288],
        //                     [-4.5497, 50.941],
        //                     [-4.543, 50.9446],
        //                     [-4.5453, 50.9529],
        //                     [-4.5331, 50.966],
        //                     [-4.5336, 50.9774],
        //                     [-4.5297, 50.986],
        //                     [-4.5353, 50.9918],
        //                     [-4.5336, 51.0012],
        //                     [-4.5225, 51.0215],
        //                     [-4.4703, 51.0218],
        //                     [-4.4497, 51.0149],
        //                     [-4.4258, 51.0143],
        //                     [-4.403, 51.0046],
        //                     [-4.3958, 50.9971],
        //                     [-4.3753, 50.9904],
        //                     [-4.3431, 50.989],
        //                     [-4.3092, 50.9951],
        //                     [-4.2792, 51.0168],
        //                     [-4.2753, 51.024],
        //                     [-4.2592, 51.0387],
        //                     [-4.2364, 51.0435],
        //                     [-4.2264, 51.0624],
        //                     [-4.2153, 51.0649],
        //                     [-4.2086, 51.0551],
        //                     [-4.1992, 51.0585],
        //                     [-4.1897, 51.0546],
        //                     [-4.182, 51.0563],
        //                     [-4.172, 51.0721],
        //                     [-4.1542, 51.0801],
        //                     [-4.1258, 51.0779],
        //                     [-4.1186, 51.0807],
        //                     [-4.1142, 51.0901],
        //                     [-4.0997, 51.0835],
        //                     [-4.0964, 51.0868],
        //                     [-4.1064, 51.0932],
        //                     [-4.128, 51.0929],
        //                     [-4.1286, 51.0871],
        //                     [-4.147, 51.0829],
        //                     [-4.157, 51.0854],
        //                     [-4.1664, 51.0799],
        //                     [-4.1853, 51.076],
        //                     [-4.1936, 51.0679],
        //                     [-4.2053, 51.0704],
        //                     [-4.2153, 51.0768],
        //                     [-4.2219, 51.086],
        //                     [-4.2214, 51.1168],
        //                     [-4.2447, 51.1221],
        //                     [-4.2375, 51.1323],
        //                     [-4.2631, 51.1423],
        //                     [-4.2575, 51.1476],
        //                     [-4.2231, 51.1448],
        //                     [-4.2131, 51.1551],
        //                     [-4.2092, 51.1723],
        //                     [-4.2147, 51.1815],
        //                     [-4.2303, 51.1885],
        //                     [-4.2136, 51.1899],
        //                     [-4.2019, 51.2007],
        //                     [-4.1747, 51.1985],
        //                     [-4.1664, 51.2029],
        //                     [-4.1475, 51.2038],
        //                     [-4.1442, 51.2065],
        //                     [-4.1219, 51.2124],
        //                     [-4.108, 51.2096],
        //                     [-4.0881, 51.2171],
        //                     [-4.0731, 51.2179],
        //                     [-4.0558, 51.2126],
        //                     [-4.0508, 51.2082],
        //                     [-4.0331, 51.2104],
        //                     [-4.0292, 51.2163],
        //                     [-4.0108, 51.2168],
        //                     [-3.9758, 51.2201],
        //                     [-3.9497, 51.2213],
        //                     [-3.9397, 51.2287],
        //                     [-3.903, 51.2296],
        //                     [-3.8936, 51.2243],
        //                     [-3.8714, 51.2315],
        //                     [-3.8397, 51.2351],
        //                     [-3.8308, 51.231],
        //                     [-3.8081, 51.2321],
        //                     [-3.7858, 51.2462],
        //                     [-3.7703, 51.2379],
        //                     [-3.7453, 51.2357],
        //                     [-3.7275, 51.2357],
        //                     [-3.7181, 51.2324],
        //                     [-3.7003, 51.2321],
        //                     [-3.6842, 51.2276],
        //                     [-3.6419, 51.2232],
        //                     [-3.6319, 51.2237],
        //                     [-3.6186, 51.2171],
        //                     [-3.6075, 51.2218],
        //                     [-3.5892, 51.224],
        //                     [-3.578, 51.2321],
        //                     [-3.5575, 51.2332],
        //                     [-3.5353, 51.2315],
        //                     [-3.5053, 51.2235],
        //                     [-3.4953, 51.2243],
        //                     [-3.4797, 51.2174],
        //                     [-3.4669, 51.2071],
        //                     [-3.4464, 51.209],
        //                     [-3.4314, 51.1954],
        //                     [-3.4097, 51.1835],
        //                     [-3.3964, 51.1826],
        //                     [-3.3669, 51.1851],
        //                     [-3.3469, 51.1815],
        //                     [-3.3397, 51.1835],
        //                     [-3.3214, 51.1829],
        //                     [-3.3142, 51.179],
        //                     [-3.2986, 51.1824],
        //                     [-3.2747, 51.1804],
        //                     [-3.2597, 51.1874],
        //                     [-3.2503, 51.1876],
        //                     [-3.2186, 51.1943],
        //                     [-3.2003, 51.2024],
        //                     [-3.1819, 51.2001],
        //                     [-3.1636, 51.2032],
        //                     [-3.1547, 51.209],
        //                     [-3.1281, 51.211],
        //                     [-3.1147, 51.2076],
        //                     [-3.0986, 51.2085],
        //                     [-3.0781, 51.2013],
        //                     [-3.0575, 51.204],
        //                     [-3.0314, 51.2174],
        //                     [-3.0253, 51.2115],
        //                     [-3.0297, 51.1965],
        //                     [-3.0447, 51.1949],
        //                     [-3.0558, 51.1871],
        //                     [-3.0325, 51.1896],
        //                     [-3.0231, 51.1957],
        //                     [-3.0125, 51.2165],
        //                     [-3.0064, 51.2207],
        //                     [-2.9997, 51.2324],
        //                     [-2.9997, 51.2435],
        //                     [-3.017, 51.2604],
        //                     [-3.0197, 51.2696],
        //                     [-3.0136, 51.2887],
        //                     [-3.0108, 51.3054],
        //                     [-3.0108, 51.3215],
        //                     [-3.003, 51.3251],
        //                     [-2.9908, 51.3213],
        //                     [-2.9831, 51.3368],
        //                     [-2.9819, 51.3482],
        //                     [-2.9953, 51.3543],
        //                     [-2.9847, 51.361],
        //                     [-2.9703, 51.3629],
        //                     [-2.9642, 51.3668],
        //                     [-2.962, 51.3821],
        //                     [-2.9697, 51.3863],
        //                     [-2.9658, 51.3929],
        //                     [-2.9553, 51.3932],
        //                     [-2.9419, 51.3985],
        //                     [-2.9242, 51.396],
        //                     [-2.9075, 51.4001],
        //                     [-2.8892, 51.4138],
        //                     [-2.8803, 51.4321],
        //                     [-2.8686, 51.4371],
        //                     [-2.8525, 51.4549],
        //                     [-2.8225, 51.469],
        //                     [-2.8186, 51.4743],
        //                     [-2.8019, 51.486],
        //                     [-2.7814, 51.489],
        //                     [-2.7747, 51.4932],
        //                     [-2.7336, 51.4951],
        //                     [-2.7086, 51.5151],
        //                     [-2.693, 51.5246],
        //                     [-2.6803, 51.5374],
        //                     [-2.6686, 51.5532],
        //                     [-2.6692, 51.5635],
        //                     [-2.6658, 51.5726],
        //                     [-2.6431, 51.5863],
        //                     [-2.6297, 51.606],
        //                     [-2.6458, 51.6124],
        //                     [-2.6553, 51.6076],
        //                     [-2.6644, 51.6138],
        //                     [-2.6755, 51.6378],
        //                     [-2.6703, 51.6528],
        //                     [-2.6836, 51.6542],
        //                     [-2.6886, 51.66],
        //                     [-2.6592, 51.6731],
        //                     [-2.6769, 51.6892],
        //                     [-2.6739, 51.7044],
        //                     [-2.6867, 51.7189],
        //                     [-2.6853, 51.7269],
        //                     [-2.6678, 51.74],
        //                     [-2.6686, 51.7475],
        //                     [-2.6839, 51.7655],
        //                     [-2.6745, 51.7827],
        //                     [-2.6768, 51.7896],
        //                     [-2.6486, 51.8122],
        //                     [-2.6475, 51.8222]
        //                 ]
        //             ],
        //             [
        //                 [
        //                     [-6.3504, 49.899],
        //                     [-6.3362, 49.8951],
        //                     [-6.3274, 49.8901],
        //                     [-6.3443, 49.8871],
        //                     [-6.3532, 49.8876],
        //                     [-6.3504, 49.899]
        //                 ]
        //             ]
        //         ]
        //     },
        //     'properties': {
        //         'name': 'South West England',
        //         'id': 'GB-UKK',
        //         'TYPE': 'England',
        //         'CNTRY': 'United Kingdom'
        //     },
        //     'id': 'GB-UKK'
        // },
        {
            'type': 'Feature',
            'geometry': {
                'type': 'MultiPolygon',
                'coordinates': [
                    [
                        [
                            [-5.2731, 51.7035],
                            [-5.2653, 51.6999],
                            [-5.2764, 51.6932],
                            [-5.2886, 51.6929],
                            [-5.2808, 51.7015],
                            [-5.2731, 51.7035]
                        ]
                    ],
                    [
                        [
                            [-5.2986, 51.7451],
                            [-5.2808, 51.7413],
                            [-5.2686, 51.7354],
                            [-5.2803, 51.7315],
                            [-5.3108, 51.7324],
                            [-5.3131, 51.7399],
                            [-5.2986, 51.7451]
                        ]
                    ],
                    [
                        [
                            [-5.3381, 51.879],
                            [-5.3319, 51.8787],
                            [-5.3314, 51.8518],
                            [-5.3497, 51.8574],
                            [-5.3525, 51.8668],
                            [-5.3436, 51.8685],
                            [-5.3486, 51.876],
                            [-5.3381, 51.879]
                        ]
                    ],
                    [
                        [
                            [-4.7892, 52.7685],
                            [-4.7792, 52.7662],
                            [-4.7797, 52.7582],
                            [-4.7858, 52.7526],
                            [-4.7958, 52.7562],
                            [-4.7969, 52.7671],
                            [-4.7892, 52.7685]
                        ]
                    ],
                    [
                        [
                            [-4.6192, 53.3312],
                            [-4.6275, 53.3251],
                            [-4.6436, 53.3246],
                            [-4.6392, 53.3171],
                            [-4.6269, 53.3193],
                            [-4.6097, 53.3026],
                            [-4.5942, 53.3051],
                            [-4.5875, 53.2985],
                            [-4.5964, 53.2832],
                            [-4.5947, 53.2754],
                            [-4.583, 53.2751],
                            [-4.577, 53.2665],
                            [-4.5614, 53.264],
                            [-4.5575, 53.2529],
                            [-4.5664, 53.2432],
                            [-4.5886, 53.239],
                            [-4.6108, 53.2437],
                            [-4.6158, 53.2482],
                            [-4.6114, 53.256],
                            [-4.6242, 53.2626],
                            [-4.6264, 53.2674],
                            [-4.6219, 53.2765],
                            [-4.6386, 53.2837],
                            [-4.6603, 53.2826],
                            [-4.6681, 53.2801],
                            [-4.6819, 53.281],
                            [-4.6897, 53.2885],
                            [-4.6792, 53.2946],
                            [-4.6964, 53.3054],
                            [-4.6764, 53.3204],
                            [-4.6631, 53.3193],
                            [-4.6442, 53.3254],
                            [-4.6286, 53.3257],
                            [-4.6192, 53.3312]
                        ]
                    ],
                    [
                        [
                            [-3.0925, 53.2567],
                            [-3.0811, 53.2505],
                            [-3.0372, 53.2511],
                            [-3.0014, 53.2394],
                            [-2.9553, 53.2155],
                            [-2.9125, 53.1864],
                            [-2.9092, 53.1714],
                            [-2.9575, 53.1517],
                            [-2.9592, 53.1472],
                            [-2.9383, 53.1247],
                            [-2.8939, 53.1041],
                            [-2.8955, 53.1008],
                            [-2.8644, 53.0536],
                            [-2.8569, 53.0325],
                            [-2.8605, 53.0219],
                            [-2.8275, 53.0022],
                            [-2.8128, 52.9842],
                            [-2.7744, 52.985],
                            [-2.7277, 52.9666],
                            [-2.717, 52.9461],
                            [-2.7197, 52.9172],
                            [-2.75, 52.9147],
                            [-2.7833, 52.8986],
                            [-2.8536, 52.9397],
                            [-2.8792, 52.942],
                            [-2.9283, 52.9328],
                            [-2.9627, 52.9527],
                            [-2.9939, 52.9536],
                            [-3.0589, 52.9244],
                            [-3.0652, 52.9259],
                            [-3.0894, 52.9131],
                            [-3.0967, 52.8942],
                            [-3.1317, 52.8833],
                            [-3.1192, 52.8561],
                            [-3.1514, 52.8339],
                            [-3.1558, 52.8219],
                            [-3.1408, 52.7964],
                            [-3.1317, 52.7889],
                            [-3.1139, 52.7844],
                            [-3.0755, 52.7815],
                            [-3.0681, 52.7703],
                            [-3.0589, 52.7658],
                            [-3.0011, 52.7578],
                            [-2.9922, 52.7453],
                            [-2.9572, 52.7328],
                            [-2.9561, 52.7267],
                            [-2.9689, 52.7161],
                            [-3.0111, 52.7117],
                            [-3.0328, 52.6822],
                            [-3.0261, 52.6614],
                            [-3.0292, 52.6533],
                            [-3.0639, 52.6383],
                            [-3.0722, 52.61],
                            [-3.0806, 52.6011],
                            [-3.1242, 52.5822],
                            [-3.125, 52.5661],
                            [-3.1078, 52.5456],
                            [-3.1192, 52.5289],
                            [-3.11, 52.5258],
                            [-3.0864, 52.5289],
                            [-3.0681, 52.5461],
                            [-3.0108, 52.5697],
                            [-2.9808, 52.5511],
                            [-2.9745, 52.5419],
                            [-2.9914, 52.5192],
                            [-3.0197, 52.5136],
                            [-3.0295, 52.4969],
                            [-3.1086, 52.4944],
                            [-3.1494, 52.4783],
                            [-3.1961, 52.4672],
                            [-3.2142, 52.4511],
                            [-3.2142, 52.4314],
                            [-3.2092, 52.4203],
                            [-3.1961, 52.4103],
                            [-3.1664, 52.4036],
                            [-3.1403, 52.3839],
                            [-3.1039, 52.3686],
                            [-3.0678, 52.345],
                            [-3.0219, 52.3403],
                            [-2.9755, 52.3464],
                            [-2.9573, 52.3413],
                            [-2.9533, 52.3322],
                            [-2.9569, 52.3247],
                            [-2.9922, 52.3103],
                            [-3.0011, 52.2872],
                            [-2.9903, 52.2758],
                            [-2.9589, 52.2706],
                            [-2.9539, 52.2614],
                            [-3.0131, 52.2556],
                            [-3.0289, 52.2422],
                            [-3.055, 52.2311],
                            [-3.0617, 52.215],
                            [-3.1136, 52.1661],
                            [-3.1125, 52.1589],
                            [-3.1044, 52.1542],
                            [-3.0761, 52.1578],
                            [-3.0756, 52.148],
                            [-3.1297, 52.1269],
                            [-3.1272, 52.1197],
                            [-3.1, 52.1125],
                            [-3.1159, 52.0983],
                            [-3.1274, 52.0706],
                            [-3.1125, 52.0694],
                            [-3.0822, 52.0467],
                            [-3.0792, 52.0358],
                            [-3.0867, 52.0222],
                            [-3.0514, 51.9833],
                            [-3.0289, 51.9633],
                            [-2.9944, 51.9433],
                            [-2.9889, 51.9256],
                            [-2.9675, 51.9194],
                            [-2.9611, 51.9097],
                            [-2.9439, 51.9067],
                            [-2.8956, 51.9264],
                            [-2.8664, 51.9289],
                            [-2.8208, 51.9017],
                            [-2.7786, 51.8858],
                            [-2.7672, 51.8742],
                            [-2.7667, 51.8664],
                            [-2.7372, 51.8395],
                            [-2.6978, 51.8395],
                            [-2.6823, 51.8259],
                            [-2.6648, 51.8236],
                            [-2.6584, 51.8149],
                            [-2.6475, 51.8222],
                            [-2.6486, 51.8122],
                            [-2.6768, 51.7896],
                            [-2.6745, 51.7827],
                            [-2.6839, 51.7655],
                            [-2.6686, 51.7475],
                            [-2.6678, 51.74],
                            [-2.6853, 51.7269],
                            [-2.6867, 51.7189],
                            [-2.6739, 51.7044],
                            [-2.6769, 51.6892],
                            [-2.6592, 51.6731],
                            [-2.6886, 51.66],
                            [-2.6836, 51.6542],
                            [-2.6703, 51.6528],
                            [-2.6755, 51.6378],
                            [-2.6644, 51.6138],
                            [-2.6664, 51.6085],
                            [-2.6819, 51.6049],
                            [-2.6947, 51.5982],
                            [-2.7003, 51.5885],
                            [-2.7131, 51.581],
                            [-2.7353, 51.5807],
                            [-2.7531, 51.5782],
                            [-2.7919, 51.566],
                            [-2.8208, 51.5532],
                            [-2.8464, 51.5446],
                            [-2.8703, 51.5421],
                            [-2.8903, 51.5354],
                            [-2.9081, 51.5326],
                            [-2.9231, 51.536],
                            [-2.958, 51.5354],
                            [-2.9725, 51.5376],
                            [-2.9808, 51.5446],
                            [-2.9897, 51.5443],
                            [-2.9986, 51.5332],
                            [-3.0419, 51.5143],
                            [-3.0547, 51.511],
                            [-3.0842, 51.4982],
                            [-3.1086, 51.4915],
                            [-3.1203, 51.4901],
                            [-3.1253, 51.4796],
                            [-3.1358, 51.4701],
                            [-3.1342, 51.4674],
                            [-3.1558, 51.4513],
                            [-3.1664, 51.4585],
                            [-3.1775, 51.4596],
                            [-3.1786, 51.4496],
                            [-3.1642, 51.4415],
                            [-3.1703, 51.4282],
                            [-3.1692, 51.4057],
                            [-3.1897, 51.3993],
                            [-3.2053, 51.3996],
                            [-3.2247, 51.4029],
                            [-3.2386, 51.3968],
                            [-3.2908, 51.3857],
                            [-3.302, 51.3915],
                            [-3.3103, 51.3924],
                            [-3.3403, 51.3807],
                            [-3.3564, 51.3835],
                            [-3.3908, 51.3824],
                            [-3.4042, 51.3807],
                            [-3.4086, 51.3857],
                            [-3.4219, 51.3882],
                            [-3.447, 51.3874],
                            [-3.4708, 51.3929],
                            [-3.5208, 51.3996],
                            [-3.538, 51.3968],
                            [-3.5597, 51.401],
                            [-3.5675, 51.4124],
                            [-3.578, 51.419],
                            [-3.5814, 51.4263],
                            [-3.597, 51.4407],
                            [-3.6203, 51.4526],
                            [-3.6331, 51.4563],
                            [-3.6419, 51.4635],
                            [-3.6419, 51.4721],
                            [-3.6492, 51.4774],
                            [-3.6636, 51.4793],
                            [-3.6997, 51.4732],
                            [-3.7186, 51.4779],
                            [-3.7347, 51.4979],
                            [-3.7436, 51.5004],
                            [-3.7536, 51.514],
                            [-3.7536, 51.5196],
                            [-3.7608, 51.5301],
                            [-3.7625, 51.5393],
                            [-3.7703, 51.5462],
                            [-3.7831, 51.564],
                            [-3.8069, 51.5824],
                            [-3.818, 51.5943],
                            [-3.8397, 51.6054],
                            [-3.8508, 51.6185],
                            [-3.8831, 51.6168],
                            [-3.8936, 51.6185],
                            [-3.9014, 51.6129],
                            [-3.9169, 51.609],
                            [-3.9303, 51.6138],
                            [-3.9658, 51.6118],
                            [-3.9819, 51.6057],
                            [-3.9981, 51.5924],
                            [-3.9992, 51.5776],
                            [-3.9942, 51.5732],
                            [-3.9758, 51.569],
                            [-3.9797, 51.5646],
                            [-3.9925, 51.5629],
                            [-4.0042, 51.5646],
                            [-4.0247, 51.5635],
                            [-4.0314, 51.5676],
                            [-4.0425, 51.5674],
                            [-4.0664, 51.5574],
                            [-4.0742, 51.5618],
                            [-4.103, 51.5651],
                            [-4.1147, 51.5712],
                            [-4.1453, 51.5687],
                            [-4.157, 51.5612],
                            [-4.1603, 51.5549],
                            [-4.148, 51.5493],
                            [-4.1458, 51.5437],
                            [-4.1558, 51.541],
                            [-4.1686, 51.5449],
                            [-4.1981, 51.5479],
                            [-4.2064, 51.5454],
                            [-4.2053, 51.5354],
                            [-4.2219, 51.5401],
                            [-4.2375, 51.5418],
                            [-4.2453, 51.546],
                            [-4.2725, 51.5554],
                            [-4.2808, 51.5607],
                            [-4.3086, 51.5637],
                            [-4.2886, 51.5732],
                            [-4.2892, 51.5835],
                            [-4.2942, 51.5946],
                            [-4.3053, 51.6085],
                            [-4.2981, 51.6151],
                            [-4.2792, 51.614],
                            [-4.2725, 51.6229],
                            [-4.2569, 51.6287],
                            [-4.2503, 51.6362],
                            [-4.2486, 51.644],
                            [-4.2425, 51.6465],
                            [-4.2358, 51.6354],
                            [-4.2069, 51.6293],
                            [-4.2008, 51.6262],
                            [-4.182, 51.6262],
                            [-4.1792, 51.6293],
                            [-4.143, 51.6374],
                            [-4.1381, 51.6426],
                            [-4.1186, 51.644],
                            [-4.1053, 51.6529],
                            [-4.0814, 51.6593],
                            [-4.0942, 51.6626],
                            [-4.108, 51.6582],
                            [-4.1425, 51.6574],
                            [-4.1503, 51.6546],
                            [-4.1714, 51.666],
                            [-4.1792, 51.6785],
                            [-4.1853, 51.6815],
                            [-4.2169, 51.6851],
                            [-4.2325, 51.6782],
                            [-4.2553, 51.6779],
                            [-4.2781, 51.6679],
                            [-4.2931, 51.6679],
                            [-4.3114, 51.6732],
                            [-4.3408, 51.6893],
                            [-4.368, 51.7113],
                            [-4.3786, 51.729],
                            [-4.3653, 51.7282],
                            [-4.3519, 51.7315],
                            [-4.3369, 51.7313],
                            [-4.3331, 51.7363],
                            [-4.3636, 51.7373],
                            [-4.3747, 51.7421],
                            [-4.3769, 51.7546],
                            [-4.3708, 51.769],
                            [-4.3625, 51.7801],
                            [-4.3731, 51.786],
                            [-4.3753, 51.7768],
                            [-4.3819, 51.774],
                            [-4.3875, 51.7649],
                            [-4.4086, 51.7565],
                            [-4.4219, 51.7621],
                            [-4.4353, 51.7626],
                            [-4.4486, 51.7685],
                            [-4.4381, 51.7796],
                            [-4.4442, 51.7843],
                            [-4.4525, 51.7735],
                            [-4.4586, 51.7704],
                            [-4.4558, 51.7638],
                            [-4.4414, 51.7579],
                            [-4.4381, 51.7532],
                            [-4.4253, 51.7479],
                            [-4.4286, 51.7415],
                            [-4.4525, 51.734],
                            [-4.4786, 51.7338],
                            [-4.5036, 51.7357],
                            [-4.5442, 51.7413],
                            [-4.5592, 51.7418],
                            [-4.5786, 51.7335],
                            [-4.5908, 51.7365],
                            [-4.6136, 51.7376],
                            [-4.6258, 51.7343],
                            [-4.6475, 51.7338],
                            [-4.6714, 51.7285],
                            [-4.6942, 51.716],
                            [-4.697, 51.7115],
                            [-4.6847, 51.6935],
                            [-4.6936, 51.6876],
                            [-4.7008, 51.6776],
                            [-4.6936, 51.6726],
                            [-4.7069, 51.666],
                            [-4.7214, 51.651],
                            [-4.7392, 51.6532],
                            [-4.7603, 51.6518],
                            [-4.7608, 51.6474],
                            [-4.7764, 51.6421],
                            [-4.7819, 51.6343],
                            [-4.7903, 51.6379],
                            [-4.8058, 51.6382],
                            [-4.8264, 51.6465],
                            [-4.8453, 51.644],
                            [-4.8631, 51.6465],
                            [-4.8808, 51.6315],
                            [-4.8903, 51.6301],
                            [-4.9047, 51.6187],
                            [-4.9003, 51.6143],
                            [-4.9303, 51.5982],
                            [-4.9475, 51.5965],
                            [-4.957, 51.6035],
                            [-4.9753, 51.606],
                            [-4.9892, 51.6115],
                            [-5.0114, 51.6085],
                            [-5.0197, 51.614],
                            [-5.0575, 51.6196],
                            [-5.0631, 51.629],
                            [-5.0519, 51.634],
                            [-5.0508, 51.6424],
                            [-5.0564, 51.646],
                            [-5.0597, 51.6565],
                            [-5.0675, 51.6637],
                            [-5.1003, 51.6668],
                            [-5.1181, 51.674],
                            [-5.1214, 51.684],
                            [-5.1136, 51.6915],
                            [-5.1036, 51.6924],
                            [-5.0786, 51.6899],
                            [-5.0808, 51.6835],
                            [-5.0747, 51.6785],
                            [-5.0486, 51.6771],
                            [-5.0447, 51.684],
                            [-5.0575, 51.6876],
                            [-5.0514, 51.6946],
                            [-5.0286, 51.6949],
                            [-5.0058, 51.6896],
                            [-4.9953, 51.6901],
                            [-4.9842, 51.6849],
                            [-4.9747, 51.6743],
                            [-4.9514, 51.6776],
                            [-4.9597, 51.6829],
                            [-4.9747, 51.6854],
                            [-4.9525, 51.699],
                            [-4.9431, 51.6963],
                            [-4.9275, 51.7038],
                            [-4.9186, 51.699],
                            [-4.9058, 51.7082],
                            [-4.8914, 51.7079],
                            [-4.8836, 51.7188],
                            [-4.8842, 51.7318],
                            [-4.8886, 51.7379],
                            [-4.8969, 51.7396],
                            [-4.8942, 51.756],
                            [-4.8847, 51.7696],
                            [-4.9014, 51.7657],
                            [-4.9036, 51.7607],
                            [-4.8986, 51.7471],
                            [-4.8997, 51.7365],
                            [-4.8864, 51.7307],
                            [-4.8925, 51.7126],
                            [-4.9075, 51.7113],
                            [-4.9225, 51.7046],
                            [-4.9325, 51.7093],
                            [-4.9458, 51.7038],
                            [-4.9597, 51.7063],
                            [-4.9842, 51.6988],
                            [-5.0147, 51.7043],
                            [-5.033, 51.7107],
                            [-5.0408, 51.7071],
                            [-5.0619, 51.7074],
                            [-5.0836, 51.7057],
                            [-5.0869, 51.7118],
                            [-5.1003, 51.7224],
                            [-5.1186, 51.7105],
                            [-5.1247, 51.7168],
                            [-5.1336, 51.7126],
                            [-5.1581, 51.7132],
                            [-5.1675, 51.7074],
                            [-5.1558, 51.701],
                            [-5.1525, 51.6954],
                            [-5.1564, 51.6876],
                            [-5.1836, 51.6857],
                            [-5.1914, 51.6999],
                            [-5.1875, 51.7088],
                            [-5.2036, 51.7113],
                            [-5.2025, 51.7174],
                            [-5.2108, 51.7221],
                            [-5.2286, 51.7226],
                            [-5.2536, 51.7326],
                            [-5.2514, 51.7379],
                            [-5.2253, 51.7376],
                            [-5.2103, 51.7343],
                            [-5.2053, 51.739],
                            [-5.2031, 51.7554],
                            [-5.1858, 51.7549],
                            [-5.1758, 51.7649],
                            [-5.1603, 51.7724],
                            [-5.1481, 51.7726],
                            [-5.1192, 51.7688],
                            [-5.1042, 51.7793],
                            [-5.1075, 51.7946],
                            [-5.1042, 51.8126],
                            [-5.1147, 51.8246],
                            [-5.1136, 51.8357],
                            [-5.1264, 51.856],
                            [-5.1353, 51.8621],
                            [-5.1742, 51.8626],
                            [-5.1814, 51.8671],
                            [-5.2025, 51.8665],
                            [-5.2181, 51.8726],
                            [-5.2458, 51.8721],
                            [-5.2514, 51.8679],
                            [-5.2664, 51.8712],
                            [-5.2814, 51.8654],
                            [-5.3047, 51.8637],
                            [-5.3158, 51.8596],
                            [-5.3203, 51.8654],
                            [-5.3097, 51.8704],
                            [-5.3047, 51.8862],
                            [-5.2958, 51.894],
                            [-5.3075, 51.9079],
                            [-5.2892, 51.9143],
                            [-5.2747, 51.9121],
                            [-5.2575, 51.916],
                            [-5.2503, 51.9218],
                            [-5.2397, 51.9246],
                            [-5.2347, 51.9301],
                            [-5.2108, 51.9329],
                            [-5.2131, 51.9388],
                            [-5.1992, 51.9421],
                            [-5.1969, 51.9504],
                            [-5.1742, 51.9513],
                            [-5.1636, 51.9485],
                            [-5.1364, 51.9632],
                            [-5.1081, 51.9624],
                            [-5.1053, 51.969],
                            [-5.0842, 51.9704],
                            [-5.0892, 51.9901],
                            [-5.0953, 51.9938],
                            [-5.0742, 52.0038],
                            [-5.0892, 52.0185],
                            [-5.0747, 52.0307],
                            [-5.0614, 52.0321],
                            [-5.0569, 52.0279],
                            [-5.0381, 52.0282],
                            [-5.0108, 52.0232],
                            [-4.988, 52.0249],
                            [-4.9858, 52.0085],
                            [-4.9808, 52.0015],
                            [-4.9625, 52.0004],
                            [-4.9469, 52.0038],
                            [-4.9414, 52.0085],
                            [-4.9303, 52.0096],
                            [-4.9147, 52.0179],
                            [-4.9186, 52.0271],
                            [-4.9114, 52.0346],
                            [-4.9025, 52.0349],
                            [-4.892, 52.0293],
                            [-4.8858, 52.021],
                            [-4.8558, 52.0238],
                            [-4.8331, 52.0215],
                            [-4.8458, 52.0426],
                            [-4.8369, 52.0504],
                            [-4.8153, 52.0563],
                            [-4.8003, 52.0565],
                            [-4.7875, 52.0604],
                            [-4.7447, 52.0957],
                            [-4.7497, 52.1043],
                            [-4.7364, 52.109],
                            [-4.7308, 52.1182],
                            [-4.7108, 52.1079],
                            [-4.6842, 52.1049],
                            [-4.6903, 52.121],
                            [-4.6875, 52.1299],
                            [-4.6758, 52.1287],
                            [-4.6586, 52.1346],
                            [-4.6436, 52.1337],
                            [-4.6436, 52.1385],
                            [-4.6086, 52.1399],
                            [-4.5847, 52.1379],
                            [-4.5686, 52.1449],
                            [-4.5558, 52.139],
                            [-4.5342, 52.1349],
                            [-4.5175, 52.136],
                            [-4.4958, 52.1443],
                            [-4.4886, 52.1546],
                            [-4.4725, 52.161],
                            [-4.4647, 52.1696],
                            [-4.4558, 52.1679],
                            [-4.4325, 52.1765],
                            [-4.4186, 52.1882],
                            [-4.4064, 52.1937],
                            [-4.3775, 52.2157],
                            [-4.3647, 52.2196],
                            [-4.3564, 52.2112],
                            [-4.3436, 52.2107],
                            [-4.3353, 52.2154],
                            [-4.3258, 52.2132],
                            [-4.3092, 52.2199],
                            [-4.2981, 52.2271],
                            [-4.2681, 52.2407],
                            [-4.2642, 52.246],
                            [-4.2531, 52.2501],
                            [-4.2347, 52.2518],
                            [-4.2069, 52.2649],
                            [-4.2014, 52.274],
                            [-4.188, 52.2818],
                            [-4.1869, 52.2901],
                            [-4.1697, 52.2957],
                            [-4.163, 52.3079],
                            [-4.1542, 52.3104],
                            [-4.1386, 52.3257],
                            [-4.1358, 52.3332],
                            [-4.1258, 52.3424],
                            [-4.118, 52.3632],
                            [-4.1092, 52.3782],
                            [-4.0975, 52.3932],
                            [-4.087, 52.3985],
                            [-4.0925, 52.4068],
                            [-4.087, 52.4246],
                            [-4.0819, 52.4337],
                            [-4.0814, 52.4451],
                            [-4.0703, 52.4679],
                            [-4.0636, 52.4768],
                            [-4.0525, 52.4807],
                            [-4.0531, 52.4982],
                            [-4.0597, 52.5235],
                            [-4.0586, 52.529],
                            [-4.0397, 52.5249],
                            [-4.0336, 52.5276],
                            [-4.0203, 52.5251],
                            [-3.9897, 52.5368],
                            [-3.9892, 52.5415],
                            [-3.9797, 52.5496],
                            [-3.9686, 52.5451],
                            [-3.9531, 52.559],
                            [-3.9614, 52.5604],
                            [-3.9703, 52.5554],
                            [-3.9836, 52.5551],
                            [-4.0097, 52.5479],
                            [-4.0264, 52.5465],
                            [-4.0547, 52.5418],
                            [-4.0703, 52.5432],
                            [-4.0753, 52.5471],
                            [-4.0847, 52.5643],
                            [-4.102, 52.5826],
                            [-4.108, 52.5929],
                            [-4.1303, 52.6113],
                            [-4.1186, 52.6401],
                            [-4.0986, 52.664],
                            [-4.0969, 52.669],
                            [-4.0847, 52.6721],
                            [-4.0725, 52.681],
                            [-4.0575, 52.6876],
                            [-4.0597, 52.7087],
                            [-4.0475, 52.7065],
                            [-4.0342, 52.7101],
                            [-4.0164, 52.7204],
                            [-3.9986, 52.7232],
                            [-3.9864, 52.739],
                            [-3.9975, 52.7393],
                            [-4.0081, 52.734],
                            [-4.0253, 52.7321],
                            [-4.0375, 52.7204],
                            [-4.0503, 52.7196],
                            [-4.0625, 52.7226],
                            [-4.0764, 52.7382],
                            [-4.0814, 52.7474],
                            [-4.1008, 52.7654],
                            [-4.1147, 52.7746],
                            [-4.1297, 52.7893],
                            [-4.1453, 52.8015],
                            [-4.1542, 52.8157],
                            [-4.128, 52.8307],
                            [-4.1275, 52.8382],
                            [-4.1192, 52.8457],
                            [-4.1214, 52.8563],
                            [-4.143, 52.8804],
                            [-4.147, 52.8882],
                            [-4.1397, 52.8963],
                            [-4.1147, 52.8982],
                            [-4.1103, 52.901],
                            [-4.0769, 52.9035],
                            [-4.0592, 52.9157],
                            [-4.0625, 52.9257],
                            [-4.087, 52.9188],
                            [-4.0931, 52.9135],
                            [-4.1064, 52.9093],
                            [-4.1058, 52.9249],
                            [-4.1158, 52.924],
                            [-4.1275, 52.9274],
                            [-4.1308, 52.9176],
                            [-4.1514, 52.9063],
                            [-4.173, 52.9071],
                            [-4.1953, 52.9146],
                            [-4.2019, 52.9132],
                            [-4.2169, 52.9188],
                            [-4.2319, 52.9149],
                            [-4.3103, 52.9096],
                            [-4.3242, 52.9046],
                            [-4.3264, 52.8915],
                            [-4.3531, 52.8951],
                            [-4.3825, 52.8963],
                            [-4.3936, 52.8946],
                            [-4.4036, 52.889],
                            [-4.418, 52.8868],
                            [-4.4114, 52.8812],
                            [-4.4281, 52.8788],
                            [-4.4597, 52.8704],
                            [-4.4642, 52.8632],
                            [-4.4786, 52.854],
                            [-4.4697, 52.8471],
                            [-4.4942, 52.8388],
                            [-4.5031, 52.8271],
                            [-4.5019, 52.8137],
                            [-4.4875, 52.8107],
                            [-4.4825, 52.8032],
                            [-4.4908, 52.7907],
                            [-4.5019, 52.7949],
                            [-4.5147, 52.7926],
                            [-4.5247, 52.7787],
                            [-4.543, 52.784],
                            [-4.5436, 52.7932],
                            [-4.5375, 52.7982],
                            [-4.5514, 52.8087],
                            [-4.5747, 52.8187],
                            [-4.6075, 52.8246],
                            [-4.6142, 52.8215],
                            [-4.6236, 52.8096],
                            [-4.6503, 52.7985],
                            [-4.6519, 52.8035],
                            [-4.6625, 52.8054],
                            [-4.6775, 52.8007],
                            [-4.6892, 52.7935],
                            [-4.693, 52.799],
                            [-4.7053, 52.8026],
                            [-4.7219, 52.8015],
                            [-4.7308, 52.7815],
                            [-4.7447, 52.7829],
                            [-4.7675, 52.7951],
                            [-4.7625, 52.8018],
                            [-4.7525, 52.8051],
                            [-4.7514, 52.816],
                            [-4.7408, 52.8221],
                            [-4.7381, 52.8304],
                            [-4.7231, 52.8351],
                            [-4.7275, 52.846],
                            [-4.7253, 52.854],
                            [-4.7142, 52.8554],
                            [-4.7064, 52.8601],
                            [-4.6925, 52.8635],
                            [-4.6919, 52.8729],
                            [-4.6742, 52.8757],
                            [-4.6653, 52.8832],
                            [-4.6669, 52.8896],
                            [-4.6542, 52.899],
                            [-4.6503, 52.9063],
                            [-4.6347, 52.9051],
                            [-4.6225, 52.9149],
                            [-4.6197, 52.9218],
                            [-4.607, 52.9265],
                            [-4.5975, 52.9257],
                            [-4.5786, 52.9388],
                            [-4.5286, 52.9376],
                            [-4.5153, 52.9421],
                            [-4.5053, 52.9501],
                            [-4.4919, 52.9554],
                            [-4.4831, 52.966],
                            [-4.4681, 52.9701],
                            [-4.4603, 52.9829],
                            [-4.4436, 52.991],
                            [-4.4381, 52.999],
                            [-4.4175, 52.9993],
                            [-4.4108, 52.9974],
                            [-4.3903, 53.0143],
                            [-4.3725, 53.0221],
                            [-4.3703, 53.0268],
                            [-4.3564, 53.0318],
                            [-4.3497, 53.0454],
                            [-4.3403, 53.0524],
                            [-4.3364, 53.084],
                            [-4.3464, 53.104],
                            [-4.3481, 53.1146],
                            [-4.3375, 53.1232],
                            [-4.3264, 53.1188],
                            [-4.3342, 53.1143],
                            [-4.3242, 53.1071],
                            [-4.3119, 53.1049],
                            [-4.3131, 53.1254],
                            [-4.3097, 53.1301],
                            [-4.2853, 53.1393],
                            [-4.2719, 53.1463],
                            [-4.2575, 53.1621],
                            [-4.243, 53.1707],
                            [-4.2125, 53.1826],
                            [-4.2086, 53.194],
                            [-4.2097, 53.2021],
                            [-4.1931, 53.2135],
                            [-4.1758, 53.2188],
                            [-4.163, 53.219],
                            [-4.148, 53.2285],
                            [-4.1358, 53.2312],
                            [-4.1242, 53.2374],
                            [-4.1097, 53.2354],
                            [-4.0903, 53.2357],
                            [-4.0831, 53.2296],
                            [-4.0664, 53.2337],
                            [-4.0514, 53.2335],
                            [-4.0331, 53.2371],
                            [-4.0269, 53.2421],
                            [-4.0103, 53.2449],
                            [-4.0008, 53.2532],
                            [-3.9536, 53.2668],
                            [-3.9308, 53.2693],
                            [-3.9125, 53.2757],
                            [-3.8814, 53.2899],
                            [-3.8675, 53.2874],
                            [-3.8575, 53.2907],
                            [-3.8508, 53.2974],
                            [-3.8375, 53.2965],
                            [-3.8436, 53.3087],
                            [-3.8442, 53.3196],
                            [-3.8642, 53.329],
                            [-3.8786, 53.3326],
                            [-3.8803, 53.3388],
                            [-3.8703, 53.3429],
                            [-3.8308, 53.3374],
                            [-3.8297, 53.326],
                            [-3.8081, 53.3224],
                            [-3.7731, 53.3276],
                            [-3.7636, 53.3185],
                            [-3.7397, 53.3146],
                            [-3.7381, 53.3032],
                            [-3.7164, 53.2946],
                            [-3.6981, 53.2929],
                            [-3.6792, 53.2946],
                            [-3.6625, 53.2924],
                            [-3.6331, 53.2946],
                            [-3.6208, 53.2901],
                            [-3.6097, 53.2901],
                            [-3.5603, 53.3012],
                            [-3.5325, 53.3099],
                            [-3.5186, 53.3157],
                            [-3.5075, 53.3149],
                            [-3.4908, 53.3251],
                            [-3.4725, 53.3301],
                            [-3.4642, 53.3285],
                            [-3.4008, 53.3454],
                            [-3.3764, 53.3507],
                            [-3.3547, 53.3504],
                            [-3.3464, 53.3532],
                            [-3.3203, 53.3565],
                            [-3.3131, 53.354],
                            [-3.3036, 53.3349],
                            [-3.2775, 53.3218],
                            [-3.263, 53.3199],
                            [-3.2592, 53.3154],
                            [-3.2364, 53.3079],
                            [-3.2331, 53.3046],
                            [-3.2147, 53.2993],
                            [-3.1975, 53.2918],
                            [-3.1869, 53.2832],
                            [-3.1642, 53.2724],
                            [-3.1431, 53.2596],
                            [-3.1314, 53.2579],
                            [-3.1225, 53.2487],
                            [-3.0969, 53.239],
                            [-3.0775, 53.2446],
                            [-3.1008, 53.251],
                            [-3.0925, 53.2567]
                        ]
                    ],
                    [
                        [
                            [-4.4264, 53.4301],
                            [-4.4147, 53.4257],
                            [-4.3986, 53.4229],
                            [-4.3819, 53.4251],
                            [-4.368, 53.4246],
                            [-4.3653, 53.4179],
                            [-4.3553, 53.4151],
                            [-4.3408, 53.4199],
                            [-4.3253, 53.4185],
                            [-4.3058, 53.4138],
                            [-4.2919, 53.4124],
                            [-4.2803, 53.4062],
                            [-4.2697, 53.3957],
                            [-4.2697, 53.3862],
                            [-4.2769, 53.3749],
                            [-4.2636, 53.3674],
                            [-4.2647, 53.3601],
                            [-4.2414, 53.3596],
                            [-4.2347, 53.3482],
                            [-4.2275, 53.3437],
                            [-4.2197, 53.3265],
                            [-4.2192, 53.319],
                            [-4.203, 53.3138],
                            [-4.2125, 53.2974],
                            [-4.2064, 53.2951],
                            [-4.1836, 53.2971],
                            [-4.1619, 53.3026],
                            [-4.1436, 53.3049],
                            [-4.1358, 53.3146],
                            [-4.1197, 53.3193],
                            [-4.0992, 53.3182],
                            [-4.0831, 53.3138],
                            [-4.0664, 53.3129],
                            [-4.0564, 53.3151],
                            [-4.0397, 53.3104],
                            [-4.0453, 53.3046],
                            [-4.0581, 53.3015],
                            [-4.0581, 53.2954],
                            [-4.0703, 53.2907],
                            [-4.0758, 53.2807],
                            [-4.0864, 53.2749],
                            [-4.0875, 53.2624],
                            [-4.1236, 53.2474],
                            [-4.1447, 53.2362],
                            [-4.1586, 53.2318],
                            [-4.1614, 53.2215],
                            [-4.1775, 53.2235],
                            [-4.1897, 53.2163],
                            [-4.2097, 53.2101],
                            [-4.2142, 53.204],
                            [-4.2153, 53.1901],
                            [-4.2319, 53.1813],
                            [-4.2447, 53.179],
                            [-4.2659, 53.1674],
                            [-4.2736, 53.1654],
                            [-4.2825, 53.1554],
                            [-4.2986, 53.1482],
                            [-4.3175, 53.1443],
                            [-4.3342, 53.1474],
                            [-4.3392, 53.1407],
                            [-4.3586, 53.131],
                            [-4.3764, 53.1401],
                            [-4.3986, 53.1451],
                            [-4.4058, 53.144],
                            [-4.4147, 53.154],
                            [-4.4169, 53.1613],
                            [-4.4114, 53.1657],
                            [-4.3875, 53.1679],
                            [-4.3803, 53.1815],
                            [-4.3875, 53.1901],
                            [-4.3958, 53.1882],
                            [-4.4119, 53.1726],
                            [-4.4258, 53.1646],
                            [-4.4281, 53.1599],
                            [-4.4425, 53.1554],
                            [-4.4658, 53.1835],
                            [-4.4897, 53.1782],
                            [-4.4953, 53.1854],
                            [-4.5086, 53.1871],
                            [-4.5014, 53.2115],
                            [-4.5136, 53.2213],
                            [-4.5247, 53.2257],
                            [-4.5219, 53.2343],
                            [-4.5353, 53.2371],
                            [-4.5536, 53.2504],
                            [-4.558, 53.2621],
                            [-4.5664, 53.2687],
                            [-4.5836, 53.2762],
                            [-4.5869, 53.2804],
                            [-4.5658, 53.2943],
                            [-4.5464, 53.3007],
                            [-4.562, 53.3065],
                            [-4.5647, 53.3179],
                            [-4.5808, 53.3296],
                            [-4.5703, 53.3362],
                            [-4.5697, 53.354],
                            [-4.5608, 53.359],
                            [-4.5586, 53.3771],
                            [-4.568, 53.3835],
                            [-4.5753, 53.404],
                            [-4.5642, 53.4079],
                            [-4.5569, 53.4046],
                            [-4.5364, 53.4068],
                            [-4.5286, 53.4121],
                            [-4.4914, 53.4124],
                            [-4.4747, 53.4179],
                            [-4.4542, 53.4162],
                            [-4.4497, 53.424],
                            [-4.4264, 53.4301]
                        ]
                    ]
                ]
            },
            'properties': {
                'name': 'Wales',
                'id': 'GB-WLS',
                'TYPE': 'Wales',
                'CNTRY': 'United Kingdom'
            },
            'id': 'GB-WLS'
        },
        {
            'type': 'Feature',
            'geometry': {
                'type': 'MultiPolygon',
                'coordinates': [
                    [
                        [
                            [-6.2811, 54.1101],
                            [-6.2906, 54.1091],
                            [-6.3171, 54.0953],
                            [-6.3336, 54.1139],
                            [-6.3497, 54.1155],
                            [-6.3581, 54.1082],
                            [-6.3503, 54.0829],
                            [-6.3572, 54.0743],
                            [-6.3747, 54.0664],
                            [-6.4436, 54.0553],
                            [-6.4486, 54.0705],
                            [-6.4702, 54.0788],
                            [-6.4723, 54.0669],
                            [-6.5037, 54.0567],
                            [-6.5292, 54.0601],
                            [-6.5675, 54.0509],
                            [-6.582, 54.0542],
                            [-6.5922, 54.0448],
                            [-6.6037, 54.0459],
                            [-6.62, 54.0372],
                            [-6.625, 54.0392],
                            [-6.6503, 54.0625],
                            [-6.6703, 54.0705],
                            [-6.6603, 54.0803],
                            [-6.6633, 54.0897],
                            [-6.6497, 54.1011],
                            [-6.6642, 54.1169],
                            [-6.6389, 54.1356],
                            [-6.6286, 54.1569],
                            [-6.6364, 54.1728],
                            [-6.6519, 54.1814],
                            [-6.6978, 54.2017],
                            [-6.7092, 54.2003],
                            [-6.7347, 54.1836],
                            [-6.7956, 54.2117],
                            [-6.81, 54.2253],
                            [-6.8278, 54.2626],
                            [-6.8586, 54.2765],
                            [-6.8517, 54.2875],
                            [-6.8674, 54.328],
                            [-6.8761, 54.3453],
                            [-6.9042, 54.3506],
                            [-6.91, 54.3675],
                            [-6.9269, 54.3792],
                            [-6.9744, 54.4017],
                            [-7.0251, 54.4161],
                            [-7.0419, 54.4159],
                            [-7.0614, 54.3997],
                            [-7.1022, 54.371],
                            [-7.1, 54.3584],
                            [-7.1086, 54.353],
                            [-7.1245, 54.3481],
                            [-7.149, 54.3377],
                            [-7.1732, 54.3364],
                            [-7.1755, 54.3205],
                            [-7.1951, 54.3106],
                            [-7.2021, 54.2977],
                            [-7.1805, 54.2914],
                            [-7.1733, 54.2858],
                            [-7.1754, 54.2758],
                            [-7.1497, 54.2725],
                            [-7.1423, 54.2273],
                            [-7.1617, 54.2189],
                            [-7.1967, 54.2192],
                            [-7.2378, 54.2035],
                            [-7.2276, 54.1965],
                            [-7.2487, 54.1907],
                            [-7.243, 54.1707],
                            [-7.2511, 54.1635],
                            [-7.2526, 54.1479],
                            [-7.2741, 54.1245],
                            [-7.2851, 54.1215],
                            [-7.2986, 54.1261],
                            [-7.2903, 54.1394],
                            [-7.2964, 54.1455],
                            [-7.2831, 54.1586],
                            [-7.2839, 54.165],
                            [-7.3033, 54.1661],
                            [-7.3252, 54.1489],
                            [-7.3251, 54.1429],
                            [-7.3067, 54.1332],
                            [-7.3056, 54.1208],
                            [-7.3133, 54.1125],
                            [-7.3433, 54.1158],
                            [-7.3642, 54.1258],
                            [-7.3939, 54.1178],
                            [-7.3972, 54.1208],
                            [-7.3919, 54.1344],
                            [-7.3964, 54.1372],
                            [-7.4239, 54.1361],
                            [-7.4225, 54.1428],
                            [-7.4147, 54.1508],
                            [-7.4417, 54.1469],
                            [-7.4638, 54.1408],
                            [-7.4637, 54.1302],
                            [-7.4734, 54.1259],
                            [-7.5231, 54.1343],
                            [-7.5543, 54.128],
                            [-7.5672, 54.1386],
                            [-7.5814, 54.1447],
                            [-7.6036, 54.1417],
                            [-7.62, 54.1461],
                            [-7.6245, 54.1664],
                            [-7.6497, 54.1758],
                            [-7.6567, 54.1844],
                            [-7.6753, 54.1822],
                            [-7.6969, 54.2025],
                            [-7.8, 54.203],
                            [-7.8206, 54.1992],
                            [-7.8514, 54.2122],
                            [-7.8675, 54.2242],
                            [-7.8683, 54.25],
                            [-7.8786, 54.2697],
                            [-7.8747, 54.2825],
                            [-7.8781, 54.2892],
                            [-7.9414, 54.2994],
                            [-7.953, 54.3066],
                            [-7.9449, 54.3097],
                            [-7.9702, 54.34],
                            [-7.9944, 54.3551],
                            [-8.0036, 54.3628],
                            [-8.0204, 54.3584],
                            [-8.0428, 54.3654],
                            [-8.0921, 54.4086],
                            [-8.1478, 54.4374],
                            [-8.1382, 54.4549],
                            [-8.1617, 54.4577],
                            [-8.1686, 54.4671],
                            [-8.1379, 54.4709],
                            [-8.1144, 54.4691],
                            [-8.1076, 54.4767],
                            [-8.0842, 54.4795],
                            [-8.0674, 54.4887],
                            [-8.0527, 54.4897],
                            [-8.0473, 54.4945],
                            [-8.0453, 54.5111],
                            [-8.0033, 54.5461],
                            [-7.9953, 54.5435],
                            [-7.9687, 54.5433],
                            [-7.9275, 54.5359],
                            [-7.9099, 54.5397],
                            [-7.896, 54.5387],
                            [-7.8293, 54.5447],
                            [-7.8216, 54.5489],
                            [-7.8194, 54.5625],
                            [-7.793, 54.5733],
                            [-7.7876, 54.5813],
                            [-7.7653, 54.5856],
                            [-7.7391, 54.6001],
                            [-7.7058, 54.6065],
                            [-7.7106, 54.6303],
                            [-7.7374, 54.6201],
                            [-7.756, 54.6197],
                            [-7.7788, 54.6321],
                            [-7.8094, 54.6391],
                            [-7.8283, 54.6353],
                            [-7.8553, 54.6347],
                            [-7.8622, 54.6533],
                            [-7.89, 54.6565],
                            [-7.9139, 54.6711],
                            [-7.905, 54.6889],
                            [-7.9264, 54.6959],
                            [-7.9253, 54.7023],
                            [-7.8841, 54.7037],
                            [-7.8709, 54.7081],
                            [-7.848, 54.7333],
                            [-7.8344, 54.7385],
                            [-7.7506, 54.7055],
                            [-7.7394, 54.7063],
                            [-7.735, 54.7137],
                            [-7.6847, 54.73],
                            [-7.6486, 54.7495],
                            [-7.6397, 54.7474],
                            [-7.5724, 54.7504],
                            [-7.561, 54.7441],
                            [-7.5373, 54.7449],
                            [-7.5372, 54.7485],
                            [-7.5533, 54.7632],
                            [-7.5483, 54.7853],
                            [-7.5525, 54.7917],
                            [-7.5456, 54.7989],
                            [-7.5197, 54.8153],
                            [-7.4828, 54.8299],
                            [-7.4771, 54.8461],
                            [-7.458, 54.8579],
                            [-7.4439, 54.8825],
                            [-7.4486, 54.9011],
                            [-7.443, 54.9345],
                            [-7.4163, 54.9414],
                            [-7.4146, 54.9439],
                            [-7.3929, 54.9459],
                            [-7.3936, 54.9729],
                            [-7.4008, 54.983],
                            [-7.3883, 54.9923],
                            [-7.3931, 55.0028],
                            [-7.3834, 55.0103],
                            [-7.3802, 55.0254],
                            [-7.353, 55.0487],
                            [-7.3417, 55.0514],
                            [-7.3333, 55.0487],
                            [-7.3055, 55.0481],
                            [-7.2936, 55.0555],
                            [-7.2738, 55.0568],
                            [-7.2601, 55.0663],
                            [-7.2458, 55.0618],
                            [-7.2514, 55.0529],
                            [-7.2658, 55.0462],
                            [-7.258, 55.0429],
                            [-7.2375, 55.0471],
                            [-7.2336, 55.0554],
                            [-7.2231, 55.061],
                            [-7.2092, 55.0579],
                            [-7.1836, 55.0607],
                            [-7.1586, 55.0596],
                            [-7.147, 55.0568],
                            [-7.147, 55.0468],
                            [-7.1331, 55.0421],
                            [-7.1036, 55.0429],
                            [-7.0536, 55.0487],
                            [-7.0481, 55.056],
                            [-7.0236, 55.0688],
                            [-7.0136, 55.0763],
                            [-7.0236, 55.0882],
                            [-7.0186, 55.1029],
                            [-6.9875, 55.1174],
                            [-6.9836, 55.1274],
                            [-6.9747, 55.1379],
                            [-6.9669, 55.1529],
                            [-6.9608, 55.1838],
                            [-6.9653, 55.1915],
                            [-6.9525, 55.1929],
                            [-6.9275, 55.179],
                            [-6.9125, 55.1735],
                            [-6.8581, 55.1657],
                            [-6.8164, 55.1671],
                            [-6.8103, 55.1693],
                            [-6.7497, 55.1682],
                            [-6.7303, 55.1704],
                            [-6.7214, 55.1901],
                            [-6.7092, 55.1938],
                            [-6.6775, 55.1996],
                            [-6.6586, 55.199],
                            [-6.6486, 55.204],
                            [-6.6297, 55.2082],
                            [-6.6053, 55.206],
                            [-6.5819, 55.2115],
                            [-6.5553, 55.2201],
                            [-6.5358, 55.2198],
                            [-6.5286, 55.2243],
                            [-6.5319, 55.2335],
                            [-6.5197, 55.236],
                            [-6.5042, 55.2471],
                            [-6.4864, 55.2512],
                            [-6.467, 55.2512],
                            [-6.4608, 55.2429],
                            [-6.4453, 55.239],
                            [-6.4169, 55.2385],
                            [-6.4103, 55.2321],
                            [-6.3986, 55.2321],
                            [-6.3842, 55.239],
                            [-6.3864, 55.2426],
                            [-6.3675, 55.2457],
                            [-6.3597, 55.2415],
                            [-6.3336, 55.2388],
                            [-6.312, 55.2301],
                            [-6.2886, 55.2304],
                            [-6.2864, 55.2243],
                            [-6.2764, 55.2224],
                            [-6.2586, 55.2129],
                            [-6.2464, 55.2121],
                            [-6.2347, 55.204],
                            [-6.2119, 55.2079],
                            [-6.2042, 55.2121],
                            [-6.1792, 55.2138],
                            [-6.1603, 55.2265],
                            [-6.1403, 55.2276],
                            [-6.1142, 55.2093],
                            [-6.1058, 55.2101],
                            [-6.0614, 55.1943],
                            [-6.0631, 55.1899],
                            [-6.0514, 55.1818],
                            [-6.047, 55.1726],
                            [-6.0308, 55.1682],
                            [-6.0253, 55.1601],
                            [-6.0242, 55.1393],
                            [-6.0408, 55.1313],
                            [-6.0342, 55.1229],
                            [-6.0347, 55.1029],
                            [-6.0508, 55.0821],
                            [-6.0558, 55.0587],
                            [-6.0369, 55.0546],
                            [-6.0247, 55.0574],
                            [-5.9886, 55.0596],
                            [-5.9692, 55.0546],
                            [-5.9625, 55.044],
                            [-5.9725, 55.0301],
                            [-5.9708, 55.0218],
                            [-5.9781, 55.0137],
                            [-5.9764, 55.0068],
                            [-5.9869, 55.0004],
                            [-5.9914, 54.9849],
                            [-5.9808, 54.9787],
                            [-5.9642, 54.9799],
                            [-5.9547, 54.9693],
                            [-5.9397, 54.971],
                            [-5.9186, 54.9624],
                            [-5.8953, 54.9385],
                            [-5.8825, 54.9135],
                            [-5.8747, 54.9054],
                            [-5.8592, 54.8993],
                            [-5.8469, 54.9018],
                            [-5.8403, 54.8974],
                            [-5.8369, 54.8804],
                            [-5.8208, 54.8754],
                            [-5.8081, 54.8654],
                            [-5.8053, 54.8582],
                            [-5.7953, 54.8487],
                            [-5.812, 54.8446],
                            [-5.8081, 54.8301],
                            [-5.8008, 54.8226],
                            [-5.7731, 54.8165],
                            [-5.7592, 54.8187],
                            [-5.7403, 54.8115],
                            [-5.7475, 54.804],
                            [-5.7253, 54.786],
                            [-5.7197, 54.7882],
                            [-5.7236, 54.7985],
                            [-5.7325, 54.8049],
                            [-5.7442, 54.8179],
                            [-5.7519, 54.8204],
                            [-5.7597, 54.829],
                            [-5.7714, 54.8318],
                            [-5.7758, 54.8379],
                            [-5.7892, 54.8438],
                            [-5.7914, 54.8485],
                            [-5.7819, 54.8532],
                            [-5.7686, 54.8524],
                            [-5.7636, 54.8593],
                            [-5.7453, 54.856],
                            [-5.7242, 54.8476],
                            [-5.7064, 54.8301],
                            [-5.6908, 54.8096],
                            [-5.6886, 54.7996],
                            [-5.692, 54.7915],
                            [-5.6936, 54.7737],
                            [-5.6875, 54.7663],
                            [-5.7008, 54.7587],
                            [-5.7119, 54.7451],
                            [-5.7342, 54.7371],
                            [-5.7486, 54.7254],
                            [-5.7642, 54.7196],
                            [-5.7781, 54.7232],
                            [-5.8047, 54.7151],
                            [-5.8053, 54.7099],
                            [-5.8314, 54.7082],
                            [-5.8392, 54.7051],
                            [-5.8708, 54.686],
                            [-5.8975, 54.6718],
                            [-5.8986, 54.6646],
                            [-5.9125, 54.6429],
                            [-5.9019, 54.6421],
                            [-5.8947, 54.634],
                            [-5.8847, 54.6382],
                            [-5.8542, 54.6343],
                            [-5.8486, 54.6401],
                            [-5.8292, 54.6449],
                            [-5.8214, 54.6524],
                            [-5.7992, 54.6618],
                            [-5.7925, 54.6621],
                            [-5.7486, 54.6746],
                            [-5.738, 54.6735],
                            [-5.7236, 54.6676],
                            [-5.6808, 54.669],
                            [-5.6514, 54.6657],
                            [-5.6358, 54.6687],
                            [-5.6397, 54.6762],
                            [-5.6347, 54.6812],
                            [-5.6231, 54.6812],
                            [-5.6092, 54.6751],
                            [-5.6036, 54.6785],
                            [-5.5747, 54.6749],
                            [-5.5647, 54.6618],
                            [-5.5425, 54.654],
                            [-5.5375, 54.6432],
                            [-5.5253, 54.6404],
                            [-5.5347, 54.6249],
                            [-5.5275, 54.6129],
                            [-5.5258, 54.6032],
                            [-5.5203, 54.596],
                            [-5.5075, 54.5926],
                            [-5.4981, 54.5768],
                            [-5.4886, 54.5765],
                            [-5.4792, 54.5674],
                            [-5.477, 54.5579],
                            [-5.4847, 54.551],
                            [-5.4842, 54.5376],
                            [-5.4708, 54.5265],
                            [-5.4714, 54.516],
                            [-5.4614, 54.496],
                            [-5.4447, 54.4893],
                            [-5.4325, 54.4874],
                            [-5.4419, 54.4735],
                            [-5.4347, 54.4704],
                            [-5.4397, 54.461],
                            [-5.4358, 54.4562],
                            [-5.4492, 54.4521],
                            [-5.4542, 54.4385],
                            [-5.4614, 54.4393],
                            [-5.4797, 54.4307],
                            [-5.4797, 54.4254],
                            [-5.4669, 54.4193],
                            [-5.462, 54.4124],
                            [-5.4625, 54.4001],
                            [-5.4575, 54.3937],
                            [-5.4625, 54.3824],
                            [-5.4764, 54.3849],
                            [-5.4836, 54.3829],
                            [-5.4842, 54.3729],
                            [-5.4914, 54.3696],
                            [-5.4797, 54.3635],
                            [-5.4953, 54.3496],
                            [-5.4925, 54.346],
                            [-5.4964, 54.3324],
                            [-5.5058, 54.3315],
                            [-5.5114, 54.3418],
                            [-5.5258, 54.3418],
                            [-5.5303, 54.3483],
                            [-5.5281, 54.3593],
                            [-5.5414, 54.3648],
                            [-5.5403, 54.3693],
                            [-5.548, 54.3799],
                            [-5.5558, 54.3826],
                            [-5.5625, 54.3904],
                            [-5.5708, 54.3904],
                            [-5.5792, 54.3985],
                            [-5.5797, 54.409],
                            [-5.5647, 54.4301],
                            [-5.5553, 54.4299],
                            [-5.5353, 54.4407],
                            [-5.533, 54.451],
                            [-5.5358, 54.459],
                            [-5.5442, 54.4615],
                            [-5.5414, 54.4718],
                            [-5.5436, 54.4851],
                            [-5.5369, 54.4893],
                            [-5.5464, 54.4949],
                            [-5.5564, 54.519],
                            [-5.5569, 54.5315],
                            [-5.5708, 54.5332],
                            [-5.582, 54.5315],
                            [-5.5953, 54.544],
                            [-5.6053, 54.5488],
                            [-5.6142, 54.5585],
                            [-5.6397, 54.561],
                            [-5.6675, 54.5743],
                            [-5.6786, 54.5829],
                            [-5.6847, 54.5823],
                            [-5.6964, 54.5718],
                            [-5.6997, 54.5596],
                            [-5.6958, 54.546],
                            [-5.7125, 54.5418],
                            [-5.7014, 54.534],
                            [-5.6886, 54.5321],
                            [-5.6819, 54.5246],
                            [-5.6397, 54.5151],
                            [-5.6447, 54.5063],
                            [-5.6381, 54.5004],
                            [-5.6475, 54.496],
                            [-5.6475, 54.5104],
                            [-5.6581, 54.5149],
                            [-5.6736, 54.5085],
                            [-5.6747, 54.5004],
                            [-5.6686, 54.4918],
                            [-5.6586, 54.4982],
                            [-5.6481, 54.4901],
                            [-5.6542, 54.4849],
                            [-5.6503, 54.4768],
                            [-5.6397, 54.466],
                            [-5.6375, 54.4565],
                            [-5.6275, 54.4546],
                            [-5.6408, 54.4415],
                            [-5.6292, 54.4379],
                            [-5.6375, 54.4324],
                            [-5.6458, 54.4179],
                            [-5.6403, 54.4112],
                            [-5.6403, 54.4001],
                            [-5.6542, 54.3846],
                            [-5.6708, 54.3765],
                            [-5.677, 54.3693],
                            [-5.6631, 54.3668],
                            [-5.6353, 54.3704],
                            [-5.6153, 54.3796],
                            [-5.6036, 54.3768],
                            [-5.588, 54.3849],
                            [-5.5725, 54.3835],
                            [-5.5708, 54.3765],
                            [-5.5569, 54.3765],
                            [-5.5458, 54.3615],
                            [-5.5492, 54.3457],
                            [-5.5381, 54.3379],
                            [-5.5447, 54.3324],
                            [-5.5386, 54.3246],
                            [-5.5392, 54.3179],
                            [-5.5225, 54.3148],
                            [-5.5258, 54.3093],
                            [-5.5397, 54.3121],
                            [-5.5492, 54.3068],
                            [-5.5597, 54.2857],
                            [-5.5775, 54.2718],
                            [-5.5858, 54.2701],
                            [-5.5903, 54.2629],
                            [-5.6114, 54.2463],
                            [-5.6197, 54.2532],
                            [-5.6358, 54.2593],
                            [-5.6408, 54.2549],
                            [-5.6347, 54.2438],
                            [-5.6475, 54.2307],
                            [-5.6603, 54.2251],
                            [-5.6742, 54.234],
                            [-5.6764, 54.246],
                            [-5.6914, 54.2513],
                            [-5.7236, 54.249],
                            [-5.7264, 54.2535],
                            [-5.7475, 54.2524],
                            [-5.7631, 54.2463],
                            [-5.7808, 54.244],
                            [-5.7914, 54.246],
                            [-5.8169, 54.2424],
                            [-5.8336, 54.2554],
                            [-5.8175, 54.2571],
                            [-5.8203, 54.2737],
                            [-5.8386, 54.2635],
                            [-5.8442, 54.2565],
                            [-5.8281, 54.2474],
                            [-5.8364, 54.2374],
                            [-5.8686, 54.2237],
                            [-5.8836, 54.2149],
                            [-5.8914, 54.2068],
                            [-5.8908, 54.201],
                            [-5.8764, 54.189],
                            [-5.8714, 54.1674],
                            [-5.8747, 54.1543],
                            [-5.8892, 54.1349],
                            [-5.8847, 54.1282],
                            [-5.8858, 54.1201],
                            [-5.8919, 54.1179],
                            [-5.8947, 54.1062],
                            [-5.9453, 54.0799],
                            [-5.9508, 54.0782],
                            [-5.9569, 54.0685],
                            [-5.9686, 54.0624],
                            [-5.9981, 54.0557],
                            [-6.0208, 54.0385],
                            [-6.0308, 54.0368],
                            [-6.0581, 54.0254],
                            [-6.0719, 54.0301],
                            [-6.0825, 54.0296],
                            [-6.0919, 54.0376],
                            [-6.1075, 54.041],
                            [-6.0936, 54.0482],
                            [-6.0814, 54.046],
                            [-6.0786, 54.0532],
                            [-6.0853, 54.0576],
                            [-6.0992, 54.0607],
                            [-6.1347, 54.0651],
                            [-6.1669, 54.0668],
                            [-6.1847, 54.076],
                            [-6.1903, 54.0849],
                            [-6.1914, 54.0946],
                            [-6.2158, 54.1004],
                            [-6.2342, 54.101],
                            [-6.2619, 54.099],
                            [-6.2814, 54.1121],
                            [-6.2892, 54.1126],
                            [-6.3175, 54.1487],
                            [-6.3214, 54.1479],
                            [-6.3131, 54.1329],
                            [-6.3014, 54.1187],
                            [-6.2892, 54.1104],
                            [-6.2811, 54.1101]
                        ]
                    ],
                    [
                        [
                            [-6.2414, 55.3126],
                            [-6.2175, 55.3068],
                            [-6.1947, 55.3068],
                            [-6.1747, 55.3037],
                            [-6.1675, 55.2965],
                            [-6.1764, 55.2876],
                            [-6.1786, 55.2726],
                            [-6.1853, 55.2615],
                            [-6.1986, 55.2646],
                            [-6.2014, 55.2774],
                            [-6.1892, 55.2851],
                            [-6.1997, 55.2932],
                            [-6.2281, 55.2957],
                            [-6.2553, 55.2915],
                            [-6.2775, 55.2912],
                            [-6.2864, 55.2949],
                            [-6.2703, 55.3071],
                            [-6.2642, 55.306],
                            [-6.2414, 55.3126]
                        ]
                    ]
                ]
            },
            'properties': {
                'name': 'Northern Ireland',
                'id': 'GB-NIR',
                'TYPE': 'Northern Ireland',
                'CNTRY': 'United Kingdom'
            },
            'id': 'GB-NIR'
        },
        {
            'type': 'Feature',
            'geometry': {
                'type': 'MultiPolygon',
                'coordinates': [
                    [
                        [
                            [-2.3599, 49.4457],
                            [-2.344, 49.4383],
                            [-2.3459, 49.4271],
                            [-2.3644, 49.4213],
                            [-2.3675, 49.4121],
                            [-2.373, 49.4086],
                            [-2.3818, 49.415],
                            [-2.3709, 49.4205],
                            [-2.3674, 49.4265],
                            [-2.3778, 49.4327],
                            [-2.3701, 49.4357],
                            [-2.3599, 49.4457]
                        ]
                    ],
                    [
                        [
                            [-2.5132, 49.5061],
                            [-2.5027, 49.5069],
                            [-2.5002, 49.4981],
                            [-2.5079, 49.4809],
                            [-2.5303, 49.4725],
                            [-2.5301, 49.4629],
                            [-2.5337, 49.4526],
                            [-2.5313, 49.4335],
                            [-2.5264, 49.423],
                            [-2.537, 49.4188],
                            [-2.5457, 49.4278],
                            [-2.5621, 49.4171],
                            [-2.566, 49.4237],
                            [-2.5783, 49.4255],
                            [-2.593, 49.4197],
                            [-2.6258, 49.4217],
                            [-2.6434, 49.4277],
                            [-2.6562, 49.4254],
                            [-2.6707, 49.4287],
                            [-2.6717, 49.4376],
                            [-2.6564, 49.4363],
                            [-2.6484, 49.4439],
                            [-2.6519, 49.4583],
                            [-2.6403, 49.4623],
                            [-2.6344, 49.4604],
                            [-2.6266, 49.4682],
                            [-2.6196, 49.4642],
                            [-2.6092, 49.4659],
                            [-2.5982, 49.4764],
                            [-2.5898, 49.4775],
                            [-2.5848, 49.4876],
                            [-2.5724, 49.4913],
                            [-2.5674, 49.496],
                            [-2.5504, 49.4949],
                            [-2.5442, 49.492],
                            [-2.5337, 49.5087],
                            [-2.5251, 49.5031],
                            [-2.5132, 49.5061]
                        ]
                    ],
                    [
                        [
                            [-2.1718, 49.7293],
                            [-2.1574, 49.7304],
                            [-2.1638, 49.7227],
                            [-2.1711, 49.723],
                            [-2.1737, 49.7143],
                            [-2.218, 49.7019],
                            [-2.2317, 49.7046],
                            [-2.2266, 49.7141],
                            [-2.2188, 49.7211],
                            [-2.2094, 49.7214],
                            [-2.2028, 49.7264],
                            [-2.1954, 49.7218],
                            [-2.1866, 49.7277],
                            [-2.1718, 49.7293]
                        ]
                    ]
                ]
            },
            'properties': {
                'name': 'Guernsey',
                'id': 'GG',
                'TYPE': 'Guernsey',
                'CNTRY': 'Guernsey'
            },
            'id': 'GG'
        },
        {
            'type': 'Feature',
            'geometry': {
                'type': 'Polygon',
                'coordinates': [
                    [
                        [-2.1512, 49.2607],
                        [-2.1353, 49.2535],
                        [-2.1049, 49.2506],
                        [-2.1013, 49.2558],
                        [-2.0913, 49.2536],
                        [-2.0801, 49.2393],
                        [-2.0731, 49.2377],
                        [-2.0529, 49.2423],
                        [-2.0414, 49.2363],
                        [-2.0253, 49.2321],
                        [-2.024, 49.2271],
                        [-2.03, 49.2163],
                        [-2.0179, 49.2003],
                        [-2.0283, 49.1982],
                        [-2.033, 49.182],
                        [-2.0277, 49.1679],
                        [-2.0332, 49.1644],
                        [-2.054, 49.17],
                        [-2.0782, 49.1635],
                        [-2.0917, 49.1751],
                        [-2.0985, 49.1779],
                        [-2.111, 49.1764],
                        [-2.1186, 49.189],
                        [-2.1311, 49.1948],
                        [-2.1421, 49.1968],
                        [-2.1595, 49.1959],
                        [-2.1692, 49.1891],
                        [-2.1695, 49.1789],
                        [-2.175, 49.1717],
                        [-2.1887, 49.1765],
                        [-2.19, 49.1835],
                        [-2.2018, 49.185],
                        [-2.204, 49.1788],
                        [-2.2234, 49.1748],
                        [-2.2435, 49.1818],
                        [-2.2309, 49.1892],
                        [-2.2233, 49.2044],
                        [-2.2307, 49.2255],
                        [-2.2421, 49.2388],
                        [-2.2535, 49.2476],
                        [-2.2538, 49.2528],
                        [-2.2425, 49.259],
                        [-2.211, 49.2549],
                        [-2.1974, 49.2495],
                        [-2.1826, 49.2495],
                        [-2.1704, 49.2539],
                        [-2.1653, 49.259],
                        [-2.1512, 49.2607]
                    ]
                ]
            },
            'properties': {
                'name': 'Jersey',
                'id': 'JE',
                'TYPE': 'Jersey',
                'CNTRY': 'Jersey'
            },
            'id': 'JE'
        },
        {
            'type': 'Feature',
            'geometry': {
                'type': 'MultiPolygon',
                'coordinates': [
                    [
                        [
                            [-4.8018, 54.0611],
                            [-4.8, 54.0559],
                            [-4.8118, 54.0465],
                            [-4.8248, 54.0488],
                            [-4.829, 54.0545],
                            [-4.8154, 54.0607],
                            [-4.8018, 54.0611]
                        ]
                    ],
                    [
                        [
                            [-4.383, 54.3315],
                            [-4.3688, 54.3153],
                            [-4.3453, 54.3087],
                            [-4.3167, 54.3043],
                            [-4.3086, 54.297],
                            [-4.3197, 54.2914],
                            [-4.3226, 54.2832],
                            [-4.3394, 54.2722],
                            [-4.3423, 54.2646],
                            [-4.3609, 54.2513],
                            [-4.368, 54.2429],
                            [-4.3708, 54.2322],
                            [-4.3888, 54.2254],
                            [-4.3997, 54.2161],
                            [-4.4002, 54.2058],
                            [-4.3863, 54.1986],
                            [-4.4039, 54.1805],
                            [-4.4162, 54.1775],
                            [-4.4218, 54.1718],
                            [-4.4335, 54.168],
                            [-4.4648, 54.1655],
                            [-4.4756, 54.1554],
                            [-4.4649, 54.1435],
                            [-4.4869, 54.1349],
                            [-4.5003, 54.1271],
                            [-4.5168, 54.1282],
                            [-4.5297, 54.1226],
                            [-4.5295, 54.1172],
                            [-4.5414, 54.1123],
                            [-4.5486, 54.1021],
                            [-4.5769, 54.1013],
                            [-4.5864, 54.0988],
                            [-4.605, 54.0892],
                            [-4.6204, 54.0736],
                            [-4.637, 54.0773],
                            [-4.6618, 54.0685],
                            [-4.6642, 54.0621],
                            [-4.6793, 54.0669],
                            [-4.6912, 54.0831],
                            [-4.6979, 54.0847],
                            [-4.726, 54.0842],
                            [-4.7364, 54.0725],
                            [-4.747, 54.0706],
                            [-4.7556, 54.0613],
                            [-4.7686, 54.0612],
                            [-4.7792, 54.0566],
                            [-4.7924, 54.0636],
                            [-4.7863, 54.0742],
                            [-4.7782, 54.0766],
                            [-4.7624, 54.0916],
                            [-4.7753, 54.0915],
                            [-4.778, 54.0973],
                            [-4.7657, 54.1083],
                            [-4.7556, 54.1102],
                            [-4.7354, 54.1285],
                            [-4.7302, 54.1403],
                            [-4.7309, 54.1546],
                            [-4.741, 54.1652],
                            [-4.7376, 54.1753],
                            [-4.7296, 54.1783],
                            [-4.7198, 54.187],
                            [-4.714, 54.2035],
                            [-4.7187, 54.2119],
                            [-4.707, 54.2221],
                            [-4.6901, 54.2257],
                            [-4.68, 54.2309],
                            [-4.6603, 54.2366],
                            [-4.6559, 54.2418],
                            [-4.6379, 54.252],
                            [-4.6102, 54.2708],
                            [-4.5969, 54.2855],
                            [-4.5794, 54.3144],
                            [-4.5588, 54.3352],
                            [-4.5492, 54.3555],
                            [-4.5351, 54.3688],
                            [-4.5156, 54.3787],
                            [-4.4602, 54.4001],
                            [-4.4267, 54.4045],
                            [-4.3743, 54.4174],
                            [-4.3606, 54.4156],
                            [-4.3621, 54.3925],
                            [-4.3681, 54.3776],
                            [-4.3802, 54.3558],
                            [-4.383, 54.3315]
                        ]
                    ]
                ]
            },
            'properties': {
                'name': 'Isle of Man',
                'id': 'IM',
                'TYPE': 'Isle of Man',
                'CNTRY': 'Isle of man'
            },
            'id': 'IM'
        },
        {
            'type': 'Feature',
            'geometry': {
                'type': 'MultiPolygon',
                'coordinates': [
                    [
                        [
                            [-8.4529, 55.049],
                            [-8.4605, 55.0578],
                            [-8.4504, 55.0619],
                            [-8.4393, 55.0523],
                            [-8.4529, 55.049]
                        ]
                    ],
                    [
                        [
                            [-8.5202, 54.9698],
                            [-8.528, 54.9747],
                            [-8.537, 54.9735],
                            [-8.5648, 54.9763],
                            [-8.5624, 54.9957],
                            [-8.5469, 55.0011],
                            [-8.5447, 55.0132],
                            [-8.5378, 55.02],
                            [-8.5301, 55.0125],
                            [-8.515, 55.0076],
                            [-8.5041, 55.0072],
                            [-8.4967, 55.0021],
                            [-8.4964, 54.9883],
                            [-8.4865, 54.982],
                            [-8.4866, 54.9748],
                            [-8.5142, 54.9744],
                            [-8.5202, 54.9698]
                        ]
                    ],
                    [
                        [
                            [-8.4126, 55.0146],
                            [-8.4303, 55.0291],
                            [-8.4212, 55.037],
                            [-8.408, 55.0228],
                            [-8.4126, 55.0146]
                        ]
                    ],
                    [
                        [
                            [-8.4622, 54.9842],
                            [-8.4494, 54.978],
                            [-8.4558, 54.9705],
                            [-8.4664, 54.9749],
                            [-8.4622, 54.9842]
                        ]
                    ],
                    [
                        [
                            [-10.0855, 54.089],
                            [-10.092, 54.0892],
                            [-10.1119, 54.0981],
                            [-10.1212, 54.0963],
                            [-10.1316, 54.1101],
                            [-10.1204, 54.115],
                            [-10.1244, 54.1317],
                            [-10.1171, 54.1466],
                            [-10.1066, 54.1504],
                            [-10.0927, 54.1687],
                            [-10.087, 54.1797],
                            [-10.0868, 54.188],
                            [-10.0962, 54.1994],
                            [-10.0814, 54.2113],
                            [-10.0629, 54.212],
                            [-10.0559, 54.2201],
                            [-10.0549, 54.2278],
                            [-10.0661, 54.2335],
                            [-10.082, 54.2334],
                            [-10.1087, 54.2439],
                            [-10.1025, 54.2467],
                            [-10.0846, 54.2441],
                            [-10.0769, 54.2358],
                            [-10.0678, 54.235],
                            [-10.074, 54.247],
                            [-10.0925, 54.2478],
                            [-10.0826, 54.2622],
                            [-10.0689, 54.2776],
                            [-10.0487, 54.28],
                            [-10.0408, 54.2833],
                            [-10.0264, 54.284],
                            [-10.0204, 54.2944],
                            [-10.0088, 54.2937],
                            [-10.0109, 54.301],
                            [-10.0041, 54.3069],
                            [-9.994, 54.3068],
                            [-9.988, 54.3018],
                            [-9.9868, 54.2915],
                            [-9.971, 54.2893],
                            [-9.9604, 54.2747],
                            [-9.9063, 54.2636],
                            [-9.8958, 54.2681],
                            [-9.8953, 54.2536],
                            [-9.9016, 54.2415],
                            [-9.9197, 54.2381],
                            [-9.9158, 54.2296],
                            [-9.9303, 54.2291],
                            [-9.9525, 54.2225],
                            [-9.9574, 54.225],
                            [-9.99, 54.2273],
                            [-10.0033, 54.2264],
                            [-10.0088, 54.2147],
                            [-10.0236, 54.212],
                            [-10.0056, 54.2041],
                            [-10.004, 54.1967],
                            [-10.0132, 54.1941],
                            [-10.0158, 54.1876],
                            [-10.0396, 54.1951],
                            [-10.041, 54.1875],
                            [-10.0362, 54.1783],
                            [-10.0418, 54.1696],
                            [-10.0543, 54.1728],
                            [-10.0684, 54.1699],
                            [-10.0721, 54.1643],
                            [-10.0913, 54.1615],
                            [-10.0896, 54.1559],
                            [-10.0574, 54.1497],
                            [-10.0748, 54.1407],
                            [-10.0681, 54.1349],
                            [-10.0771, 54.1284],
                            [-10.0908, 54.1247],
                            [-10.0891, 54.1136],
                            [-10.0669, 54.1111],
                            [-10.0686, 54.1043],
                            [-10.0612, 54.1009],
                            [-10.0726, 54.0914],
                            [-10.0855, 54.089]
                        ]
                    ],
                    [
                        [
                            [-8.5958, 54.301],
                            [-8.5894, 54.3067],
                            [-8.5756, 54.3019],
                            [-8.5816, 54.2922],
                            [-8.5958, 54.301]
                        ]
                    ],
                    [
                        [
                            [-9.8911, 54.0044],
                            [-9.8919, 53.9932],
                            [-9.9032, 53.9931],
                            [-9.9155, 53.9881],
                            [-9.9221, 53.9984],
                            [-9.9132, 54.0028],
                            [-9.8911, 54.0044]
                        ]
                    ],
                    [
                        [
                            [-8.4436, 54.9509],
                            [-8.4569, 54.9567],
                            [-8.4429, 54.9633],
                            [-8.4355, 54.9544],
                            [-8.4436, 54.9509]
                        ]
                    ],
                    [
                        [
                            [-9.9574, 53.877],
                            [-9.9632, 53.8772],
                            [-9.9815, 53.8894],
                            [-9.9891, 53.8904],
                            [-10.0021, 53.8999],
                            [-9.994, 53.9042],
                            [-10.0066, 53.9129],
                            [-10.0144, 53.9141],
                            [-10.027, 53.9224],
                            [-10.036, 53.9163],
                            [-10.0537, 53.9187],
                            [-10.0518, 53.9293],
                            [-10.0542, 53.9406],
                            [-10.0428, 53.9606],
                            [-10.0507, 53.967],
                            [-10.0687, 53.9747],
                            [-10.082, 53.9747],
                            [-10.102, 53.9659],
                            [-10.1268, 53.9761],
                            [-10.1366, 53.9712],
                            [-10.1574, 53.9698],
                            [-10.1901, 53.9724],
                            [-10.2023, 53.9673],
                            [-10.2136, 53.9691],
                            [-10.2337, 53.9829],
                            [-10.2076, 53.9864],
                            [-10.1904, 53.9965],
                            [-10.1863, 54.0047],
                            [-10.1916, 54.0072],
                            [-10.1907, 54.0161],
                            [-10.1708, 54.0095],
                            [-10.1521, 54.011],
                            [-10.1336, 54.0007],
                            [-10.1265, 54.004],
                            [-10.1013, 54.0025],
                            [-10.0907, 54.0125],
                            [-10.0721, 54.0253],
                            [-10.0461, 54.0268],
                            [-10.0262, 54.0135],
                            [-10.0133, 54.0185],
                            [-9.9982, 54.0182],
                            [-9.9876, 54.0152],
                            [-9.9817, 54.0223],
                            [-9.9684, 54.0303],
                            [-9.9602, 54.0213],
                            [-9.9534, 54.0197],
                            [-9.9377, 54.0091],
                            [-9.9297, 53.9957],
                            [-9.9468, 53.9934],
                            [-9.9563, 53.977],
                            [-9.947, 53.9614],
                            [-9.928, 53.9643],
                            [-9.9244, 53.9594],
                            [-9.9231, 53.9465],
                            [-9.9298, 53.939],
                            [-9.9223, 53.9342],
                            [-9.9281, 53.9278],
                            [-9.9402, 53.9245],
                            [-9.9561, 53.9137],
                            [-9.9403, 53.9103],
                            [-9.9364, 53.9006],
                            [-9.9475, 53.8809],
                            [-9.9574, 53.877]
                        ]
                    ],
                    [
                        [
                            [-9.8712, 53.9952],
                            [-9.8603, 53.9964],
                            [-9.8528, 53.9856],
                            [-9.8576, 53.9747],
                            [-9.8746, 53.987],
                            [-9.8712, 53.9952]
                        ]
                    ],
                    [
                        [
                            [-7.5313, 55.0749],
                            [-7.5129, 55.0846],
                            [-7.4895, 55.0846],
                            [-7.4632, 55.0669],
                            [-7.4539, 55.056],
                            [-7.4653, 55.0504],
                            [-7.4723, 55.0518],
                            [-7.4951, 55.0487],
                            [-7.5056, 55.0567],
                            [-7.524, 55.0594],
                            [-7.5313, 55.0749]
                        ]
                    ],
                    [
                        [
                            [-9.9429, 53.8618],
                            [-9.9565, 53.8636],
                            [-9.9667, 53.8738],
                            [-9.9485, 53.8735],
                            [-9.9429, 53.8618]
                        ]
                    ],
                    [
                        [
                            [-10.1728, 53.5286],
                            [-10.1806, 53.5376],
                            [-10.1552, 53.5384],
                            [-10.1493, 53.528],
                            [-10.1685, 53.5249],
                            [-10.1728, 53.5286]
                        ]
                    ],
                    [
                        [
                            [-6.1167, 53.3836],
                            [-6.1384, 53.3747],
                            [-6.1649, 53.3613],
                            [-6.1639, 53.37],
                            [-6.156, 53.3745],
                            [-6.1347, 53.3816],
                            [-6.1167, 53.3836]
                        ]
                    ],
                    [
                        [
                            [-9.9004, 53.3779],
                            [-9.9105, 53.4111],
                            [-9.8991, 53.4189],
                            [-9.8953, 53.4086],
                            [-9.8866, 53.3954],
                            [-9.8997, 53.395],
                            [-9.8921, 53.387],
                            [-9.8912, 53.3791],
                            [-9.9004, 53.3779]
                        ]
                    ],
                    [
                        [
                            [-9.6909, 53.2828],
                            [-9.6937, 53.2937],
                            [-9.7104, 53.2987],
                            [-9.704, 53.3049],
                            [-9.6825, 53.3109],
                            [-9.6625, 53.3066],
                            [-9.6532, 53.3012],
                            [-9.6467, 53.3047],
                            [-9.6309, 53.3006],
                            [-9.6537, 53.2891],
                            [-9.6814, 53.2886],
                            [-9.6909, 53.2828]
                        ]
                    ],
                    [
                        [
                            [-9.6505, 53.3124],
                            [-9.6484, 53.3175],
                            [-9.6354, 53.3218],
                            [-9.635, 53.3127],
                            [-9.6505, 53.3124]
                        ]
                    ],
                    [
                        [
                            [-9.6748, 53.2262],
                            [-9.6785, 53.2315],
                            [-9.6993, 53.2274],
                            [-9.7041, 53.2347],
                            [-9.7123, 53.2358],
                            [-9.7156, 53.2462],
                            [-9.7014, 53.2529],
                            [-9.7204, 53.2602],
                            [-9.7212, 53.2652],
                            [-9.6812, 53.272],
                            [-9.6816, 53.2815],
                            [-9.6511, 53.284],
                            [-9.6476, 53.2757],
                            [-9.6544, 53.2683],
                            [-9.6434, 53.2644],
                            [-9.6412, 53.2435],
                            [-9.6562, 53.228],
                            [-9.6748, 53.2262]
                        ]
                    ],
                    [
                        [
                            [-9.638, 53.102],
                            [-9.6387, 53.0899],
                            [-9.6521, 53.091],
                            [-9.6652, 53.0976],
                            [-9.6868, 53.1054],
                            [-9.6898, 53.1092],
                            [-9.7037, 53.1085],
                            [-9.718, 53.115],
                            [-9.7401, 53.1185],
                            [-9.7774, 53.1303],
                            [-9.7905, 53.1317],
                            [-9.8155, 53.1381],
                            [-9.8262, 53.144],
                            [-9.8088, 53.1522],
                            [-9.7832, 53.1528],
                            [-9.7745, 53.1494],
                            [-9.7594, 53.149],
                            [-9.7516, 53.1338],
                            [-9.7331, 53.1392],
                            [-9.7116, 53.1392],
                            [-9.7016, 53.143],
                            [-9.6886, 53.1398],
                            [-9.6839, 53.1344],
                            [-9.6743, 53.1356],
                            [-9.6532, 53.1322],
                            [-9.6638, 53.121],
                            [-9.6722, 53.1197],
                            [-9.6658, 53.1096],
                            [-9.6533, 53.1039],
                            [-9.638, 53.102]
                        ]
                    ],
                    [
                        [
                            [-9.72, 53.234],
                            [-9.7459, 53.234],
                            [-9.7381, 53.2417],
                            [-9.7418, 53.2467],
                            [-9.7299, 53.2513],
                            [-9.7186, 53.2474],
                            [-9.723, 53.2397],
                            [-9.72, 53.234]
                        ]
                    ],
                    [
                        [
                            [-9.5086, 53.0574],
                            [-9.5256, 53.0482],
                            [-9.5372, 53.0489],
                            [-9.553, 53.0534],
                            [-9.5429, 53.0668],
                            [-9.5289, 53.07],
                            [-9.5072, 53.0669],
                            [-9.5021, 53.0615],
                            [-9.5086, 53.0574]
                        ]
                    ],
                    [
                        [
                            [-9.6026, 53.0683],
                            [-9.6116, 53.0688],
                            [-9.6159, 53.0744],
                            [-9.612, 53.0857],
                            [-9.6002, 53.0916],
                            [-9.5939, 53.1011],
                            [-9.5698, 53.1033],
                            [-9.5633, 53.0991],
                            [-9.5621, 53.0883],
                            [-9.5713, 53.085],
                            [-9.5785, 53.0738],
                            [-9.6026, 53.0683]
                        ]
                    ],
                    [
                        [
                            [-10.0496, 53.7914],
                            [-10.0448, 53.807],
                            [-10.0228, 53.8134],
                            [-9.9947, 53.8158],
                            [-9.9939, 53.8195],
                            [-9.9788, 53.83],
                            [-9.9622, 53.8143],
                            [-9.9432, 53.8126],
                            [-9.9538, 53.8003],
                            [-9.9765, 53.7937],
                            [-10.0171, 53.7924],
                            [-10.022, 53.794],
                            [-10.0496, 53.7914]
                        ]
                    ],
                    [
                        [
                            [-10.2314, 51.5804],
                            [-10.2299, 51.586],
                            [-10.2028, 51.6042],
                            [-10.1862, 51.6093],
                            [-10.1747, 51.6084],
                            [-10.1658, 51.6116],
                            [-10.1602, 51.6035],
                            [-10.1796, 51.5962],
                            [-10.2047, 51.5887],
                            [-10.2132, 51.5881],
                            [-10.2314, 51.5804]
                        ]
                    ],
                    [
                        [
                            [-9.3986, 51.4691],
                            [-9.4227, 51.4572],
                            [-9.4349, 51.4538],
                            [-9.4379, 51.4637],
                            [-9.4241, 51.4662],
                            [-9.4208, 51.4799],
                            [-9.4151, 51.4875],
                            [-9.4071, 51.4913],
                            [-9.4014, 51.4839],
                            [-9.3986, 51.4691]
                        ]
                    ],
                    [
                        [
                            [-9.5085, 51.4265],
                            [-9.519, 51.4298],
                            [-9.5124, 51.4396],
                            [-9.4848, 51.4511],
                            [-9.4635, 51.4537],
                            [-9.4611, 51.4498],
                            [-9.4876, 51.4307],
                            [-9.5085, 51.4265]
                        ]
                    ],
                    [
                        [
                            [-10.4236, 51.8811],
                            [-10.4209, 51.8978],
                            [-10.4078, 51.905],
                            [-10.4088, 51.9101],
                            [-10.3936, 51.9145],
                            [-10.3757, 51.9146],
                            [-10.3497, 51.9259],
                            [-10.3427, 51.9308],
                            [-10.3287, 51.9301],
                            [-10.3206, 51.9338],
                            [-10.3166, 51.9245],
                            [-10.2989, 51.9281],
                            [-10.2868, 51.9264],
                            [-10.2905, 51.9148],
                            [-10.3067, 51.9063],
                            [-10.3454, 51.897],
                            [-10.3538, 51.8908],
                            [-10.3799, 51.8868],
                            [-10.3959, 51.891],
                            [-10.4132, 51.8828],
                            [-10.4236, 51.8811]
                        ]
                    ],
                    [
                        [
                            [-9.4999, 51.6799],
                            [-9.504, 51.6823],
                            [-9.5258, 51.6835],
                            [-9.4985, 51.6989],
                            [-9.4824, 51.6967],
                            [-9.4999, 51.6799]
                        ]
                    ],
                    [
                        [
                            [-9.8793, 51.6134],
                            [-9.8839, 51.6184],
                            [-9.8967, 51.6164],
                            [-9.9178, 51.6188],
                            [-9.9076, 51.6354],
                            [-9.8992, 51.6394],
                            [-9.8831, 51.6399],
                            [-9.8349, 51.6451],
                            [-9.8197, 51.6383],
                            [-9.8031, 51.6443],
                            [-9.7867, 51.6419],
                            [-9.803, 51.6345],
                            [-9.8198, 51.6296],
                            [-9.819, 51.6259],
                            [-9.8314, 51.6212],
                            [-9.8413, 51.6247],
                            [-9.8519, 51.6211],
                            [-9.877, 51.6171],
                            [-9.8793, 51.6134]
                        ]
                    ],
                    [
                        [
                            [-7.2601, 55.0663],
                            [-7.2738, 55.0568],
                            [-7.2936, 55.0555],
                            [-7.3055, 55.0481],
                            [-7.3333, 55.0487],
                            [-7.3417, 55.0514],
                            [-7.353, 55.0487],
                            [-7.3802, 55.0254],
                            [-7.3834, 55.0103],
                            [-7.3931, 55.0028],
                            [-7.3883, 54.9923],
                            [-7.4008, 54.983],
                            [-7.3936, 54.9729],
                            [-7.3929, 54.9459],
                            [-7.4146, 54.9439],
                            [-7.4163, 54.9415],
                            [-7.443, 54.9345],
                            [-7.4486, 54.9011],
                            [-7.4439, 54.8825],
                            [-7.458, 54.8579],
                            [-7.4771, 54.8461],
                            [-7.4828, 54.8299],
                            [-7.5197, 54.8153],
                            [-7.5456, 54.7989],
                            [-7.5525, 54.7917],
                            [-7.5483, 54.7853],
                            [-7.5533, 54.7632],
                            [-7.5372, 54.7485],
                            [-7.5373, 54.7449],
                            [-7.561, 54.7441],
                            [-7.5724, 54.7504],
                            [-7.6397, 54.7474],
                            [-7.6486, 54.7495],
                            [-7.6847, 54.73],
                            [-7.735, 54.7137],
                            [-7.7394, 54.7063],
                            [-7.7506, 54.7055],
                            [-7.8344, 54.7385],
                            [-7.848, 54.7333],
                            [-7.8709, 54.7081],
                            [-7.8841, 54.7037],
                            [-7.9253, 54.7023],
                            [-7.9264, 54.6959],
                            [-7.905, 54.6889],
                            [-7.9139, 54.6711],
                            [-7.89, 54.6565],
                            [-7.8622, 54.6533],
                            [-7.8553, 54.6347],
                            [-7.8283, 54.6353],
                            [-7.8094, 54.6391],
                            [-7.7788, 54.6321],
                            [-7.756, 54.6197],
                            [-7.7374, 54.6201],
                            [-7.7106, 54.6303],
                            [-7.7058, 54.6065],
                            [-7.7391, 54.6001],
                            [-7.7653, 54.5856],
                            [-7.7876, 54.5813],
                            [-7.793, 54.5733],
                            [-7.8194, 54.5625],
                            [-7.8216, 54.5489],
                            [-7.8293, 54.5447],
                            [-7.896, 54.5387],
                            [-7.9099, 54.5397],
                            [-7.9275, 54.5359],
                            [-7.9687, 54.5433],
                            [-7.9953, 54.5435],
                            [-8.0033, 54.5461],
                            [-8.0453, 54.5111],
                            [-8.0473, 54.4945],
                            [-8.0527, 54.4897],
                            [-8.0674, 54.4887],
                            [-8.0842, 54.4795],
                            [-8.1076, 54.4767],
                            [-8.1144, 54.4691],
                            [-8.1379, 54.4709],
                            [-8.1686, 54.4671],
                            [-8.1617, 54.4577],
                            [-8.1382, 54.4549],
                            [-8.1478, 54.4374],
                            [-8.0921, 54.4086],
                            [-8.0428, 54.3654],
                            [-8.0204, 54.3584],
                            [-8.0036, 54.3628],
                            [-7.9944, 54.3551],
                            [-7.9702, 54.34],
                            [-7.9449, 54.3097],
                            [-7.953, 54.3066],
                            [-7.9414, 54.2994],
                            [-7.8781, 54.2892],
                            [-7.8747, 54.2825],
                            [-7.8786, 54.2697],
                            [-7.8683, 54.25],
                            [-7.8675, 54.2242],
                            [-7.8514, 54.2122],
                            [-7.8206, 54.1992],
                            [-7.8, 54.203],
                            [-7.6969, 54.2025],
                            [-7.6753, 54.1822],
                            [-7.6567, 54.1844],
                            [-7.6497, 54.1758],
                            [-7.6245, 54.1664],
                            [-7.62, 54.1461],
                            [-7.6036, 54.1417],
                            [-7.5814, 54.1447],
                            [-7.5672, 54.1386],
                            [-7.5543, 54.128],
                            [-7.5231, 54.1343],
                            [-7.4734, 54.1259],
                            [-7.4637, 54.1302],
                            [-7.4638, 54.1408],
                            [-7.4417, 54.1469],
                            [-7.4147, 54.1508],
                            [-7.4225, 54.1428],
                            [-7.4239, 54.1361],
                            [-7.3964, 54.1372],
                            [-7.3919, 54.1344],
                            [-7.3972, 54.1208],
                            [-7.3939, 54.1178],
                            [-7.3642, 54.1258],
                            [-7.3433, 54.1158],
                            [-7.3133, 54.1125],
                            [-7.3056, 54.1208],
                            [-7.3067, 54.1332],
                            [-7.3251, 54.1429],
                            [-7.3252, 54.1489],
                            [-7.3033, 54.1661],
                            [-7.2839, 54.165],
                            [-7.2831, 54.1586],
                            [-7.2964, 54.1455],
                            [-7.2903, 54.1394],
                            [-7.2986, 54.1261],
                            [-7.2851, 54.1215],
                            [-7.2741, 54.1245],
                            [-7.2526, 54.1479],
                            [-7.2511, 54.1635],
                            [-7.243, 54.1707],
                            [-7.2487, 54.1907],
                            [-7.2276, 54.1965],
                            [-7.2378, 54.2035],
                            [-7.1967, 54.2192],
                            [-7.1617, 54.2189],
                            [-7.1423, 54.2273],
                            [-7.1497, 54.2725],
                            [-7.1754, 54.2758],
                            [-7.1733, 54.2858],
                            [-7.1805, 54.2914],
                            [-7.2021, 54.2977],
                            [-7.1951, 54.3106],
                            [-7.1755, 54.3205],
                            [-7.1732, 54.3364],
                            [-7.149, 54.3377],
                            [-7.1245, 54.3481],
                            [-7.1086, 54.353],
                            [-7.1, 54.3584],
                            [-7.1022, 54.371],
                            [-7.0614, 54.3997],
                            [-7.0419, 54.4159],
                            [-7.0251, 54.4161],
                            [-6.9744, 54.4017],
                            [-6.9269, 54.3792],
                            [-6.91, 54.3675],
                            [-6.9042, 54.3506],
                            [-6.8761, 54.3453],
                            [-6.8674, 54.328],
                            [-6.8517, 54.2875],
                            [-6.8586, 54.2765],
                            [-6.8278, 54.2626],
                            [-6.81, 54.2253],
                            [-6.7956, 54.2117],
                            [-6.7347, 54.1836],
                            [-6.7092, 54.2003],
                            [-6.6978, 54.2017],
                            [-6.6519, 54.1814],
                            [-6.6364, 54.1728],
                            [-6.6286, 54.1569],
                            [-6.6389, 54.1356],
                            [-6.6642, 54.1169],
                            [-6.6497, 54.1011],
                            [-6.6633, 54.0897],
                            [-6.6603, 54.0803],
                            [-6.6703, 54.0705],
                            [-6.6503, 54.0625],
                            [-6.625, 54.0392],
                            [-6.62, 54.0372],
                            [-6.6037, 54.0459],
                            [-6.5922, 54.0448],
                            [-6.582, 54.0542],
                            [-6.5675, 54.0509],
                            [-6.5292, 54.0601],
                            [-6.5037, 54.0567],
                            [-6.4723, 54.0669],
                            [-6.4702, 54.0788],
                            [-6.4486, 54.0705],
                            [-6.4436, 54.0553],
                            [-6.3747, 54.0664],
                            [-6.3572, 54.0743],
                            [-6.3503, 54.0829],
                            [-6.3581, 54.1082],
                            [-6.3497, 54.1155],
                            [-6.3336, 54.1139],
                            [-6.3171, 54.0953],
                            [-6.2906, 54.1091],
                            [-6.2811, 54.1101],
                            [-6.2672, 54.102],
                            [-6.2577, 54.0916],
                            [-6.238, 54.0757],
                            [-6.1995, 54.0621],
                            [-6.1927, 54.0572],
                            [-6.1809, 54.0424],
                            [-6.1762, 54.0433],
                            [-6.1487, 54.0294],
                            [-6.1287, 54.0344],
                            [-6.1261, 54.0196],
                            [-6.1017, 54.0025],
                            [-6.1231, 53.993],
                            [-6.1355, 53.9854],
                            [-6.1641, 53.9791],
                            [-6.1743, 53.9819],
                            [-6.1956, 53.9811],
                            [-6.218, 53.9868],
                            [-6.2477, 53.9895],
                            [-6.2734, 53.9988],
                            [-6.292, 54.0084],
                            [-6.3196, 54.0154],
                            [-6.3381, 54.0144],
                            [-6.3592, 54.0179],
                            [-6.3761, 54.0099],
                            [-6.3551, 54.0067],
                            [-6.3463, 54.0088],
                            [-6.3382, 53.9986],
                            [-6.3442, 53.9919],
                            [-6.3611, 53.985],
                            [-6.3588, 53.973],
                            [-6.3653, 53.9592],
                            [-6.3782, 53.9522],
                            [-6.3708, 53.9457],
                            [-6.3741, 53.9229],
                            [-6.3656, 53.9024],
                            [-6.3468, 53.8871],
                            [-6.3285, 53.8787],
                            [-6.3035, 53.8795],
                            [-6.2907, 53.8737],
                            [-6.2642, 53.871],
                            [-6.2574, 53.866],
                            [-6.2449, 53.8659],
                            [-6.2375, 53.861],
                            [-6.247, 53.8548],
                            [-6.2588, 53.825],
                            [-6.2581, 53.8101],
                            [-6.248, 53.8028],
                            [-6.2166, 53.7982],
                            [-6.2217, 53.7918],
                            [-6.2323, 53.7899],
                            [-6.2448, 53.7656],
                            [-6.2529, 53.7289],
                            [-6.2438, 53.7218],
                            [-6.2437, 53.7042],
                            [-6.2318, 53.6668],
                            [-6.2209, 53.6547],
                            [-6.212, 53.6337],
                            [-6.188, 53.6316],
                            [-6.1872, 53.6202],
                            [-6.1793, 53.6128],
                            [-6.1658, 53.6093],
                            [-6.1606, 53.6013],
                            [-6.1465, 53.5886],
                            [-6.129, 53.588],
                            [-6.1028, 53.5819],
                            [-6.0965, 53.5687],
                            [-6.0832, 53.5621],
                            [-6.0789, 53.5478],
                            [-6.0865, 53.5336],
                            [-6.0852, 53.5283],
                            [-6.0756, 53.5208],
                            [-6.0952, 53.5187],
                            [-6.1083, 53.5119],
                            [-6.1248, 53.5149],
                            [-6.1637, 53.5064],
                            [-6.159, 53.5002],
                            [-6.125, 53.5036],
                            [-6.1294, 53.5113],
                            [-6.1121, 53.5085],
                            [-6.1075, 53.4966],
                            [-6.0965, 53.4917],
                            [-6.1187, 53.4778],
                            [-6.1267, 53.4614],
                            [-6.1412, 53.4634],
                            [-6.1315, 53.4695],
                            [-6.1419, 53.4754],
                            [-6.1568, 53.47],
                            [-6.1714, 53.4716],
                            [-6.1908, 53.4661],
                            [-6.1722, 53.4567],
                            [-6.1384, 53.4521],
                            [-6.1228, 53.4457],
                            [-6.1194, 53.4383],
                            [-6.1232, 53.4333],
                            [-6.1218, 53.4238],
                            [-6.1147, 53.4086],
                            [-6.1249, 53.4089],
                            [-6.1279, 53.4194],
                            [-6.1352, 53.4195],
                            [-6.1308, 53.4056],
                            [-6.12, 53.3964],
                            [-6.1077, 53.394],
                            [-6.0724, 53.3918],
                            [-6.0642, 53.396],
                            [-6.0446, 53.3859],
                            [-6.0442, 53.3773],
                            [-6.0523, 53.3685],
                            [-6.0775, 53.3626],
                            [-6.0967, 53.3719],
                            [-6.1018, 53.3849],
                            [-6.1112, 53.3887],
                            [-6.1247, 53.3891],
                            [-6.1528, 53.3811],
                            [-6.1772, 53.3625],
                            [-6.1976, 53.3543],
                            [-6.1941, 53.3481],
                            [-6.224, 53.3506],
                            [-6.2132, 53.3443],
                            [-6.1749, 53.3432],
                            [-6.1761, 53.3388],
                            [-6.1909, 53.3356],
                            [-6.206, 53.3378],
                            [-6.2067, 53.3302],
                            [-6.2016, 53.3163],
                            [-6.1767, 53.3043],
                            [-6.1529, 53.2969],
                            [-6.1401, 53.2992],
                            [-6.1219, 53.2898],
                            [-6.1017, 53.2857],
                            [-6.0895, 53.2718],
                            [-6.1049, 53.2672],
                            [-6.1094, 53.2605],
                            [-6.1101, 53.2421],
                            [-6.1, 53.2106],
                            [-6.0904, 53.1987],
                            [-6.0755, 53.1917],
                            [-6.0702, 53.1778],
                            [-6.0741, 53.1703],
                            [-6.0693, 53.1574],
                            [-6.0466, 53.1331],
                            [-6.0394, 53.1224],
                            [-6.0339, 53.0958],
                            [-6.0312, 53.0708],
                            [-6.038, 53.0554],
                            [-6.0451, 53.0333],
                            [-6.0465, 53.0045],
                            [-6.0385, 52.9867],
                            [-6.0212, 52.9792],
                            [-6.0165, 52.9746],
                            [-6.0052, 52.9742],
                            [-5.9979, 52.9661],
                            [-6.0123, 52.9533],
                            [-6.0121, 52.9441],
                            [-6.019, 52.9278],
                            [-6.035, 52.9184],
                            [-6.037, 52.9009],
                            [-6.0476, 52.8946],
                            [-6.0547, 52.886],
                            [-6.0609, 52.8676],
                            [-6.058, 52.8578],
                            [-6.0825, 52.85],
                            [-6.1051, 52.8373],
                            [-6.1133, 52.8272],
                            [-6.1179, 52.8165],
                            [-6.1354, 52.8022],
                            [-6.1357, 52.7928],
                            [-6.143, 52.7827],
                            [-6.1386, 52.7757],
                            [-6.1419, 52.7642],
                            [-6.1342, 52.7596],
                            [-6.1435, 52.745],
                            [-6.1378, 52.7348],
                            [-6.1533, 52.7244],
                            [-6.1565, 52.7165],
                            [-6.1838, 52.7013],
                            [-6.2001, 52.6772],
                            [-6.2209, 52.6528],
                            [-6.2265, 52.6318],
                            [-6.2239, 52.6207],
                            [-6.2079, 52.604],
                            [-6.2089, 52.5893],
                            [-6.2018, 52.5831],
                            [-6.2006, 52.5723],
                            [-6.1931, 52.5673],
                            [-6.1946, 52.56],
                            [-6.2132, 52.5333],
                            [-6.242, 52.5108],
                            [-6.2539, 52.4983],
                            [-6.2887, 52.4676],
                            [-6.3191, 52.4348],
                            [-6.3428, 52.42],
                            [-6.3491, 52.4138],
                            [-6.3609, 52.3935],
                            [-6.363, 52.3843],
                            [-6.3619, 52.364],
                            [-6.3547, 52.3483],
                            [-6.371, 52.3477],
                            [-6.3718, 52.3526],
                            [-6.3822, 52.3576],
                            [-6.4332, 52.3584],
                            [-6.4394, 52.357],
                            [-6.4495, 52.3476],
                            [-6.4603, 52.3433],
                            [-6.4471, 52.3326],
                            [-6.4441, 52.3095],
                            [-6.4273, 52.3087],
                            [-6.4115, 52.301],
                            [-6.4134, 52.2939],
                            [-6.3976, 52.2902],
                            [-6.3961, 52.3041],
                            [-6.3884, 52.3081],
                            [-6.3883, 52.287],
                            [-6.3814, 52.2719],
                            [-6.3696, 52.2586],
                            [-6.3574, 52.2546],
                            [-6.3407, 52.255],
                            [-6.3133, 52.2434],
                            [-6.3227, 52.2368],
                            [-6.3255, 52.2268],
                            [-6.3418, 52.2161],
                            [-6.3498, 52.2018],
                            [-6.3447, 52.1913],
                            [-6.3574, 52.1846],
                            [-6.3618, 52.1753],
                            [-6.3691, 52.1781],
                            [-6.3861, 52.1791],
                            [-6.3974, 52.1844],
                            [-6.4163, 52.1889],
                            [-6.4621, 52.1925],
                            [-6.4937, 52.1916],
                            [-6.5284, 52.1879],
                            [-6.551, 52.1836],
                            [-6.5581, 52.1788],
                            [-6.5919, 52.1757],
                            [-6.6073, 52.1881],
                            [-6.6443, 52.2044],
                            [-6.6922, 52.2177],
                            [-6.706, 52.2204],
                            [-6.7395, 52.2134],
                            [-6.7547, 52.2152],
                            [-6.7673, 52.208],
                            [-6.7858, 52.2069],
                            [-6.8006, 52.2128],
                            [-6.8061, 52.2202],
                            [-6.7961, 52.2254],
                            [-6.7879, 52.216],
                            [-6.7841, 52.2307],
                            [-6.7606, 52.2464],
                            [-6.752, 52.2501],
                            [-6.7599, 52.2571],
                            [-6.7741, 52.2471],
                            [-6.7937, 52.2422],
                            [-6.8171, 52.2304],
                            [-6.8267, 52.2285],
                            [-6.8347, 52.2198],
                            [-6.8231, 52.2166],
                            [-6.817, 52.2103],
                            [-6.8286, 52.2],
                            [-6.8194, 52.1926],
                            [-6.8294, 52.187],
                            [-6.8284, 52.1778],
                            [-6.8433, 52.1759],
                            [-6.855, 52.1684],
                            [-6.8777, 52.1638],
                            [-6.8881, 52.1525],
                            [-6.8999, 52.1488],
                            [-6.9081, 52.1369],
                            [-6.9066, 52.1328],
                            [-6.9164, 52.1274],
                            [-6.929, 52.1253],
                            [-6.9307, 52.1332],
                            [-6.9235, 52.1413],
                            [-6.912, 52.1472],
                            [-6.9103, 52.1527],
                            [-6.8987, 52.1577],
                            [-6.8968, 52.1762],
                            [-6.91, 52.1933],
                            [-6.9022, 52.202],
                            [-6.9204, 52.2195],
                            [-6.9277, 52.2223],
                            [-6.9414, 52.2355],
                            [-6.9662, 52.2467],
                            [-6.9696, 52.2425],
                            [-6.9667, 52.2306],
                            [-6.974, 52.216],
                            [-6.9688, 52.2096],
                            [-6.9791, 52.1991],
                            [-6.9816, 52.1908],
                            [-6.9626, 52.1793],
                            [-6.9748, 52.1635],
                            [-6.9868, 52.1565],
                            [-6.9978, 52.143],
                            [-7.0321, 52.1342],
                            [-7.0474, 52.1404],
                            [-7.0719, 52.1364],
                            [-7.0803, 52.137],
                            [-7.0932, 52.131],
                            [-7.1051, 52.137],
                            [-7.0909, 52.1453],
                            [-7.0914, 52.1491],
                            [-7.0753, 52.16],
                            [-7.0936, 52.1696],
                            [-7.1025, 52.1719],
                            [-7.1207, 52.1687],
                            [-7.1125, 52.1569],
                            [-7.1466, 52.1613],
                            [-7.1565, 52.1561],
                            [-7.1673, 52.1416],
                            [-7.1849, 52.1363],
                            [-7.2046, 52.1374],
                            [-7.2165, 52.134],
                            [-7.24, 52.1356],
                            [-7.2706, 52.1415],
                            [-7.2947, 52.1429],
                            [-7.3075, 52.1376],
                            [-7.3419, 52.1404],
                            [-7.3671, 52.1403],
                            [-7.3826, 52.1329],
                            [-7.3923, 52.1308],
                            [-7.4033, 52.1339],
                            [-7.4397, 52.1299],
                            [-7.4474, 52.1249],
                            [-7.4643, 52.1214],
                            [-7.466, 52.1167],
                            [-7.4773, 52.1145],
                            [-7.4935, 52.1067],
                            [-7.5135, 52.1079],
                            [-7.5374, 52.1003],
                            [-7.5463, 52.0917],
                            [-7.5502, 52.0831],
                            [-7.5694, 52.0854],
                            [-7.5726, 52.0938],
                            [-7.5817, 52.0994],
                            [-7.5958, 52.0935],
                            [-7.6318, 52.0849],
                            [-7.6308, 52.0722],
                            [-7.6367, 52.0649],
                            [-7.6298, 52.0625],
                            [-7.6072, 52.0667],
                            [-7.5862, 52.0535],
                            [-7.5648, 52.0531],
                            [-7.55, 52.0558],
                            [-7.5349, 52.0538],
                            [-7.5461, 52.0464],
                            [-7.5647, 52.0421],
                            [-7.572, 52.0371],
                            [-7.5744, 52.0267],
                            [-7.5818, 52.0186],
                            [-7.576, 52.0107],
                            [-7.583, 51.9952],
                            [-7.6133, 51.9818],
                            [-7.6285, 51.9812],
                            [-7.6388, 51.9773],
                            [-7.6476, 51.9784],
                            [-7.6632, 51.9754],
                            [-7.694, 51.974],
                            [-7.7054, 51.9677],
                            [-7.7078, 51.9613],
                            [-7.7161, 51.9589],
                            [-7.7186, 51.9509],
                            [-7.7071, 51.947],
                            [-7.7186, 51.9395],
                            [-7.7431, 51.9389],
                            [-7.7553, 51.9421],
                            [-7.7613, 51.9479],
                            [-7.7738, 51.9512],
                            [-7.7899, 51.9489],
                            [-7.7929, 51.9417],
                            [-7.815, 51.938],
                            [-7.8274, 51.9408],
                            [-7.8297, 51.9525],
                            [-7.8388, 51.954],
                            [-7.8388, 51.9412],
                            [-7.8625, 51.9307],
                            [-7.8813, 51.9115],
                            [-7.9025, 51.9085],
                            [-7.9016, 51.8955],
                            [-7.8888, 51.8959],
                            [-7.8624, 51.8849],
                            [-7.8679, 51.8782],
                            [-7.887, 51.8783],
                            [-7.915, 51.8731],
                            [-7.964, 51.8688],
                            [-7.9996, 51.8583],
                            [-8.0197, 51.8438],
                            [-8.0289, 51.8418],
                            [-8.0192, 51.8338],
                            [-8.0024, 51.8283],
                            [-8.0059, 51.8248],
                            [-8.0249, 51.8202],
                            [-8.0464, 51.818],
                            [-8.0605, 51.8105],
                            [-8.0816, 51.8091],
                            [-8.0906, 51.8111],
                            [-8.1286, 51.8068],
                            [-8.1409, 51.8012],
                            [-8.1596, 51.7879],
                            [-8.1726, 51.7861],
                            [-8.1764, 51.7958],
                            [-8.2058, 51.7934],
                            [-8.2179, 51.7958],
                            [-8.2491, 51.7941],
                            [-8.2492, 51.8093],
                            [-8.2573, 51.8107],
                            [-8.2609, 51.8178],
                            [-8.2313, 51.8278],
                            [-8.2329, 51.8362],
                            [-8.2261, 51.8406],
                            [-8.1928, 51.8479],
                            [-8.1857, 51.8606],
                            [-8.2022, 51.8584],
                            [-8.236, 51.8592],
                            [-8.2542, 51.8574],
                            [-8.2623, 51.859],
                            [-8.2752, 51.8525],
                            [-8.3032, 51.8486],
                            [-8.3111, 51.8437],
                            [-8.3293, 51.8498],
                            [-8.3384, 51.8416],
                            [-8.3243, 51.8316],
                            [-8.3013, 51.8322],
                            [-8.2974, 51.8268],
                            [-8.3062, 51.8201],
                            [-8.2906, 51.811],
                            [-8.276, 51.8104],
                            [-8.2718, 51.799],
                            [-8.2913, 51.7808],
                            [-8.3118, 51.7732],
                            [-8.2965, 51.7682],
                            [-8.2961, 51.7564],
                            [-8.3074, 51.7421],
                            [-8.309, 51.7327],
                            [-8.3279, 51.7348],
                            [-8.3356, 51.728],
                            [-8.3373, 51.7179],
                            [-8.3599, 51.7175],
                            [-8.3818, 51.7154],
                            [-8.3839, 51.7099],
                            [-8.394, 51.7029],
                            [-8.4053, 51.7062],
                            [-8.417, 51.7048],
                            [-8.4247, 51.6984],
                            [-8.4235, 51.6931],
                            [-8.4374, 51.6865],
                            [-8.4505, 51.693],
                            [-8.4552, 51.685],
                            [-8.47, 51.6822],
                            [-8.4748, 51.6762],
                            [-8.4927, 51.6811],
                            [-8.4885, 51.6862],
                            [-8.5035, 51.7054],
                            [-8.5104, 51.6972],
                            [-8.5013, 51.6866],
                            [-8.5072, 51.681],
                            [-8.5173, 51.6822],
                            [-8.5292, 51.6632],
                            [-8.5275, 51.6588],
                            [-8.5432, 51.651],
                            [-8.5474, 51.645],
                            [-8.5366, 51.6338],
                            [-8.5352, 51.6169],
                            [-8.5254, 51.6117],
                            [-8.5293, 51.607],
                            [-8.5405, 51.6119],
                            [-8.5392, 51.6201],
                            [-8.555, 51.6261],
                            [-8.5539, 51.6328],
                            [-8.5593, 51.6401],
                            [-8.5806, 51.6463],
                            [-8.622, 51.6377],
                            [-8.6388, 51.6387],
                            [-8.6548, 51.6365],
                            [-8.669, 51.654],
                            [-8.6777, 51.6466],
                            [-8.6953, 51.6499],
                            [-8.7081, 51.6411],
                            [-8.7195, 51.6465],
                            [-8.7421, 51.6484],
                            [-8.741, 51.6439],
                            [-8.7237, 51.6371],
                            [-8.7026, 51.6353],
                            [-8.6845, 51.6383],
                            [-8.6849, 51.6286],
                            [-8.6972, 51.6222],
                            [-8.6973, 51.6174],
                            [-8.6828, 51.6146],
                            [-8.6886, 51.6019],
                            [-8.6951, 51.601],
                            [-8.7029, 51.5919],
                            [-8.695, 51.5841],
                            [-8.7046, 51.5742],
                            [-8.7324, 51.5748],
                            [-8.7545, 51.5767],
                            [-8.7475, 51.5838],
                            [-8.7534, 51.5882],
                            [-8.7736, 51.5845],
                            [-8.7825, 51.59],
                            [-8.8022, 51.5969],
                            [-8.8452, 51.5947],
                            [-8.8442, 51.6072],
                            [-8.8492, 51.6127],
                            [-8.8722, 51.6152],
                            [-8.8696, 51.606],
                            [-8.8538, 51.6089],
                            [-8.8497, 51.6017],
                            [-8.8703, 51.598],
                            [-8.8901, 51.6051],
                            [-8.892, 51.5985],
                            [-8.8648, 51.5933],
                            [-8.8698, 51.5817],
                            [-8.8894, 51.5721],
                            [-8.8951, 51.5546],
                            [-8.9145, 51.5423],
                            [-8.9278, 51.5497],
                            [-8.9408, 51.5451],
                            [-8.949, 51.5373],
                            [-8.9541, 51.5546],
                            [-8.9876, 51.5672],
                            [-9.0193, 51.568],
                            [-9.0164, 51.5599],
                            [-9.029, 51.5604],
                            [-9.0512, 51.5525],
                            [-9.0582, 51.5549],
                            [-9.0676, 51.5499],
                            [-9.0812, 51.548],
                            [-9.0961, 51.5504],
                            [-9.105, 51.5547],
                            [-9.1101, 51.5626],
                            [-9.1211, 51.5675],
                            [-9.1394, 51.5595],
                            [-9.1097, 51.5593],
                            [-9.1178, 51.5494],
                            [-9.1102, 51.5383],
                            [-9.1351, 51.5321],
                            [-9.1299, 51.5287],
                            [-9.1459, 51.5226],
                            [-9.1662, 51.518],
                            [-9.1741, 51.5185],
                            [-9.1631, 51.533],
                            [-9.1878, 51.52],
                            [-9.1836, 51.5172],
                            [-9.1951, 51.5079],
                            [-9.1999, 51.5102],
                            [-9.2158, 51.4991],
                            [-9.2095, 51.489],
                            [-9.2214, 51.4871],
                            [-9.2267, 51.4824],
                            [-9.2366, 51.4897],
                            [-9.2513, 51.4934],
                            [-9.2644, 51.489],
                            [-9.2754, 51.4957],
                            [-9.2939, 51.4986],
                            [-9.3006, 51.5066],
                            [-9.3083, 51.5045],
                            [-9.3025, 51.4975],
                            [-9.2944, 51.4972],
                            [-9.3009, 51.4872],
                            [-9.3078, 51.4879],
                            [-9.3194, 51.4803],
                            [-9.3362, 51.4761],
                            [-9.3458, 51.4695],
                            [-9.351, 51.4733],
                            [-9.3792, 51.4698],
                            [-9.3812, 51.4751],
                            [-9.3712, 51.4881],
                            [-9.3574, 51.4861],
                            [-9.3523, 51.4927],
                            [-9.3568, 51.4964],
                            [-9.3524, 51.5063],
                            [-9.3647, 51.5058],
                            [-9.3624, 51.4956],
                            [-9.368, 51.4912],
                            [-9.3862, 51.4909],
                            [-9.3808, 51.4989],
                            [-9.3982, 51.5063],
                            [-9.4021, 51.5004],
                            [-9.4116, 51.4971],
                            [-9.4174, 51.5019],
                            [-9.4123, 51.5147],
                            [-9.3953, 51.5364],
                            [-9.3921, 51.5457],
                            [-9.4116, 51.5409],
                            [-9.4184, 51.5444],
                            [-9.4144, 51.5524],
                            [-9.4427, 51.5496],
                            [-9.4348, 51.5429],
                            [-9.4459, 51.5305],
                            [-9.462, 51.5243],
                            [-9.4689, 51.5281],
                            [-9.4779, 51.5231],
                            [-9.4896, 51.5245],
                            [-9.5035, 51.519],
                            [-9.5262, 51.5186],
                            [-9.5245, 51.53],
                            [-9.5382, 51.5295],
                            [-9.5433, 51.5255],
                            [-9.5412, 51.5146],
                            [-9.5441, 51.5109],
                            [-9.562, 51.506],
                            [-9.58, 51.5055],
                            [-9.5854, 51.4982],
                            [-9.6134, 51.493],
                            [-9.617, 51.4993],
                            [-9.6288, 51.5],
                            [-9.6327, 51.5113],
                            [-9.6627, 51.5156],
                            [-9.6565, 51.5081],
                            [-9.6693, 51.5069],
                            [-9.7035, 51.4931],
                            [-9.7078, 51.4801],
                            [-9.7376, 51.4706],
                            [-9.742, 51.4636],
                            [-9.7568, 51.4519],
                            [-9.7604, 51.4594],
                            [-9.7698, 51.465],
                            [-9.781, 51.4625],
                            [-9.7957, 51.4514],
                            [-9.8074, 51.4493],
                            [-9.8149, 51.4531],
                            [-9.8177, 51.461],
                            [-9.8054, 51.4743],
                            [-9.8306, 51.4793],
                            [-9.8358, 51.4829],
                            [-9.8, 51.4954],
                            [-9.7946, 51.4958],
                            [-9.774, 51.5058],
                            [-9.7713, 51.5121],
                            [-9.7557, 51.5172],
                            [-9.7467, 51.5235],
                            [-9.7316, 51.5258],
                            [-9.7192, 51.5249],
                            [-9.6872, 51.5314],
                            [-9.6672, 51.5449],
                            [-9.6442, 51.5529],
                            [-9.6436, 51.5652],
                            [-9.6134, 51.5739],
                            [-9.6183, 51.579],
                            [-9.6014, 51.5822],
                            [-9.5879, 51.5891],
                            [-9.5738, 51.6013],
                            [-9.56, 51.6046],
                            [-9.553, 51.6025],
                            [-9.5312, 51.6111],
                            [-9.5494, 51.6163],
                            [-9.554, 51.6117],
                            [-9.567, 51.6133],
                            [-9.583, 51.6119],
                            [-9.6024, 51.6062],
                            [-9.6185, 51.5982],
                            [-9.6316, 51.6001],
                            [-9.6439, 51.5885],
                            [-9.6874, 51.5802],
                            [-9.6968, 51.5734],
                            [-9.7242, 51.5701],
                            [-9.7323, 51.56],
                            [-9.7384, 51.5645],
                            [-9.7542, 51.558],
                            [-9.7573, 51.5608],
                            [-9.7732, 51.5516],
                            [-9.7929, 51.5513],
                            [-9.8151, 51.5423],
                            [-9.8358, 51.541],
                            [-9.8427, 51.5457],
                            [-9.831, 51.5518],
                            [-9.8119, 51.5574],
                            [-9.7998, 51.5661],
                            [-9.784, 51.5701],
                            [-9.7828, 51.5805],
                            [-9.7687, 51.5832],
                            [-9.746, 51.5947],
                            [-9.7173, 51.6007],
                            [-9.7124, 51.6063],
                            [-9.6959, 51.614],
                            [-9.6853, 51.6148],
                            [-9.6767, 51.6205],
                            [-9.651, 51.6286],
                            [-9.633, 51.6299],
                            [-9.5982, 51.6417],
                            [-9.5816, 51.6457],
                            [-9.5638, 51.6549],
                            [-9.5599, 51.6538],
                            [-9.5205, 51.6608],
                            [-9.5089, 51.6639],
                            [-9.5063, 51.6705],
                            [-9.4938, 51.6734],
                            [-9.4872, 51.6797],
                            [-9.4722, 51.6794],
                            [-9.4605, 51.682],
                            [-9.4583, 51.6965],
                            [-9.4506, 51.7151],
                            [-9.4566, 51.7176],
                            [-9.4494, 51.7274],
                            [-9.463, 51.7268],
                            [-9.4813, 51.7152],
                            [-9.5008, 51.7172],
                            [-9.5026, 51.7236],
                            [-9.5108, 51.729],
                            [-9.5204, 51.7278],
                            [-9.5273, 51.7366],
                            [-9.525, 51.7418],
                            [-9.5304, 51.75],
                            [-9.5407, 51.7514],
                            [-9.558, 51.7347],
                            [-9.5488, 51.726],
                            [-9.5481, 51.7146],
                            [-9.5581, 51.7135],
                            [-9.5713, 51.7051],
                            [-9.5815, 51.7082],
                            [-9.5856, 51.7001],
                            [-9.5958, 51.6939],
                            [-9.6172, 51.6869],
                            [-9.6223, 51.6817],
                            [-9.6396, 51.6772],
                            [-9.6638, 51.6742],
                            [-9.6761, 51.6786],
                            [-9.7004, 51.6795],
                            [-9.7133, 51.6817],
                            [-9.7245, 51.6929],
                            [-9.7316, 51.6897],
                            [-9.7244, 51.6756],
                            [-9.7358, 51.6677],
                            [-9.7447, 51.6718],
                            [-9.763, 51.663],
                            [-9.797, 51.6597],
                            [-9.8114, 51.6556],
                            [-9.8213, 51.6594],
                            [-9.8396, 51.6591],
                            [-9.8587, 51.6541],
                            [-9.8651, 51.6575],
                            [-9.8789, 51.6502],
                            [-9.8996, 51.6524],
                            [-9.9134, 51.6423],
                            [-9.9241, 51.6404],
                            [-9.9226, 51.6333],
                            [-9.9336, 51.6164],
                            [-9.9524, 51.6159],
                            [-9.9678, 51.618],
                            [-9.9878, 51.6081],
                            [-10.0034, 51.603],
                            [-10.019, 51.5954],
                            [-10.0382, 51.5969],
                            [-10.0532, 51.5942],
                            [-10.0477, 51.6036],
                            [-10.0741, 51.6039],
                            [-10.0826, 51.6002],
                            [-10.1091, 51.5978],
                            [-10.1227, 51.5999],
                            [-10.1279, 51.5953],
                            [-10.1428, 51.5938],
                            [-10.1552, 51.5826],
                            [-10.1618, 51.584],
                            [-10.1505, 51.5953],
                            [-10.144, 51.5966],
                            [-10.1425, 51.6053],
                            [-10.1575, 51.6097],
                            [-10.1373, 51.6196],
                            [-10.131, 51.613],
                            [-10.0967, 51.619],
                            [-10.0901, 51.6247],
                            [-10.0794, 51.6198],
                            [-10.0657, 51.6233],
                            [-10.0603, 51.6314],
                            [-10.0571, 51.6484],
                            [-10.0598, 51.6538],
                            [-10.0726, 51.651],
                            [-10.0859, 51.6598],
                            [-10.1012, 51.6607],
                            [-10.1067, 51.6645],
                            [-10.0896, 51.6745],
                            [-10.0767, 51.6713],
                            [-10.0702, 51.6733],
                            [-10.0547, 51.6687],
                            [-10.0316, 51.6781],
                            [-10.0209, 51.6733],
                            [-10.0013, 51.6778],
                            [-10.0028, 51.6829],
                            [-9.9922, 51.6856],
                            [-9.9827, 51.6832],
                            [-9.9709, 51.6869],
                            [-9.9703, 51.6955],
                            [-9.9636, 51.7048],
                            [-9.95, 51.7104],
                            [-9.9576, 51.7173],
                            [-9.9826, 51.7112],
                            [-9.9865, 51.7159],
                            [-10.0032, 51.7155],
                            [-10.0006, 51.7223],
                            [-9.9806, 51.73],
                            [-9.975, 51.7357],
                            [-9.964, 51.7347],
                            [-9.9479, 51.7412],
                            [-9.9381, 51.739],
                            [-9.9043, 51.7514],
                            [-9.8874, 51.7622],
                            [-9.8811, 51.7575],
                            [-9.8777, 51.7463],
                            [-9.8652, 51.7475],
                            [-9.8454, 51.7575],
                            [-9.8511, 51.7631],
                            [-9.8474, 51.7763],
                            [-9.8361, 51.7694],
                            [-9.8039, 51.7599],
                            [-9.7837, 51.7646],
                            [-9.7898, 51.7748],
                            [-9.8075, 51.7802],
                            [-9.8207, 51.7804],
                            [-9.824, 51.7854],
                            [-9.8118, 51.7908],
                            [-9.7801, 51.8007],
                            [-9.7754, 51.81],
                            [-9.7396, 51.8241],
                            [-9.7417, 51.828],
                            [-9.7314, 51.8348],
                            [-9.6914, 51.8418],
                            [-9.6693, 51.8418],
                            [-9.6478, 51.8446],
                            [-9.6335, 51.8512],
                            [-9.6282, 51.8568],
                            [-9.6147, 51.8602],
                            [-9.5876, 51.8704],
                            [-9.5619, 51.8746],
                            [-9.5641, 51.8835],
                            [-9.582, 51.8765],
                            [-9.6138, 51.8695],
                            [-9.6294, 51.8674],
                            [-9.6334, 51.8701],
                            [-9.6542, 51.8718],
                            [-9.6871, 51.8615],
                            [-9.7306, 51.8534],
                            [-9.751, 51.8455],
                            [-9.7725, 51.8416],
                            [-9.7807, 51.836],
                            [-9.8092, 51.8286],
                            [-9.8128, 51.8302],
                            [-9.8306, 51.824],
                            [-9.8316, 51.8145],
                            [-9.8412, 51.8093],
                            [-9.8536, 51.8066],
                            [-9.8607, 51.812],
                            [-9.877, 51.8171],
                            [-9.8953, 51.8122],
                            [-9.9084, 51.8043],
                            [-9.9271, 51.8055],
                            [-9.9339, 51.8014],
                            [-9.9495, 51.8014],
                            [-9.9696, 51.7895],
                            [-9.9775, 51.7908],
                            [-10.0137, 51.7716],
                            [-10.0211, 51.7737],
                            [-10.0419, 51.7744],
                            [-10.0602, 51.7701],
                            [-10.0568, 51.7612],
                            [-10.0747, 51.7605],
                            [-10.0849, 51.7566],
                            [-10.1001, 51.7571],
                            [-10.1017, 51.7497],
                            [-10.1182, 51.7474],
                            [-10.1306, 51.739],
                            [-10.1406, 51.7416],
                            [-10.1136, 51.7623],
                            [-10.1448, 51.7593],
                            [-10.147, 51.7637],
                            [-10.164, 51.762],
                            [-10.1706, 51.7679],
                            [-10.1826, 51.7671],
                            [-10.2, 51.7769],
                            [-10.2194, 51.7755],
                            [-10.2246, 51.7822],
                            [-10.2017, 51.7819],
                            [-10.1963, 51.786],
                            [-10.1817, 51.7882],
                            [-10.1802, 51.7989],
                            [-10.1724, 51.8063],
                            [-10.1787, 51.8095],
                            [-10.1727, 51.8241],
                            [-10.1789, 51.8325],
                            [-10.1895, 51.8346],
                            [-10.2059, 51.845],
                            [-10.2322, 51.846],
                            [-10.2458, 51.8444],
                            [-10.2533, 51.8388],
                            [-10.2543, 51.8326],
                            [-10.2725, 51.8229],
                            [-10.2731, 51.8079],
                            [-10.3004, 51.8014],
                            [-10.3066, 51.7959],
                            [-10.3429, 51.7839],
                            [-10.3506, 51.7989],
                            [-10.3343, 51.8052],
                            [-10.3397, 51.8131],
                            [-10.3318, 51.8222],
                            [-10.3377, 51.8254],
                            [-10.3358, 51.8467],
                            [-10.3469, 51.8445],
                            [-10.3557, 51.8466],
                            [-10.3752, 51.8419],
                            [-10.388, 51.8417],
                            [-10.3937, 51.8477],
                            [-10.3829, 51.8592],
                            [-10.3871, 51.8727],
                            [-10.393, 51.8776],
                            [-10.3923, 51.8851],
                            [-10.3492, 51.8856],
                            [-10.3386, 51.891],
                            [-10.3218, 51.8914],
                            [-10.3097, 51.898],
                            [-10.2946, 51.8998],
                            [-10.2785, 51.912],
                            [-10.2656, 51.9137],
                            [-10.2546, 51.9051],
                            [-10.2487, 51.9118],
                            [-10.2516, 51.9199],
                            [-10.2584, 51.9246],
                            [-10.2781, 51.9299],
                            [-10.2484, 51.9392],
                            [-10.2386, 51.9469],
                            [-10.2261, 51.9485],
                            [-10.2133, 51.9561],
                            [-10.2004, 51.9571],
                            [-10.1814, 51.9629],
                            [-10.1948, 51.9656],
                            [-10.2121, 51.9605],
                            [-10.2286, 51.9504],
                            [-10.2585, 51.9477],
                            [-10.2681, 51.9395],
                            [-10.2911, 51.9512],
                            [-10.3187, 51.9528],
                            [-10.3158, 51.9583],
                            [-10.3055, 51.9628],
                            [-10.2925, 51.9643],
                            [-10.2798, 51.9698],
                            [-10.2749, 51.9647],
                            [-10.2628, 51.9667],
                            [-10.2665, 51.973],
                            [-10.258, 51.9904],
                            [-10.2527, 51.9892],
                            [-10.2295, 51.9944],
                            [-10.2163, 51.9911],
                            [-10.2049, 52.0023],
                            [-10.1817, 52.0128],
                            [-10.1715, 52.0125],
                            [-10.158, 52.0167],
                            [-10.1473, 52.0248],
                            [-10.1293, 52.03],
                            [-10.1157, 52.0259],
                            [-10.1039, 52.0258],
                            [-10.0893, 52.033],
                            [-10.0644, 52.0399],
                            [-10.0543, 52.0408],
                            [-10.0397, 52.0371],
                            [-10.022, 52.0389],
                            [-9.9966, 52.0488],
                            [-9.9747, 52.055],
                            [-9.9714, 52.059],
                            [-9.9511, 52.0656],
                            [-9.9452, 52.0725],
                            [-9.9277, 52.0752],
                            [-9.9332, 52.0855],
                            [-9.9248, 52.0953],
                            [-9.9109, 52.1003],
                            [-9.8979, 52.1211],
                            [-9.8895, 52.1145],
                            [-9.8794, 52.1112],
                            [-9.857, 52.1143],
                            [-9.8354, 52.127],
                            [-9.8227, 52.1246],
                            [-9.8101, 52.1297],
                            [-9.7961, 52.1304],
                            [-9.7972, 52.1432],
                            [-9.791, 52.1547],
                            [-9.7976, 52.1602],
                            [-9.8115, 52.1538],
                            [-9.8217, 52.1601],
                            [-9.8401, 52.1569],
                            [-9.8636, 52.1585],
                            [-9.8801, 52.1562],
                            [-9.9203, 52.1478],
                            [-9.9505, 52.1466],
                            [-9.9579, 52.1354],
                            [-9.9496, 52.1341],
                            [-9.9427, 52.1254],
                            [-9.9364, 52.1057],
                            [-9.9545, 52.1122],
                            [-9.9695, 52.1314],
                            [-9.985, 52.1436],
                            [-10.0012, 52.1403],
                            [-10.0561, 52.1334],
                            [-10.068, 52.1285],
                            [-10.0775, 52.1285],
                            [-10.0915, 52.1228],
                            [-10.1036, 52.1259],
                            [-10.1201, 52.1148],
                            [-10.1384, 52.1121],
                            [-10.1377, 52.1174],
                            [-10.1569, 52.1206],
                            [-10.1594, 52.1174],
                            [-10.1849, 52.1101],
                            [-10.1996, 52.1147],
                            [-10.2111, 52.1227],
                            [-10.2316, 52.1178],
                            [-10.2579, 52.1236],
                            [-10.2692, 52.1387],
                            [-10.2798, 52.139],
                            [-10.2932, 52.1345],
                            [-10.2984, 52.127],
                            [-10.264, 52.1238],
                            [-10.2588, 52.1209],
                            [-10.2673, 52.114],
                            [-10.2898, 52.1114],
                            [-10.3025, 52.1154],
                            [-10.3217, 52.1152],
                            [-10.3264, 52.122],
                            [-10.347, 52.1297],
                            [-10.3589, 52.132],
                            [-10.3705, 52.127],
                            [-10.3758, 52.1212],
                            [-10.3727, 52.1162],
                            [-10.3615, 52.115],
                            [-10.3553, 52.1055],
                            [-10.3705, 52.108],
                            [-10.4059, 52.1037],
                            [-10.421, 52.0985],
                            [-10.4269, 52.1008],
                            [-10.4495, 52.0972],
                            [-10.4531, 52.1059],
                            [-10.4624, 52.1142],
                            [-10.4567, 52.1217],
                            [-10.4677, 52.1352],
                            [-10.4641, 52.1424],
                            [-10.475, 52.1499],
                            [-10.4593, 52.1543],
                            [-10.4624, 52.1586],
                            [-10.4489, 52.1677],
                            [-10.4533, 52.1794],
                            [-10.4695, 52.1813],
                            [-10.4463, 52.1918],
                            [-10.4343, 52.194],
                            [-10.4319, 52.199],
                            [-10.4178, 52.204],
                            [-10.4016, 52.2048],
                            [-10.4116, 52.1947],
                            [-10.4115, 52.1829],
                            [-10.4038, 52.1801],
                            [-10.3831, 52.1793],
                            [-10.3716, 52.1719],
                            [-10.3626, 52.1857],
                            [-10.375, 52.1907],
                            [-10.3757, 52.197],
                            [-10.3531, 52.2128],
                            [-10.3561, 52.2169],
                            [-10.3687, 52.2162],
                            [-10.3701, 52.2249],
                            [-10.3557, 52.2363],
                            [-10.3451, 52.2324],
                            [-10.3406, 52.2378],
                            [-10.3299, 52.2349],
                            [-10.2982, 52.2454],
                            [-10.2914, 52.257],
                            [-10.2643, 52.2604],
                            [-10.258, 52.2696],
                            [-10.2392, 52.2754],
                            [-10.2252, 52.2777],
                            [-10.213, 52.2724],
                            [-10.2064, 52.2808],
                            [-10.1948, 52.2863],
                            [-10.1732, 52.2908],
                            [-10.1532, 52.2884],
                            [-10.156, 52.2805],
                            [-10.1524, 52.2757],
                            [-10.1597, 52.2645],
                            [-10.1466, 52.2614],
                            [-10.1571, 52.2476],
                            [-10.1767, 52.2367],
                            [-10.1344, 52.239],
                            [-10.1297, 52.2442],
                            [-10.0998, 52.2451],
                            [-10.071, 52.2531],
                            [-10.0609, 52.261],
                            [-10.0457, 52.2689],
                            [-10.0318, 52.2827],
                            [-10.0317, 52.2958],
                            [-10.0404, 52.3027],
                            [-10.0541, 52.3074],
                            [-10.0398, 52.3112],
                            [-10.0261, 52.3042],
                            [-10.0135, 52.3079],
                            [-10.0113, 52.2843],
                            [-10.021, 52.2795],
                            [-10.0195, 52.2676],
                            [-9.9987, 52.2543],
                            [-9.9983, 52.2511],
                            [-9.9792, 52.2463],
                            [-9.9672, 52.2379],
                            [-9.9542, 52.2326],
                            [-9.9348, 52.2324],
                            [-9.922, 52.2345],
                            [-9.9066, 52.2292],
                            [-9.8944, 52.2296],
                            [-9.8614, 52.2361],
                            [-9.838, 52.2502],
                            [-9.8248, 52.2434],
                            [-9.809, 52.2448],
                            [-9.7803, 52.2527],
                            [-9.7691, 52.249],
                            [-9.7505, 52.2521],
                            [-9.7449, 52.2589],
                            [-9.7507, 52.267],
                            [-9.7637, 52.2687],
                            [-9.7738, 52.2743],
                            [-9.7916, 52.2713],
                            [-9.8108, 52.2712],
                            [-9.8202, 52.2755],
                            [-9.836, 52.2759],
                            [-9.8476, 52.2799],
                            [-9.8634, 52.2735],
                            [-9.8733, 52.2744],
                            [-9.874, 52.2857],
                            [-9.8848, 52.2961],
                            [-9.8743, 52.3019],
                            [-9.8668, 52.2883],
                            [-9.8586, 52.2842],
                            [-9.8502, 52.291],
                            [-9.837, 52.2922],
                            [-9.8316, 52.2992],
                            [-9.8463, 52.3006],
                            [-9.8557, 52.298],
                            [-9.8676, 52.3022],
                            [-9.8528, 52.3088],
                            [-9.8256, 52.3157],
                            [-9.8223, 52.3207],
                            [-9.8325, 52.325],
                            [-9.8426, 52.3249],
                            [-9.8334, 52.338],
                            [-9.8361, 52.3621],
                            [-9.8301, 52.3778],
                            [-9.8362, 52.3878],
                            [-9.86, 52.3919],
                            [-9.8724, 52.3912],
                            [-9.9078, 52.3962],
                            [-9.9399, 52.404],
                            [-9.9463, 52.4109],
                            [-9.9406, 52.4216],
                            [-9.9075, 52.432],
                            [-9.8741, 52.4308],
                            [-9.8613, 52.4261],
                            [-9.8398, 52.4327],
                            [-9.8244, 52.4337],
                            [-9.7942, 52.4456],
                            [-9.7831, 52.4456],
                            [-9.7565, 52.4549],
                            [-9.7418, 52.4688],
                            [-9.729, 52.4749],
                            [-9.7159, 52.4767],
                            [-9.7083, 52.4815],
                            [-9.698, 52.4799],
                            [-9.6886, 52.4832],
                            [-9.6793, 52.4981],
                            [-9.6804, 52.5083],
                            [-9.6749, 52.5189],
                            [-9.6794, 52.523],
                            [-9.6708, 52.5315],
                            [-9.6708, 52.5424],
                            [-9.6778, 52.5477],
                            [-9.6617, 52.5558],
                            [-9.6614, 52.5624],
                            [-9.6957, 52.5845],
                            [-9.7108, 52.5799],
                            [-9.7211, 52.5853],
                            [-9.7429, 52.5863],
                            [-9.7427, 52.5803],
                            [-9.7704, 52.5719],
                            [-9.7851, 52.5708],
                            [-9.8028, 52.5658],
                            [-9.8146, 52.5648],
                            [-9.8266, 52.5698],
                            [-9.8607, 52.5699],
                            [-9.8608, 52.5654],
                            [-9.8789, 52.5572],
                            [-9.9019, 52.5564],
                            [-9.9311, 52.5572],
                            [-9.933, 52.5615],
                            [-9.9206, 52.5646],
                            [-9.912, 52.5751],
                            [-9.8933, 52.5811],
                            [-9.8814, 52.5789],
                            [-9.8708, 52.5879],
                            [-9.8533, 52.5962],
                            [-9.8161, 52.5999],
                            [-9.8052, 52.6053],
                            [-9.805, 52.6142],
                            [-9.7919, 52.619],
                            [-9.7711, 52.634],
                            [-9.747, 52.6403],
                            [-9.7247, 52.6517],
                            [-9.7181, 52.6575],
                            [-9.6956, 52.6652],
                            [-9.6928, 52.6722],
                            [-9.6742, 52.6774],
                            [-9.6637, 52.6837],
                            [-9.6487, 52.6798],
                            [-9.6504, 52.6988],
                            [-9.6452, 52.7069],
                            [-9.633, 52.7129],
                            [-9.6147, 52.717],
                            [-9.6326, 52.728],
                            [-9.62, 52.7342],
                            [-9.6068, 52.734],
                            [-9.6039, 52.7449],
                            [-9.5686, 52.7524],
                            [-9.5543, 52.7531],
                            [-9.5406, 52.7468],
                            [-9.5301, 52.7367],
                            [-9.5224, 52.7467],
                            [-9.504, 52.7472],
                            [-9.4975, 52.7504],
                            [-9.4903, 52.7622],
                            [-9.4985, 52.7724],
                            [-9.4828, 52.7753],
                            [-9.4806, 52.7825],
                            [-9.4841, 52.8093],
                            [-9.4676, 52.8135],
                            [-9.455, 52.8193],
                            [-9.4506, 52.8346],
                            [-9.4338, 52.8346],
                            [-9.4324, 52.8452],
                            [-9.449, 52.8504],
                            [-9.43, 52.8603],
                            [-9.4356, 52.8681],
                            [-9.4357, 52.8773],
                            [-9.4315, 52.8843],
                            [-9.4094, 52.8935],
                            [-9.3944, 52.8963],
                            [-9.3834, 52.9052],
                            [-9.3709, 52.9103],
                            [-9.3672, 52.9167],
                            [-9.3524, 52.9203],
                            [-9.3493, 52.9362],
                            [-9.3619, 52.9455],
                            [-9.3737, 52.9451],
                            [-9.3887, 52.9408],
                            [-9.4, 52.935],
                            [-9.4241, 52.9346],
                            [-9.4373, 52.9391],
                            [-9.4658, 52.9326],
                            [-9.4754, 52.9341],
                            [-9.4744, 52.9438],
                            [-9.4674, 52.9503],
                            [-9.4538, 52.9546],
                            [-9.4287, 52.9719],
                            [-9.4289, 52.9875],
                            [-9.4171, 52.9925],
                            [-9.4069, 53.0029],
                            [-9.3912, 53.0104],
                            [-9.4073, 53.0196],
                            [-9.3959, 53.026],
                            [-9.3822, 53.0433],
                            [-9.3647, 53.0519],
                            [-9.363, 53.0659],
                            [-9.3554, 53.0752],
                            [-9.3286, 53.0871],
                            [-9.3175, 53.0887],
                            [-9.3082, 53.0952],
                            [-9.2864, 53.1208],
                            [-9.2902, 53.1332],
                            [-9.2805, 53.1458],
                            [-9.2623, 53.156],
                            [-9.2396, 53.1504],
                            [-9.2179, 53.1411],
                            [-9.1816, 53.1364],
                            [-9.1789, 53.1311],
                            [-9.1649, 53.1243],
                            [-9.1405, 53.1217],
                            [-9.1289, 53.1281],
                            [-9.1178, 53.1388],
                            [-9.1093, 53.1418],
                            [-9.0874, 53.14],
                            [-9.0802, 53.1309],
                            [-9.0718, 53.1373],
                            [-9.0882, 53.1481],
                            [-9.1006, 53.1452],
                            [-9.1122, 53.1578],
                            [-9.1005, 53.1602],
                            [-9.0713, 53.1567],
                            [-9.0546, 53.1599],
                            [-9.0411, 53.152],
                            [-9.0242, 53.151],
                            [-9.0242, 53.1455],
                            [-9.0094, 53.1462],
                            [-9.0085, 53.1549],
                            [-9.0248, 53.1602],
                            [-9.041, 53.1615],
                            [-9.0465, 53.1672],
                            [-9.0754, 53.1595],
                            [-9.0846, 53.1661],
                            [-9.0776, 53.1702],
                            [-9.0572, 53.1675],
                            [-9.0217, 53.1721],
                            [-8.9893, 53.1705],
                            [-8.9804, 53.1756],
                            [-8.9654, 53.1775],
                            [-8.974, 53.1667],
                            [-8.9646, 53.1603],
                            [-8.9502, 53.1552],
                            [-8.9331, 53.1421],
                            [-8.9329, 53.1552],
                            [-8.947, 53.174],
                            [-8.9418, 53.1945],
                            [-8.9255, 53.2035],
                            [-8.9225, 53.21],
                            [-8.8956, 53.2202],
                            [-8.9069, 53.2234],
                            [-8.9218, 53.2151],
                            [-8.938, 53.2146],
                            [-8.9586, 53.2105],
                            [-8.9715, 53.2143],
                            [-8.9887, 53.2259],
                            [-8.9759, 53.2353],
                            [-8.952, 53.2394],
                            [-8.959, 53.2452],
                            [-8.9765, 53.2465],
                            [-8.9761, 53.2567],
                            [-8.965, 53.2559],
                            [-8.9348, 53.2601],
                            [-8.9365, 53.2658],
                            [-8.929, 53.272],
                            [-8.9428, 53.2742],
                            [-8.9909, 53.2634],
                            [-8.9915, 53.2718],
                            [-9.0144, 53.2681],
                            [-9.046, 53.2692],
                            [-9.0528, 53.2646],
                            [-9.0683, 53.264],
                            [-9.0755, 53.2601],
                            [-9.1092, 53.255],
                            [-9.1103, 53.2608],
                            [-9.1239, 53.2594],
                            [-9.1388, 53.2506],
                            [-9.1471, 53.2516],
                            [-9.1617, 53.2476],
                            [-9.1762, 53.2468],
                            [-9.1998, 53.2486],
                            [-9.2156, 53.247],
                            [-9.2288, 53.249],
                            [-9.2707, 53.2448],
                            [-9.3075, 53.2446],
                            [-9.3127, 53.2414],
                            [-9.3364, 53.2402],
                            [-9.3613, 53.2436],
                            [-9.3755, 53.2386],
                            [-9.4003, 53.235],
                            [-9.4155, 53.2366],
                            [-9.4261, 53.2344],
                            [-9.4515, 53.2354],
                            [-9.4653, 53.2275],
                            [-9.4743, 53.2304],
                            [-9.4883, 53.2272],
                            [-9.5216, 53.223],
                            [-9.5306, 53.231],
                            [-9.5413, 53.2336],
                            [-9.5532, 53.2412],
                            [-9.5482, 53.2482],
                            [-9.5611, 53.256],
                            [-9.5658, 53.2648],
                            [-9.5544, 53.2695],
                            [-9.5543, 53.2737],
                            [-9.5416, 53.2795],
                            [-9.5427, 53.2857],
                            [-9.5516, 53.2925],
                            [-9.5733, 53.2801],
                            [-9.5821, 53.2726],
                            [-9.5728, 53.262],
                            [-9.5768, 53.2484],
                            [-9.5845, 53.2388],
                            [-9.5996, 53.2415],
                            [-9.6122, 53.2339],
                            [-9.6249, 53.2403],
                            [-9.6299, 53.2527],
                            [-9.6164, 53.2689],
                            [-9.6056, 53.2727],
                            [-9.5968, 53.2811],
                            [-9.6023, 53.2955],
                            [-9.6131, 53.31],
                            [-9.6239, 53.3207],
                            [-9.6194, 53.3278],
                            [-9.5964, 53.3304],
                            [-9.5814, 53.3296],
                            [-9.5462, 53.3443],
                            [-9.5712, 53.3535],
                            [-9.5871, 53.3558],
                            [-9.5964, 53.3651],
                            [-9.5922, 53.3743],
                            [-9.5813, 53.3747],
                            [-9.5722, 53.379],
                            [-9.5715, 53.3925],
                            [-9.5551, 53.3916],
                            [-9.553, 53.4037],
                            [-9.5937, 53.3816],
                            [-9.604, 53.3845],
                            [-9.6106, 53.3805],
                            [-9.6056, 53.3712],
                            [-9.598, 53.3677],
                            [-9.6049, 53.3499],
                            [-9.5937, 53.3427],
                            [-9.6003, 53.3381],
                            [-9.6257, 53.3318],
                            [-9.6436, 53.3327],
                            [-9.6642, 53.3414],
                            [-9.6473, 53.345],
                            [-9.628, 53.3444],
                            [-9.6258, 53.3504],
                            [-9.6392, 53.3502],
                            [-9.6419, 53.3554],
                            [-9.6256, 53.3637],
                            [-9.6337, 53.3682],
                            [-9.628, 53.3773],
                            [-9.6347, 53.3865],
                            [-9.6545, 53.3923],
                            [-9.6556, 53.3819],
                            [-9.6637, 53.3793],
                            [-9.6629, 53.3723],
                            [-9.6951, 53.3621],
                            [-9.6971, 53.354],
                            [-9.7211, 53.3335],
                            [-9.7198, 53.3293],
                            [-9.7349, 53.3236],
                            [-9.7301, 53.3201],
                            [-9.7323, 53.3098],
                            [-9.7643, 53.306],
                            [-9.7735, 53.2935],
                            [-9.7918, 53.3049],
                            [-9.8117, 53.3106],
                            [-9.8315, 53.3131],
                            [-9.843, 53.3064],
                            [-9.8369, 53.2918],
                            [-9.8502, 53.2929],
                            [-9.8494, 53.3005],
                            [-9.8626, 53.3018],
                            [-9.8666, 53.3081],
                            [-9.8613, 53.3123],
                            [-9.834, 53.315],
                            [-9.8613, 53.3322],
                            [-9.864, 53.3169],
                            [-9.8811, 53.314],
                            [-9.8907, 53.3209],
                            [-9.9042, 53.3256],
                            [-9.8964, 53.3322],
                            [-9.8987, 53.3386],
                            [-9.8858, 53.3506],
                            [-9.8755, 53.3551],
                            [-9.8874, 53.3602],
                            [-9.8916, 53.3672],
                            [-9.8774, 53.372],
                            [-9.8648, 53.3703],
                            [-9.855, 53.3753],
                            [-9.8385, 53.3768],
                            [-9.8338, 53.3819],
                            [-9.8176, 53.3786],
                            [-9.8066, 53.3881],
                            [-9.793, 53.39],
                            [-9.785, 53.3949],
                            [-9.7992, 53.3995],
                            [-9.8035, 53.4056],
                            [-9.8153, 53.4039],
                            [-9.8201, 53.4127],
                            [-9.8051, 53.4151],
                            [-9.8078, 53.42],
                            [-9.8236, 53.4188],
                            [-9.8366, 53.408],
                            [-9.848, 53.4031],
                            [-9.8621, 53.4027],
                            [-9.8609, 53.3915],
                            [-9.8802, 53.396],
                            [-9.8845, 53.4151],
                            [-9.8689, 53.4204],
                            [-9.8634, 53.4188],
                            [-9.8377, 53.4226],
                            [-9.8364, 53.4307],
                            [-9.8558, 53.4304],
                            [-9.8619, 53.4243],
                            [-9.8726, 53.4241],
                            [-9.8874, 53.4176],
                            [-9.8952, 53.4226],
                            [-9.9082, 53.4214],
                            [-9.9188, 53.4085],
                            [-9.9173, 53.3899],
                            [-9.941, 53.3804],
                            [-9.9491, 53.3839],
                            [-9.9632, 53.3815],
                            [-9.9686, 53.3861],
                            [-9.9861, 53.3824],
                            [-10.0029, 53.3854],
                            [-10.0104, 53.3822],
                            [-10.0188, 53.3871],
                            [-10.0303, 53.3869],
                            [-10.0374, 53.3925],
                            [-10.0377, 53.4104],
                            [-10.0547, 53.4165],
                            [-10.0625, 53.4166],
                            [-10.0742, 53.4244],
                            [-10.0788, 53.4157],
                            [-10.0956, 53.4157],
                            [-10.1049, 53.4114],
                            [-10.1162, 53.414],
                            [-10.1274, 53.4085],
                            [-10.1371, 53.4123],
                            [-10.1496, 53.4229],
                            [-10.1576, 53.4186],
                            [-10.1763, 53.4148],
                            [-10.1709, 53.426],
                            [-10.1525, 53.4426],
                            [-10.1401, 53.4449],
                            [-10.1339, 53.4533],
                            [-10.1112, 53.4545],
                            [-10.0982, 53.4517],
                            [-10.0908, 53.4404],
                            [-10.0763, 53.4403],
                            [-10.065, 53.4441],
                            [-10.0629, 53.4532],
                            [-10.0529, 53.459],
                            [-10.0482, 53.4663],
                            [-10.066, 53.4658],
                            [-10.092, 53.47],
                            [-10.0815, 53.4761],
                            [-10.092, 53.4849],
                            [-10.0809, 53.4908],
                            [-10.0541, 53.4801],
                            [-10.0467, 53.4755],
                            [-10.0416, 53.4881],
                            [-10.0525, 53.488],
                            [-10.0619, 53.4933],
                            [-10.0728, 53.4937],
                            [-10.0903, 53.4987],
                            [-10.1073, 53.4979],
                            [-10.1158, 53.5088],
                            [-10.1376, 53.5152],
                            [-10.1205, 53.5211],
                            [-10.0949, 53.5185],
                            [-10.0896, 53.5145],
                            [-10.0741, 53.5114],
                            [-10.0621, 53.5053],
                            [-10.0535, 53.5106],
                            [-10.08, 53.5156],
                            [-10.0981, 53.5211],
                            [-10.1345, 53.5243],
                            [-10.1442, 53.5333],
                            [-10.1456, 53.5437],
                            [-10.1672, 53.5443],
                            [-10.1777, 53.541],
                            [-10.189, 53.5454],
                            [-10.1917, 53.5566],
                            [-10.1651, 53.5633],
                            [-10.1584, 53.5599],
                            [-10.1461, 53.5657],
                            [-10.1345, 53.5594],
                            [-10.1244, 53.5626],
                            [-10.1066, 53.557],
                            [-10.0967, 53.5588],
                            [-10.128, 53.5776],
                            [-10.1019, 53.5783],
                            [-10.0973, 53.5747],
                            [-10.0821, 53.5765],
                            [-10.0612, 53.5712],
                            [-10.046, 53.5731],
                            [-10.0144, 53.5681],
                            [-10.0119, 53.5524],
                            [-9.99, 53.5499],
                            [-9.9753, 53.5577],
                            [-9.9788, 53.5615],
                            [-9.9619, 53.5728],
                            [-10.0025, 53.5749],
                            [-10.0228, 53.5797],
                            [-10.0443, 53.5954],
                            [-10.0488, 53.6114],
                            [-10.0362, 53.6118],
                            [-10.0248, 53.6082],
                            [-10.006, 53.6123],
                            [-9.9923, 53.6117],
                            [-9.9672, 53.6024],
                            [-9.9462, 53.602],
                            [-9.933, 53.5995],
                            [-9.9091, 53.6029],
                            [-9.8988, 53.6157],
                            [-9.8744, 53.6167],
                            [-9.8694, 53.6321],
                            [-9.8905, 53.651],
                            [-9.9102, 53.6545],
                            [-9.9132, 53.6675],
                            [-9.9059, 53.6795],
                            [-9.9179, 53.6912],
                            [-9.9107, 53.7141],
                            [-9.9003, 53.7231],
                            [-9.8939, 53.7403],
                            [-9.8981, 53.7515],
                            [-9.9051, 53.7565],
                            [-9.9002, 53.7669],
                            [-9.8803, 53.7657],
                            [-9.863, 53.7691],
                            [-9.8323, 53.7722],
                            [-9.821, 53.7717],
                            [-9.8026, 53.7793],
                            [-9.7813, 53.7834],
                            [-9.769, 53.7825],
                            [-9.7649, 53.7762],
                            [-9.7382, 53.7748],
                            [-9.7021, 53.7789],
                            [-9.6932, 53.7836],
                            [-9.6607, 53.7895],
                            [-9.6577, 53.7841],
                            [-9.6399, 53.7829],
                            [-9.6403, 53.7887],
                            [-9.6181, 53.7873],
                            [-9.6138, 53.7824],
                            [-9.5925, 53.7836],
                            [-9.5763, 53.7918],
                            [-9.5533, 53.7983],
                            [-9.5451, 53.803],
                            [-9.5498, 53.8077],
                            [-9.5658, 53.8102],
                            [-9.5897, 53.8041],
                            [-9.5944, 53.8127],
                            [-9.6126, 53.8115],
                            [-9.6242, 53.8174],
                            [-9.6267, 53.8242],
                            [-9.6174, 53.8307],
                            [-9.6037, 53.8316],
                            [-9.6037, 53.8366],
                            [-9.6181, 53.842],
                            [-9.6165, 53.8462],
                            [-9.5885, 53.8518],
                            [-9.574, 53.8509],
                            [-9.5648, 53.857],
                            [-9.5755, 53.8601],
                            [-9.5747, 53.8749],
                            [-9.5616, 53.883],
                            [-9.5608, 53.8892],
                            [-9.5674, 53.8936],
                            [-9.5882, 53.8985],
                            [-9.6021, 53.8956],
                            [-9.6041, 53.8898],
                            [-9.6148, 53.8896],
                            [-9.62, 53.8974],
                            [-9.6317, 53.891],
                            [-9.6404, 53.8969],
                            [-9.6536, 53.8932],
                            [-9.6823, 53.8986],
                            [-9.715, 53.9011],
                            [-9.7191, 53.8974],
                            [-9.7443, 53.9034],
                            [-9.7504, 53.8956],
                            [-9.7779, 53.9069],
                            [-9.7856, 53.9042],
                            [-9.8124, 53.8815],
                            [-9.8653, 53.8686],
                            [-9.8805, 53.8668],
                            [-9.897, 53.8682],
                            [-9.9062, 53.8656],
                            [-9.9159, 53.8714],
                            [-9.9373, 53.8742],
                            [-9.9316, 53.8865],
                            [-9.923, 53.8949],
                            [-9.9277, 53.8993],
                            [-9.9292, 53.9152],
                            [-9.9132, 53.9211],
                            [-9.9132, 53.9253],
                            [-9.8997, 53.9362],
                            [-9.9158, 53.9383],
                            [-9.9052, 53.9474],
                            [-9.9044, 53.9538],
                            [-9.8948, 53.9573],
                            [-9.8857, 53.9555],
                            [-9.8699, 53.9605],
                            [-9.8336, 53.9602],
                            [-9.8336, 53.9556],
                            [-9.8151, 53.9479],
                            [-9.8017, 53.9525],
                            [-9.7984, 53.9466],
                            [-9.8004, 53.9338],
                            [-9.8096, 53.9262],
                            [-9.8043, 53.915],
                            [-9.7976, 53.9146],
                            [-9.7928, 53.931],
                            [-9.7943, 53.9575],
                            [-9.8074, 53.9677],
                            [-9.8253, 53.9664],
                            [-9.8306, 53.9709],
                            [-9.8414, 53.9649],
                            [-9.8515, 53.9694],
                            [-9.8475, 53.9762],
                            [-9.847, 53.997],
                            [-9.8561, 54.0036],
                            [-9.8772, 54.0096],
                            [-9.8822, 54.0153],
                            [-9.8726, 54.0205],
                            [-9.8966, 54.0302],
                            [-9.9051, 54.0392],
                            [-9.9058, 54.0494],
                            [-9.8903, 54.055],
                            [-9.8901, 54.0669],
                            [-9.8944, 54.0743],
                            [-9.9099, 54.0696],
                            [-9.9224, 54.0687],
                            [-9.9345, 54.0645],
                            [-9.9477, 54.0694],
                            [-9.9666, 54.0641],
                            [-9.9631, 54.0743],
                            [-9.9658, 54.0851],
                            [-9.9758, 54.0984],
                            [-9.988, 54.1024],
                            [-9.9828, 54.109],
                            [-9.972, 54.1075],
                            [-9.9642, 54.1111],
                            [-9.9531, 54.1098],
                            [-9.927, 54.1191],
                            [-9.9103, 54.1195],
                            [-9.8987, 54.1224],
                            [-9.9109, 54.129],
                            [-9.9146, 54.1351],
                            [-9.926, 54.1377],
                            [-9.9305, 54.129],
                            [-9.9445, 54.141],
                            [-9.9578, 54.1453],
                            [-9.9559, 54.1559],
                            [-9.9429, 54.1543],
                            [-9.9318, 54.1494],
                            [-9.9212, 54.1561],
                            [-9.9391, 54.1586],
                            [-9.9534, 54.1744],
                            [-9.9345, 54.1824],
                            [-9.9372, 54.1895],
                            [-9.9317, 54.1969],
                            [-9.9602, 54.2037],
                            [-9.9856, 54.2159],
                            [-9.9859, 54.2263],
                            [-9.9653, 54.2187],
                            [-9.9462, 54.2147],
                            [-9.9143, 54.2143],
                            [-9.8781, 54.2189],
                            [-9.8755, 54.2277],
                            [-9.8917, 54.2321],
                            [-9.8655, 54.237],
                            [-9.8787, 54.2466],
                            [-9.8716, 54.2529],
                            [-9.8716, 54.2666],
                            [-9.8674, 54.2748],
                            [-9.8394, 54.2825],
                            [-9.8173, 54.286],
                            [-9.8073, 54.2896],
                            [-9.8034, 54.2953],
                            [-9.7941, 54.2964],
                            [-9.7812, 54.2865],
                            [-9.7741, 54.2887],
                            [-9.7899, 54.2998],
                            [-9.8034, 54.2993],
                            [-9.8128, 54.2936],
                            [-9.853, 54.3097],
                            [-9.8581, 54.3196],
                            [-9.8322, 54.3271],
                            [-9.8055, 54.3425],
                            [-9.7785, 54.3438],
                            [-9.7699, 54.3362],
                            [-9.7611, 54.3384],
                            [-9.7505, 54.3356],
                            [-9.7389, 54.3283],
                            [-9.6961, 54.3231],
                            [-9.679, 54.3186],
                            [-9.6705, 54.3226],
                            [-9.6601, 54.3153],
                            [-9.6156, 54.3274],
                            [-9.6109, 54.3236],
                            [-9.5984, 54.326],
                            [-9.5795, 54.3218],
                            [-9.5643, 54.3233],
                            [-9.5605, 54.3148],
                            [-9.5457, 54.3182],
                            [-9.5173, 54.3114],
                            [-9.5064, 54.3139],
                            [-9.5029, 54.3195],
                            [-9.4793, 54.3184],
                            [-9.4626, 54.3122],
                            [-9.4353, 54.3117],
                            [-9.4221, 54.3136],
                            [-9.3886, 54.3095],
                            [-9.3841, 54.2981],
                            [-9.3758, 54.2989],
                            [-9.3725, 54.3063],
                            [-9.36, 54.3151],
                            [-9.334, 54.3237],
                            [-9.3216, 54.3194],
                            [-9.3024, 54.3177],
                            [-9.2936, 54.3145],
                            [-9.2693, 54.313],
                            [-9.2524, 54.3055],
                            [-9.2474, 54.2989],
                            [-9.254, 54.2823],
                            [-9.2526, 54.2736],
                            [-9.2436, 54.2736],
                            [-9.2435, 54.2812],
                            [-9.2284, 54.2812],
                            [-9.22, 54.2881],
                            [-9.2121, 54.2881],
                            [-9.2064, 54.2778],
                            [-9.2161, 54.2625],
                            [-9.2147, 54.254],
                            [-9.2205, 54.2481],
                            [-9.2379, 54.239],
                            [-9.2339, 54.2339],
                            [-9.2152, 54.2471],
                            [-9.1951, 54.2485],
                            [-9.1926, 54.2418],
                            [-9.2018, 54.2287],
                            [-9.2234, 54.2191],
                            [-9.2186, 54.215],
                            [-9.1926, 54.2092],
                            [-9.1824, 54.2099],
                            [-9.1748, 54.2039],
                            [-9.16, 54.2026],
                            [-9.1577, 54.1978],
                            [-9.1658, 54.1926],
                            [-9.1444, 54.1853],
                            [-9.146, 54.1788],
                            [-9.1407, 54.1701],
                            [-9.1452, 54.1599],
                            [-9.1371, 54.1519],
                            [-9.1323, 54.1748],
                            [-9.1242, 54.1925],
                            [-9.1271, 54.1977],
                            [-9.1167, 54.2041],
                            [-9.1231, 54.2111],
                            [-9.1004, 54.213],
                            [-9.0944, 54.2173],
                            [-9.0971, 54.2267],
                            [-9.0788, 54.2445],
                            [-9.066, 54.2614],
                            [-9.0648, 54.2687],
                            [-9.0551, 54.2748],
                            [-9.0599, 54.2803],
                            [-9.0535, 54.2866],
                            [-9.0526, 54.2959],
                            [-9.036, 54.295],
                            [-9.0228, 54.2975],
                            [-8.9985, 54.293],
                            [-8.9887, 54.296],
                            [-8.9725, 54.2928],
                            [-8.9613, 54.295],
                            [-8.9411, 54.2948],
                            [-8.9083, 54.2867],
                            [-8.8904, 54.2736],
                            [-8.8737, 54.2712],
                            [-8.8626, 54.2636],
                            [-8.8241, 54.2543],
                            [-8.7934, 54.2624],
                            [-8.7809, 54.2738],
                            [-8.7614, 54.2811],
                            [-8.7556, 54.2728],
                            [-8.7274, 54.2649],
                            [-8.7021, 54.2687],
                            [-8.6849, 54.2745],
                            [-8.6647, 54.2741],
                            [-8.653, 54.2704],
                            [-8.638, 54.2552],
                            [-8.6248, 54.2388],
                            [-8.6051, 54.2324],
                            [-8.6034, 54.2259],
                            [-8.5923, 54.2253],
                            [-8.5849, 54.2114],
                            [-8.5734, 54.21],
                            [-8.5711, 54.219],
                            [-8.56, 54.2175],
                            [-8.5432, 54.2191],
                            [-8.5333, 54.2167],
                            [-8.5113, 54.2166],
                            [-8.5047, 54.2195],
                            [-8.5437, 54.2265],
                            [-8.5433, 54.231],
                            [-8.56, 54.2315],
                            [-8.5703, 54.2348],
                            [-8.5702, 54.2421],
                            [-8.5862, 54.2531],
                            [-8.5963, 54.256],
                            [-8.6021, 54.2624],
                            [-8.619, 54.265],
                            [-8.6053, 54.2774],
                            [-8.6079, 54.2837],
                            [-8.5879, 54.2855],
                            [-8.5833, 54.2787],
                            [-8.5664, 54.2774],
                            [-8.5437, 54.2824],
                            [-8.515, 54.2795],
                            [-8.5039, 54.285],
                            [-8.4928, 54.2822],
                            [-8.477, 54.2844],
                            [-8.5024, 54.2977],
                            [-8.5221, 54.3042],
                            [-8.5337, 54.3034],
                            [-8.5503, 54.3067],
                            [-8.5598, 54.3054],
                            [-8.5692, 54.3098],
                            [-8.5706, 54.3305],
                            [-8.5535, 54.3222],
                            [-8.5286, 54.3166],
                            [-8.5105, 54.3162],
                            [-8.5018, 54.3245],
                            [-8.5131, 54.3299],
                            [-8.5329, 54.3338],
                            [-8.5543, 54.343],
                            [-8.5727, 54.345],
                            [-8.5968, 54.3437],
                            [-8.6126, 54.3399],
                            [-8.6179, 54.336],
                            [-8.6296, 54.3371],
                            [-8.6479, 54.3313],
                            [-8.6546, 54.3439],
                            [-8.6713, 54.3479],
                            [-8.6723, 54.3626],
                            [-8.6422, 54.3721],
                            [-8.6236, 54.3704],
                            [-8.6155, 54.3814],
                            [-8.5924, 54.3864],
                            [-8.5793, 54.3925],
                            [-8.5686, 54.3937],
                            [-8.5719, 54.4023],
                            [-8.5672, 54.4119],
                            [-8.5582, 54.4061],
                            [-8.5613, 54.4008],
                            [-8.5472, 54.3957],
                            [-8.5274, 54.4049],
                            [-8.513, 54.4147],
                            [-8.4891, 54.42],
                            [-8.4869, 54.4286],
                            [-8.4673, 54.4406],
                            [-8.4686, 54.4495],
                            [-8.4745, 54.4534],
                            [-8.4739, 54.4608],
                            [-8.4648, 54.4633],
                            [-8.4666, 54.4718],
                            [-8.4544, 54.4749],
                            [-8.446, 54.4701],
                            [-8.4504, 54.4641],
                            [-8.4391, 54.4558],
                            [-8.4158, 54.458],
                            [-8.3972, 54.4651],
                            [-8.3668, 54.4689],
                            [-8.3569, 54.4687],
                            [-8.3447, 54.4729],
                            [-8.3334, 54.4718],
                            [-8.3105, 54.4799],
                            [-8.2862, 54.4781],
                            [-8.2772, 54.4845],
                            [-8.2823, 54.4885],
                            [-8.2652, 54.4919],
                            [-8.2652, 54.4989],
                            [-8.2551, 54.5133],
                            [-8.268, 54.5238],
                            [-8.265, 54.5292],
                            [-8.2524, 54.5313],
                            [-8.21, 54.5526],
                            [-8.2219, 54.5719],
                            [-8.2099, 54.5731],
                            [-8.1986, 54.5785],
                            [-8.1916, 54.5858],
                            [-8.1788, 54.5873],
                            [-8.1661, 54.5969],
                            [-8.164, 54.6044],
                            [-8.1688, 54.6211],
                            [-8.1567, 54.6271],
                            [-8.1553, 54.6143],
                            [-8.1465, 54.6115],
                            [-8.1521, 54.6042],
                            [-8.1365, 54.6047],
                            [-8.1365, 54.6152],
                            [-8.1323, 54.6247],
                            [-8.1231, 54.6308],
                            [-8.1224, 54.6463],
                            [-8.1166, 54.6531],
                            [-8.1311, 54.6535],
                            [-8.1349, 54.6448],
                            [-8.1518, 54.6365],
                            [-8.1736, 54.637],
                            [-8.1857, 54.6421],
                            [-8.2069, 54.6311],
                            [-8.2297, 54.6251],
                            [-8.2341, 54.6197],
                            [-8.2478, 54.6184],
                            [-8.2731, 54.6076],
                            [-8.2909, 54.6053],
                            [-8.3001, 54.6102],
                            [-8.289, 54.6203],
                            [-8.2823, 54.631],
                            [-8.2719, 54.637],
                            [-8.2848, 54.6486],
                            [-8.3044, 54.6397],
                            [-8.3278, 54.6336],
                            [-8.3412, 54.6318],
                            [-8.3514, 54.6167],
                            [-8.3754, 54.6061],
                            [-8.3905, 54.5955],
                            [-8.4283, 54.5884],
                            [-8.4394, 54.5823],
                            [-8.4383, 54.5759],
                            [-8.4525, 54.5699],
                            [-8.4535, 54.5777],
                            [-8.4437, 54.5828],
                            [-8.4469, 54.5889],
                            [-8.4152, 54.5948],
                            [-8.3968, 54.5995],
                            [-8.3942, 54.6041],
                            [-8.3762, 54.614],
                            [-8.3781, 54.6252],
                            [-8.3967, 54.6355],
                            [-8.4148, 54.6272],
                            [-8.4208, 54.6194],
                            [-8.4342, 54.6208],
                            [-8.4293, 54.6348],
                            [-8.4206, 54.6455],
                            [-8.4277, 54.6483],
                            [-8.4346, 54.6402],
                            [-8.4444, 54.6362],
                            [-8.4411, 54.6276],
                            [-8.4469, 54.6207],
                            [-8.4573, 54.6155],
                            [-8.4639, 54.6068],
                            [-8.4826, 54.6062],
                            [-8.4786, 54.6158],
                            [-8.4857, 54.6211],
                            [-8.4752, 54.6268],
                            [-8.4793, 54.6348],
                            [-8.4861, 54.6362],
                            [-8.506, 54.6288],
                            [-8.5423, 54.619],
                            [-8.5577, 54.6198],
                            [-8.5631, 54.6158],
                            [-8.6127, 54.6199],
                            [-8.6272, 54.6315],
                            [-8.6335, 54.6236],
                            [-8.6779, 54.6204],
                            [-8.6839, 54.6362],
                            [-8.6914, 54.6437],
                            [-8.7239, 54.6479],
                            [-8.7468, 54.6552],
                            [-8.7717, 54.6581],
                            [-8.772, 54.6662],
                            [-8.7907, 54.6616],
                            [-8.7926, 54.6696],
                            [-8.7829, 54.6809],
                            [-8.7899, 54.69],
                            [-8.7999, 54.6945],
                            [-8.8043, 54.7016],
                            [-8.7941, 54.7081],
                            [-8.7765, 54.7037],
                            [-8.7555, 54.7115],
                            [-8.7439, 54.709],
                            [-8.7496, 54.7207],
                            [-8.7479, 54.7296],
                            [-8.7348, 54.7394],
                            [-8.7248, 54.7438],
                            [-8.7094, 54.7465],
                            [-8.7017, 54.7548],
                            [-8.6874, 54.7599],
                            [-8.6714, 54.7618],
                            [-8.6656, 54.7718],
                            [-8.6539, 54.7702],
                            [-8.6365, 54.7725],
                            [-8.6165, 54.7781],
                            [-8.5923, 54.7799],
                            [-8.5706, 54.7748],
                            [-8.5489, 54.7723],
                            [-8.5335, 54.7666],
                            [-8.5124, 54.7718],
                            [-8.5093, 54.7651],
                            [-8.4751, 54.7607],
                            [-8.468, 54.7681],
                            [-8.4848, 54.7736],
                            [-8.4999, 54.7761],
                            [-8.5144, 54.7739],
                            [-8.545, 54.7846],
                            [-8.5443, 54.7912],
                            [-8.5313, 54.7922],
                            [-8.5175, 54.7868],
                            [-8.5002, 54.7911],
                            [-8.4693, 54.7901],
                            [-8.4699, 54.7834],
                            [-8.4584, 54.7817],
                            [-8.455, 54.7735],
                            [-8.4476, 54.7732],
                            [-8.4276, 54.7641],
                            [-8.4232, 54.7707],
                            [-8.4454, 54.7914],
                            [-8.4613, 54.8009],
                            [-8.4911, 54.8004],
                            [-8.4966, 54.8101],
                            [-8.5121, 54.8144],
                            [-8.527, 54.815],
                            [-8.5233, 54.8253],
                            [-8.5419, 54.8244],
                            [-8.5478, 54.8274],
                            [-8.5634, 54.8277],
                            [-8.5532, 54.8351],
                            [-8.54, 54.8365],
                            [-8.5093, 54.8322],
                            [-8.5092, 54.8392],
                            [-8.5012, 54.8457],
                            [-8.4865, 54.85],
                            [-8.474, 54.8484],
                            [-8.4641, 54.8429],
                            [-8.4463, 54.8415],
                            [-8.4229, 54.8506],
                            [-8.3982, 54.8469],
                            [-8.3829, 54.8427],
                            [-8.3787, 54.8531],
                            [-8.384, 54.8596],
                            [-8.3838, 54.8813],
                            [-8.3698, 54.8778],
                            [-8.3603, 54.8839],
                            [-8.3502, 54.885],
                            [-8.3272, 54.8783],
                            [-8.3259, 54.8893],
                            [-8.3411, 54.8935],
                            [-8.3388, 54.9053],
                            [-8.3524, 54.9055],
                            [-8.3764, 54.9004],
                            [-8.3733, 54.8905],
                            [-8.3775, 54.8863],
                            [-8.3981, 54.8954],
                            [-8.432, 54.9053],
                            [-8.4414, 54.9064],
                            [-8.4553, 54.9141],
                            [-8.4545, 54.9243],
                            [-8.4461, 54.9264],
                            [-8.4434, 54.9338],
                            [-8.4563, 54.938],
                            [-8.4505, 54.947],
                            [-8.4227, 54.9375],
                            [-8.4073, 54.9379],
                            [-8.398, 54.9427],
                            [-8.3746, 54.9439],
                            [-8.3768, 54.9536],
                            [-8.4116, 54.9606],
                            [-8.424, 54.9733],
                            [-8.4393, 54.9807],
                            [-8.4395, 54.99],
                            [-8.4527, 54.9995],
                            [-8.4496, 55.007],
                            [-8.4157, 55.0102],
                            [-8.4067, 55.0023],
                            [-8.3994, 55.0048],
                            [-8.4068, 55.0139],
                            [-8.4066, 55.0193],
                            [-8.395, 55.023],
                            [-8.4015, 55.0326],
                            [-8.3993, 55.0416],
                            [-8.3907, 55.0429],
                            [-8.3803, 55.0339],
                            [-8.3689, 55.0417],
                            [-8.3504, 55.0403],
                            [-8.343, 55.0466],
                            [-8.3457, 55.0518],
                            [-8.3411, 55.0653],
                            [-8.329, 55.0674],
                            [-8.32, 55.0799],
                            [-8.3258, 55.0902],
                            [-8.3163, 55.0919],
                            [-8.3135, 55.0999],
                            [-8.3164, 55.113],
                            [-8.3026, 55.1262],
                            [-8.2959, 55.1266],
                            [-8.2951, 55.1373],
                            [-8.2889, 55.1461],
                            [-8.2959, 55.1514],
                            [-8.2847, 55.1596],
                            [-8.2745, 55.1553],
                            [-8.2315, 55.1499],
                            [-8.2195, 55.1533],
                            [-8.2122, 55.1472],
                            [-8.1947, 55.149],
                            [-8.1719, 55.1461],
                            [-8.1577, 55.1477],
                            [-8.1502, 55.1549],
                            [-8.1501, 55.1615],
                            [-8.1342, 55.1637],
                            [-8.1293, 55.1584],
                            [-8.144, 55.1489],
                            [-8.1655, 55.1428],
                            [-8.1562, 55.1395],
                            [-8.1634, 55.1284],
                            [-8.1535, 55.1248],
                            [-8.1486, 55.1309],
                            [-8.1345, 55.1281],
                            [-8.1365, 55.1418],
                            [-8.1222, 55.1376],
                            [-8.1234, 55.1584],
                            [-8.1144, 55.1604],
                            [-8.0692, 55.1636],
                            [-8.0517, 55.1745],
                            [-8.0408, 55.1762],
                            [-8.0347, 55.1719],
                            [-8.0236, 55.1751],
                            [-8.015, 55.1855],
                            [-8.0246, 55.1901],
                            [-8.0135, 55.1976],
                            [-8.0243, 55.1994],
                            [-8.0148, 55.2159],
                            [-8.0008, 55.2156],
                            [-7.9822, 55.2262],
                            [-7.9651, 55.2131],
                            [-7.956, 55.215],
                            [-7.9401, 55.2136],
                            [-7.9376, 55.2045],
                            [-7.9418, 55.198],
                            [-7.9577, 55.1914],
                            [-7.9726, 55.1918],
                            [-7.9808, 55.184],
                            [-7.96, 55.1854],
                            [-7.9546, 55.1892],
                            [-7.9434, 55.1817],
                            [-7.9138, 55.1863],
                            [-7.8989, 55.1901],
                            [-7.8937, 55.184],
                            [-7.8956, 55.1744],
                            [-7.8852, 55.1709],
                            [-7.8905, 55.1618],
                            [-7.8606, 55.1682],
                            [-7.8538, 55.1641],
                            [-7.8624, 55.1574],
                            [-7.8646, 55.1506],
                            [-7.8784, 55.1506],
                            [-7.8907, 55.1472],
                            [-7.8891, 55.1402],
                            [-7.867, 55.1402],
                            [-7.8559, 55.1427],
                            [-7.8372, 55.1508],
                            [-7.8471, 55.1555],
                            [-7.8363, 55.1603],
                            [-7.8257, 55.1695],
                            [-7.8233, 55.1794],
                            [-7.8371, 55.1954],
                            [-7.8601, 55.1948],
                            [-7.8715, 55.2022],
                            [-7.8701, 55.2146],
                            [-7.8648, 55.2277],
                            [-7.8556, 55.2268],
                            [-7.8382, 55.2316],
                            [-7.8265, 55.2253],
                            [-7.8165, 55.2265],
                            [-7.819, 55.2395],
                            [-7.8059, 55.2388],
                            [-7.8076, 55.2466],
                            [-7.7887, 55.2477],
                            [-7.7882, 55.2328],
                            [-7.7945, 55.225],
                            [-7.8044, 55.2194],
                            [-7.8068, 55.2054],
                            [-7.8111, 55.1982],
                            [-7.7953, 55.1834],
                            [-7.7849, 55.1855],
                            [-7.7673, 55.1839],
                            [-7.7544, 55.1863],
                            [-7.7545, 55.1779],
                            [-7.7456, 55.1751],
                            [-7.74, 55.1821],
                            [-7.7305, 55.1702],
                            [-7.7098, 55.1673],
                            [-7.706, 55.1579],
                            [-7.6938, 55.1525],
                            [-7.6941, 55.1391],
                            [-7.702, 55.1211],
                            [-7.7044, 55.1094],
                            [-7.6927, 55.106],
                            [-7.6874, 55.1186],
                            [-7.6686, 55.1429],
                            [-7.6647, 55.1598],
                            [-7.6783, 55.1661],
                            [-7.6808, 55.182],
                            [-7.6917, 55.1877],
                            [-7.7086, 55.1918],
                            [-7.71, 55.2034],
                            [-7.696, 55.2037],
                            [-7.7053, 55.23],
                            [-7.7176, 55.2257],
                            [-7.7213, 55.2192],
                            [-7.7202, 55.1996],
                            [-7.7154, 55.1902],
                            [-7.7032, 55.1831],
                            [-7.7107, 55.1771],
                            [-7.7273, 55.1806],
                            [-7.7432, 55.1873],
                            [-7.7326, 55.194],
                            [-7.7455, 55.1992],
                            [-7.7615, 55.1917],
                            [-7.7714, 55.193],
                            [-7.782, 55.2062],
                            [-7.7941, 55.207],
                            [-7.7979, 55.2159],
                            [-7.7936, 55.2214],
                            [-7.7774, 55.2259],
                            [-7.7573, 55.2353],
                            [-7.7583, 55.2422],
                            [-7.7491, 55.2537],
                            [-7.7246, 55.2477],
                            [-7.7001, 55.2487],
                            [-7.6898, 55.2556],
                            [-7.6923, 55.2632],
                            [-7.6724, 55.2657],
                            [-7.6561, 55.277],
                            [-7.647, 55.2777],
                            [-7.6276, 55.2696],
                            [-7.6246, 55.2599],
                            [-7.6172, 55.256],
                            [-7.6132, 55.2397],
                            [-7.6034, 55.2336],
                            [-7.6083, 55.2181],
                            [-7.6252, 55.2044],
                            [-7.6123, 55.1922],
                            [-7.6028, 55.1877],
                            [-7.5922, 55.1893],
                            [-7.5717, 55.1807],
                            [-7.5717, 55.1671],
                            [-7.5453, 55.151],
                            [-7.5404, 55.1433],
                            [-7.5326, 55.1438],
                            [-7.5198, 55.1324],
                            [-7.5179, 55.1236],
                            [-7.5312, 55.1117],
                            [-7.5253, 55.1052],
                            [-7.5342, 55.0946],
                            [-7.5493, 55.0926],
                            [-7.5584, 55.0878],
                            [-7.5832, 55.0822],
                            [-7.5979, 55.0699],
                            [-7.596, 55.0625],
                            [-7.611, 55.0574],
                            [-7.6248, 55.0566],
                            [-7.6324, 55.0488],
                            [-7.6079, 55.0446],
                            [-7.586, 55.0503],
                            [-7.5769, 55.0555],
                            [-7.5669, 55.054],
                            [-7.5603, 55.0476],
                            [-7.5594, 55.0348],
                            [-7.5785, 55.0251],
                            [-7.5818, 55.02],
                            [-7.5952, 55.0131],
                            [-7.6384, 54.9972],
                            [-7.6365, 54.9923],
                            [-7.655, 54.9771],
                            [-7.6582, 54.9699],
                            [-7.6544, 54.9621],
                            [-7.6408, 54.9642],
                            [-7.6343, 54.9721],
                            [-7.622, 54.9648],
                            [-7.6075, 54.9782],
                            [-7.5945, 54.9952],
                            [-7.5828, 54.9981],
                            [-7.5686, 55.0088],
                            [-7.5548, 55.0134],
                            [-7.5377, 55.0252],
                            [-7.5262, 55.0211],
                            [-7.5148, 55.0256],
                            [-7.5175, 55.0299],
                            [-7.5109, 55.0419],
                            [-7.4933, 55.0414],
                            [-7.481, 55.0462],
                            [-7.4722, 55.0438],
                            [-7.4498, 55.0468],
                            [-7.4482, 55.056],
                            [-7.4563, 55.0785],
                            [-7.4782, 55.0921],
                            [-7.4768, 55.1036],
                            [-7.4709, 55.1112],
                            [-7.4608, 55.1157],
                            [-7.4557, 55.1227],
                            [-7.4614, 55.1301],
                            [-7.4628, 55.1393],
                            [-7.4717, 55.1409],
                            [-7.4879, 55.16],
                            [-7.5013, 55.1637],
                            [-7.5018, 55.1692],
                            [-7.512, 55.177],
                            [-7.5137, 55.1835],
                            [-7.5369, 55.1948],
                            [-7.5513, 55.1958],
                            [-7.5514, 55.2005],
                            [-7.5386, 55.2041],
                            [-7.5458, 55.2107],
                            [-7.5448, 55.2177],
                            [-7.5362, 55.2296],
                            [-7.5276, 55.2317],
                            [-7.5183, 55.2394],
                            [-7.5216, 55.2448],
                            [-7.5332, 55.2492],
                            [-7.5124, 55.2577],
                            [-7.5082, 55.2712],
                            [-7.52, 55.2757],
                            [-7.5248, 55.2815],
                            [-7.5195, 55.287],
                            [-7.5024, 55.2909],
                            [-7.479, 55.283],
                            [-7.4628, 55.2857],
                            [-7.4692, 55.2936],
                            [-7.4633, 55.2968],
                            [-7.4485, 55.291],
                            [-7.4485, 55.2837],
                            [-7.4342, 55.2804],
                            [-7.4315, 55.2882],
                            [-7.4159, 55.2927],
                            [-7.3815, 55.2928],
                            [-7.3727, 55.308],
                            [-7.3731, 55.3158],
                            [-7.3616, 55.3184],
                            [-7.3344, 55.3132],
                            [-7.3317, 55.3088],
                            [-7.308, 55.2989],
                            [-7.3044, 55.292],
                            [-7.3122, 55.2897],
                            [-7.3323, 55.292],
                            [-7.3343, 55.2872],
                            [-7.3084, 55.2846],
                            [-7.2965, 55.278],
                            [-7.2805, 55.2765],
                            [-7.27, 55.2826],
                            [-7.251, 55.279],
                            [-7.2569, 55.2874],
                            [-7.269, 55.2932],
                            [-7.2839, 55.2962],
                            [-7.2917, 55.3012],
                            [-7.3163, 55.3112],
                            [-7.3272, 55.3117],
                            [-7.3329, 55.3253],
                            [-7.3523, 55.3338],
                            [-7.3487, 55.3421],
                            [-7.3477, 55.3599],
                            [-7.3719, 55.3616],
                            [-7.3853, 55.3676],
                            [-7.3906, 55.3765],
                            [-7.3838, 55.3815],
                            [-7.3696, 55.3839],
                            [-7.3647, 55.38],
                            [-7.3375, 55.3746],
                            [-7.3336, 55.3684],
                            [-7.3118, 55.3696],
                            [-7.2787, 55.367],
                            [-7.2709, 55.3611],
                            [-7.2564, 55.3587],
                            [-7.2437, 55.3601],
                            [-7.2399, 55.3549],
                            [-7.2234, 55.3506],
                            [-7.1937, 55.3474],
                            [-7.1794, 55.3417],
                            [-7.1692, 55.3293],
                            [-7.1755, 55.3207],
                            [-7.1565, 55.3109],
                            [-7.1553, 55.2969],
                            [-7.1335, 55.2921],
                            [-7.1252, 55.2955],
                            [-7.117, 55.2895],
                            [-7.0936, 55.2861],
                            [-7.0752, 55.2752],
                            [-7.0598, 55.2725],
                            [-7.0448, 55.276],
                            [-7.0356, 55.2695],
                            [-7.0097, 55.2661],
                            [-7.0104, 55.2588],
                            [-6.9942, 55.2552],
                            [-6.9768, 55.258],
                            [-6.9518, 55.2538],
                            [-6.9372, 55.2471],
                            [-6.9336, 55.2417],
                            [-6.922, 55.2367],
                            [-6.9236, 55.2268],
                            [-6.9523, 55.211],
                            [-7.0026, 55.1974],
                            [-7.0209, 55.19],
                            [-7.0474, 55.1866],
                            [-7.0558, 55.1813],
                            [-7.1023, 55.1672],
                            [-7.1185, 55.1593],
                            [-7.1349, 55.1572],
                            [-7.1584, 55.1486],
                            [-7.1852, 55.1322],
                            [-7.1876, 55.1263],
                            [-7.2062, 55.1144],
                            [-7.2105, 55.1046],
                            [-7.2244, 55.0961],
                            [-7.2457, 55.0799],
                            [-7.2601, 55.0663]
                        ]
                    ]
                ]
            },
            'properties': {
                'name': 'Ireland',
                'id': 'IE',
                'TYPE': 'Ireland',
                'CNTRY': 'Ireland'
            },
            'id': 'IE'
        },
        {
            'type': 'Feature',
            'geometry': {
                'type': 'MultiPolygon',
                'coordinates': [
                    [
                        [
                            [
                                -2.0269775390625,
                                55.80282469789477
                            ],
                            [
                                -2.0819091796875,
                                55.79356141947292
                            ],
                            [
                                -2.08740234375,
                                55.75880449639896
                            ],
                            [
                                -2.113494873046875,
                                55.74489304677828
                            ],
                            [
                                -2.142333984375,
                                55.735615990618776
                            ],
                            [
                                -2.173919677734375,
                                55.72246971901109
                            ],
                            [
                                -2.1752929687499996,
                                55.70854531198258
                            ],
                            [
                                -2.18902587890625,
                                55.696937847461236
                            ],
                            [
                                -2.2137451171875,
                                55.67526135500508
                            ],
                            [
                                -2.228851318359375,
                                55.6551224230224
                            ],
                            [
                                -2.256317138671875,
                                55.650473505359464
                            ],
                            [
                                -2.313995361328125,
                                55.642724082556086
                            ],
                            [
                                -2.327728271484375,
                                55.640398956687356
                            ],
                            [
                                -2.3291015625,
                                55.627220636248104
                            ],
                            [
                                -2.31536865234375,
                                55.62179298063115
                            ],
                            [
                                -2.305755615234375,
                                55.61714010614988
                            ],
                            [
                                -2.29888916015625,
                                55.611711054594984
                            ],
                            [
                                -2.30438232421875,
                                55.603953962610454
                            ],
                            [
                                -2.289276123046875,
                                55.597747184319935
                            ],
                            [
                                -2.272796630859375,
                                55.579897226135714
                            ],
                            [
                                -2.264556884765625,
                                55.5581558834549
                            ],
                            [
                                -2.2508239746093746,
                                55.54417295022067
                            ],
                            [
                                -2.230224609375,
                                55.52707594193452
                            ],
                            [
                                -2.2137451171875,
                                55.506860802459855
                            ],
                            [
                                -2.21649169921875,
                                55.49363759615692
                            ],
                            [
                                -2.201385498046875,
                                55.48118816890478
                            ],
                            [
                                -2.186279296875,
                                55.4679563415489
                            ],
                            [
                                -2.184906005859375,
                                55.45394132943307
                            ],
                            [
                                -2.21649169921875,
                                55.42433772238543
                            ],
                            [
                                -2.274169921875,
                                55.4204408577456
                            ],
                            [
                                -2.292022705078125,
                                55.40329008489734
                            ],
                            [
                                -2.330474853515625,
                                55.39939114358243
                            ],
                            [
                                -2.35382080078125,
                                55.362722291635684
                            ],
                            [
                                -2.379913330078125,
                                55.34398465787114
                            ],
                            [
                                -2.393646240234375,
                                55.35569671810525
                            ],
                            [
                                -2.399139404296875,
                                55.362722291635684
                            ],
                            [
                                -2.42523193359375,
                                55.36818576460152
                            ],
                            [
                                -2.459564208984375,
                                55.363502833950776
                            ],
                            [
                                -2.48016357421875,
                                55.35101230968552
                            ],
                            [
                                -2.4993896484375,
                                55.344765569657014
                            ],
                            [
                                -2.515869140625,
                                55.331487975251925
                            ],
                            [
                                -2.533721923828125,
                                55.31898735045462
                            ],
                            [
                                -2.55157470703125,
                                55.31586157821399
                            ],
                            [
                                -2.559814453125,
                                55.30570111642547
                            ],
                            [
                                -2.566680908203125,
                                55.2963199179754
                            ],
                            [
                                -2.62847900390625,
                                55.268163010533115
                            ],
                            [
                                -2.6312255859375,
                                55.2525116539652
                            ],
                            [
                                -2.6202392578125,
                                55.24390077966148
                            ],
                            [
                                -2.621612548828125,
                                55.22589019607769
                            ],
                            [
                                -2.629852294921875,
                                55.22040709505979
                            ],
                            [
                                -2.66143798828125,
                                55.21492323838662
                            ],
                            [
                                -2.682037353515625,
                                55.19768334019969
                            ],
                            [
                                -2.68341064453125,
                                55.1906285027331
                            ],
                            [
                                -2.69439697265625,
                                55.18357241563886
                            ],
                            [
                                -2.72735595703125,
                                55.16945649211022
                            ],
                            [
                                -2.739715576171875,
                                55.156904807126104
                            ],
                            [
                                -2.769927978515625,
                                55.148273231753834
                            ],
                            [
                                -2.797393798828125,
                                55.14199454927118
                            ],
                            [
                                -2.8179931640624996,
                                55.13728488905076
                            ],
                            [
                                -2.827606201171875,
                                55.12393783348962
                            ],
                            [
                                -2.83721923828125,
                                55.11451369585085
                            ],
                            [
                                -2.86468505859375,
                                55.10430170396557
                            ],
                            [
                                -2.88116455078125,
                                55.091729515360875
                            ],
                            [
                                -2.879791259765625,
                                55.081511700352344
                            ],
                            [
                                -2.929229736328125,
                                55.071291274425384
                            ],
                            [
                                -2.948455810546875,
                                55.040614327716746
                            ],
                            [
                                -2.98004150390625,
                                55.038253588892545
                            ],
                            [
                                -3.01025390625,
                                55.05005589189804
                            ],
                            [
                                -3.033599853515625,
                                55.05241593518546
                            ],
                            [
                                -3.028106689453125,
                                55.03510572071745
                            ],
                            [
                                -3.033599853515625,
                                55.013851140701505
                            ],
                            [
                                -3.050079345703125,
                                54.9878580124252
                            ],
                            [
                                -3.06793212890625,
                                54.968155034807836
                            ],
                            [
                                -3.0899047851562496,
                                54.953962903574094
                            ],
                            [
                                -3.08441162109375,
                                54.94765368041606
                            ],
                            [
                                -3.069305419921875,
                                54.95159706095151
                            ],
                            [
                                -3.063812255859375,
                                54.94213229768862
                            ],
                            [
                                -3.07891845703125,
                                54.937399080335325
                            ],
                            [
                                -3.1091308593749996,
                                54.92714186454645
                            ],
                            [
                                -3.137969970703125,
                                54.927930974018665
                            ],
                            [
                                -3.1585693359375,
                                54.93266530578977
                            ],
                            [
                                -3.15582275390625,
                                54.93897688136169
                            ],
                            [
                                -3.175048828125,
                                54.94055462047904
                            ],
                            [
                                -3.187408447265625,
                                54.94370991299161
                            ],
                            [
                                -3.1997680664062496,
                                54.95159706095151
                            ],
                            [
                                -3.2258605957031246,
                                54.95317430484108
                            ],
                            [
                                -3.2354736328125,
                                54.94607621987403
                            ],
                            [
                                -3.2560729980468746,
                                54.944498697428536
                            ],
                            [
                                -3.2684326171875,
                                54.9381879885872
                            ],
                            [
                                -3.2862854003906246,
                                54.93345430690937
                            ],
                            [
                                -3.300018310546875,
                                54.92240688263684
                            ],
                            [
                                -3.300018310546875,
                                54.91214584328125
                            ],
                            [
                                -3.283538818359375,
                                54.90740909648185
                            ],
                            [
                                -3.258819580078125,
                                54.908988074013656
                            ],
                            [
                                -3.250579833984375,
                                54.91293524689154
                            ],
                            [
                                -3.2560729980468746,
                                54.899513279793524
                            ],
                            [
                                -3.269805908203125,
                                54.89319551153393
                            ],
                            [
                                -3.283538818359375,
                                54.89319551153393
                            ],
                            [
                                -3.283538818359375,
                                54.87976696307156
                            ],
                            [
                                -3.30413818359375,
                                54.88529690744418
                            ],
                            [
                                -3.327484130859375,
                                54.89003625574075
                            ],
                            [
                                -3.3343505859375,
                                54.895564790773385
                            ],
                            [
                                -3.33984375,
                                54.90346138168996
                            ],
                            [
                                -3.372802734375,
                                54.88924640307589
                            ],
                            [
                                -3.387908935546875,
                                54.8710755170758
                            ],
                            [
                                -3.393402099609375,
                                54.86712424019824
                            ],
                            [
                                -3.40301513671875,
                                54.85368700183775
                            ],
                            [
                                -3.4222412109375,
                                54.82521689149074
                            ],
                            [
                                -3.437347412109375,
                                54.80385112692028
                            ],
                            [
                                -3.4304809570312496,
                                54.77851410375888
                            ],
                            [
                                -3.437347412109375,
                                54.7595009150459
                            ],
                            [
                                -3.4661865234375,
                                54.73810039762111
                            ],
                            [
                                -3.495025634765625,
                                54.72699938009519
                            ],
                            [
                                -3.5018920898437496,
                                54.718275018302315
                            ],
                            [
                                -3.5101318359375,
                                54.71589532099472
                            ],
                            [
                                -3.514251708984375,
                                54.6984399390424
                            ],
                            [
                                -3.53485107421875,
                                54.67780116436963
                            ],
                            [
                                -3.552703857421875,
                                54.67144866052865
                            ],
                            [
                                -3.558197021484375,
                                54.66271234496802
                            ],
                            [
                                -3.571929931640625,
                                54.65397415021701
                            ],
                            [
                                -3.57879638671875,
                                54.64126069376035
                            ],
                            [
                                -3.574676513671875,
                                54.629338216555766
                            ],
                            [
                                -3.570556640625,
                                54.60786894786166
                            ],
                            [
                                -3.57879638671875,
                                54.59354980818523
                            ],
                            [
                                -3.58428955078125,
                                54.5800215520618
                            ],
                            [
                                -3.582916259765625,
                                54.56489641957533
                            ],
                            [
                                -3.5870361328124996,
                                54.56011889582142
                            ],
                            [
                                -3.591156005859375,
                                54.54976567389827
                            ],
                            [
                                -3.6021423339843746,
                                54.550562168891574
                            ],
                            [
                                -3.607635498046875,
                                54.52984824432482
                            ],
                            [
                                -3.6199951171875,
                                54.52347261363511
                            ],
                            [
                                -3.6419677734374996,
                                54.51390730076223
                            ],
                            [
                                -3.6337280273437496,
                                54.508326500290735
                            ],
                            [
                                -3.6254882812499996,
                                54.50035260560785
                            ],
                            [
                                -3.6241149902343754,
                                54.49157952414198
                            ],
                            [
                                -3.6103820800781246,
                                54.49078187790788
                            ],
                            [
                                -3.6035156249999996,
                                54.486793413290854
                            ],
                            [
                                -3.484039306640625,
                                54.39335222384589
                            ],
                            [
                                -3.4716796874999996,
                                54.37095860924334
                            ],
                            [
                                -3.44970703125,
                                54.35335505466622
                            ],
                            [
                                -3.4304809570312496,
                                54.34134830540375
                            ],
                            [
                                -3.423614501953125,
                                54.34775234151605
                            ],
                            [
                                -3.4263610839843746,
                                54.35815677227375
                            ],
                            [
                                -3.4112548828124996,
                                54.35255471383972
                            ],
                            [
                                -3.420867919921875,
                                54.34294940797258
                            ],
                            [
                                -3.4222412109375,
                                54.334943271492
                            ],
                            [
                                -3.41949462890625,
                                54.323732060964595
                            ],
                            [
                                -3.41949462890625,
                                54.308511957926754
                            ],
                            [
                                -3.41400146484375,
                                54.299697745943455
                            ],
                            [
                                -3.42498779296875,
                                54.29488919845351
                            ],
                            [
                                -3.416748046875,
                                54.27404566967879
                            ],
                            [
                                -3.40301513671875,
                                54.25880719007081
                            ],
                            [
                                -3.382415771484375,
                                54.247575231805506
                            ],
                            [
                                -3.36456298828125,
                                54.229918830835224
                            ],
                            [
                                -3.338470458984375,
                                54.204223304732196
                            ],
                            [
                                -3.31787109375,
                                54.18815548107151
                            ],
                            [
                                -3.297271728515625,
                                54.18815548107151
                            ],
                            [
                                -3.28216552734375,
                                54.194583360162646
                            ],
                            [
                                -3.26568603515625,
                                54.19217302263812
                            ],
                            [
                                -3.2409667968749996,
                                54.19779692488548
                            ],
                            [
                                -3.239593505859375,
                                54.20261680346748
                            ],
                            [
                                -3.251953125,
                                54.2162700733
                            ],
                            [
                                -3.236846923828125,
                                54.228313328833536
                            ],
                            [
                                -3.223114013671875,
                                54.23874797568893
                            ],
                            [
                                -3.2244873046875,
                                54.259609355756226
                            ],
                            [
                                -3.2135009765625,
                                54.251586996626116
                            ],
                            [
                                -3.209381103515625,
                                54.243563076790146
                            ],
                            [
                                -3.201141357421875,
                                54.2355375961021
                            ],
                            [
                                -3.1997680664062496,
                                54.21867900543369
                            ],
                            [
                                -3.20526123046875,
                                54.208239284622316
                            ],
                            [
                                -3.203887939453125,
                                54.19779692488548
                            ],
                            [
                                -3.2135009765625,
                                54.19377992993876
                            ],
                            [
                                -3.2148742675781246,
                                54.17610051351112
                            ],
                            [
                                -3.22174072265625,
                                54.169669760399614
                            ],
                            [
                                -3.2354736328125,
                                54.172885261926154
                            ],
                            [
                                -3.251953125,
                                54.168061915905334
                            ],
                            [
                                -3.25469970703125,
                                54.16323800748458
                            ],
                            [
                                -3.2464599609375,
                                54.15600109028493
                            ],
                            [
                                -3.2378768920898438,
                                54.155397956726375
                            ],
                            [
                                -3.2385635375976562,
                                54.150371501946495
                            ],
                            [
                                -3.2454299926757812,
                                54.13528847525875
                            ],
                            [
                                -3.2454299926757812,
                                54.11657789162392
                            ],
                            [
                                -3.2416534423828125,
                                54.10550851655398
                            ],
                            [
                                -3.237533569335937,
                                54.10188517005382
                            ],
                            [
                                -3.228607177734375,
                                54.09463752726641
                            ],
                            [
                                -3.2100677490234375,
                                54.099268111800924
                            ],
                            [
                                -3.2131576538085938,
                                54.10490464745556
                            ],
                            [
                                -3.2097244262695312,
                                54.10671622836933
                            ],
                            [
                                -3.203201293945312,
                                54.10872900322883
                            ],
                            [
                                -3.1867218017578125,
                                54.10087862873027
                            ],
                            [
                                -3.1839752197265625,
                                54.088798227334244
                            ],
                            [
                                -3.1671524047851562,
                                54.080944079817584
                            ],
                            [
                                -3.157882690429687,
                                54.08799274215467
                            ],
                            [
                                -3.143463134765625,
                                54.09524154586937
                            ],
                            [
                                -3.12286376953125,
                                54.10490464745556
                            ],
                            [
                                -3.118743896484375,
                                54.112553006284585
                            ],
                            [
                                -3.1029510498046875,
                                54.12019995430548
                            ],
                            [
                                -3.10089111328125,
                                54.12543126382392
                            ],
                            [
                                -3.0850982666015625,
                                54.13790326015812
                            ],
                            [
                                -3.077545166015625,
                                54.15238215710059
                            ],
                            [
                                -3.0644989013671875,
                                54.160021756077484
                            ],
                            [
                                -3.0562591552734375,
                                54.170875602762685
                            ],
                            [
                                -3.0590057373046875,
                                54.178511788181325
                            ],
                            [
                                -3.0617523193359375,
                                54.180922922268515
                            ],
                            [
                                -3.05694580078125,
                                54.18695014246177
                            ],
                            [
                                -3.052139282226562,
                                54.198600277023715
                            ],
                            [
                                -3.039093017578125,
                                54.2030184346396
                            ],
                            [
                                -3.033599853515625,
                                54.21265641162065
                            ],
                            [
                                -3.036346435546875,
                                54.21787604366902
                            ],
                            [
                                -3.0535125732421875,
                                54.22148924865818
                            ],
                            [
                                -3.05145263671875,
                                54.22751055441583
                            ],
                            [
                                -3.0322265625,
                                54.22791194357612
                            ],
                            [
                                -3.0150604248046875,
                                54.204223304732196
                            ],
                            [
                                -3.033599853515625,
                                54.19619017375832
                            ],
                            [
                                -2.995147705078125,
                                54.176502402385715
                            ],
                            [
                                -2.9972076416015625,
                                54.16484603944897
                            ],
                            [
                                -3.00201416015625,
                                54.16162991302781
                            ],
                            [
                                -2.9944610595703125,
                                54.154392714598124
                            ],
                            [
                                -2.9821014404296875,
                                54.150371501946495
                            ],
                            [
                                -2.956695556640625,
                                54.151577906757865
                            ],
                            [
                                -2.94158935546875,
                                54.158815597352685
                            ],
                            [
                                -2.9347229003906246,
                                54.153186391818274
                            ],
                            [
                                -2.9175567626953125,
                                54.1584135366325
                            ],
                            [
                                -2.916183471679687,
                                54.18413754904026
                            ],
                            [
                                -2.9024505615234375,
                                54.195788476215874
                            ],
                            [
                                -2.840652465820312,
                                54.20582974353425
                            ],
                            [
                                -2.8351593017578125,
                                54.21747455693176
                            ],
                            [
                                -2.80426025390625,
                                54.225503550071174
                            ],
                            [
                                -2.806320190429687,
                                54.235938907209004
                            ],
                            [
                                -2.7939605712890625,
                                54.23433363936637
                            ],
                            [
                                -2.7870941162109375,
                                54.226306363517764
                            ],
                            [
                                -2.8173065185546875,
                                54.21024712817615
                            ],
                            [
                                -2.82073974609375,
                                54.204223304732196
                            ],
                            [
                                -2.8330993652343746,
                                54.20342006190774
                            ],
                            [
                                -2.860565185546875,
                                54.194583360162646
                            ],
                            [
                                -2.8653717041015625,
                                54.18373573436089
                            ],
                            [
                                -2.8482055664062496,
                                54.17971737279753
                            ],
                            [
                                -2.83721923828125,
                                54.17489482345622
                            ],
                            [
                                -2.8337860107421875,
                                54.160021756077484
                            ],
                            [
                                -2.821426391601562,
                                54.14715425056863
                            ],
                            [
                                -2.8138732910156246,
                                54.13548961841918
                            ],
                            [
                                -2.7967071533203125,
                                54.12502887884479
                            ],
                            [
                                -2.8028869628906246,
                                54.10933281663397
                            ],
                            [
                                -2.80975341796875,
                                54.10812518103018
                            ],
                            [
                                -2.81524658203125,
                                54.08920096406031
                            ],
                            [
                                -2.8379058837890625,
                                54.08356229415844
                            ],
                            [
                                -2.8461456298828125,
                                54.07711716173652
                            ],
                            [
                                -2.8598785400390625,
                                54.0787285386706
                            ],
                            [
                                -2.8928375244140625,
                                54.05979090876292
                            ],
                            [
                                -2.899017333984375,
                                54.04850481065724
                            ],
                            [
                                -2.9038238525390625,
                                54.04769854346955
                            ],
                            [
                                -2.9045104980468746,
                                54.04044143479036
                            ],
                            [
                                -2.9203033447265625,
                                54.03640916017354
                            ],
                            [
                                -2.9216766357421875,
                                54.03156991431878
                            ],
                            [
                                -2.9220199584960933,
                                54.02935173838773
                            ],
                            [
                                -2.9185867309570312,
                                54.026528434243936
                            ],
                            [
                                -2.9014205932617188,
                                54.01583847496656
                            ],
                            [
                                -2.9000473022460938,
                                54.0083740446996
                            ],
                            [
                                -2.888031005859375,
                                53.99465214014127
                            ],
                            [
                                -2.881851196289062,
                                53.992230157993994
                            ],
                            [
                                -2.8742980957031246,
                                53.97123374419088
                            ],
                            [
                                -2.8540420532226562,
                                53.965982987022926
                            ],
                            [
                                -2.8612518310546875,
                                53.95810561082356
                            ],
                            [
                                -2.8746414184570312,
                                53.955681503275756
                            ],
                            [
                                -2.8773880004882812,
                                53.948610384549724
                            ],
                            [
                                -2.8966140747070312,
                                53.9417401496101
                            ],
                            [
                                -2.915496826171875,
                                53.94679190307103
                            ],
                            [
                                -2.9522323608398433,
                                53.9397192769176
                            ],
                            [
                                -2.9711151123046875,
                                53.93406031257705
                            ],
                            [
                                -2.9961776733398438,
                                53.92840058070098
                            ],
                            [
                                -2.997894287109375,
                                53.91728101547621
                            ],
                            [
                                -2.9913711547851562,
                                53.89644913450918
                            ],
                            [
                                -2.97454833984375,
                                53.87985710151575
                            ],
                            [
                                -2.9930877685546875,
                                53.88532105918089
                            ],
                            [
                                -3.0054473876953125,
                                53.8962468323121
                            ],
                            [
                                -3.0064773559570312,
                                53.918898590859456
                            ],
                            [
                                -3.0037307739257812,
                                53.92354877101746
                            ],
                            [
                                -3.011627197265625,
                                53.929411303402055
                            ],
                            [
                                -3.052825927734375,
                                53.918898590859456
                            ],
                            [
                                -3.043212890625,
                                53.87196345747181
                            ],
                            [
                                -3.058319091796875,
                                53.84523545094408
                            ],
                            [
                                -3.058319091796875,
                                53.77793497204605
                            ],
                            [
                                -3.039093017578125,
                                53.75033489579978
                            ],
                            [
                                -2.99652099609375,
                                53.736528053783026
                            ],
                            [
                                -2.94158935546875,
                                53.72840426276383
                            ],
                            [
                                -2.940216064453125,
                                53.72271667491848
                            ],
                            [
                                -2.951202392578125,
                                53.716215632472036
                            ],
                            [
                                -2.948455810546875,
                                53.708087916231406
                            ],
                            [
                                -2.955322265625,
                                53.69670647530323
                            ],
                            [
                                -2.9718017578125,
                                53.69508030389493
                            ],
                            [
                                -2.989654541015625,
                                53.6747478603009
                            ],
                            [
                                -2.991714477539062,
                                53.667425777235316
                            ],
                            [
                                -3.0140304565429688,
                                53.65481254001451
                            ],
                            [
                                -3.0270767211914062,
                                53.6462659442739
                            ],
                            [
                                -3.031196594238281,
                                53.638938911890925
                            ],
                            [
                                -3.0435562133789062,
                                53.63323922888163
                            ],
                            [
                                -3.06243896484375,
                                53.60758112477209
                            ],
                            [
                                -3.0878448486328125,
                                53.58435320870081
                            ],
                            [
                                -3.1002044677734375,
                                53.56722972951221
                            ],
                            [
                                -3.1036376953125,
                                53.5517310815021
                            ],
                            [
                                -3.10089111328125,
                                53.54357161755108
                            ],
                            [
                                -3.0826950073242188,
                                53.53398223722513
                            ],
                            [
                                -3.0751419067382812,
                                53.526635710898915
                            ],
                            [
                                -3.0648422241210938,
                                53.524390684764555
                            ],
                            [
                                -3.0607223510742188,
                                53.50132125326796
                            ],
                            [
                                -3.0548858642578125,
                                53.488249809339365
                            ],
                            [
                                -3.0394363403320312,
                                53.47435698489405
                            ],
                            [
                                -3.0428695678710933,
                                53.46454754604325
                            ],
                            [
                                -3.019866943359375,
                                53.451464767401504
                            ],
                            [
                                -3.0092239379882812,
                                53.43940050976852
                            ],
                            [
                                -3.006820678710937,
                                53.424673383862505
                            ],
                            [
                                -2.9879379272460938,
                                53.387014207656314
                            ],
                            [
                                -2.9659652709960938,
                                53.37390754868567
                            ],
                            [
                                -2.925453186035156,
                                53.359362628336044
                            ],
                            [
                                -2.9106903076171875,
                                53.34870686020199
                            ],
                            [
                                -2.8784179687499996,
                                53.33292323332096
                            ],
                            [
                                -2.8571319580078125,
                                53.32800246703935
                            ],
                            [
                                -2.8351593017578125,
                                53.326567136619815
                            ],
                            [
                                -2.8190231323242188,
                                53.331898120486706
                            ],
                            [
                                -2.7936172485351562,
                                53.32144056235643
                            ],
                            [
                                -2.7850341796875,
                                53.32287606523678
                            ],
                            [
                                -2.7774810791015625,
                                53.3284125525758
                            ],
                            [
                                -2.7623748779296875,
                                53.32779742279295
                            ],
                            [
                                -2.745208740234375,
                                53.312006056326894
                            ],
                            [
                                -2.7785110473632812,
                                53.30564684332868
                            ],
                            [
                                -2.8131866455078125,
                                53.30523653899535
                            ],
                            [
                                -2.8396224975585938,
                                53.29395162470101
                            ],
                            [
                                -2.8767013549804688,
                                53.28902636393971
                            ],
                            [
                                -2.910003662109375,
                                53.30544169165485
                            ],
                            [
                                -2.9213333129882812,
                                53.304826230719286
                            ],
                            [
                                -2.940216064453125,
                                53.31590317031308
                            ],
                            [
                                -2.9508590698242188,
                                53.325746926128325
                            ],
                            [
                                -2.9738616943359375,
                                53.35649402974238
                            ],
                            [
                                -2.986907958984375,
                                53.3612066254703
                            ],
                            [
                                -2.9989242553710938,
                                53.36960604714081
                            ],
                            [
                                -3.0092239379882812,
                                53.39029024207508
                            ],
                            [
                                -3.0126571655273433,
                                53.4105550993264
                            ],
                            [
                                -3.0246734619140625,
                                53.41976320783967
                            ],
                            [
                                -3.0284500122070312,
                                53.42651455367774
                            ],
                            [
                                -3.0380630493164062,
                                53.43980952375717
                            ],
                            [
                                -3.0754852294921875,
                                53.435514680505605
                            ],
                            [
                                -3.09814453125,
                                53.42283213430631
                            ],
                            [
                                -3.1585693359375,
                                53.40809926699665
                            ],
                            [
                                -3.179168701171875,
                                53.399093335364185
                            ],
                            [
                                -3.1959915161132812,
                                53.387423725746345
                            ],
                            [
                                -3.192901611328125,
                                53.37534128600465
                            ],
                            [
                                -3.1798553466796875,
                                53.363870036015534
                            ],
                            [
                                -3.1716156005859375,
                                53.355879304922276
                            ],
                            [
                                -3.1582260131835938,
                                53.3454276263561
                            ],
                            [
                                -3.1455230712890625,
                                53.3419431640244
                            ],
                            [
                                -3.1293869018554683,
                                53.325746926128325
                            ],
                            [
                                -3.1235504150390625,
                                53.304415918500425
                            ],
                            [
                                -3.1091308593749996,
                                53.28738448416437
                            ],
                            [
                                -3.088531494140625,
                                53.27835301753182
                            ],
                            [
                                -3.1029510498046875,
                                53.270551578402454
                            ],
                            [
                                -3.1026077270507812,
                                53.26295407216515
                            ],
                            [
                                -3.0796051025390625,
                                53.25042550620077
                            ],
                            [
                                -3.0360031127929688,
                                53.251041750982615
                            ],
                            [
                                -3.0002975463867188,
                                53.23953705140636
                            ],
                            [
                                -2.9494857788085938,
                                53.21281778736058
                            ],
                            [
                                -2.9124069213867188,
                                53.18669902037713
                            ],
                            [
                                -2.9082870483398438,
                                53.17126707620159
                            ],
                            [
                                -2.9573822021484375,
                                53.15171197633304
                            ],
                            [
                                -2.9587554931640625,
                                53.14677033085082
                            ],
                            [
                                -2.9395294189453125,
                                53.124319867401844
                            ],
                            [
                                -2.8935241699218746,
                                53.104949495367656
                            ],
                            [
                                -2.896270751953125,
                                53.100827013670525
                            ],
                            [
                                -2.8643417358398438,
                                53.05359643250982
                            ],
                            [
                                -2.8561019897460938,
                                53.032129625464634
                            ],
                            [
                                -2.8602218627929688,
                                53.02263128156746
                            ],
                            [
                                -2.8272628784179683,
                                53.00218209808626
                            ],
                            [
                                -2.8125,
                                52.9844102955179
                            ],
                            [
                                -2.7737045288085938,
                                52.985030365232305
                            ],
                            [
                                -2.72735595703125,
                                52.96704472979301
                            ],
                            [
                                -2.7160263061523438,
                                52.9473966920633
                            ],
                            [
                                -2.7167129516601562,
                                52.94636233750803
                            ],
                            [
                                -2.7208328247070312,
                                52.91739036767123
                            ],
                            [
                                -2.7510452270507812,
                                52.91387102227775
                            ],
                            [
                                -2.78228759765625,
                                52.89916948807934
                            ],
                            [
                                -2.85369873046875,
                                52.93912116309922
                            ],
                            [
                                -2.8784179687499996,
                                52.94181088364027
                            ],
                            [
                                -2.9268264770507812,
                                52.93270653935951
                            ],
                            [
                                -2.9632186889648433,
                                52.95194755829188
                            ],
                            [
                                -2.9930877685546875,
                                52.95380913829401
                            ],
                            [
                                -3.0576324462890625,
                                52.92525610563002
                            ],
                            [
                                -3.0644989013671875,
                                52.92587702408662
                            ],
                            [
                                -3.0905914306640625,
                                52.91324993163776
                            ],
                            [
                                -3.0971145629882812,
                                52.894198827103146
                            ],
                            [
                                -3.131790161132812,
                                52.88321993103789
                            ],
                            [
                                -3.118743896484375,
                                52.855864177853974
                            ],
                            [
                                -3.1523895263671875,
                                52.83367677779068
                            ],
                            [
                                -3.1551361083984375,
                                52.82164522391119
                            ],
                            [
                                -3.1400299072265625,
                                52.79674177468881
                            ],
                            [
                                -3.1321334838867188,
                                52.789267958041876
                            ],
                            [
                                -3.1142807006835933,
                                52.78511528282571
                            ],
                            [
                                -3.0754852294921875,
                                52.78158519726513
                            ],
                            [
                                -3.0675888061523438,
                                52.77078551077449
                            ],
                            [
                                -3.0590057373046875,
                                52.76600787164062
                            ],
                            [
                                -3.0013275146484375,
                                52.75748991030215
                            ],
                            [
                                -2.992401123046875,
                                52.74522943230584
                            ],
                            [
                                -2.9570388793945312,
                                52.732965503769044
                            ],
                            [
                                -2.9560089111328125,
                                52.7281837154348
                            ],
                            [
                                -2.9683685302734375,
                                52.715707016318
                            ],
                            [
                                -3.0099105834960938,
                                52.71258728381861
                            ],
                            [
                                -3.0332565307617188,
                                52.68221023264222
                            ],
                            [
                                -3.0267333984375,
                                52.66118359972071
                            ],
                            [
                                -3.0287933349609375,
                                52.65347824119917
                            ],
                            [
                                -3.0634689331054688,
                                52.6382717936139
                            ],
                            [
                                -3.0727386474609375,
                                52.60971939156648
                            ],
                            [
                                -3.080635070800781,
                                52.60158792933861
                            ],
                            [
                                -3.1249237060546875,
                                52.58198281531925
                            ],
                            [
                                -3.1249237060546875,
                                52.566125458663116
                            ],
                            [
                                -3.107757568359375,
                                52.54608691552761
                            ],
                            [
                                -3.1190872192382812,
                                52.528754547664185
                            ],
                            [
                                -3.110504150390625,
                                52.526039219655445
                            ],
                            [
                                -3.0861282348632812,
                                52.52958999943304
                            ],
                            [
                                -3.0675888061523438,
                                52.54692203754986
                            ],
                            [
                                -3.011627197265625,
                                52.569672996900756
                            ],
                            [
                                -2.9742050170898438,
                                52.541493460365
                            ],
                            [
                                -2.9920578002929688,
                                52.51893679887988
                            ],
                            [
                                -3.020210266113281,
                                52.51350476109457
                            ],
                            [
                                -3.0287933349609375,
                                52.49678658634651
                            ],
                            [
                                -3.1081008911132812,
                                52.49469636740568
                            ],
                            [
                                -3.1479263305664062,
                                52.47922565896137
                            ],
                            [
                                -3.1959915161132812,
                                52.46793278868704
                            ],
                            [
                                -3.2155609130859375,
                                52.45098804923731
                            ],
                            [
                                -3.2141876220703125,
                                52.43068761930483
                            ],
                            [
                                -3.2086944580078125,
                                52.41959167995837
                            ],
                            [
                                -3.1963348388671875,
                                52.40954011714691
                            ],
                            [
                                -3.16680908203125,
                                52.40367564747814
                            ],
                            [
                                -3.140716552734375,
                                52.38314386359783
                            ],
                            [
                                -3.1036376953125,
                                52.36805320057393
                            ],
                            [
                                -3.0682754516601562,
                                52.34498806295652
                            ],
                            [
                                -3.0260467529296875,
                                52.34058334997003
                            ],
                            [
                                -2.9783248901367183,
                                52.34666593343618
                            ],
                            [
                                -2.9563522338867188,
                                52.341422376750366
                            ],
                            [
                                -2.9515457153320312,
                                52.331982407533786
                            ],
                            [
                                -2.9563522338867188,
                                52.324638816109996
                            ],
                            [
                                -2.991714477539062,
                                52.310997483367316
                            ],
                            [
                                -2.9996109008789062,
                                52.288322586002984
                            ],
                            [
                                -2.989654541015625,
                                52.275300269135606
                            ],
                            [
                                -2.9590988159179688,
                                52.27025834482595
                            ],
                            [
                                -2.9529190063476562,
                                52.26101332738652
                            ],
                            [
                                -3.0126571655273433,
                                52.25617993741785
                            ],
                            [
                                -3.0270767211914062,
                                52.24209705988646
                            ],
                            [
                                -3.0538558959960933,
                                52.23137426088906
                            ],
                            [
                                -3.061065673828125,
                                52.215180028456814
                            ],
                            [
                                -3.113250732421875,
                                52.166772472956495
                            ],
                            [
                                -3.113250732421875,
                                52.15961210128131
                            ],
                            [
                                -3.1032943725585933,
                                52.15434638707717
                            ],
                            [
                                -3.0758285522460938,
                                52.15750589035063
                            ],
                            [
                                -3.0758285522460938,
                                52.14802670774809
                            ],
                            [
                                -3.129730224609375,
                                52.12568998912527
                            ],
                            [
                                -3.1273269653320312,
                                52.1204202626731
                            ],
                            [
                                -3.1002044677734375,
                                52.11240908504091
                            ],
                            [
                                -3.1156539916992188,
                                52.098280606674734
                            ],
                            [
                                -3.1262969970703125,
                                52.07127644127848
                            ],
                            [
                                -3.110847473144531,
                                52.06937709602395
                            ],
                            [
                                -3.0826950073242188,
                                52.04700094984326
                            ],
                            [
                                -3.0799484252929688,
                                52.03454144651829
                            ],
                            [
                                -3.0854415893554688,
                                52.022501000650195
                            ],
                            [
                                -3.031196594238281,
                                51.96521171889782
                            ],
                            [
                                -2.9941177368164062,
                                51.94257177774754
                            ],
                            [
                                -2.98828125,
                                51.926060690953335
                            ],
                            [
                                -2.9666519165039062,
                                51.91886164908389
                            ],
                            [
                                -2.9608154296875,
                                51.911237875723145
                            ],
                            [
                                -2.9436492919921875,
                                51.90657826586804
                            ],
                            [
                                -2.896957397460937,
                                51.926272410001324
                            ],
                            [
                                -2.8664016723632812,
                                51.92838954555318
                            ],
                            [
                                -2.8190231323242188,
                                51.9010708309271
                            ],
                            [
                                -2.7798843383789062,
                                51.88666357770388
                            ],
                            [
                                -2.76580810546875,
                                51.875007273087725
                            ],
                            [
                                -2.7668380737304683,
                                51.86631606154489
                            ],
                            [
                                -2.7335357666015625,
                                51.839383843710586
                            ],
                            [
                                -2.69989013671875,
                                51.84023234838278
                            ],
                            [
                                -2.6827239990234375,
                                51.82813964710642
                            ],
                            [
                                -2.66693115234375,
                                51.82410802503322
                            ],
                            [
                                -2.6583480834960938,
                                51.815831459725224
                            ],
                            [
                                -2.6466751098632812,
                                51.82177376311537
                            ],
                            [
                                -2.6477050781249996,
                                51.816255935957535
                            ],
                            [
                                -2.6487350463867188,
                                51.811161957261994
                            ],
                            [
                                -2.6762008666992183,
                                51.79035556791182
                            ],
                            [
                                -2.6748275756835938,
                                51.78270999291771
                            ],
                            [
                                -2.683753967285156,
                                51.76635260726088
                            ],
                            [
                                -2.6679611206054688,
                                51.7465883788042
                            ],
                            [
                                -2.6676177978515625,
                                51.74042357049732
                            ],
                            [
                                -2.6861572265625,
                                51.726602840804404
                            ],
                            [
                                -2.6871871948242183,
                                51.720435305593604
                            ],
                            [
                                -2.673797607421875,
                                51.70490640601452
                            ],
                            [
                                -2.6772308349609375,
                                51.688095151079516
                            ],
                            [
                                -2.6593780517578125,
                                51.6721293198388
                            ],
                            [
                                -2.687530517578125,
                                51.660204494796155
                            ],
                            [
                                -2.683753967285156,
                                51.655305889458916
                            ],
                            [
                                -2.671051025390625,
                                51.652749885165086
                            ],
                            [
                                -2.6755142211914062,
                                51.63847621195153
                            ],
                            [
                                -2.6648712158203125,
                                51.61268699710062
                            ],
                            [
                                -2.65594482421875,
                                51.60757003871097
                            ],
                            [
                                -2.6459884643554683,
                                51.6120474088444
                            ],
                            [
                                -2.6305389404296875,
                                51.60586425773961
                            ],
                            [
                                -2.6398086547851562,
                                51.58474991408093
                            ],
                            [
                                -2.664527893066406,
                                51.57408237343995
                            ],
                            [
                                -2.6679611206054688,
                                51.566613605050975
                            ],
                            [
                                -2.668647766113281,
                                51.5540206177
                            ],
                            [
                                -2.731475830078125,
                                51.49591970845512
                            ],
                            [
                                -2.7960205078125,
                                51.484803739516046
                            ],
                            [
                                -2.8070068359375,
                                51.481382896100975
                            ],
                            [
                                -2.845458984375,
                                51.45742980658965
                            ],
                            [
                                -2.867431640625,
                                51.4428807236673
                            ],
                            [
                                -2.877044677734375,
                                51.43346414054374
                            ],
                            [
                                -2.8948974609375,
                                51.41291212935532
                            ],
                            [
                                -2.910003662109375,
                                51.39834886240482
                            ],
                            [
                                -2.93060302734375,
                                51.40091918770499
                            ],
                            [
                                -2.9498291015625,
                                51.39749205520681
                            ],
                            [
                                -2.959442138671875,
                                51.39235087498254
                            ],
                            [
                                -2.96356201171875,
                                51.385495069223204
                            ],
                            [
                                -2.956695556640625,
                                51.376923867455886
                            ],
                            [
                                -2.964935302734375,
                                51.365778905402145
                            ],
                            [
                                -2.986907958984375,
                                51.358061573190916
                            ],
                            [
                                -2.9937744140625,
                                51.354631230360226
                            ],
                            [
                                -2.981414794921875,
                                51.348627512300396
                            ],
                            [
                                -2.986907958984375,
                                51.32717923968566
                            ],
                            [
                                -2.995147705078125,
                                51.319455404749775
                            ],
                            [
                                -3.00750732421875,
                                51.32889547080779
                            ],
                            [
                                -3.00750732421875,
                                51.31602217169266
                            ],
                            [
                                -3.0157470703125,
                                51.293699893323726
                            ],
                            [
                                -3.017120361328125,
                                51.27566243415853
                            ],
                            [
                                -3.019866943359375,
                                51.25503952021694
                            ],
                            [
                                -3.00201416015625,
                                51.24644390808839
                            ],
                            [
                                -2.997894287109375,
                                51.227527905265006
                            ],
                            [
                                -3.01025390625,
                                51.21634661126673
                            ],
                            [
                                -3.019866943359375,
                                51.19999983412068
                            ],
                            [
                                -3.030853271484375,
                                51.19053325836227
                            ],
                            [
                                -3.05419921875,
                                51.18709038493268
                            ],
                            [
                                -3.047332763671875,
                                51.19483648846097
                            ],
                            [
                                -3.030853271484375,
                                51.19569708625667
                            ],
                            [
                                -3.021240234375,
                                51.20946446493662
                            ],
                            [
                                -3.0294799804687496,
                                51.21634661126673
                            ],
                            [
                                -3.0487060546875,
                                51.21290566668017
                            ],
                            [
                                -3.05419921875,
                                51.203441743080994
                            ],
                            [
                                -3.072052001953125,
                                51.203441743080994
                            ],
                            [
                                -3.07891845703125,
                                51.20172082074822
                            ],
                            [
                                -3.0899047851562496,
                                51.205162601119824
                            ],
                            [
                                -3.10089111328125,
                                51.207743767628884
                            ],
                            [
                                -3.115997314453125,
                                51.20688339486559
                            ],
                            [
                                -3.1256103515625,
                                51.21118509795345
                            ],
                            [
                                -3.146209716796875,
                                51.21118509795345
                            ],
                            [
                                -3.153076171875,
                                51.20602300602931
                            ],
                            [
                                -3.168182373046875,
                                51.203441743080994
                            ],
                            [
                                -3.179168701171875,
                                51.20086033547136
                            ],
                            [
                                -3.201141357421875,
                                51.2025812899514
                            ],
                            [
                                -3.2192516326904292,
                                51.19424481815195
                            ],
                            [
                                -3.250408172607422,
                                51.18762835086053
                            ],
                            [
                                -3.2599353790283203,
                                51.18768214710792
                            ],
                            [
                                -3.275470733642578,
                                51.17988103564426
                            ],
                            [
                                -3.298816680908203,
                                51.181710380278176
                            ],
                            [
                                -3.315296173095703,
                                51.17912775498893
                            ],
                            [
                                -3.321819305419922,
                                51.182140803759665
                            ],
                            [
                                -3.341217041015625,
                                51.18386245749554
                            ],
                            [
                                -3.346881866455078,
                                51.181279952777636
                            ],
                            [
                                -3.3679962158203125,
                                51.18483085946347
                            ],
                            [
                                -3.3958053588867188,
                                51.18235601399329
                            ],
                            [
                                -3.4102249145507812,
                                51.183432050090055
                            ],
                            [
                                -3.4479904174804688,
                                51.20892675393425
                            ],
                            [
                                -3.4685897827148438,
                                51.20677584714007
                            ],
                            [
                                -3.4802627563476562,
                                51.21742185371385
                            ],
                            [
                                -3.4960556030273433,
                                51.22462533035267
                            ],
                            [
                                -3.506183624267578,
                                51.22451782406268
                            ],
                            [
                                -3.5358810424804688,
                                51.23150521061917
                            ],
                            [
                                -3.5564804077148433,
                                51.23333250593456
                            ],
                            [
                                -3.5808563232421875,
                                51.232042657950586
                            ],
                            [
                                -3.5906410217285156,
                                51.22419530368602
                            ],
                            [
                                -3.6066055297851562,
                                51.222260133966415
                            ],
                            [
                                -3.6186218261718746,
                                51.21742185371385
                            ],
                            [
                                -3.632526397705078,
                                51.22355025615275
                            ],
                            [
                                -3.6416244506835933,
                                51.222582667903
                            ],
                            [
                                -3.68539810180664,
                                51.22709790571764
                            ],
                            [
                                -3.7001609802246094,
                                51.231935168986496
                            ],
                            [
                                -3.7193870544433594,
                                51.23215014666359
                            ],
                            [
                                -3.7279701232910156,
                                51.23558965290394
                            ],
                            [
                                -3.7727737426757812,
                                51.23827658825513
                            ],
                            [
                                -3.7865066528320312,
                                51.246873726855796
                            ],
                            [
                                -3.80950927734375,
                                51.23182767977129
                            ],
                            [
                                -3.8333702087402344,
                                51.23075277380922
                            ],
                            [
                                -3.838863372802734,
                                51.234622317761534
                            ],
                            [
                                -3.8716506958007817,
                                51.231290229928945
                            ],
                            [
                                -3.893966674804687,
                                51.22484034217936
                            ],
                            [
                                -3.903064727783203,
                                51.22946285351015
                            ],
                            [
                                -3.939285278320312,
                                51.22935535851977
                            ],
                            [
                                -3.949756622314453,
                                51.221400032419936
                            ],
                            [
                                -3.9760208129882812,
                                51.22021736655215
                            ],
                            [
                                -4.010009765624999,
                                51.217206807233396
                            ],
                            [
                                -4.031639099121094,
                                51.216131559763845
                            ],
                            [
                                -4.034214019775391,
                                51.2092493812891
                            ],
                            [
                                -4.051551818847656,
                                51.20806640327126
                            ],
                            [
                                -4.056358337402344,
                                51.21312073325066
                            ],
                            [
                                -4.0738677978515625,
                                51.21795946552035
                            ],
                            [
                                -4.088115692138672,
                                51.21731433059918
                            ],
                            [
                                -4.106998443603516,
                                51.21000216966061
                            ],
                            [
                                -4.121246337890625,
                                51.21290566668017
                            ],
                            [
                                -4.144248962402344,
                                51.20688339486559
                            ],
                            [
                                -4.1473388671875,
                                51.203871963618234
                            ],
                            [
                                -4.166049957275391,
                                51.2027964047407
                            ],
                            [
                                -4.175662994384765,
                                51.19817121538
                            ],
                            [
                                -4.2015838623046875,
                                51.201613260967655
                            ],
                            [
                                -4.213085174560547,
                                51.18999532634326
                            ],
                            [
                                -4.2304229736328125,
                                51.18827390168502
                            ],
                            [
                                -4.215831756591797,
                                51.18149516703029
                            ],
                            [
                                -4.209308624267578,
                                51.17256293114924
                            ],
                            [
                                -4.213085174560547,
                                51.15490860591647
                            ],
                            [
                                -4.223384857177734,
                                51.145002001494156
                            ],
                            [
                                -4.258232116699219,
                                51.147694223989234
                            ],
                            [
                                -4.260978698730469,
                                51.14284811043114
                            ],
                            [
                                -4.237117767333984,
                                51.13293891700141
                            ],
                            [
                                -4.24346923828125,
                                51.12162691254952
                            ],
                            [
                                -4.220123291015625,
                                51.117747873223344
                            ],
                            [
                                -4.220123291015625,
                                51.084547222263666
                            ],
                            [
                                -4.2139434814453125,
                                51.07635118600777
                            ],
                            [
                                -4.2057037353515625,
                                51.069016659603896
                            ],
                            [
                                -4.1933441162109375,
                                51.066427725678686
                            ],
                            [
                                -4.18853759765625,
                                51.07419409303002
                            ],
                            [
                                -4.167938232421875,
                                51.07937094724242
                            ],
                            [
                                -4.159698486328125,
                                51.08411588813325
                            ],
                            [
                                -4.1452789306640625,
                                51.08152779888779
                            ],
                            [
                                -4.1329193115234375,
                                51.08756644856133
                            ],
                            [
                                -4.1301727294921875,
                                51.09274180657607
                            ],
                            [
                                -4.107513427734375,
                                51.09231054886148
                            ],
                            [
                                -4.09515380859375,
                                51.087997750516124
                            ],
                            [
                                -4.097213745117187,
                                51.084547222263666
                            ],
                            [
                                -4.1150665283203125,
                                51.089722918116315
                            ],
                            [
                                -4.1191864013671875,
                                51.08023369996697
                            ],
                            [
                                -4.123992919921875,
                                51.07850817842925
                            ],
                            [
                                -4.1493988037109375,
                                51.07980232561576
                            ],
                            [
                                -4.1713714599609375,
                                51.07246834624617
                            ],
                            [
                                -4.1802978515625,
                                51.05650213741962
                            ],
                            [
                                -4.195404052734375,
                                51.057796900048594
                            ],
                            [
                                -4.199523925781249,
                                51.05866005502052
                            ],
                            [
                                -4.209136962890625,
                                51.054344119247425
                            ],
                            [
                                -4.214630126953124,
                                51.062544053267686
                            ],
                            [
                                -4.2242431640625,
                                51.06168097070512
                            ],
                            [
                                -4.236602783203125,
                                51.0439842320174
                            ],
                            [
                                -4.261322021484375,
                                51.03880341939632
                            ],
                            [
                                -4.274711608886719,
                                51.02412130394265
                            ],
                            [
                                -4.278488159179687,
                                51.015698580008184
                            ],
                            [
                                -4.308013916015625,
                                50.99711998640689
                            ],
                            [
                                -4.340972900390625,
                                50.98934069124923
                            ],
                            [
                                -4.376678466796875,
                                50.9906373309996
                            ],
                            [
                                -4.397621154785156,
                                50.99668783755265
                            ],
                            [
                                -4.40277099609375,
                                51.0053300499721
                            ],
                            [
                                -4.426116943359374,
                                51.01505061478908
                            ],
                            [
                                -4.4528961181640625,
                                51.01461863294623
                            ],
                            [
                                -4.471092224121094,
                                51.02152985954755
                            ],
                            [
                                -4.52362060546875,
                                51.0210979380648
                            ],
                            [
                                -4.5352935791015625,
                                51.00100914498818
                            ],
                            [
                                -4.5352935791015625,
                                50.9930144097952
                            ],
                            [
                                -4.5298004150390625,
                                50.98631505762755
                            ],
                            [
                                -4.5325469970703125,
                                50.97961473846458
                            ],
                            [
                                -4.533576965332031,
                                50.96729227297127
                            ],
                            [
                                -4.545936584472656,
                                50.95345262552378
                            ],
                            [
                                -4.543190002441406,
                                50.94307018453559
                            ],
                            [
                                -4.5462799072265625,
                                50.94198854689987
                            ],
                            [
                                -4.550743103027344,
                                50.94090688409996
                            ],
                            [
                                -4.545936584472656,
                                50.93030525693042
                            ],
                            [
                                -4.5538330078125,
                                50.92467892226281
                            ],
                            [
                                -4.559669494628906,
                                50.92035050944008
                            ],
                            [
                                -4.566535949707031,
                                50.91104305824259
                            ],
                            [
                                -4.565849304199219,
                                50.89545432059727
                            ],
                            [
                                -4.567909240722655,
                                50.88549211660664
                            ],
                            [
                                -4.5600128173828125,
                                50.86707808969461
                            ],
                            [
                                -4.555549621582031,
                                50.84171982192652
                            ],
                            [
                                -4.559669494628906,
                                50.82350538258947
                            ],
                            [
                                -4.556236267089843,
                                50.818299951469584
                            ],
                            [
                                -4.560699462890625,
                                50.806585609679104
                            ],
                            [
                                -4.558296203613281,
                                50.78835746033317
                            ],
                            [
                                -4.5764923095703125,
                                50.770990707672595
                            ],
                            [
                                -4.612884521484375,
                                50.76143624444377
                            ],
                            [
                                -4.619407653808594,
                                50.75079375029074
                            ],
                            [
                                -4.631080627441406,
                                50.751228185180004
                            ],
                            [
                                -4.6396636962890625,
                                50.74688365485319
                            ],
                            [
                                -4.6396636962890625,
                                50.73993156768006
                            ],
                            [
                                -4.640007019042969,
                                50.73862793642048
                            ],
                            [
                                -4.654426574707031,
                                50.740800635025714
                            ],
                            [
                                -4.651679992675781,
                                50.73319574888393
                            ],
                            [
                                -4.649620056152344,
                                50.73167462346925
                            ],
                            [
                                -4.65545654296875,
                                50.71711278106889
                            ],
                            [
                                -4.667472839355469,
                                50.712547689956345
                            ],
                            [
                                -4.668846130371094,
                                50.70711247794506
                            ],
                            [
                                -4.681549072265625,
                                50.70472078502399
                            ],
                            [
                                -4.689788818359375,
                                50.69580521837641
                            ],
                            [
                                -4.706611633300781,
                                50.691020557004755
                            ],
                            [
                                -4.716224670410156,
                                50.68514780554603
                            ],
                            [
                                -4.722747802734375,
                                50.68580036978865
                            ],
                            [
                                -4.733734130859375,
                                50.67274736047949
                            ],
                            [
                                -4.7625732421875,
                                50.67078909594768
                            ],
                            [
                                -4.760856628417968,
                                50.66578427100331
                            ],
                            [
                                -4.7660064697265625,
                                50.65555536092366
                            ],
                            [
                                -4.75982666015625,
                                50.65316103894354
                            ],
                            [
                                -4.761543273925781,
                                50.645759635740774
                            ],
                            [
                                -4.7673797607421875,
                                50.643364814465016
                            ],
                            [
                                -4.77081298828125,
                                50.625944260587374
                            ],
                            [
                                -4.7962188720703125,
                                50.5993654846964
                            ],
                            [
                                -4.8236846923828125,
                                50.59435304939253
                            ],
                            [
                                -4.847373962402344,
                                50.597404160538645
                            ],
                            [
                                -4.865226745605469,
                                50.59304536978631
                            ],
                            [
                                -4.86968994140625,
                                50.59544275464843
                            ],
                            [
                                -4.875869750976562,
                                50.588686175404796
                            ],
                            [
                                -4.887199401855469,
                                50.583236614805884
                            ],
                            [
                                -4.894409179687499,
                                50.584980542817995
                            ],
                            [
                                -4.906425476074219,
                                50.58476255534847
                            ],
                            [
                                -4.920845031738281,
                                50.590429901593666
                            ],
                            [
                                -4.924964904785156,
                                50.582800622711474
                            ],
                            [
                                -4.9143218994140625,
                                50.57473404085453
                            ],
                            [
                                -4.923248291015625,
                                50.57320777535897
                            ],
                            [
                                -4.931144714355469,
                                50.56579378237965
                            ],
                            [
                                -4.927711486816406,
                                50.54594470788649
                            ],
                            [
                                -4.91535186767578,
                                50.54158115353795
                            ],
                            [
                                -4.914665222167969,
                                50.53678077739754
                            ],
                            [
                                -4.898185729980469,
                                50.529579297094294
                            ],
                            [
                                -4.884796142578125,
                                50.5345986267297
                            ],
                            [
                                -4.8497772216796875,
                                50.53285283351307
                            ],
                            [
                                -4.852180480957031,
                                50.52870631568803
                            ],
                            [
                                -4.878959655761719,
                                50.53067050113813
                            ],
                            [
                                -4.900245666503905,
                                50.52630553353518
                            ],
                            [
                                -4.910888671875,
                                50.53023402254911
                            ],
                            [
                                -4.9225616455078125,
                                50.531543446202086
                            ],
                            [
                                -4.931488037109375,
                                50.52739681329302
                            ],
                            [
                                -4.936637878417969,
                                50.54005381412546
                            ],
                            [
                                -4.934234619140625,
                                50.54747185651959
                            ],
                            [
                                -4.939384460449219,
                                50.55336182365659
                            ],
                            [
                                -4.94659423828125,
                                50.555761228942096
                            ],
                            [
                                -4.943504333496094,
                                50.569500924704
                            ],
                            [
                                -4.9527740478515625,
                                50.56841061900368
                            ],
                            [
                                -4.962043762207031,
                                50.55946916052669
                            ],
                            [
                                -4.9706268310546875,
                                50.559032948421205
                            ],
                            [
                                -4.973716735839844,
                                50.55248928236334
                            ],
                            [
                                -4.990882873535155,
                                50.54419933459893
                            ],
                            [
                                -5.001869201660156,
                                50.540926585560634
                            ],
                            [
                                -5.003929138183594,
                                50.545508370621036
                            ],
                            [
                                -5.0131988525390625,
                                50.54638104111437
                            ],
                            [
                                -5.0173187255859375,
                                50.54419933459893
                            ],
                            [
                                -5.025215148925781,
                                50.551398583036274
                            ],
                            [
                                -5.0379180908203125,
                                50.549435260657646
                            ],
                            [
                                -5.040321350097656,
                                50.545072029317964
                            ],
                            [
                                -5.027961730957031,
                                50.540926585560634
                            ],
                            [
                                -5.0241851806640625,
                                50.54027200849841
                            ],
                            [
                                -5.030708312988281,
                                50.52237671743191
                            ],
                            [
                                -5.026931762695312,
                                50.50971497375786
                            ],
                            [
                                -5.0351715087890625,
                                50.508186602590555
                            ],
                            [
                                -5.042724609375,
                                50.49836017804841
                            ],
                            [
                                -5.0337982177734375,
                                50.48634732684517
                            ],
                            [
                                -5.0365447998046875,
                                50.47673484653018
                            ],
                            [
                                -5.032081604003906,
                                50.466027737901314
                            ],
                            [
                                -5.0406646728515625,
                                50.46515358116524
                            ],
                            [
                                -5.041007995605469,
                                50.44482488145606
                            ],
                            [
                                -5.057144165039062,
                                50.42842440526485
                            ],
                            [
                                -5.085639953613281,
                                50.41726883571082
                            ],
                            [
                                -5.089073181152344,
                                50.42251884281916
                            ],
                            [
                                -5.0983428955078125,
                                50.41989391200375
                            ],
                            [
                                -5.102462768554687,
                                50.413112167385705
                            ],
                            [
                                -5.1120758056640625,
                                50.41464361393782
                            ],
                            [
                                -5.1251220703125,
                                50.41026792102014
                            ],
                            [
                                -5.1285552978515625,
                                50.40523537455813
                            ],
                            [
                                -5.148468017578125,
                                50.401515322782366
                            ],
                            [
                                -5.145378112792969,
                                50.39451208023374
                            ],
                            [
                                -5.153617858886718,
                                50.388164497948594
                            ],
                            [
                                -5.147781372070312,
                                50.37480991314028
                            ],
                            [
                                -5.151214599609375,
                                50.36079450321162
                            ],
                            [
                                -5.1573944091796875,
                                50.34830854350331
                            ],
                            [
                                -5.172843933105469,
                                50.34042098225083
                            ],
                            [
                                -5.181770324707031,
                                50.341078329055215
                            ],
                            [
                                -5.183143615722656,
                                50.33340871695205
                            ],
                            [
                                -5.1958465576171875,
                                50.32639541655309
                            ],
                            [
                                -5.200309753417969,
                                50.31916186634034
                            ],
                            [
                                -5.225028991699219,
                                50.322449980182796
                            ],
                            [
                                -5.233955383300781,
                                50.3204771391723
                            ],
                            [
                                -5.234642028808594,
                                50.305130024910035
                            ],
                            [
                                -5.247688293457031,
                                50.28561011175866
                            ],
                            [
                                -5.262451171875,
                                50.28210006454705
                            ],
                            [
                                -5.2658843994140625,
                                50.27595685903675
                            ],
                            [
                                -5.2754974365234375,
                                50.27573744417743
                            ],
                            [
                                -5.291290283203125,
                                50.26213174792879
                            ],
                            [
                                -5.305366516113281,
                                50.26257070203296
                            ],
                            [
                                -5.3112030029296875,
                                50.257741984396894
                            ],
                            [
                                -5.31463623046875,
                                50.24918078195333
                            ],
                            [
                                -5.344161987304687,
                                50.23842221881728
                            ],
                            [
                                -5.357208251953125,
                                50.2406180411774
                            ],
                            [
                                -5.368537902832031,
                                50.23622629531058
                            ],
                            [
                                -5.3778076171875,
                                50.2434724590338
                            ],
                            [
                                -5.3949737548828125,
                                50.24149634180072
                            ],
                            [
                                -5.394287109375,
                                50.23271260731141
                            ],
                            [
                                -5.389480590820312,
                                50.22963791789675
                            ],
                            [
                                -5.397720336914062,
                                50.21711749270724
                            ],
                            [
                                -5.412139892578125,
                                50.207889813140866
                            ],
                            [
                                -5.433769226074218,
                                50.19668237449501
                            ],
                            [
                                -5.439262390136719,
                                50.19382515553367
                            ],
                            [
                                -5.469474792480469,
                                50.199759188312065
                            ],
                            [
                                -5.469474792480469,
                                50.20437403723282
                            ],
                            [
                                -5.479774475097656,
                                50.21623874296548
                            ],
                            [
                                -5.495567321777344,
                                50.218874943633836
                            ],
                            [
                                -5.516510009765625,
                                50.21733717761366
                            ],
                            [
                                -5.524406433105468,
                                50.21448119492458
                            ],
                            [
                                -5.53985595703125,
                                50.21689780678922
                            ],
                            [
                                -5.541229248046875,
                                50.21162504127143
                            ],
                            [
                                -5.5535888671875,
                                50.21074619036717
                            ],
                            [
                                -5.55805206298828,
                                50.20701089344406
                            ],
                            [
                                -5.566291809082031,
                                50.199759188312065
                            ],
                            [
                                -5.5803680419921875,
                                50.19909988775905
                            ],
                            [
                                -5.5865478515625,
                                50.1920667819548
                            ],
                            [
                                -5.598564147949219,
                                50.19030834362283
                            ],
                            [
                                -5.60302734375,
                                50.189868723922075
                            ],
                            [
                                -5.619163513183594,
                                50.17953649586382
                            ],
                            [
                                -5.626029968261719,
                                50.172280617128465
                            ],
                            [
                                -5.629463195800781,
                                50.166563088064656
                            ],
                            [
                                -5.649375915527344,
                                50.16788257856361
                            ],
                            [
                                -5.656242370605469,
                                50.16480371073114
                            ],
                            [
                                -5.6689453125,
                                50.166563088064656
                            ],
                            [
                                -5.674781799316406,
                                50.16238446114938
                            ],
                            [
                                -5.6819915771484375,
                                50.15710567340038
                            ],
                            [
                                -5.69091796875,
                                50.15160631631611
                            ],
                            [
                                -5.692291259765625,
                                50.13774513107287
                            ],
                            [
                                -5.702934265136719,
                                50.137084974435936
                            ],
                            [
                                -5.707740783691406,
                                50.12145860843637
                            ],
                            [
                                -5.701904296875,
                                50.12013783664857
                            ],
                            [
                                -5.7012176513671875,
                                50.11375359262906
                            ],
                            [
                                -5.69915771484375,
                                50.10648772767332
                            ],
                            [
                                -5.696411132812499,
                                50.095917228872004
                            ],
                            [
                                -5.6888580322265625,
                                50.09327423971961
                            ],
                            [
                                -5.691947937011719,
                                50.083802331409686
                            ],
                            [
                                -5.711517333984374,
                                50.07631159023147
                            ],
                            [
                                -5.71563720703125,
                                50.069921503714426
                            ],
                            [
                                -5.714950561523437,
                                50.06176739838384
                            ],
                            [
                                -5.70911407470703,
                                50.0542732145224
                            ],
                            [
                                -5.695381164550781,
                                50.05405277962895
                            ],
                            [
                                -5.695037841796875,
                                50.048982497585754
                            ],
                            [
                                -5.680274963378906,
                                50.034209492254035
                            ],
                            [
                                -5.655555725097656,
                                50.03707625174409
                            ],
                            [
                                -5.641822814941406,
                                50.04347071384303
                            ],
                            [
                                -5.635643005371094,
                                50.0399428400785
                            ],
                            [
                                -5.619163513183594,
                                50.049643869101864
                            ],
                            [
                                -5.6050872802734375,
                                50.04854157817827
                            ],
                            [
                                -5.60028076171875,
                                50.051848374998535
                            ],
                            [
                                -5.5748748779296875,
                                50.051187033862554
                            ],
                            [
                                -5.565605163574219,
                                50.05713877598689
                            ],
                            [
                                -5.548095703125,
                                50.06110619395334
                            ],
                            [
                                -5.5419158935546875,
                                50.0734471739922
                            ],
                            [
                                -5.538825988769531,
                                50.08270082522937
                            ],
                            [
                                -5.531272888183593,
                                50.08820810301766
                            ],
                            [
                                -5.53436279296875,
                                50.09129190218363
                            ],
                            [
                                -5.546722412109375,
                                50.108909805146375
                            ],
                            [
                                -5.529212951660156,
                                50.11639545202466
                            ],
                            [
                                -5.525779724121094,
                                50.12542070516123
                            ],
                            [
                                -5.4965972900390625,
                                50.128722201913185
                            ],
                            [
                                -5.479087829589843,
                                50.1265212293832
                            ],
                            [
                                -5.4746246337890625,
                                50.12299946279942
                            ],
                            [
                                -5.46295166015625,
                                50.1227793437842
                            ],
                            [
                                -5.429649353027344,
                                50.10494634186922
                            ],
                            [
                                -5.4293060302734375,
                                50.09635771289063
                            ],
                            [
                                -5.413856506347656,
                                50.1038453216394
                            ],
                            [
                                -5.398063659667969,
                                50.101202769829456
                            ],
                            [
                                -5.389823913574219,
                                50.10362511455642
                            ],
                            [
                                -5.366477966308594,
                                50.09393500067502
                            ],
                            [
                                -5.361328125,
                                50.08776754408084
                            ],
                            [
                                -5.348968505859375,
                                50.092613469652605
                            ],
                            [
                                -5.3338623046875,
                                50.09019056811813
                            ],
                            [
                                -5.307769775390625,
                                50.07741324322202
                            ],
                            [
                                -5.283050537109375,
                                50.060224573869576
                            ],
                            [
                                -5.277214050292969,
                                50.050966584791894
                            ],
                            [
                                -5.280303955078124,
                                50.042147791563075
                            ],
                            [
                                -5.266571044921875,
                                50.03817880597379
                            ],
                            [
                                -5.264854431152344,
                                50.02935766319773
                            ],
                            [
                                -5.2562713623046875,
                                50.02119666339291
                            ],
                            [
                                -5.269660949707031,
                                50.00597379753065
                            ],
                            [
                                -5.265197753906249,
                                49.99847090157433
                            ],
                            [
                                -5.251808166503906,
                                49.99162900525654
                            ],
                            [
                                -5.253868103027344,
                                49.98588988994238
                            ],
                            [
                                -5.249061584472656,
                                49.97507200338225
                            ],
                            [
                                -5.233955383300781,
                                49.97109747495407
                            ],
                            [
                                -5.220222473144531,
                                49.97021420183543
                            ],
                            [
                                -5.216102600097656,
                                49.95431251357478
                            ],
                            [
                                -5.2095794677734375,
                                49.95895104856801
                            ],
                            [
                                -5.197906494140625,
                                49.95850930258238
                            ],
                            [
                                -5.185203552246094,
                                49.96138057904258
                            ],
                            [
                                -5.186233520507812,
                                49.97926698282594
                            ],
                            [
                                -5.171127319335937,
                                49.9914082827153
                            ],
                            [
                                -5.16632080078125,
                                50.00222249592715
                            ],
                            [
                                -5.1560211181640625,
                                50.00663576154257
                            ],
                            [
                                -5.130271911621094,
                                50.0086215988794
                            ],
                            [
                                -5.1134490966796875,
                                50.0028845116
                            ],
                            [
                                -5.100746154785156,
                                50.00332585031708
                            ],
                            [
                                -5.0921630859375,
                                50.01546107724932
                            ],
                            [
                                -5.09490966796875,
                                50.026049316879906
                            ],
                            [
                                -5.088043212890625,
                                50.03134256160531
                            ],
                            [
                                -5.070533752441406,
                                50.03310684687554
                            ],
                            [
                                -5.067100524902344,
                                50.04677786004091
                            ],
                            [
                                -5.05645751953125,
                                50.05030523150393
                            ],
                            [
                                -5.060577392578125,
                                50.05956334817432
                            ],
                            [
                                -5.06744384765625,
                                50.06793820027185
                            ],
                            [
                                -5.076713562011719,
                                50.06837894145809
                            ],
                            [
                                -5.078086853027343,
                                50.080497736933474
                            ],
                            [
                                -5.085639953613281,
                                50.08600526783601
                            ],
                            [
                                -5.104179382324219,
                                50.093494494383805
                            ],
                            [
                                -5.12786865234375,
                                50.1001016635506
                            ],
                            [
                                -5.112419128417969,
                                50.10340490646112
                            ],
                            [
                                -5.097312927246094,
                                50.09966121395255
                            ],
                            [
                                -5.087356567382812,
                                50.10252406395657
                            ],
                            [
                                -5.083580017089844,
                                50.11199227205053
                            ],
                            [
                                -5.090789794921875,
                                50.114193912650954
                            ],
                            [
                                -5.086669921875,
                                50.126741331191035
                            ],
                            [
                                -5.072593688964844,
                                50.13378405461423
                            ],
                            [
                                -5.076026916503906,
                                50.137084974435936
                            ],
                            [
                                -5.051994323730469,
                                50.149406396378744
                            ],
                            [
                                -5.046844482421875,
                                50.15270623833364
                            ],
                            [
                                -5.06744384765625,
                                50.15556591717328
                            ],
                            [
                                -5.0708770751953125,
                                50.16172464455786
                            ],
                            [
                                -5.054054260253906,
                                50.16260439798932
                            ],
                            [
                                -5.045127868652344,
                                50.169861746007314
                            ],
                            [
                                -5.04444122314453,
                                50.1751391251435
                            ],
                            [
                                -5.052680969238281,
                                50.17865705409927
                            ],
                            [
                                -5.0585174560546875,
                                50.19909988775905
                            ],
                            [
                                -5.0482177734375,
                                50.20217654577131
                            ],
                            [
                                -5.033111572265625,
                                50.20327530414826
                            ],
                            [
                                -5.0296783447265625,
                                50.19712193146678
                            ],
                            [
                                -5.027961730957031,
                                50.18657144716358
                            ],
                            [
                                -5.0200653076171875,
                                50.17799746215137
                            ],
                            [
                                -5.0283050537109375,
                                50.157985511837715
                            ],
                            [
                                -5.014915466308594,
                                50.157985511837715
                            ],
                            [
                                -5.0186920166015625,
                                50.14962639292665
                            ],
                            [
                                -5.016975402832031,
                                50.140605704573204
                            ],
                            [
                                -5.006675720214844,
                                50.13862532575246
                            ],
                            [
                                -4.9980926513671875,
                                50.1480863958384
                            ],
                            [
                                -4.981956481933594,
                                50.15050636899785
                            ],
                            [
                                -4.985389709472656,
                                50.15754559464304
                            ],
                            [
                                -4.9713134765625,
                                50.163704067009604
                            ],
                            [
                                -4.973030090332031,
                                50.174039719221554
                            ],
                            [
                                -4.966163635253906,
                                50.18503264010109
                            ],
                            [
                                -4.9678802490234375,
                                50.19228658219332
                            ],
                            [
                                -4.9582672119140625,
                                50.200858002332836
                            ],
                            [
                                -4.947967529296874,
                                50.20437403723282
                            ],
                            [
                                -4.932861328124999,
                                50.20723062488576
                            ],
                            [
                                -4.924621582031249,
                                50.20195679106085
                            ],
                            [
                                -4.922218322753906,
                                50.196902153486775
                            ],
                            [
                                -4.905738830566406,
                                50.20437403723282
                            ],
                            [
                                -4.9005889892578125,
                                50.21382209771751
                            ],
                            [
                                -4.874839782714844,
                                50.22634338780325
                            ],
                            [
                                -4.865913391113281,
                                50.23403027065588
                            ],
                            [
                                -4.8401641845703125,
                                50.23490869265562
                            ],
                            [
                                -4.829864501953125,
                                50.231175287386165
                            ],
                            [
                                -4.8126983642578125,
                                50.23051642081693
                            ],
                            [
                                -4.805145263671875,
                                50.21843558697177
                            ],
                            [
                                -4.796562194824219,
                                50.21909462044748
                            ],
                            [
                                -4.799308776855469,
                                50.22985754514407
                            ],
                            [
                                -4.780426025390625,
                                50.23446948367872
                            ],
                            [
                                -4.7845458984375,
                                50.24588760217225
                            ],
                            [
                                -4.769439697265625,
                                50.25247373417045
                            ],
                            [
                                -4.769096374511719,
                                50.25840047471556
                            ],
                            [
                                -4.780426025390625,
                                50.26191226935973
                            ],
                            [
                                -4.783515930175781,
                                50.27420151184809
                            ],
                            [
                                -4.7756195068359375,
                                50.27968675692932
                            ],
                            [
                                -4.7824859619140625,
                                50.28648758311506
                            ],
                            [
                                -4.7660064697265625,
                                50.29942840644836
                            ],
                            [
                                -4.7605133056640625,
                                50.30951542019119
                            ],
                            [
                                -4.766693115234375,
                                50.32398435546869
                            ],
                            [
                                -4.753303527832031,
                                50.332093801974196
                            ],
                            [
                                -4.7440338134765625,
                                50.33121717177202
                            ],
                            [
                                -4.728584289550781,
                                50.33779150406155
                            ],
                            [
                                -4.705238342285156,
                                50.34085921446453
                            ],
                            [
                                -4.6966552734375,
                                50.346774953629875
                            ],
                            [
                                -4.681205749511719,
                                50.3380106328034
                            ],
                            [
                                -4.681892395019531,
                                50.32201157814577
                            ],
                            [
                                -4.672966003417969,
                                50.313681171133204
                            ],
                            [
                                -4.6726226806640625,
                                50.320257929560945
                            ],
                            [
                                -4.637947082519531,
                                50.32617623423627
                            ],
                            [
                                -4.616661071777343,
                                50.32376516203201
                            ],
                            [
                                -4.603958129882812,
                                50.32529949485997
                            ],
                            [
                                -4.586448669433593,
                                50.33121717177202
                            ],
                            [
                                -4.5758056640625,
                                50.331655488894796
                            ],
                            [
                                -4.549369812011719,
                                50.32376516203201
                            ],
                            [
                                -4.532203674316406,
                                50.32398435546869
                            ],
                            [
                                -4.5078277587890625,
                                50.3305596885064
                            ],
                            [
                                -4.498214721679687,
                                50.33494273843299
                            ],
                            [
                                -4.474868774414062,
                                50.331655488894796
                            ],
                            [
                                -4.472808837890625,
                                50.33779150406155
                            ],
                            [
                                -4.4570159912109375,
                                50.34239299537267
                            ],
                            [
                                -4.4501495361328125,
                                50.355537657254665
                            ],
                            [
                                -4.4384765625,
                                50.361013525826486
                            ],
                            [
                                -4.3856048583984375,
                                50.364736755649716
                            ],
                            [
                                -4.368438720703125,
                                50.36013742930313
                            ],
                            [
                                -4.346466064453125,
                                50.36167058760708
                            ],
                            [
                                -4.33685302734375,
                                50.359918402645654
                            ],
                            [
                                -4.326896667480469,
                                50.362327640291824
                            ],
                            [
                                -4.297370910644531,
                                50.359480346298696
                            ],
                            [
                                -4.2681884765625,
                                50.35181370580996
                            ],
                            [
                                -4.2414093017578125,
                                50.34042098225083
                            ],
                            [
                                -4.2263031005859375,
                                50.331874645939926
                            ],
                            [
                                -4.217720031738281,
                                50.32464192971339
                            ],
                            [
                                -4.2249298095703125,
                                50.31916186634034
                            ],
                            [
                                -4.21600341796875,
                                50.314558124826526
                            ],
                            [
                                -4.1912841796875,
                                50.31784655711474
                            ],
                            [
                                -4.18853759765625,
                                50.3231075756565
                            ],
                            [
                                -4.1988372802734375,
                                50.332751264011925
                            ],
                            [
                                -4.189910888671875,
                                50.340201864627815
                            ],
                            [
                                -4.16656494140625,
                                50.34589859432286
                            ],
                            [
                                -4.169654846191406,
                                50.35838518774458
                            ],
                            [
                                -4.180641174316406,
                                50.35663288150293
                            ],
                            [
                                -4.2057037353515625,
                                50.36013742930313
                            ],
                            [
                                -4.214973449707031,
                                50.359480346298696
                            ],
                            [
                                -4.221839904785156,
                                50.368459693400524
                            ],
                            [
                                -4.193687438964843,
                                50.37568573882017
                            ],
                            [
                                -4.2015838623046875,
                                50.388383394242794
                            ],
                            [
                                -4.211540222167969,
                                50.39363660216505
                            ],
                            [
                                -4.2317962646484375,
                                50.39057230160899
                            ],
                            [
                                -4.2372894287109375,
                                50.38115928299588
                            ],
                            [
                                -4.247932434082031,
                                50.377218394853514
                            ],
                            [
                                -4.269218444824218,
                                50.37875100137005
                            ],
                            [
                                -4.267158508300781,
                                50.38641329121783
                            ],
                            [
                                -4.247245788574219,
                                50.385318754170356
                            ],
                            [
                                -4.239349365234375,
                                50.392104476643006
                            ],
                            [
                                -4.210853576660156,
                                50.398232681664645
                            ],
                            [
                                -4.204673767089844,
                                50.406548264293214
                            ],
                            [
                                -4.2111968994140625,
                                50.41464361393782
                            ],
                            [
                                -4.2084503173828125,
                                50.42711212169851
                            ],
                            [
                                -4.198493957519531,
                                50.43651601698633
                            ],
                            [
                                -4.2084503173828125,
                                50.44526214970796
                            ],
                            [
                                -4.21051025390625,
                                50.45837831855341
                            ],
                            [
                                -4.200553894042969,
                                50.457941171507
                            ],
                            [
                                -4.199523925781249,
                                50.445918044510165
                            ],
                            [
                                -4.184761047363281,
                                50.43432923127259
                            ],
                            [
                                -4.203987121582031,
                                50.40020229361594
                            ],
                            [
                                -4.1905975341796875,
                                50.38947786055672
                            ],
                            [
                                -4.184761047363281,
                                50.37875100137005
                            ],
                            [
                                -4.184417724609374,
                                50.36626976538939
                            ],
                            [
                                -4.173431396484375,
                                50.36561276727897
                            ],
                            [
                                -4.160728454589844,
                                50.360575479586124
                            ],
                            [
                                -4.124336242675781,
                                50.36320369638911
                            ],
                            [
                                -4.123649597167969,
                                50.35159464074624
                            ],
                            [
                                -4.1233062744140625,
                                50.34261210288786
                            ],
                            [
                                -4.119873046875,
                                50.32661459785906
                            ],
                            [
                                -4.118156433105468,
                                50.31981950730549
                            ],
                            [
                                -4.112663269042969,
                                50.315435062344434
                            ],
                            [
                                -4.0999603271484375,
                                50.31587352503761
                            ],
                            [
                                -4.08416748046875,
                                50.31631198368696
                            ],
                            [
                                -4.059791564941406,
                                50.313023445248035
                            ],
                            [
                                -4.0704345703125,
                                50.308857636679754
                            ],
                            [
                                -4.074897766113281,
                                50.30403361290097
                            ],
                            [
                                -4.0587615966796875,
                                50.30074422521789
                            ],
                            [
                                -4.051895141601562,
                                50.29350677155152
                            ],
                            [
                                -4.030265808105469,
                                50.2908746972229
                            ],
                            [
                                -4.0175628662109375,
                                50.29613870028112
                            ],
                            [
                                -4.015846252441405,
                                50.300524924617285
                            ],
                            [
                                -3.9993667602539062,
                                50.30206000758937
                            ],
                            [
                                -3.9931869506835938,
                                50.30819984406929
                            ],
                            [
                                -3.970870971679687,
                                50.305568582636454
                            ],
                            [
                                -3.94683837890625,
                                50.30337575356313
                            ],
                            [
                                -3.93035888671875,
                                50.29986701674912
                            ],
                            [
                                -3.90289306640625,
                                50.29460342621637
                            ],
                            [
                                -3.8726806640625,
                                50.28231945008158
                            ],
                            [
                                -3.856201171875,
                                50.261253827584724
                            ],
                            [
                                -3.86444091796875,
                                50.245448494340785
                            ],
                            [
                                -3.856201171875,
                                50.22788086350316
                            ],
                            [
                                -3.8232421874999996,
                                50.222609311890224
                            ],
                            [
                                -3.7765502929687496,
                                50.208548992291014
                            ],
                            [
                                -3.77105712890625,
                                50.226123744371364
                            ],
                            [
                                -3.7628173828124996,
                                50.241935486043715
                            ],
                            [
                                -3.7683105468749996,
                                50.261253827584724
                            ],
                            [
                                -3.7408447265625,
                                50.261253827584724
                            ],
                            [
                                -3.748226165771484,
                                50.258180978954
                            ],
                            [
                                -3.7569808959960933,
                                50.25082728650708
                            ],
                            [
                                -3.7562942504882812,
                                50.23798304220771
                            ],
                            [
                                -3.7635040283203125,
                                50.2360066973968
                            ],
                            [
                                -3.7732887268066406,
                                50.2270023120296
                            ],
                            [
                                -3.771743774414063,
                                50.2218404952654
                            ],
                            [
                                -3.7499427795410156,
                                50.21832574717402
                            ],
                            [
                                -3.7405014038085933,
                                50.21535997703798
                            ],
                            [
                                -3.7319183349609375,
                                50.2063516930489
                            ],
                            [
                                -3.7168121337890625,
                                50.20151727860476
                            ],
                            [
                                -3.704452514648437,
                                50.20547274502523
                            ],
                            [
                                -3.7003326416015625,
                                50.21074619036717
                            ],
                            [
                                -3.689346313476562,
                                50.215140283027054
                            ],
                            [
                                -3.682479858398437,
                                50.22129133294659
                            ],
                            [
                                -3.658447265625,
                                50.21777654439172
                            ],
                            [
                                -3.65020751953125,
                                50.219973317586145
                            ],
                            [
                                -3.658447265625,
                                50.231394907552854
                            ],
                            [
                                -3.6563873291015625,
                                50.251156580590994
                            ],
                            [
                                -3.635101318359375,
                                50.303814327466064
                            ],
                            [
                                -3.6199951171875,
                                50.305568582636454
                            ],
                            [
                                -3.6117553710937496,
                                50.3217923756109
                            ],
                            [
                                -3.585662841796875,
                                50.32661459785906
                            ],
                            [
                                -3.57330322265625,
                                50.3235459675844
                            ],
                            [
                                -3.5650634765625,
                                50.33713411177109
                            ],
                            [
                                -3.5671234130859375,
                                50.3432694193687
                            ],
                            [
                                -3.5753631591796875,
                                50.34633677599788
                            ],
                            [
                                -3.5767364501953125,
                                50.35597574998605
                            ],
                            [
                                -3.582916259765625,
                                50.36342270788681
                            ],
                            [
                                -3.580169677734375,
                                50.37218233908614
                            ],
                            [
                                -3.6117553710937496,
                                50.39232335474891
                            ],
                            [
                                -3.5870361328124996,
                                50.394949813205464
                            ],
                            [
                                -3.57879638671875,
                                50.38969675078809
                            ],
                            [
                                -3.5884094238281246,
                                50.38269176218573
                            ],
                            [
                                -3.5774230957031246,
                                50.376561548331125
                            ],
                            [
                                -3.5760498046875,
                                50.36824070514717
                            ],
                            [
                                -3.5684967041015625,
                                50.35641383867465
                            ],
                            [
                                -3.571929931640625,
                                50.34984208385045
                            ],
                            [
                                -3.5513305664062496,
                                50.3406400988631
                            ],
                            [
                                -3.5451507568359375,
                                50.3353810211872
                            ],
                            [
                                -3.52935791015625,
                                50.337572374308884
                            ],
                            [
                                -3.5149383544921875,
                                50.3480894622679
                            ],
                            [
                                -3.515625,
                                50.356851923320505
                            ],
                            [
                                -3.519744873046875,
                                50.359480346298696
                            ],
                            [
                                -3.515625,
                                50.369992582877195
                            ],
                            [
                                -3.515625,
                                50.37393407129137
                            ],
                            [
                                -3.5060119628906246,
                                50.37875100137005
                            ],
                            [
                                -3.492279052734375,
                                50.37875100137005
                            ],
                            [
                                -3.5012054443359375,
                                50.388383394242794
                            ],
                            [
                                -3.4860992431640625,
                                50.39451208023374
                            ],
                            [
                                -3.479232788085937,
                                50.399326920630486
                            ],
                            [
                                -3.4970855712890625,
                                50.40239065535228
                            ],
                            [
                                -3.511505126953125,
                                50.40020229361594
                            ],
                            [
                                -3.5300445556640625,
                                50.40589182397226
                            ],
                            [
                                -3.5472106933593746,
                                50.401952991088066
                            ],
                            [
                                -3.554763793945312,
                                50.40720469552101
                            ],
                            [
                                -3.5506439208984375,
                                50.41420606283159
                            ],
                            [
                                -3.558197021484375,
                                50.42208136445241
                            ],
                            [
                                -3.5561370849609375,
                                50.44657393022164
                            ],
                            [
                                -3.53759765625,
                                50.46056399318573
                            ],
                            [
                                -3.5149383544921875,
                                50.454006666287384
                            ],
                            [
                                -3.503265380859375,
                                50.46012686633918
                            ],
                            [
                                -3.4888458251953125,
                                50.45925260052624
                            ],
                            [
                                -3.49365234375,
                                50.46886863569486
                            ],
                            [
                                -3.497772216796875,
                                50.477608789165075
                            ],
                            [
                                -3.514251708984375,
                                50.48154133106944
                            ],
                            [
                                -3.509445190429687,
                                50.5064398321055
                            ],
                            [
                                -3.500518798828125,
                                50.52477769947372
                            ],
                            [
                                -3.489532470703125,
                                50.54747185651959
                            ],
                            [
                                -3.473052978515625,
                                50.56317680042185
                            ],
                            [
                                -3.4696197509765625,
                                50.56361297417422
                            ],
                            [
                                -3.468246459960937,
                                50.57756840272205
                            ],
                            [
                                -3.442840576171875,
                                50.58934008029386
                            ],
                            [
                                -3.437347412109375,
                                50.59892964194682
                            ],
                            [
                                -3.4435272216796875,
                                50.60372369020802
                            ],
                            [
                                -3.4449005126953125,
                                50.62507306341435
                            ],
                            [
                                -3.453826904296875,
                                50.64031668358762
                            ],
                            [
                                -3.4462738037109375,
                                50.65207267042477
                            ],
                            [
                                -3.4572601318359375,
                                50.65773191136251
                            ],
                            [
                                -3.4654998779296875,
                                50.66382571601043
                            ],
                            [
                                -3.468246459960937,
                                50.67209461471226
                            ],
                            [
                                -3.464813232421875,
                                50.67557582058605
                            ],
                            [
                                -3.4476470947265625,
                                50.6712242729033
                            ],
                            [
                                -3.438034057617187,
                                50.65903779321195
                            ],
                            [
                                -3.4325408935546875,
                                50.643800245593596
                            ],
                            [
                                -3.4222412109375,
                                50.63813932619779
                            ],
                            [
                                -3.416748046875,
                                50.623330620643436
                            ],
                            [
                                -3.4105682373046875,
                                50.61418173677348
                            ],
                            [
                                -3.40301513671875,
                                50.6106959795449
                            ],
                            [
                                -3.3892822265625,
                                50.60938875399383
                            ],
                            [
                                -3.385162353515625,
                                50.60677419392376
                            ],
                            [
                                -3.369369506835937,
                                50.608517250113955
                            ],
                            [
                                -3.360443115234375,
                                50.611567443066605
                            ],
                            [
                                -3.3528900146484375,
                                50.617667235717185
                            ],
                            [
                                -3.3460235595703125,
                                50.620281190429196
                            ],
                            [
                                -3.321990966796875,
                                50.625508664018554
                            ],
                            [
                                -3.308258056640625,
                                50.62768660650907
                            ],
                            [
                                -3.2883453369140625,
                                50.63944575273666
                            ],
                            [
                                -3.282852172851562,
                                50.65294336725709
                            ],
                            [
                                -3.26568603515625,
                                50.665566657816164
                            ],
                            [
                                -3.264312744140625,
                                50.67035391495795
                            ],
                            [
                                -3.1908416748046875,
                                50.68471275767546
                            ],
                            [
                                -3.1523895263671875,
                                50.68601788918605
                            ],
                            [
                                -3.13385009765625,
                                50.686452924955525
                            ],
                            [
                                -3.099517822265625,
                                50.68471275767546
                            ],
                            [
                                -3.0919647216796875,
                                50.69558774435639
                            ],
                            [
                                -3.0754852294921875,
                                50.701241741166335
                            ],
                            [
                                -3.0596923828124996,
                                50.70385104825872
                            ],
                            [
                                -3.03497314453125,
                                50.69906720767511
                            ],
                            [
                                -3.006820678710937,
                                50.69993703317144
                            ],
                            [
                                -2.9937744140625,
                                50.70472078502399
                            ],
                            [
                                -2.981414794921875,
                                50.70211152632997
                            ],
                            [
                                -2.9690551757812496,
                                50.712112896185104
                            ],
                            [
                                -2.956695556640625,
                                50.712112896185104
                            ],
                            [
                                -2.9340362548828125,
                                50.720373288220316
                            ],
                            [
                                -2.929229736328125,
                                50.73124000713507
                            ],
                            [
                                -2.910003662109375,
                                50.73471682490245
                            ],
                            [
                                -2.8777313232421875,
                                50.73254384404044
                            ],
                            [
                                -2.8502655029296875,
                                50.72472027822819
                            ],
                            [
                                -2.8399658203125,
                                50.720373288220316
                            ],
                            [
                                -2.8282928466796875,
                                50.72472027822819
                            ],
                            [
                                -2.8200531005859375,
                                50.72080800536808
                            ],
                            [
                                -2.79327392578125,
                                50.717764900646586
                            ],
                            [
                                -2.7774810791015625,
                                50.71515636789281
                            ],
                            [
                                -2.72735595703125,
                                50.69993703317144
                            ],
                            [
                                -2.6641845703125,
                                50.67427039863853
                            ],
                            [
                                -2.60101318359375,
                                50.64641274763311
                            ],
                            [
                                -2.4712371826171875,
                                50.57407993312597
                            ],
                            [
                                -2.4465179443359375,
                                50.55750617425856
                            ],
                            [
                                -2.448577880859375,
                                50.54354480296085
                            ],
                            [
                                -2.456817626953125,
                                50.53088873891836
                            ],
                            [
                                -2.456817626953125,
                                50.51517303835635
                            ],
                            [
                                -2.4423980712890625,
                                50.52172188294704
                            ],
                            [
                                -2.4355316162109375,
                                50.534380406110806
                            ],
                            [
                                -2.41973876953125,
                                50.542235712430404
                            ],
                            [
                                -2.4169921874999996,
                                50.55532498251967
                            ],
                            [
                                -2.423858642578125,
                                50.56841061900368
                            ],
                            [
                                -2.4506378173828125,
                                50.56928286558243
                            ],
                            [
                                -2.4609375,
                                50.57233560144463
                            ],
                            [
                                -2.470550537109375,
                                50.583672602863736
                            ],
                            [
                                -2.4623107910156246,
                                50.59762208948121
                            ],
                            [
                                -2.4472045898437496,
                                50.59892964194682
                            ],
                            [
                                -2.4506378173828125,
                                50.610260241730366
                            ],
                            [
                                -2.443771362304687,
                                50.623330620643436
                            ],
                            [
                                -2.42523193359375,
                                50.633348784855315
                            ],
                            [
                                -2.40875244140625,
                                50.63291325688617
                            ],
                            [
                                -2.39227294921875,
                                50.635961867932195
                            ],
                            [
                                -2.3737335205078125,
                                50.634655344551845
                            ],
                            [
                                -2.3709869384765625,
                                50.633348784855315
                            ],
                            [
                                -2.3380279541015625,
                                50.63204218884234
                            ],
                            [
                                -2.3242950439453125,
                                50.625508664018554
                            ],
                            [
                                -2.2995758056640625,
                                50.62507306341435
                            ],
                            [
                                -2.2927093505859375,
                                50.620281190429196
                            ],
                            [
                                -2.2679901123046875,
                                50.62158811330538
                            ],
                            [
                                -2.2597503662109375,
                                50.61984554139944
                            ],
                            [
                                -2.22747802734375,
                                50.61374603124499
                            ],
                            [
                                -2.209625244140625,
                                50.61984554139944
                            ],
                            [
                                -2.1903991699218746,
                                50.620716835423465
                            ],
                            [
                                -2.182846069335937,
                                50.615924518530534
                            ],
                            [
                                -2.1691131591796875,
                                50.61548882914478
                            ],
                            [
                                -2.15606689453125,
                                50.61723156247395
                            ],
                            [
                                -2.1450805664062496,
                                50.610260241730366
                            ],
                            [
                                -2.13134765625,
                                50.610260241730366
                            ],
                            [
                                -2.1292877197265625,
                                50.60546685940414
                            ],
                            [
                                -2.1045684814453125,
                                50.59544275464843
                            ],
                            [
                                -2.0977020263671875,
                                50.597186230587035
                            ],
                            [
                                -2.06268310546875,
                                50.58934008029386
                            ],
                            [
                                -2.05169677734375,
                                50.57277169042023
                            ],
                            [
                                -2.036590576171875,
                                50.58062060169053
                            ],
                            [
                                -2.0159912109375,
                                50.59195560903164
                            ],
                            [
                                -1.9555664062500002,
                                50.590211939351896
                            ],
                            [
                                -1.9500732421875,
                                50.59892964194682
                            ],
                            [
                                -1.954193115234375,
                                50.616360203880646
                            ],
                            [
                                -1.951446533203125,
                                50.63639736765544
                            ],
                            [
                                -1.9253540039062502,
                                50.63726835499671
                            ],
                            [
                                -1.921234130859375,
                                50.643364814465016
                            ],
                            [
                                -1.9335937499999998,
                                50.641623049601776
                            ],
                            [
                                -1.94732666015625,
                                50.6512019574539
                            ],
                            [
                                -1.9500732421875,
                                50.6607789125291
                            ],
                            [
                                -1.9404602050781252,
                                50.66948354087614
                            ],
                            [
                                -1.94732666015625,
                                50.676446081714474
                            ],
                            [
                                -1.9555664062500002,
                                50.6729649403849
                            ],
                            [
                                -1.9747924804687498,
                                50.6686131506577
                            ],
                            [
                                -1.984405517578125,
                                50.67470554332169
                            ],
                            [
                                -2.00225830078125,
                                50.680797145321655
                            ],
                            [
                                -2.017364501953125,
                                50.67992696487123
                            ],
                            [
                                -2.028350830078125,
                                50.677316326707135
                            ],
                            [
                                -2.02423095703125,
                                50.692108022899525
                            ],
                            [
                                -2.032470703125,
                                50.69993703317144
                            ],
                            [
                                -2.053070068359375,
                                50.698197366045534
                            ],
                            [
                                -2.061309814453125,
                                50.68775800806201
                            ],
                            [
                                -2.0709228515625,
                                50.68949806239989
                            ],
                            [
                                -2.077789306640625,
                                50.697327508282626
                            ],
                            [
                                -2.06817626953125,
                                50.711243296543756
                            ],
                            [
                                -2.04071044921875,
                                50.719069112580804
                            ],
                            [
                                -2.0159912109375,
                                50.71472159831894
                            ],
                            [
                                -1.9789123535156248,
                                50.71037368077058
                            ],
                            [
                                -1.962432861328125,
                                50.71385204707258
                            ],
                            [
                                -1.9445800781249998,
                                50.71298247969465
                            ],
                            [
                                -1.934967041015625,
                                50.70167663576478
                            ],
                            [
                                -1.915740966796875,
                                50.69993703317144
                            ],
                            [
                                -1.904754638671875,
                                50.708634400828224
                            ],
                            [
                                -1.87591552734375,
                                50.71472159831894
                            ],
                            [
                                -1.844329833984375,
                                50.718199641990765
                            ],
                            [
                                -1.8182373046875,
                                50.72167742756552
                            ],
                            [
                                -1.77978515625,
                                50.71559113343383
                            ],
                            [
                                -1.7413330078125,
                                50.707764736658866
                            ],
                            [
                                -1.737213134765625,
                                50.72254683363231
                            ],
                            [
                                -1.7152404785156248,
                                50.72776293129446
                            ],
                            [
                                -1.7193603515625,
                                50.736455137010665
                            ],
                            [
                                -1.649322509765625,
                                50.73037076236953
                            ],
                            [
                                -1.60400390625,
                                50.728632224449335
                            ],
                            [
                                -1.58203125,
                                50.718199641990765
                            ],
                            [
                                -1.5600585937499998,
                                50.707764736658866
                            ],
                            [
                                -1.553192138671875,
                                50.72167742756552
                            ],
                            [
                                -1.53533935546875,
                                50.73210923577103
                            ],
                            [
                                -1.52435302734375,
                                50.74427674312445
                            ],
                            [
                                -1.4996337890624998,
                                50.74688365485319
                            ],
                            [
                                -1.481781005859375,
                                50.752965884419
                            ],
                            [
                                -1.448822021484375,
                                50.761653413004304
                            ],
                            [
                                -1.40625,
                                50.77033932897997
                            ],
                            [
                                -1.38153076171875,
                                50.77728690074856
                            ],
                            [
                                -1.349945068359375,
                                50.78510168548186
                            ],
                            [
                                -1.31561279296875,
                                50.80246319809847
                            ],
                            [
                                -1.3087463378906248,
                                50.817215413611876
                            ],
                            [
                                -1.333465576171875,
                                50.826758482363275
                            ],
                            [
                                -1.32659912109375,
                                50.83803414003555
                            ],
                            [
                                -1.3540649414062498,
                                50.84930707388861
                            ],
                            [
                                -1.396636962890625,
                                50.86664473085768
                            ],
                            [
                                -1.413116455078125,
                                50.8865750680795
                            ],
                            [
                                -1.440582275390625,
                                50.90130070888041
                            ],
                            [
                                -1.4337158203125,
                                50.909094751475706
                            ],
                            [
                                -1.4117431640625,
                                50.89870240470782
                            ],
                            [
                                -1.4007568359375,
                                50.887441411132265
                            ],
                            [
                                -1.388397216796875,
                                50.885708708915175
                            ],
                            [
                                -1.38153076171875,
                                50.890906622229174
                            ],
                            [
                                -1.366424560546875,
                                50.88051021557967
                            ],
                            [
                                -1.327972412109375,
                                50.85884358291
                            ],
                            [
                                -1.307373046875,
                                50.84323737103244
                            ],
                            [
                                -1.303253173828125,
                                50.834564997026824
                            ],
                            [
                                -1.2483215332031248,
                                50.820685846099174
                            ],
                            [
                                -1.23046875,
                                50.819818262156545
                            ],
                            [
                                -1.20025634765625,
                                50.798123424528
                            ],
                            [
                                -1.154937744140625,
                                50.78076029964647
                            ],
                            [
                                -1.142578125,
                                50.775550104554206
                            ],
                            [
                                -1.13433837890625,
                                50.774681682270334
                            ],
                            [
                                -1.1178588867187498,
                                50.78596991427834
                            ],
                            [
                                -1.119232177734375,
                                50.798123424528
                            ],
                            [
                                -1.130218505859375,
                                50.81461241998999
                            ],
                            [
                                -1.1480712890624998,
                                50.829360798981426
                            ],
                            [
                                -1.14532470703125,
                                50.83716687845952
                            ],
                            [
                                -1.12060546875,
                                50.834564997026824
                            ],
                            [
                                -1.11236572265625,
                                50.835432306955276
                            ],
                            [
                                -1.108245849609375,
                                50.84497165243032
                            ],
                            [
                                -1.0986328125,
                                50.834564997026824
                            ],
                            [
                                -1.100006103515625,
                                50.820685846099174
                            ],
                            [
                                -1.1041259765625,
                                50.80853820400125
                            ],
                            [
                                -1.109619140625,
                                50.80333110444795
                            ],
                            [
                                -1.1027526855468748,
                                50.78857450392834
                            ],
                            [
                                -1.0876464843749998,
                                50.78162860906095
                            ],
                            [
                                -1.0711669921875,
                                50.77728690074856
                            ],
                            [
                                -1.058807373046875,
                                50.782496902351625
                            ],
                            [
                                -1.031341552734375,
                                50.78336517951859
                            ],
                            [
                                -1.02996826171875,
                                50.787706323501475
                            ],
                            [
                                -1.036834716796875,
                                50.79638740224723
                            ],
                            [
                                -1.039581298828125,
                                50.80767039437801
                            ],
                            [
                                -1.039581298828125,
                                50.822420965626726
                            ],
                            [
                                -1.0382080078125,
                                50.829360798981426
                            ],
                            [
                                -1.02996826171875,
                                50.825891011253546
                            ],
                            [
                                -1.021728515625,
                                50.83196297053503
                            ],
                            [
                                -1.01898193359375,
                                50.84237020615854
                            ],
                            [
                                -1.0052490234375,
                                50.84410451978964
                            ],
                            [
                                -0.9942626953125,
                                50.83976861483587
                            ],
                            [
                                -0.973663330078125,
                                50.84150302516789
                            ],
                            [
                                -0.954437255859375,
                                50.84237020615854
                            ],
                            [
                                -0.935211181640625,
                                50.84237020615854
                            ],
                            [
                                -0.9393310546875,
                                50.834564997026824
                            ],
                            [
                                -0.935211181640625,
                                50.822420965626726
                            ],
                            [
                                -0.937957763671875,
                                50.8154801006505
                            ],
                            [
                                -0.92010498046875,
                                50.80940599750376
                            ],
                            [
                                -0.907745361328125,
                                50.80506686878317
                            ],
                            [
                                -0.9063720703124999,
                                50.8241560206779
                            ],
                            [
                                -0.90911865234375,
                                50.834564997026824
                            ],
                            [
                                -0.8953857421874999,
                                50.838901385494296
                            ],
                            [
                                -0.8953857421874999,
                                50.830228205617445
                            ],
                            [
                                -0.891265869140625,
                                50.819818262156545
                            ],
                            [
                                -0.885772705078125,
                                50.80940599750376
                            ],
                            [
                                -0.8734130859375,
                                50.81461241998999
                            ],
                            [
                                -0.866546630859375,
                                50.8232885012118
                            ],
                            [
                                -0.869293212890625,
                                50.83629960076613
                            ],
                            [
                                -0.8528137207031249,
                                50.835432306955276
                            ],
                            [
                                -0.8600234985351562,
                                50.82762593735444
                            ],
                            [
                                -0.8641433715820311,
                                50.819601363652225
                            ],
                            [
                                -0.8703231811523438,
                                50.81222621505465
                            ],
                            [
                                -0.869293212890625,
                                50.80723648352111
                            ],
                            [
                                -0.88714599609375,
                                50.80419899467614
                            ],
                            [
                                -0.8892059326171875,
                                50.80376505157722
                            ],
                            [
                                -0.8988189697265624,
                                50.79096191696835
                            ],
                            [
                                -0.9108352661132812,
                                50.78553580189552
                            ],
                            [
                                -0.9149551391601562,
                                50.78705517760055
                            ],
                            [
                                -0.9170150756835938,
                                50.77815527465925
                            ],
                            [
                                -0.9101486206054686,
                                50.776418510713576
                            ],
                            [
                                -0.9043121337890624,
                                50.774681682270334
                            ],
                            [
                                -0.8943557739257811,
                                50.77185919848671
                            ],
                            [
                                -0.8689498901367186,
                                50.76404220065041
                            ],
                            [
                                -0.8545303344726562,
                                50.758395778767856
                            ],
                            [
                                -0.8353042602539062,
                                50.75187982995427
                            ],
                            [
                                -0.8160781860351562,
                                50.739279756586456
                            ],
                            [
                                -0.8068084716796875,
                                50.73037076236953
                            ],
                            [
                                -0.7930755615234375,
                                50.722112132615244
                            ],
                            [
                                -0.7838058471679686,
                                50.72298153061673
                            ],
                            [
                                -0.7625198364257812,
                                50.74275597758379
                            ],
                            [
                                -0.7590866088867188,
                                50.752965884419
                            ],
                            [
                                -0.7309341430664061,
                                50.771424955095256
                            ],
                            [
                                -0.6928253173828125,
                                50.77924071937294
                            ],
                            [
                                -0.6622695922851562,
                                50.78206275772177
                            ],
                            [
                                -0.6488800048828125,
                                50.786838126951494
                            ],
                            [
                                -0.6279373168945311,
                                50.78835746033317
                            ],
                            [
                                -0.6142044067382812,
                                50.78965970678897
                            ],
                            [
                                -0.6004714965820311,
                                50.790527850939256
                            ],
                            [
                                -0.5740356445312499,
                                50.79703841815972
                            ],
                            [
                                -0.5427932739257812,
                                50.801812257756666
                            ],
                            [
                                -0.476531982421875,
                                50.802897153288384
                            ],
                            [
                                -0.457305908203125,
                                50.801161308346565
                            ],
                            [
                                -0.4044342041015625,
                                50.80419899467614
                            ],
                            [
                                -0.36426544189453125,
                                50.80897210276759
                            ],
                            [
                                -0.33061981201171875,
                                50.817215413611876
                            ],
                            [
                                -0.28186798095703125,
                                50.82372226295971
                            ],
                            [
                                -0.22659301757812497,
                                50.82762593735444
                            ],
                            [
                                -0.163421630859375,
                                50.8232885012118
                            ],
                            [
                                -0.10711669921875,
                                50.80853820400125
                            ],
                            [
                                -0.083770751953125,
                                50.81114153614715
                            ],
                            [
                                -0.045318603515625,
                                50.80419899467614
                            ],
                            [
                                -0.010986328125,
                                50.793783247910106
                            ],
                            [
                                0.034332275390625,
                                50.77815527465925
                            ],
                            [
                                0.070037841796875,
                                50.78336517951859
                            ],
                            [
                                0.111236572265625,
                                50.76252207716766
                            ],
                            [
                                0.1373291015625,
                                50.751228185180004
                            ],
                            [
                                0.152435302734375,
                                50.756441089372665
                            ],
                            [
                                0.1922607421875,
                                50.745145729828636
                            ],
                            [
                                0.248565673828125,
                                50.73384764465462
                            ],
                            [
                                0.27191162109374994,
                                50.74601470040487
                            ],
                            [
                                0.28839111328125,
                                50.75991603629921
                            ],
                            [
                                0.325469970703125,
                                50.7798919741081
                            ],
                            [
                                0.333709716796875,
                                50.7903108164132
                            ],
                            [
                                0.339202880859375,
                                50.80159527562757
                            ],
                            [
                                0.363922119140625,
                                50.81461241998999
                            ],
                            [
                                0.399627685546875,
                                50.819818262156545
                            ],
                            [
                                0.41885375976562494,
                                50.82762593735444
                            ],
                            [
                                0.479278564453125,
                                50.83369767098071
                            ],
                            [
                                0.506744384765625,
                                50.84150302516789
                            ],
                            [
                                0.516357421875,
                                50.846705869362324
                            ],
                            [
                                0.55206298828125,
                                50.84930707388861
                            ],
                            [
                                0.5877685546875,
                                50.8510411296595
                            ],
                            [
                                0.627593994140625,
                                50.86404449323755
                            ],
                            [
                                0.660552978515625,
                                50.86491125522503
                            ],
                            [
                                0.670166015625,
                                50.8744445735763
                            ],
                            [
                                0.699005126953125,
                                50.88397594225127
                            ],
                            [
                                0.712738037109375,
                                50.899568522208746
                            ],
                            [
                                0.73883056640625,
                                50.9212162242195
                            ],
                            [
                                0.76904296875,
                                50.9281413625921
                            ],
                            [
                                0.78277587890625,
                                50.932469050603345
                            ],
                            [
                                0.8404541015624999,
                                50.9281413625921
                            ],
                            [
                                0.88165283203125,
                                50.92035050944008
                            ],
                            [
                                0.9516906738281249,
                                50.910826583740125
                            ],
                            [
                                0.9832763671875,
                                50.92035050944008
                            ],
                            [
                                0.9558105468749999,
                                50.97745313889934
                            ],
                            [
                                0.9970092773437499,
                                51.031031114144035
                            ],
                            [
                                1.109619140625,
                                51.07419409303002
                            ],
                            [
                                1.197509765625,
                                51.08109643660297
                            ],
                            [
                                1.21673583984375,
                                51.09489803482296
                            ],
                            [
                                1.2799072265625,
                                51.103521942404186
                            ],
                            [
                                1.318359375,
                                51.11559271064121
                            ],
                            [
                                1.34857177734375,
                                51.12421275782688
                            ],
                            [
                                1.38153076171875,
                                51.144894309328016
                            ],
                            [
                                1.4089965820312498,
                                51.17417731875822
                            ],
                            [
                                1.417236328125,
                                51.23096775701038
                            ],
                            [
                                1.3677978515625,
                                51.32203016092245
                            ],
                            [
                                1.43096923828125,
                                51.33575975299127
                            ],
                            [
                                1.45843505859375,
                                51.382066781130575
                            ],
                            [
                                1.4144897460937498,
                                51.394064665922045
                            ],
                            [
                                1.35955810546875,
                                51.385495069223204
                            ],
                            [
                                1.28265380859375,
                                51.37349493730543
                            ],
                            [
                                1.23046875,
                                51.380352540777984
                            ],
                            [
                                1.153564453125,
                                51.37349493730543
                            ],
                            [
                                1.0876464843749998,
                                51.376923867455886
                            ],
                            [
                                1.0546875,
                                51.37178037591737
                            ],
                            [
                                1.0272216796875,
                                51.36320660581431
                            ],
                            [
                                1.0107421875,
                                51.342623007528275
                            ],
                            [
                                0.95855712890625,
                                51.342623007528275
                            ],
                            [
                                0.9118652343749999,
                                51.339191508712105
                            ],
                            [
                                0.87890625,
                                51.34776977407131
                            ],
                            [
                                0.8184814453125,
                                51.35291596261771
                            ],
                            [
                                0.78277587890625,
                                51.36320660581431
                            ],
                            [
                                0.76629638671875,
                                51.37178037591737
                            ],
                            [
                                0.7498168945312499,
                                51.39235087498254
                            ],
                            [
                                0.72784423828125,
                                51.40777268236964
                            ],
                            [
                                0.70037841796875,
                                51.41976382669734
                            ],
                            [
                                0.70587158203125,
                                51.390637019843744
                            ],
                            [
                                0.71136474609375,
                                51.38378095727871
                            ],
                            [
                                0.6866455078125,
                                51.380352540777984
                            ],
                            [
                                0.6619262695312499,
                                51.390637019843744
                            ],
                            [
                                0.60699462890625,
                                51.382066781130575
                            ],
                            [
                                0.54107666015625,
                                51.40091918770499
                            ],
                            [
                                0.6042480468749999,
                                51.4163381064004
                            ],
                            [
                                0.63995361328125,
                                51.43517639096306
                            ],
                            [
                                0.67840576171875,
                                51.43860069927038
                            ],
                            [
                                0.7196044921874999,
                                51.44202475087509
                            ],
                            [
                                0.7086181640625,
                                51.46427482966439
                            ],
                            [
                                0.65643310546875,
                                51.47625114982365
                            ],
                            [
                                0.5657958984375,
                                51.47796179607121
                            ],
                            [
                                0.48339843749999994,
                                51.48651406499528
                            ],
                            [
                                0.46142578125,
                                51.47625114982365
                            ],
                            [
                                0.45043945312499994,
                                51.45742980658965
                            ],
                            [
                                0.43121337890625,
                                51.45914115860514
                            ],
                            [
                                0.45318603515624994,
                                51.48993452350154
                            ],
                            [
                                0.48339843749999994,
                                51.50361379162682
                            ],
                            [
                                0.538330078125,
                                51.508742458803326
                            ],
                            [
                                0.59326171875,
                                51.508742458803326
                            ],
                            [
                                0.6207275390625,
                                51.5189980614127
                            ],
                            [
                                0.63995361328125,
                                51.53437713632629
                            ],
                            [
                                0.703125,
                                51.53437713632629
                            ],
                            [
                                0.76629638671875,
                                51.520707104039275
                            ],
                            [
                                0.79925537109375,
                                51.5189980614127
                            ],
                            [
                                0.9558105468749999,
                                51.6163111603273
                            ],
                            [
                                0.9255981445312499,
                                51.62995247363852
                            ],
                            [
                                0.9667968749999999,
                                51.691287641824474
                            ],
                            [
                                0.9503173828125,
                                51.73723454645786
                            ],
                            [
                                0.90362548828125,
                                51.742336876891024
                            ],
                            [
                                0.8651733398437499,
                                51.725326868064954
                            ],
                            [
                                0.78826904296875,
                                51.71852107186864
                            ],
                            [
                                0.7305908203125,
                                51.713416052417614
                            ],
                            [
                                0.71136474609375,
                                51.732131639851644
                            ],
                            [
                                0.7772827148437499,
                                51.73723454645786
                            ],
                            [
                                0.8349609375,
                                51.74403752566788
                            ],
                            [
                                0.889892578125,
                                51.75253980933652
                            ],
                            [
                                0.89813232421875,
                                51.77463825786986
                            ],
                            [
                                0.9722900390624999,
                                51.8001230280236
                            ],
                            [
                                0.98876953125,
                                51.813709018585094
                            ],
                            [
                                1.0272216796875,
                                51.78993084774129
                            ],
                            [
                                1.0821533203125,
                                51.77803705914517
                            ],
                            [
                                1.15081787109375,
                                51.77463825786986
                            ],
                            [
                                1.19476318359375,
                                51.793328497122566
                            ],
                            [
                                1.27166748046875,
                                51.832383069996645
                            ],
                            [
                                1.3018798828125,
                                51.878186564984
                            ],
                            [
                                1.2634277343749998,
                                51.878186564984
                            ],
                            [
                                1.2579345703125,
                                51.91547346517476
                            ],
                            [
                                1.29638671875,
                                51.93579873353698
                            ],
                            [
                                1.27166748046875,
                                51.944264879028765
                            ],
                            [
                                1.14532470703125,
                                51.944264879028765
                            ],
                            [
                                1.07391357421875,
                                51.9493437994359
                            ],
                            [
                                1.131591796875,
                                51.964577109947506
                            ],
                            [
                                1.197509765625,
                                51.95611479866179
                            ],
                            [
                                1.24969482421875,
                                51.959499914870015
                            ],
                            [
                                1.2908935546875,
                                51.952729426852905
                            ],
                            [
                                1.2634277343749998,
                                51.97980524492489
                            ],
                            [
                                1.2084960937499998,
                                52.00179230422271
                            ],
                            [
                                1.21124267578125,
                                52.01362701862776
                            ],
                            [
                                1.27166748046875,
                                51.991645772197344
                            ],
                            [
                                1.2936401367187498,
                                51.96288477548509
                            ],
                            [
                                1.34307861328125,
                                51.947650889871994
                            ],
                            [
                                1.3897705078125,
                                51.981496940474585
                            ],
                            [
                                1.4556884765625,
                                52.0339078196625
                            ],
                            [
                                1.49688720703125,
                                52.05080146285827
                            ],
                            [
                                1.56829833984375,
                                52.07444183716456
                            ],
                            [
                                1.60675048828125,
                                52.13011607781287
                            ],
                            [
                                1.61224365234375,
                                52.19413974159753
                            ],
                            [
                                1.6452026367187498,
                                52.26479561297205
                            ],
                            [
                                1.69464111328125,
                                52.34372961830717
                            ],
                            [
                                1.746826171875,
                                52.43424610262303
                            ],
                            [
                                1.7523193359375,
                                52.47441608702583
                            ],
                            [
                                1.7358398437499998,
                                52.576349937498875
                            ],
                            [
                                1.74957275390625,
                                52.638063449400555
                            ],
                            [
                                1.57928466796875,
                                52.802761415419674
                            ],
                            [
                                1.37054443359375,
                                52.907245596258804
                            ],
                            [
                                1.26068115234375,
                                52.948637884883205
                            ],
                            [
                                1.0986328125,
                                52.96187505907603
                            ],
                            [
                                0.95855712890625,
                                52.9883372533954
                            ],
                            [
                                0.7800292968749999,
                                52.9784158294106
                            ],
                            [
                                0.670166015625,
                                52.985030365232305
                            ],
                            [
                                0.59600830078125,
                                52.985030365232305
                            ],
                            [
                                0.51910400390625,
                                52.96849212681396
                            ],
                            [
                                0.46417236328125,
                                52.90227586168308
                            ],
                            [
                                0.43395996093749994,
                                52.86581372042818
                            ],
                            [
                                0.40924072265625,
                                52.832639706103215
                            ],
                            [
                                0.3350830078125,
                                52.81936300159786
                            ],
                            [
                                0.26641845703125,
                                52.81936300159786
                            ],
                            [
                                0.2032470703125,
                                52.84757114966556
                            ],
                            [
                                0.1593017578125,
                                52.87741863698718
                            ],
                            [
                                0.1043701171875,
                                52.90393250321626
                            ],
                            [
                                0.0714111328125,
                                52.912214760778674
                            ],
                            [
                                0.076904296875,
                                52.948637884883205
                            ],
                            [
                                0.16204833984375,
                                53.001562274591464
                            ],
                            [
                                0.2362060546875,
                                53.05112003878514
                            ],
                            [
                                0.3131103515625,
                                53.08412692217884
                            ],
                            [
                                0.3570556640625,
                                53.11710851455023
                            ],
                            [
                                0.35980224609374994,
                                53.19780658276436
                            ],
                            [
                                0.28839111328125,
                                53.337433437129675
                            ],
                            [
                                0.2471923828125,
                                53.375136469342564
                            ],
                            [
                                0.20599365234375,
                                53.420990805007634
                            ],
                            [
                                0.17303466796874997,
                                53.45207811269815
                            ],
                            [
                                0.12084960937499999,
                                53.48477702972815
                            ],
                            [
                                0.076904296875,
                                53.499483324932996
                            ],
                            [
                                0.02197265625,
                                53.528880618043225
                            ],
                            [
                                0,
                                53.54030739150022
                            ],
                            [
                                -0.05218505859375,
                                53.59413494042568
                            ],
                            [
                                -0.164794921875,
                                53.608803292930894
                            ],
                            [
                                -0.208740234375,
                                53.66417110963306
                            ],
                            [
                                -0.2801513671875,
                                53.70321053273598
                            ],
                            [
                                -0.46142578125,
                                53.70971358510174
                            ],
                            [
                                -0.52734375,
                                53.68044193408404
                            ],
                            [
                                -0.6427001953125,
                                53.70971358510174
                            ],
                            [
                                -0.6317138671874999,
                                53.72596681931765
                            ],
                            [
                                -0.516357421875,
                                53.72596681931765
                            ],
                            [
                                -0.406494140625,
                                53.73571574532637
                            ],
                            [
                                -0.263671875,
                                53.73246635451261
                            ],
                            [
                                -0.17578125,
                                53.69020141273198
                            ],
                            [
                                -0.0823974609375,
                                53.64138139745019
                            ],
                            [
                                0.032958984375,
                                53.6348677883201
                            ],
                            [
                                0.1593017578125,
                                53.608803292930894
                            ],
                            [
                                0.1263427734375,
                                53.68369534495075
                            ],
                            [
                                0.0054931640625,
                                53.77468884583577
                            ],
                            [
                                -0.142822265625,
                                53.904338156274704
                            ],
                            [
                                -0.19775390625,
                                54.030360014843545
                            ],
                            [
                                -0.12084960937499999,
                                54.081951104880396
                            ],
                            [
                                -0.0823974609375,
                                54.1173828217967
                            ],
                            [
                                -0.1922607421875,
                                54.165650031996904
                            ],
                            [
                                -0.274658203125,
                                54.20743611987478
                            ],
                            [
                                -0.3515625,
                                54.24597041662376
                            ],
                            [
                                -0.4119873046875,
                                54.31011433916155
                            ],
                            [
                                -0.47790527343749994,
                                54.39655031438518
                            ],
                            [
                                -0.52734375,
                                54.438102809740165
                            ],
                            [
                                -0.5987548828125,
                                54.48918653875083
                            ],
                            [
                                -0.703125,
                                54.52426962191851
                            ],
                            [
                                -0.8184814453125,
                                54.55613719840548
                            ],
                            [
                                -1.021728515625,
                                54.61025498157912
                            ],
                            [
                                -1.153564453125,
                                54.63251788559964
                            ],
                            [
                                -1.2139892578125,
                                54.635697306063854
                            ],
                            [
                                -1.16455078125,
                                54.64523407607479
                            ],
                            [
                                -1.1810302734375,
                                54.677007155737826
                            ],
                            [
                                -1.1810302734375,
                                54.71510205751832
                            ],
                            [
                                -1.2084960937499998,
                                54.7246201949245
                            ],
                            [
                                -1.2689208984375,
                                54.77217736682664
                            ],
                            [
                                -1.3238525390624998,
                                54.826007999094955
                            ],
                            [
                                -1.3568115234375,
                                54.88608683754535
                            ],
                            [
                                -1.3568115234375,
                                54.92714186454645
                            ],
                            [
                                -1.351318359375,
                                54.95238569063361
                            ],
                            [
                                -1.3623046875,
                                54.98076605428234
                            ],
                            [
                                -1.417236328125,
                                55.00597621361476
                            ],
                            [
                                -1.4392089843749998,
                                55.02802211299252
                            ],
                            [
                                -1.4392089843749998,
                                55.04376176308079
                            ],
                            [
                                -1.4556884765625,
                                55.07207755373826
                            ],
                            [
                                -1.4996337890624998,
                                55.10665854913562
                            ],
                            [
                                -1.5106201171875,
                                55.134929850527655
                            ],
                            [
                                -1.51611328125,
                                55.156904807126104
                            ],
                            [
                                -1.51611328125,
                                55.188276612554866
                            ],
                            [
                                -1.51611328125,
                                55.21649013168979
                            ],
                            [
                                -1.5380859375,
                                55.263468250921285
                            ],
                            [
                                -1.5655517578125,
                                55.275986376948325
                            ],
                            [
                                -1.549072265625,
                                55.30413773740139
                            ],
                            [
                                -1.5435791015625,
                                55.32601943701404
                            ],
                            [
                                -1.58203125,
                                55.34164183013326
                            ],
                            [
                                -1.5985107421875,
                                55.36974661834996
                            ],
                            [
                                -1.6094970703125,
                                55.40095076626326
                            ],
                            [
                                -1.58203125,
                                55.41342553237579
                            ],
                            [
                                -1.5875244140625,
                                55.44459522072959
                            ],
                            [
                                -1.5875244140625,
                                55.47885346331034
                            ],
                            [
                                -1.6149902343749998,
                                55.500638670267456
                            ],
                            [
                                -1.6259765625,
                                55.52552129986064
                            ],
                            [
                                -1.64794921875,
                                55.55660246986701
                            ],
                            [
                                -1.6259765625,
                                55.57834467218206
                            ],
                            [
                                -1.669921875,
                                55.59076338488528
                            ],
                            [
                                -1.7413330078125,
                                55.61248667941204
                            ],
                            [
                                -1.768798828125,
                                55.60472974085067
                            ],
                            [
                                -1.772918701171875,
                                55.61248667941204
                            ],
                            [
                                -1.764678955078125,
                                55.630321816296
                            ],
                            [
                                -1.7852783203125,
                                55.65667193958129
                            ],
                            [
                                -1.7935180664062498,
                                55.63729857416297
                            ],
                            [
                                -1.80999755859375,
                                55.63729857416297
                            ],
                            [
                                -1.833343505859375,
                                55.648148839527714
                            ],
                            [
                                -1.852569580078125,
                                55.66209476458093
                            ],
                            [
                                -1.8663024902343748,
                                55.68455275165637
                            ],
                            [
                                -1.885528564453125,
                                55.70158124698169
                            ],
                            [
                                -1.93084716796875,
                                55.72401656896143
                            ],
                            [
                                -1.9706726074218752,
                                55.74334702389655
                            ],
                            [
                                -1.99676513671875,
                                55.76189525593947
                            ],
                            [
                                -2.00225830078125,
                                55.78275147606406
                            ],
                            [
                                -2.0201110839843746,
                                55.79510545223691
                            ],
                            [
                                -2.0269775390625,
                                55.80282469789477
                            ]
                        ].reverse()
                    ]
                ]
            },
            'properties': {
                'name': 'England',
                'id': 'GB-ENG',
                'TYPE': 'England',
                'CNTRY': 'United Kingdom'
            },
            'id': 'GB-ENG'
        }
    ]
};
